/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&t(n[r],r,n)!==false;);return n}function e(n,t){for(var r=null==n?0:n.length;r--&&t(n[r],r,n)!==false;);return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;
return true}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!!(null==n?0:n.length)&&y(n,t,0)>-1}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function p(n){return n.split("")}function _(n){return n.match(Dt)||[]}function v(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function g(n,t,r,e){for(var u=n.length,i=r+(e?1:-1);e?i--:++i<u;)if(t(n[i],i,n))return i;return-1}function y(n,t,r){return t===t?Z(n,t,r):g(n,b,r)}function d(n,t,r,e){
for(var u=r-1,i=n.length;++u<i;)if(e(n[u],t))return u;return-1}function b(n){return n!==n}function w(n,t){var r=null==n?0:n.length;return r?k(n,t)/r:Un}function m(n){return function(t){return null==t?X:t[n]}}function x(n){return function(t){return null==n?X:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function A(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function k(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==X&&(r=r===X?i:r+i)}return r;
}function I(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function O(n,t){return c(t,function(t){return[t,n[t]]})}function R(n){return n?n.slice(0,H(n)+1).replace(Ct,""):n}function z(n){return function(t){return n(t)}}function E(n,t){return c(t,function(t){return n[t]})}function S(n,t){return n.has(t)}function W(n,t){for(var r=-1,e=n.length;++r<e&&y(t,n[r],0)>-1;);return r}function L(n,t){for(var r=n.length;r--&&y(t,n[r],0)>-1;);return r}function C(n,t){for(var r=n.length,e=0;r--;)n[r]===t&&++e;
return e}function U(n){return"\\"+Yr[n]}function B(n,t){return null==n?X:n[t]}function T(n){return Pr.test(n)}function $(n){return qr.test(n)}function D(n){for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}function M(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n]}),r}function F(n,t){return function(r){return n(t(r))}}function N(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&o!==an||(n[r]=an,i[u++]=r)}return i}function P(n){var t=-1,r=Array(n.size);
return n.forEach(function(n){r[++t]=n}),r}function q(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function Z(n,t,r){for(var e=r-1,u=n.length;++e<u;)if(n[e]===t)return e;return-1}function K(n,t,r){for(var e=r+1;e--;)if(n[e]===t)return e;return e}function V(n){return T(n)?J(n):_e(n)}function G(n){return T(n)?Y(n):p(n)}function H(n){for(var t=n.length;t--&&Ut.test(n.charAt(t)););return t}function J(n){for(var t=Fr.lastIndex=0;Fr.test(n);)++t;return t}function Y(n){return n.match(Fr)||[];
}function Q(n){return n.match(Nr)||[]}var X,nn="4.18.1",tn=200,rn="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",en="Expected a function",un="Invalid `variable` option passed into `_.template`",on="Invalid `imports` option passed into `_.template`",fn="__lodash_hash_undefined__",cn=500,an="__lodash_placeholder__",ln=1,sn=2,hn=4,pn=1,_n=2,vn=1,gn=2,yn=4,dn=8,bn=16,wn=32,mn=64,xn=128,jn=256,An=512,kn=30,In="...",On=800,Rn=16,zn=1,En=2,Sn=3,Wn=1/0,Ln=9007199254740991,Cn=1.7976931348623157e308,Un=NaN,Bn=4294967295,Tn=Bn-1,$n=Bn>>>1,Dn=[["ary",xn],["bind",vn],["bindKey",gn],["curry",dn],["curryRight",bn],["flip",An],["partial",wn],["partialRight",mn],["rearg",jn]],Mn="[object Arguments]",Fn="[object Array]",Nn="[object AsyncFunction]",Pn="[object Boolean]",qn="[object Date]",Zn="[object DOMException]",Kn="[object Error]",Vn="[object Function]",Gn="[object GeneratorFunction]",Hn="[object Map]",Jn="[object Number]",Yn="[object Null]",Qn="[object Object]",Xn="[object Promise]",nt="[object Proxy]",tt="[object RegExp]",rt="[object Set]",et="[object String]",ut="[object Symbol]",it="[object Undefined]",ot="[object WeakMap]",ft="[object WeakSet]",ct="[object ArrayBuffer]",at="[object DataView]",lt="[object Float32Array]",st="[object Float64Array]",ht="[object Int8Array]",pt="[object Int16Array]",_t="[object Int32Array]",vt="[object Uint8Array]",gt="[object Uint8ClampedArray]",yt="[object Uint16Array]",dt="[object Uint32Array]",bt=/\b__p\+='';/g,wt=/\b(__p\+=)''\+/g,mt=/(__e\(.*?\)|\b__t\))\+'';/g,xt=/&(?:amp|lt|gt|quot|#39);/g,jt=/[&<>"']/g,At=RegExp(xt.source),kt=RegExp(jt.source),It=/<%-([\s\S]+?)%>/g,Ot=/<%([\s\S]+?)%>/g,Rt=/<%=([\s\S]+?)%>/g,zt=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,Et=/^\w*$/,St=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Wt=/[\\^$.*+?()[\]{}|]/g,Lt=RegExp(Wt.source),Ct=/^\s+/,Ut=/\s/,Bt=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Tt=/\{\n\/\* \[wrapped with (.+)\] \*/,$t=/,? & /,Dt=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,Mt=/[()=,{}\[\]\/\s]/,Ft=/\\(\\)?/g,Nt=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Pt=/\w*$/,qt=/^[-+]0x[0-9a-f]+$/i,Zt=/^0b[01]+$/i,Kt=/^\[object .+?Constructor\]$/,Vt=/^0o[0-7]+$/i,Gt=/^(?:0|[1-9]\d*)$/,Ht=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Jt=/($^)/,Yt=/['\n\r\u2028\u2029\\]/g,Qt="\\ud800-\\udfff",Xt="\\u0300-\\u036f",nr="\\ufe20-\\ufe2f",tr="\\u20d0-\\u20ff",rr=Xt+nr+tr,er="\\u2700-\\u27bf",ur="a-z\\xdf-\\xf6\\xf8-\\xff",ir="\\xac\\xb1\\xd7\\xf7",or="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",fr="\\u2000-\\u206f",cr=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",ar="A-Z\\xc0-\\xd6\\xd8-\\xde",lr="\\ufe0e\\ufe0f",sr=ir+or+fr+cr,hr="['\u2019]",pr="["+Qt+"]",_r="["+sr+"]",vr="["+rr+"]",gr="\\d+",yr="["+er+"]",dr="["+ur+"]",br="[^"+Qt+sr+gr+er+ur+ar+"]",wr="\\ud83c[\\udffb-\\udfff]",mr="(?:"+vr+"|"+wr+")",xr="[^"+Qt+"]",jr="(?:\\ud83c[\\udde6-\\uddff]){2}",Ar="[\\ud800-\\udbff][\\udc00-\\udfff]",kr="["+ar+"]",Ir="\\u200d",Or="(?:"+dr+"|"+br+")",Rr="(?:"+kr+"|"+br+")",zr="(?:"+hr+"(?:d|ll|m|re|s|t|ve))?",Er="(?:"+hr+"(?:D|LL|M|RE|S|T|VE))?",Sr=mr+"?",Wr="["+lr+"]?",Lr="(?:"+Ir+"(?:"+[xr,jr,Ar].join("|")+")"+Wr+Sr+")*",Cr="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",Ur="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",Br=Wr+Sr+Lr,Tr="(?:"+[yr,jr,Ar].join("|")+")"+Br,$r="(?:"+[xr+vr+"?",vr,jr,Ar,pr].join("|")+")",Dr=RegExp(hr,"g"),Mr=RegExp(vr,"g"),Fr=RegExp(wr+"(?="+wr+")|"+$r+Br,"g"),Nr=RegExp([kr+"?"+dr+"+"+zr+"(?="+[_r,kr,"$"].join("|")+")",Rr+"+"+Er+"(?="+[_r,kr+Or,"$"].join("|")+")",kr+"?"+Or+"+"+zr,kr+"+"+Er,Ur,Cr,gr,Tr].join("|"),"g"),Pr=RegExp("["+Ir+Qt+rr+lr+"]"),qr=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Zr=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],Kr={};
Kr[lt]=Kr[st]=Kr[ht]=Kr[pt]=Kr[_t]=Kr[vt]=Kr[gt]=Kr[yt]=Kr[dt]=true,Kr[Mn]=Kr[Fn]=Kr[ct]=Kr[Pn]=Kr[at]=Kr[qn]=Kr[Kn]=Kr[Vn]=Kr[Hn]=Kr[Jn]=Kr[Qn]=Kr[tt]=Kr[rt]=Kr[et]=Kr[ot]=false;var Vr={};Vr[Mn]=Vr[Fn]=Vr[ct]=Vr[at]=Vr[Pn]=Vr[qn]=Vr[lt]=Vr[st]=Vr[ht]=Vr[pt]=Vr[_t]=Vr[Hn]=Vr[Jn]=Vr[Qn]=Vr[tt]=Vr[rt]=Vr[et]=Vr[ut]=Vr[vt]=Vr[gt]=Vr[yt]=Vr[dt]=true,Vr[Kn]=Vr[Vn]=Vr[ot]=false;var Gr={"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a",
"\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae",
"\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g",
"\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O",
"\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w",
"\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"},Hr={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Jr={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Yr={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Qr=parseFloat,Xr=parseInt,ne=typeof global=="object"&&global&&global.Object===Object&&global,te=typeof self=="object"&&self&&self.Object===Object&&self,re=ne||te||Function("return this")(),ee=typeof exports=="object"&&exports&&!exports.nodeType&&exports,ue=ee&&typeof module=="object"&&module&&!module.nodeType&&module,ie=ue&&ue.exports===ee,oe=ie&&ne.process,fe=function(){
try{var n=ue&&ue.require&&ue.require("util").types;return n?n:oe&&oe.binding&&oe.binding("util")}catch(n){}}(),ce=fe&&fe.isArrayBuffer,ae=fe&&fe.isDate,le=fe&&fe.isMap,se=fe&&fe.isRegExp,he=fe&&fe.isSet,pe=fe&&fe.isTypedArray,_e=m("length"),ve=x(Gr),ge=x(Hr),ye=x(Jr),de=function p(x){function Z(n){if(cc(n)&&!bh(n)&&!(n instanceof Ut)){if(n instanceof Y)return n;if(bl.call(n,"__wrapped__"))return eo(n)}return new Y(n)}function J(){}function Y(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,
this.__index__=0,this.__values__=X}function Ut(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=Bn,this.__views__=[]}function Dt(){var n=new Ut(this.__wrapped__);return n.__actions__=Tu(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Tu(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Tu(this.__views__),n}function Qt(){if(this.__filtered__){var n=new Ut(this);n.__dir__=-1,
n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n}function Xt(){var n=this.__wrapped__.value(),t=this.__dir__,r=bh(n),e=t<0,u=r?n.length:0,i=Ii(0,u,this.__views__),o=i.start,f=i.end,c=f-o,a=e?f:o-1,l=this.__iteratees__,s=l.length,h=0,p=Hl(c,this.__takeCount__);if(!r||!e&&u==c&&p==c)return wu(n,this.__actions__);var _=[];n:for(;c--&&h<p;){a+=t;for(var v=-1,g=n[a];++v<s;){var y=l[v],d=y.iteratee,b=y.type,w=d(g);if(b==En)g=w;else if(!w){if(b==zn)continue n;break n}}_[h++]=g}return _}function nr(n){
var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function tr(){this.__data__=is?is(null):{},this.size=0}function rr(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function er(n){var t=this.__data__;if(is){var r=t[n];return r===fn?X:r}return bl.call(t,n)?t[n]:X}function ur(n){var t=this.__data__;return is?t[n]!==X:bl.call(t,n)}function ir(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=is&&t===X?fn:t,this}function or(n){
var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function fr(){this.__data__=[],this.size=0}function cr(n){var t=this.__data__,r=Lr(t,n);return!(r<0)&&(r==t.length-1?t.pop():Ll.call(t,r,1),--this.size,true)}function ar(n){var t=this.__data__,r=Lr(t,n);return r<0?X:t[r][1]}function lr(n){return Lr(this.__data__,n)>-1}function sr(n,t){var r=this.__data__,e=Lr(r,n);return e<0?(++this.size,r.push([n,t])):r[e][1]=t,this}function hr(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){
var e=n[t];this.set(e[0],e[1])}}function pr(){this.size=0,this.__data__={hash:new nr,map:new(ts||or),string:new nr}}function _r(n){var t=xi(this,n).delete(n);return this.size-=t?1:0,t}function vr(n){return xi(this,n).get(n)}function gr(n){return xi(this,n).has(n)}function yr(n,t){var r=xi(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this}function dr(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new hr;++t<r;)this.add(n[t])}function br(n){return this.__data__.set(n,fn),this}function wr(n){
return this.__data__.has(n)}function mr(n){this.size=(this.__data__=new or(n)).size}function xr(){this.__data__=new or,this.size=0}function jr(n){var t=this.__data__,r=t.delete(n);return this.size=t.size,r}function Ar(n){return this.__data__.get(n)}function kr(n){return this.__data__.has(n)}function Ir(n,t){var r=this.__data__;if(r instanceof or){var e=r.__data__;if(!ts||e.length<tn-1)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new hr(e)}return r.set(n,t),this.size=r.size,this}function Or(n,t){
var r=bh(n),e=!r&&dh(n),u=!r&&!e&&mh(n),i=!r&&!e&&!u&&Ih(n),o=r||e||u||i,f=o?I(n.length,hl):[],c=f.length;for(var a in n)!t&&!bl.call(n,a)||o&&("length"==a||u&&("offset"==a||"parent"==a)||i&&("buffer"==a||"byteLength"==a||"byteOffset"==a)||Ci(a,c))||f.push(a);return f}function Rr(n){var t=n.length;return t?n[tu(0,t-1)]:X}function zr(n,t){return Xi(Tu(n),Fr(t,0,n.length))}function Er(n){return Xi(Tu(n))}function Sr(n,t,r){(r===X||Gf(n[t],r))&&(r!==X||t in n)||Tr(n,t,r)}function Wr(n,t,r){var e=n[t];
bl.call(n,t)&&Gf(e,r)&&(r!==X||t in n)||Tr(n,t,r)}function Lr(n,t){for(var r=n.length;r--;)if(Gf(n[r][0],t))return r;return-1}function Cr(n,t,r,e){return ys(n,function(n,u,i){t(e,n,r(n),i)}),e}function Ur(n,t){return n&&$u(t,Pc(t),n)}function Br(n,t){return n&&$u(t,qc(t),n)}function Tr(n,t,r){"__proto__"==t&&Tl?Tl(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function $r(n,t){for(var r=-1,e=t.length,u=il(e),i=null==n;++r<e;)u[r]=i?X:Mc(n,t[r]);return u}function Fr(n,t,r){return n===n&&(r!==X&&(n=n<=r?n:r),
t!==X&&(n=n>=t?n:t)),n}function Nr(n,t,e,u,i,o){var f,c=t&ln,a=t&sn,l=t&hn;if(e&&(f=i?e(n,u,i,o):e(n)),f!==X)return f;if(!fc(n))return n;var s=bh(n);if(s){if(f=zi(n),!c)return Tu(n,f)}else{var h=zs(n),p=h==Vn||h==Gn;if(mh(n))return Ou(n,c);if(h==Qn||h==Mn||p&&!i){if(f=a||p?{}:Ei(n),!c)return a?Mu(n,Br(f,n)):Du(n,Ur(f,n))}else{if(!Vr[h])return i?n:{};f=Si(n,h,c)}}o||(o=new mr);var _=o.get(n);if(_)return _;o.set(n,f),kh(n)?n.forEach(function(r){f.add(Nr(r,t,e,r,n,o))}):jh(n)&&n.forEach(function(r,u){
f.set(u,Nr(r,t,e,u,n,o))});var v=l?a?di:yi:a?qc:Pc,g=s?X:v(n);return r(g||n,function(r,u){g&&(u=r,r=n[u]),Wr(f,u,Nr(r,t,e,u,n,o))}),f}function Pr(n){var t=Pc(n);return function(r){return qr(r,n,t)}}function qr(n,t,r){var e=r.length;if(null==n)return!e;for(n=ll(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===X&&!(u in n)||!i(o))return false}return true}function Gr(n,t,r){if(typeof n!="function")throw new pl(en);return Ws(function(){n.apply(X,r)},t)}function Hr(n,t,r,e){var u=-1,i=o,a=true,l=n.length,s=[],h=t.length;
if(!l)return s;r&&(t=c(t,z(r))),e?(i=f,a=false):t.length>=tn&&(i=S,a=false,t=new dr(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p);if(p=e||0!==p?p:0,a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function Jr(n,t){var r=true;return ys(n,function(n,e,u){return r=!!t(n,e,u)}),r}function Yr(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===X?o===o&&!bc(o):r(o,f)))var f=o,c=i}return c}function ne(n,t,r,e){var u=n.length;for(r=kc(r),r<0&&(r=-r>u?0:u+r),
e=e===X||e>u?u:kc(e),e<0&&(e+=u),e=r>e?0:Ic(e);r<e;)n[r++]=t;return n}function te(n,t){var r=[];return ys(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function ee(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Li),u||(u=[]);++i<o;){var f=n[i];t>0&&r(f)?t>1?ee(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function ue(n,t){return n&&bs(n,t,Pc)}function oe(n,t){return n&&ws(n,t,Pc)}function fe(n,t){return i(t,function(t){return uc(n[t])})}function _e(n,t){t=ku(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[no(t[r++])];
return r&&r==e?n:X}function de(n,t,r){var e=t(n);return bh(n)?e:a(e,r(n))}function we(n){return null==n?n===X?it:Yn:Bl&&Bl in ll(n)?ki(n):Ki(n)}function me(n,t){return n>t}function xe(n,t){return null!=n&&bl.call(n,t)}function je(n,t){return null!=n&&t in ll(n)}function Ae(n,t,r){return n>=Hl(t,r)&&n<Gl(t,r)}function ke(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=il(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,z(t))),s=Hl(p.length,s),l[a]=!r&&(t||u>=120&&p.length>=120)?new dr(a&&p):X}p=n[0];
var _=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],y=t?t(g):g;if(g=r||0!==g?g:0,!(v?S(v,y):e(h,y,r))){for(a=i;--a;){var d=l[a];if(!(d?S(d,y):e(n[a],y,r)))continue n}v&&v.push(y),h.push(g)}}return h}function Ie(n,t,r,e){return ue(n,function(n,u,i){t(e,r(n),u,i)}),e}function Oe(t,r,e){r=ku(r,t),t=Gi(t,r);var u=null==t?t:t[no(jo(r))];return null==u?X:n(u,t,e)}function Re(n){return cc(n)&&we(n)==Mn}function ze(n){return cc(n)&&we(n)==ct}function Ee(n){return cc(n)&&we(n)==qn}function Se(n,t,r,e,u){
return n===t||(null==n||null==t||!cc(n)&&!cc(t)?n!==n&&t!==t:We(n,t,r,e,Se,u))}function We(n,t,r,e,u,i){var o=bh(n),f=bh(t),c=o?Fn:zs(n),a=f?Fn:zs(t);c=c==Mn?Qn:c,a=a==Mn?Qn:a;var l=c==Qn,s=a==Qn,h=c==a;if(h&&mh(n)){if(!mh(t))return false;o=true,l=false}if(h&&!l)return i||(i=new mr),o||Ih(n)?pi(n,t,r,e,u,i):_i(n,t,c,r,e,u,i);if(!(r&pn)){var p=l&&bl.call(n,"__wrapped__"),_=s&&bl.call(t,"__wrapped__");if(p||_){var v=p?n.value():n,g=_?t.value():t;return i||(i=new mr),u(v,g,r,e,i)}}return!!h&&(i||(i=new mr),vi(n,t,r,e,u,i));
}function Le(n){return cc(n)&&zs(n)==Hn}function Ce(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=ll(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){f=r[u];var c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===X&&!(c in n))return false}else{var s=new mr;if(e)var h=e(a,l,c,n,t,s);if(!(h===X?Se(l,a,pn|_n,e,s):h))return false}}return true}function Ue(n){return!(!fc(n)||Di(n))&&(uc(n)?kl:Kt).test(to(n))}function Be(n){return cc(n)&&we(n)==tt}function Te(n){return cc(n)&&zs(n)==rt;
}function $e(n){return cc(n)&&oc(n.length)&&!!Kr[we(n)]}function De(n){return typeof n=="function"?n:null==n?La:typeof n=="object"?bh(n)?Ze(n[0],n[1]):qe(n):Fa(n)}function Me(n){if(!Mi(n))return Vl(n);var t=[];for(var r in ll(n))bl.call(n,r)&&"constructor"!=r&&t.push(r);return t}function Fe(n){if(!fc(n))return Zi(n);var t=Mi(n),r=[];for(var e in n)("constructor"!=e||!t&&bl.call(n,e))&&r.push(e);return r}function Ne(n,t){return n<t}function Pe(n,t){var r=-1,e=Hf(n)?il(n.length):[];return ys(n,function(n,u,i){
e[++r]=t(n,u,i)}),e}function qe(n){var t=ji(n);return 1==t.length&&t[0][2]?Ni(t[0][0],t[0][1]):function(r){return r===n||Ce(r,n,t)}}function Ze(n,t){return Bi(n)&&Fi(t)?Ni(no(n),t):function(r){var e=Mc(r,n);return e===X&&e===t?Nc(r,n):Se(t,e,pn|_n)}}function Ke(n,t,r,e,u){n!==t&&bs(t,function(i,o){if(u||(u=new mr),fc(i))Ve(n,t,o,r,Ke,e,u);else{var f=e?e(Ji(n,o),i,o+"",n,t,u):X;f===X&&(f=i),Sr(n,o,f)}},qc)}function Ve(n,t,r,e,u,i,o){var f=Ji(n,r),c=Ji(t,r),a=o.get(c);if(a)return Sr(n,r,a),X;var l=i?i(f,c,r+"",n,t,o):X,s=l===X;
if(s){var h=bh(c),p=!h&&mh(c),_=!h&&!p&&Ih(c);l=c,h||p||_?bh(f)?l=f:Jf(f)?l=Tu(f):p?(s=false,l=Ou(c,true)):_?(s=false,l=Wu(c,true)):l=[]:gc(c)||dh(c)?(l=f,dh(f)?l=Rc(f):fc(f)&&!uc(f)||(l=Ei(c))):s=false}s&&(o.set(c,l),u(l,c,e,i,o),o.delete(c)),Sr(n,r,l)}function Ge(n,t){var r=n.length;if(r)return t+=t<0?r:0,Ci(t,r)?n[t]:X}function He(n,t,r){t=t.length?c(t,function(n){return bh(n)?function(t){return _e(t,1===n.length?n[0]:n)}:n}):[La];var e=-1;return t=c(t,z(mi())),A(Pe(n,function(n,r,u){return{a:c(t,function(t){
return t(n)}),b:++e,c:n}}),function(n,t){return Cu(n,t,r)})}function Je(n,t){return Ye(n,t,function(t,r){return Nc(n,r)})}function Ye(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=_e(n,o);r(f,o)&&fu(i,ku(o,n),f)}return i}function Qe(n){return function(t){return _e(t,n)}}function Xe(n,t,r,e){var u=e?d:y,i=-1,o=t.length,f=n;for(n===t&&(t=Tu(t)),r&&(f=c(n,z(r)));++i<o;)for(var a=0,l=t[i],s=r?r(l):l;(a=u(f,s,a,e))>-1;)f!==n&&Ll.call(f,a,1),Ll.call(n,a,1);return n}function nu(n,t){for(var r=n?t.length:0,e=r-1;r--;){
var u=t[r];if(r==e||u!==i){var i=u;Ci(u)?Ll.call(n,u,1):yu(n,u)}}return n}function tu(n,t){return n+Nl(Ql()*(t-n+1))}function ru(n,t,r,e){for(var u=-1,i=Gl(Fl((t-n)/(r||1)),0),o=il(i);i--;)o[e?i:++u]=n,n+=r;return o}function eu(n,t){var r="";if(!n||t<1||t>Ln)return r;do t%2&&(r+=n),t=Nl(t/2),t&&(n+=n);while(t);return r}function uu(n,t){return Ls(Vi(n,t,La),n+"")}function iu(n){return Rr(ra(n))}function ou(n,t){var r=ra(n);return Xi(r,Fr(t,0,r.length))}function fu(n,t,r,e){if(!fc(n))return n;t=ku(t,n);
for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=no(t[u]),a=r;if("__proto__"===c||"constructor"===c||"prototype"===c)return n;if(u!=o){var l=f[c];a=e?e(l,c,f):X,a===X&&(a=fc(l)?l:Ci(t[u+1])?[]:{})}Wr(f,c,a),f=f[c]}return n}function cu(n){return Xi(ra(n))}function au(n,t,r){var e=-1,u=n.length;t<0&&(t=-t>u?0:u+t),r=r>u?u:r,r<0&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0;for(var i=il(u);++e<u;)i[e]=n[e+t];return i}function lu(n,t){var r;return ys(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function su(n,t,r){
var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&u<=$n){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!bc(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return hu(n,t,La,r)}function hu(n,t,r,e){var u=0,i=null==n?0:n.length;if(0===i)return 0;t=r(t);for(var o=t!==t,f=null===t,c=bc(t),a=t===X;u<i;){var l=Nl((u+i)/2),s=r(n[l]),h=s!==X,p=null===s,_=s===s,v=bc(s);if(o)var g=e||_;else g=a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):!p&&!v&&(e?s<=t:s<t);g?u=l+1:i=l}return Hl(i,Tn)}function pu(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){
var o=n[r],f=t?t(o):o;if(!r||!Gf(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function _u(n){return typeof n=="number"?n:bc(n)?Un:+n}function vu(n){if(typeof n=="string")return n;if(bh(n))return c(n,vu)+"";if(bc(n))return vs?vs.call(n):"";var t=n+"";return"0"==t&&1/n==-Wn?"-0":t}function gu(n,t,r){var e=-1,u=o,i=n.length,c=true,a=[],l=a;if(r)c=false,u=f;else if(i>=tn){var s=t?null:ks(n);if(s)return P(s);c=false,u=S,l=new dr}else l=t?[]:a;n:for(;++e<i;){var h=n[e],p=t?t(h):h;if(h=r||0!==h?h:0,c&&p===p){for(var _=l.length;_--;)if(l[_]===p)continue n;
t&&l.push(p),a.push(h)}else u(l,p,r)||(l!==a&&l.push(p),a.push(h))}return a}function yu(n,t){t=ku(t,n);var r=-1,e=t.length;if(!e)return true;for(;++r<e;){var u=no(t[r]);if("__proto__"===u&&!bl.call(n,"__proto__"))return false;if(("constructor"===u||"prototype"===u)&&r<e-1)return false}var i=Gi(n,t);return null==i||delete i[no(jo(t))]}function du(n,t,r,e){return fu(n,t,r(_e(n,t)),e)}function bu(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?au(n,e?0:i,e?i+1:u):au(n,e?i+1:0,e?u:i)}
function wu(n,t){var r=n;return r instanceof Ut&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mu(n,t,r){var e=n.length;if(e<2)return e?gu(n[0]):[];for(var u=-1,i=il(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=Hr(i[u]||o,n[f],t,r));return gu(ee(i,1),t,r)}function xu(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;){r(o,n[e],e<i?t[e]:X)}return o}function ju(n){return Jf(n)?n:[]}function Au(n){return typeof n=="function"?n:La}function ku(n,t){return bh(n)?n:Bi(n,t)?[n]:Cs(Ec(n));
}function Iu(n,t,r){var e=n.length;return r=r===X?e:r,!t&&r>=e?n:au(n,t,r)}function Ou(n,t){if(t)return n.slice();var r=n.length,e=zl?zl(r):new n.constructor(r);return n.copy(e),e}function Ru(n){var t=new n.constructor(n.byteLength);return new Rl(t).set(new Rl(n)),t}function zu(n,t){return new n.constructor(t?Ru(n.buffer):n.buffer,n.byteOffset,n.byteLength)}function Eu(n){var t=new n.constructor(n.source,Pt.exec(n));return t.lastIndex=n.lastIndex,t}function Su(n){return _s?ll(_s.call(n)):{}}function Wu(n,t){
return new n.constructor(t?Ru(n.buffer):n.buffer,n.byteOffset,n.length)}function Lu(n,t){if(n!==t){var r=n!==X,e=null===n,u=n===n,i=bc(n),o=t!==X,f=null===t,c=t===t,a=bc(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Cu(n,t,r){for(var e=-1,u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Lu(u[e],i[e]);if(c){if(e>=f)return c;return c*("desc"==r[e]?-1:1)}}return n.b-t.b}function Uu(n,t,r,e){for(var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Gl(i-o,0),l=il(c+a),s=!e;++f<c;)l[f]=t[f];
for(;++u<o;)(s||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Bu(n,t,r,e){for(var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Gl(i-f,0),s=il(l+a),h=!e;++u<l;)s[u]=n[u];for(var p=u;++c<a;)s[p+c]=t[c];for(;++o<f;)(h||u<i)&&(s[p+r[o]]=n[u++]);return s}function Tu(n,t){var r=-1,e=n.length;for(t||(t=il(e));++r<e;)t[r]=n[r];return t}function $u(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):X;c===X&&(c=n[f]),u?Tr(r,f,c):Wr(r,f,c)}return r;
}function Du(n,t){return $u(n,Os(n),t)}function Mu(n,t){return $u(n,Rs(n),t)}function Fu(n,r){return function(e,u){var i=bh(e)?t:Cr,o=r?r():{};return i(e,n,mi(u,2),o)}}function Nu(n){return uu(function(t,r){var e=-1,u=r.length,i=u>1?r[u-1]:X,o=u>2?r[2]:X;for(i=n.length>3&&typeof i=="function"?(u--,i):X,o&&Ui(r[0],r[1],o)&&(i=u<3?X:i,u=1),t=ll(t);++e<u;){var f=r[e];f&&n(t,f,e,i)}return t})}function Pu(n,t){return function(r,e){if(null==r)return r;if(!Hf(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=ll(r);(t?i--:++i<u)&&e(o[i],i,o)!==false;);
return r}}function qu(n){return function(t,r,e){for(var u=-1,i=ll(t),o=e(t),f=o.length;f--;){var c=o[n?f:++u];if(r(i[c],c,i)===false)break}return t}}function Zu(n,t,r){function e(){return(this&&this!==re&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=t&vn,i=Gu(n);return e}function Ku(n){return function(t){t=Ec(t);var r=T(t)?G(t):X,e=r?r[0]:t.charAt(0),u=r?Iu(r,1).join(""):t.slice(1);return e[n]()+u}}function Vu(n){return function(t){return l(Ra(ca(t).replace(Dr,"")),n,"")}}function Gu(n){return function(){
var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=gs(n.prototype),e=n.apply(r,t);return fc(e)?e:r}}function Hu(t,r,e){function u(){for(var o=arguments.length,f=il(o),c=o,a=wi(u);c--;)f[c]=arguments[c];var l=o<3&&f[0]!==a&&f[o-1]!==a?[]:N(f,a);
return o-=l.length,o<e?oi(t,r,Qu,u.placeholder,X,f,l,X,X,e-o):n(this&&this!==re&&this instanceof u?i:t,this,f)}var i=Gu(t);return u}function Ju(n){return function(t,r,e){var u=ll(t);if(!Hf(t)){var i=mi(r,3);t=Pc(t),r=function(n){return i(u[n],n,u)}}var o=n(t,r,e);return o>-1?u[i?t[o]:o]:X}}function Yu(n){return gi(function(t){var r=t.length,e=r,u=Y.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new pl(en);if(u&&!o&&"wrapper"==bi(i))var o=new Y([],true)}for(e=o?e:r;++e<r;){
i=t[e];var f=bi(i),c="wrapper"==f?Is(i):X;o=c&&$i(c[0])&&c[1]==(xn|dn|wn|jn)&&!c[4].length&&1==c[9]?o[bi(c[0])].apply(o,c[3]):1==i.length&&$i(i)?o[f]():o.thru(i)}return function(){var n=arguments,e=n[0];if(o&&1==n.length&&bh(e))return o.plant(e).value();for(var u=0,i=r?t[u].apply(this,n):e;++u<r;)i=t[u].call(this,i);return i}})}function Qu(n,t,r,e,u,i,o,f,c,a){function l(){for(var y=arguments.length,d=il(y),b=y;b--;)d[b]=arguments[b];if(_)var w=wi(l),m=C(d,w);if(e&&(d=Uu(d,e,u,_)),i&&(d=Bu(d,i,o,_)),
y-=m,_&&y<a){return oi(n,t,Qu,l.placeholder,r,d,N(d,w),f,c,a-y)}var x=h?r:this,j=p?x[n]:n;return y=d.length,f?d=Hi(d,f):v&&y>1&&d.reverse(),s&&c<y&&(d.length=c),this&&this!==re&&this instanceof l&&(j=g||Gu(j)),j.apply(x,d)}var s=t&xn,h=t&vn,p=t&gn,_=t&(dn|bn),v=t&An,g=p?X:Gu(n);return l}function Xu(n,t){return function(r,e){return Ie(r,n,t(e),{})}}function ni(n,t){return function(r,e){var u;if(r===X&&e===X)return t;if(r!==X&&(u=r),e!==X){if(u===X)return e;typeof r=="string"||typeof e=="string"?(r=vu(r),
e=vu(e)):(r=_u(r),e=_u(e)),u=n(r,e)}return u}}function ti(t){return gi(function(r){return r=c(r,z(mi())),uu(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ri(n,t){t=t===X?" ":vu(t);var r=t.length;if(r<2)return r?eu(t,n):t;var e=eu(t,Fl(n/V(t)));return T(t)?Iu(G(e),0,n).join(""):e.slice(0,n)}function ei(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=il(l+c),h=this&&this!==re&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];
return n(h,o?e:this,s)}var o=r&vn,f=Gu(t);return i}function ui(n){return function(t,r,e){return e&&typeof e!="number"&&Ui(t,r,e)&&(r=e=X),t=Ac(t),r===X?(r=t,t=0):r=Ac(r),e=e===X?t<r?1:-1:Ac(e),ru(t,r,e,n)}}function ii(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Oc(t),r=Oc(r)),n(t,r)}}function oi(n,t,r,e,u,i,o,f,c,a){var l=t&dn,s=l?o:X,h=l?X:o,p=l?i:X,_=l?X:i;t|=l?wn:mn,t&=~(l?mn:wn),t&yn||(t&=~(vn|gn));var v=[n,t,u,p,s,_,h,f,c,a],g=r.apply(X,v);return $i(n)&&Ss(g,v),g.placeholder=e,
Yi(g,n,t)}function fi(n){var t=al[n];return function(n,r){if(n=Oc(n),r=null==r?0:Hl(kc(r),292),r&&Zl(n)){var e=(Ec(n)+"e").split("e");return e=(Ec(t(e[0]+"e"+(+e[1]+r)))+"e").split("e"),+(e[0]+"e"+(+e[1]-r))}return t(n)}}function ci(n){return function(t){var r=zs(t);return r==Hn?M(t):r==rt?q(t):O(t,n(t))}}function ai(n,t,r,e,u,i,o,f){var c=t&gn;if(!c&&typeof n!="function")throw new pl(en);var a=e?e.length:0;if(a||(t&=~(wn|mn),e=u=X),o=o===X?o:Gl(kc(o),0),f=f===X?f:kc(f),a-=u?u.length:0,t&mn){var l=e,s=u;
e=u=X}var h=c?X:Is(n),p=[n,t,r,e,u,l,s,i,o,f];if(h&&qi(p,h),n=p[0],t=p[1],r=p[2],e=p[3],u=p[4],f=p[9]=p[9]===X?c?0:n.length:Gl(p[9]-a,0),!f&&t&(dn|bn)&&(t&=~(dn|bn)),t&&t!=vn)_=t==dn||t==bn?Hu(n,t,f):t!=wn&&t!=(vn|wn)||u.length?Qu.apply(X,p):ei(n,t,r,e);else var _=Zu(n,t,r);return Yi((h?ms:Ss)(_,p),n,t)}function li(n,t,r,e){return n===X||Gf(n,gl[r])&&!bl.call(e,r)?t:n}function si(n,t,r,e,u,i){return fc(n)&&fc(t)&&(i.set(t,n),Ke(n,t,X,si,i),i.delete(t)),n}function hi(n){return gc(n)?X:n}function pi(n,t,r,e,u,i){
var o=r&pn,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;var a=i.get(n),l=i.get(t);if(a&&l)return a==t&&l==n;var s=-1,p=true,_=r&_n?new dr:X;for(i.set(n,t),i.set(t,n);++s<f;){var v=n[s],g=t[s];if(e)var y=o?e(g,v,s,t,n,i):e(v,g,s,n,t,i);if(y!==X){if(y)continue;p=false;break}if(_){if(!h(t,function(n,t){if(!S(_,t)&&(v===n||u(v,n,r,e,i)))return _.push(t)})){p=false;break}}else if(v!==g&&!u(v,g,r,e,i)){p=false;break}}return i.delete(n),i.delete(t),p}function _i(n,t,r,e,u,i,o){switch(r){case at:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return false;
n=n.buffer,t=t.buffer;case ct:return!(n.byteLength!=t.byteLength||!i(new Rl(n),new Rl(t)));case Pn:case qn:case Jn:return Gf(+n,+t);case Kn:return n.name==t.name&&n.message==t.message;case tt:case et:return n==t+"";case Hn:var f=M;case rt:var c=e&pn;if(f||(f=P),n.size!=t.size&&!c)return false;var a=o.get(n);if(a)return a==t;e|=_n,o.set(n,t);var l=pi(f(n),f(t),e,u,i,o);return o.delete(n),l;case ut:if(_s)return _s.call(n)==_s.call(t)}return false}function vi(n,t,r,e,u,i){var o=r&pn,f=yi(n),c=f.length;if(c!=yi(t).length&&!o)return false;
for(var a=c;a--;){var l=f[a];if(!(o?l in t:bl.call(t,l)))return false}var s=i.get(n),h=i.get(t);if(s&&h)return s==t&&h==n;var p=true;i.set(n,t),i.set(t,n);for(var _=o;++a<c;){l=f[a];var v=n[l],g=t[l];if(e)var y=o?e(g,v,l,t,n,i):e(v,g,l,n,t,i);if(!(y===X?v===g||u(v,g,r,e,i):y)){p=false;break}_||(_="constructor"==l)}if(p&&!_){var d=n.constructor,b=t.constructor;d!=b&&"constructor"in n&&"constructor"in t&&!(typeof d=="function"&&d instanceof d&&typeof b=="function"&&b instanceof b)&&(p=false)}return i.delete(n),
i.delete(t),p}function gi(n){return Ls(Vi(n,X,_o),n+"")}function yi(n){return de(n,Pc,Os)}function di(n){return de(n,qc,Rs)}function bi(n){for(var t=n.name+"",r=fs[t],e=bl.call(fs,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function wi(n){return(bl.call(Z,"placeholder")?Z:n).placeholder}function mi(){var n=Z.iteratee||Ca;return n=n===Ca?De:n,arguments.length?n(arguments[0],arguments[1]):n}function xi(n,t){var r=n.__data__;return Ti(t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function ji(n){for(var t=Pc(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,Fi(u)]}return t}function Ai(n,t){var r=B(n,t);return Ue(r)?r:X}function ki(n){var t=bl.call(n,Bl),r=n[Bl];try{n[Bl]=X;var e=true}catch(n){}var u=xl.call(n);return e&&(t?n[Bl]=r:delete n[Bl]),u}function Ii(n,t,r){for(var e=-1,u=r.length;++e<u;){var i=r[e],o=i.size;switch(i.type){case"drop":n+=o;break;case"dropRight":t-=o;break;case"take":t=Hl(t,n+o);break;case"takeRight":n=Gl(n,t-o)}}return{start:n,end:t}}function Oi(n){var t=n.match(Tt);
return t?t[1].split($t):[]}function Ri(n,t,r){t=ku(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=no(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&oc(u)&&Ci(o,u)&&(bh(n)||dh(n)))}function zi(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&bl.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ei(n){return typeof n.constructor!="function"||Mi(n)?{}:gs(El(n))}function Si(n,t,r){var e=n.constructor;switch(t){case ct:return Ru(n);
case Pn:case qn:return new e(+n);case at:return zu(n,r);case lt:case st:case ht:case pt:case _t:case vt:case gt:case yt:case dt:return Wu(n,r);case Hn:return new e;case Jn:case et:return new e(n);case tt:return Eu(n);case rt:return new e;case ut:return Su(n)}}function Wi(n,t){var r=t.length;if(!r)return n;var e=r-1;return t[e]=(r>1?"& ":"")+t[e],t=t.join(r>2?", ":" "),n.replace(Bt,"{\n/* [wrapped with "+t+"] */\n")}function Li(n){return bh(n)||dh(n)||!!(Cl&&n&&n[Cl])}function Ci(n,t){var r=typeof n;
return t=null==t?Ln:t,!!t&&("number"==r||"symbol"!=r&&Gt.test(n))&&n>-1&&n%1==0&&n<t}function Ui(n,t,r){if(!fc(r))return false;var e=typeof t;return!!("number"==e?Hf(r)&&Ci(t,r.length):"string"==e&&t in r)&&Gf(r[t],n)}function Bi(n,t){if(bh(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!bc(n))||(Et.test(n)||!zt.test(n)||null!=t&&n in ll(t))}function Ti(n){var t=typeof n;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==n:null===n}function $i(n){
var t=bi(n),r=Z[t];if(typeof r!="function"||!(t in Ut.prototype))return false;if(n===r)return true;var e=Is(r);return!!e&&n===e[0]}function Di(n){return!!ml&&ml in n}function Mi(n){var t=n&&n.constructor;return n===(typeof t=="function"&&t.prototype||gl)}function Fi(n){return n===n&&!fc(n)}function Ni(n,t){return function(r){return null!=r&&(r[n]===t&&(t!==X||n in ll(r)))}}function Pi(n){var t=Cf(n,function(n){return r.size===cn&&r.clear(),n}),r=t.cache;return t}function qi(n,t){var r=n[1],e=t[1],u=r|e,i=u<(vn|gn|xn),o=e==xn&&r==dn||e==xn&&r==jn&&n[7].length<=t[8]||e==(xn|jn)&&t[7].length<=t[8]&&r==dn;
if(!i&&!o)return n;e&vn&&(n[2]=t[2],u|=r&vn?0:yn);var f=t[3];if(f){var c=n[3];n[3]=c?Uu(c,f,t[4]):f,n[4]=c?N(n[3],an):t[4]}return f=t[5],f&&(c=n[5],n[5]=c?Bu(c,f,t[6]):f,n[6]=c?N(n[5],an):t[6]),f=t[7],f&&(n[7]=f),e&xn&&(n[8]=null==n[8]?t[8]:Hl(n[8],t[8])),null==n[9]&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Zi(n){var t=[];if(null!=n)for(var r in ll(n))t.push(r);return t}function Ki(n){return xl.call(n)}function Vi(t,r,e){return r=Gl(r===X?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Gl(u.length-r,0),f=il(o);++i<o;)f[i]=u[r+i];
i=-1;for(var c=il(r+1);++i<r;)c[i]=u[i];return c[r]=e(f),n(t,this,c)}}function Gi(n,t){return t.length<2?n:_e(n,au(t,0,-1))}function Hi(n,t){for(var r=n.length,e=Hl(t.length,r),u=Tu(n);e--;){var i=t[e];n[e]=Ci(i,r)?u[i]:X}return n}function Ji(n,t){if(("constructor"!==t||"function"!=typeof n[t])&&"__proto__"!=t)return n[t]}function Yi(n,t,r){var e=t+"";return Ls(n,Wi(e,ro(Oi(e),r)))}function Qi(n){var t=0,r=0;return function(){var e=Jl(),u=Rn-(e-r);if(r=e,u>0){if(++t>=On)return arguments[0]}else t=0;
return n.apply(X,arguments)}}function Xi(n,t){var r=-1,e=n.length,u=e-1;for(t=t===X?e:t;++r<t;){var i=tu(r,u),o=n[i];n[i]=n[r],n[r]=o}return n.length=t,n}function no(n){if(typeof n=="string"||bc(n))return n;var t=n+"";return"0"==t&&1/n==-Wn?"-0":t}function to(n){if(null!=n){try{return dl.call(n)}catch(n){}try{return n+""}catch(n){}}return""}function ro(n,t){return r(Dn,function(r){var e="_."+r[0];t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function eo(n){if(n instanceof Ut)return n.clone();var t=new Y(n.__wrapped__,n.__chain__);
return t.__actions__=Tu(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function uo(n,t,r){t=(r?Ui(n,t,r):t===X)?1:Gl(kc(t),0);var e=null==n?0:n.length;if(!e||t<1)return[];for(var u=0,i=0,o=il(Fl(e/t));u<e;)o[i++]=au(n,u,u+=t);return o}function io(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){var i=n[t];i&&(u[e++]=i)}return u}function oo(){var n=arguments.length;if(!n)return[];for(var t=il(n-1),r=arguments[0],e=n;e--;)t[e-1]=arguments[e];return a(bh(r)?Tu(r):[r],ee(t,1));
}function fo(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===X?1:kc(t),au(n,t<0?0:t,e)):[]}function co(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===X?1:kc(t),t=e-t,au(n,0,t<0?0:t)):[]}function ao(n,t){return n&&n.length?bu(n,mi(t,3),true,true):[]}function lo(n,t){return n&&n.length?bu(n,mi(t,3),true):[]}function so(n,t,r,e){var u=null==n?0:n.length;return u?(r&&typeof r!="number"&&Ui(n,t,r)&&(r=0,e=u),ne(n,t,r,e)):[]}function ho(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=null==r?0:kc(r);
return u<0&&(u=Gl(e+u,0)),g(n,mi(t,3),u)}function po(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==X&&(u=kc(r),u=r<0?Gl(e+u,0):Hl(u,e-1)),g(n,mi(t,3),u,true)}function _o(n){return(null==n?0:n.length)?ee(n,1):[]}function vo(n){return(null==n?0:n.length)?ee(n,Wn):[]}function go(n,t){return(null==n?0:n.length)?(t=t===X?1:kc(t),ee(n,t)):[]}function yo(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];Tr(e,u[0],u[1])}return e}function bo(n){return n&&n.length?n[0]:X}function wo(n,t,r){
var e=null==n?0:n.length;if(!e)return-1;var u=null==r?0:kc(r);return u<0&&(u=Gl(e+u,0)),y(n,t,u)}function mo(n){return(null==n?0:n.length)?au(n,0,-1):[]}function xo(n,t){return null==n?"":Kl.call(n,t)}function jo(n){var t=null==n?0:n.length;return t?n[t-1]:X}function Ao(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;return r!==X&&(u=kc(r),u=u<0?Gl(e+u,0):Hl(u,e-1)),t===t?K(n,t,u):g(n,b,u,true)}function ko(n,t){return n&&n.length?Ge(n,kc(t)):X}function Io(n,t){return n&&n.length&&t&&t.length?Xe(n,t):n;
}function Oo(n,t,r){return n&&n.length&&t&&t.length?Xe(n,t,mi(r,2)):n}function Ro(n,t,r){return n&&n.length&&t&&t.length?Xe(n,t,X,r):n}function zo(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=mi(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),u.push(e))}return nu(n,u),r}function Eo(n){return null==n?n:Xl.call(n)}function So(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&Ui(n,t,r)?(t=0,r=e):(t=null==t?0:kc(t),r=r===X?e:kc(r)),au(n,t,r)):[]}function Wo(n,t){
return su(n,t)}function Lo(n,t,r){return hu(n,t,mi(r,2))}function Co(n,t){var r=null==n?0:n.length;if(r){var e=su(n,t);if(e<r&&Gf(n[e],t))return e}return-1}function Uo(n,t){return su(n,t,true)}function Bo(n,t,r){return hu(n,t,mi(r,2),true)}function To(n,t){if(null==n?0:n.length){var r=su(n,t,true)-1;if(Gf(n[r],t))return r}return-1}function $o(n){return n&&n.length?pu(n):[]}function Do(n,t){return n&&n.length?pu(n,mi(t,2)):[]}function Mo(n){var t=null==n?0:n.length;return t?au(n,1,t):[]}function Fo(n,t,r){
return n&&n.length?(t=r||t===X?1:kc(t),au(n,0,t<0?0:t)):[]}function No(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===X?1:kc(t),t=e-t,au(n,t<0?0:t,e)):[]}function Po(n,t){return n&&n.length?bu(n,mi(t,3),false,true):[]}function qo(n,t){return n&&n.length?bu(n,mi(t,3)):[]}function Zo(n){return n&&n.length?gu(n):[]}function Ko(n,t){return n&&n.length?gu(n,mi(t,2)):[]}function Vo(n,t){return t=typeof t=="function"?t:X,n&&n.length?gu(n,X,t):[]}function Go(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){
if(Jf(n))return t=Gl(n.length,t),true}),I(t,function(t){return c(n,m(t))})}function Ho(t,r){if(!t||!t.length)return[];var e=Go(t);return null==r?e:c(e,function(t){return n(r,X,t)})}function Jo(n,t){return xu(n||[],t||[],Wr)}function Yo(n,t){return xu(n||[],t||[],fu)}function Qo(n){var t=Z(n);return t.__chain__=true,t}function Xo(n,t){return t(n),n}function nf(n,t){return t(n)}function tf(){return Qo(this)}function rf(){return new Y(this.value(),this.__chain__)}function ef(){this.__values__===X&&(this.__values__=jc(this.value()));
var n=this.__index__>=this.__values__.length;return{done:n,value:n?X:this.__values__[this.__index__++]}}function uf(){return this}function of(n){for(var t,r=this;r instanceof J;){var e=eo(r);e.__index__=0,e.__values__=X,t?u.__wrapped__=e:t=e;var u=e;r=r.__wrapped__}return u.__wrapped__=n,t}function ff(){var n=this.__wrapped__;if(n instanceof Ut){var t=n;return this.__actions__.length&&(t=new Ut(this)),t=t.reverse(),t.__actions__.push({func:nf,args:[Eo],thisArg:X}),new Y(t,this.__chain__)}return this.thru(Eo);
}function cf(){return wu(this.__wrapped__,this.__actions__)}function af(n,t,r){var e=bh(n)?u:Jr;return r&&Ui(n,t,r)&&(t=X),e(n,mi(t,3))}function lf(n,t){return(bh(n)?i:te)(n,mi(t,3))}function sf(n,t){return ee(yf(n,t),1)}function hf(n,t){return ee(yf(n,t),Wn)}function pf(n,t,r){return r=r===X?1:kc(r),ee(yf(n,t),r)}function _f(n,t){return(bh(n)?r:ys)(n,mi(t,3))}function vf(n,t){return(bh(n)?e:ds)(n,mi(t,3))}function gf(n,t,r,e){n=Hf(n)?n:ra(n),r=r&&!e?kc(r):0;var u=n.length;return r<0&&(r=Gl(u+r,0)),
dc(n)?r<=u&&n.indexOf(t,r)>-1:!!u&&y(n,t,r)>-1}function yf(n,t){return(bh(n)?c:Pe)(n,mi(t,3))}function df(n,t,r,e){return null==n?[]:(bh(t)||(t=null==t?[]:[t]),r=e?X:r,bh(r)||(r=null==r?[]:[r]),He(n,t,r))}function bf(n,t,r){var e=bh(n)?l:j,u=arguments.length<3;return e(n,mi(t,4),r,u,ys)}function wf(n,t,r){var e=bh(n)?s:j,u=arguments.length<3;return e(n,mi(t,4),r,u,ds)}function mf(n,t){return(bh(n)?i:te)(n,Uf(mi(t,3)))}function xf(n){return(bh(n)?Rr:iu)(n)}function jf(n,t,r){return t=(r?Ui(n,t,r):t===X)?1:kc(t),
(bh(n)?zr:ou)(n,t)}function Af(n){return(bh(n)?Er:cu)(n)}function kf(n){if(null==n)return 0;if(Hf(n))return dc(n)?V(n):n.length;var t=zs(n);return t==Hn||t==rt?n.size:Me(n).length}function If(n,t,r){var e=bh(n)?h:lu;return r&&Ui(n,t,r)&&(t=X),e(n,mi(t,3))}function Of(n,t){if(typeof t!="function")throw new pl(en);return n=kc(n),function(){if(--n<1)return t.apply(this,arguments)}}function Rf(n,t,r){return t=r?X:t,t=n&&null==t?n.length:t,ai(n,xn,X,X,X,X,t)}function zf(n,t){var r;if(typeof t!="function")throw new pl(en);
return n=kc(n),function(){return--n>0&&(r=t.apply(this,arguments)),n<=1&&(t=X),r}}function Ef(n,t,r){t=r?X:t;var e=ai(n,dn,X,X,X,X,X,t);return e.placeholder=Ef.placeholder,e}function Sf(n,t,r){t=r?X:t;var e=ai(n,bn,X,X,X,X,X,t);return e.placeholder=Sf.placeholder,e}function Wf(n,t,r){function e(t){var r=h,e=p;return h=p=X,d=t,v=n.apply(e,r)}function u(n){return d=n,g=Ws(f,t),b?e(n):v}function i(n){var r=n-y,e=n-d,u=t-r;return w?Hl(u,_-e):u}function o(n){var r=n-y,e=n-d;return y===X||r>=t||r<0||w&&e>=_;
}function f(){var n=fh();return o(n)?c(n):(g=Ws(f,i(n)),X)}function c(n){return g=X,m&&h?e(n):(h=p=X,v)}function a(){g!==X&&As(g),d=0,h=y=p=g=X}function l(){return g===X?v:c(fh())}function s(){var n=fh(),r=o(n);if(h=arguments,p=this,y=n,r){if(g===X)return u(y);if(w)return As(g),g=Ws(f,t),e(y)}return g===X&&(g=Ws(f,t)),v}var h,p,_,v,g,y,d=0,b=false,w=false,m=true;if(typeof n!="function")throw new pl(en);return t=Oc(t)||0,fc(r)&&(b=!!r.leading,w="maxWait"in r,_=w?Gl(Oc(r.maxWait)||0,t):_,m="trailing"in r?!!r.trailing:m),
s.cancel=a,s.flush=l,s}function Lf(n){return ai(n,An)}function Cf(n,t){if(typeof n!="function"||null!=t&&typeof t!="function")throw new pl(en);var r=function(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;if(i.has(u))return i.get(u);var o=n.apply(this,e);return r.cache=i.set(u,o)||i,o};return r.cache=new(Cf.Cache||hr),r}function Uf(n){if(typeof n!="function")throw new pl(en);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:
return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function Bf(n){return zf(2,n)}function Tf(n,t){if(typeof n!="function")throw new pl(en);return t=t===X?t:kc(t),uu(n,t)}function $f(t,r){if(typeof t!="function")throw new pl(en);return r=null==r?0:Gl(kc(r),0),uu(function(e){var u=e[r],i=Iu(e,0,r);return u&&a(i,u),n(t,this,i)})}function Df(n,t,r){var e=true,u=true;if(typeof n!="function")throw new pl(en);return fc(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),
Wf(n,t,{leading:e,maxWait:t,trailing:u})}function Mf(n){return Rf(n,1)}function Ff(n,t){return ph(Au(t),n)}function Nf(){if(!arguments.length)return[];var n=arguments[0];return bh(n)?n:[n]}function Pf(n){return Nr(n,hn)}function qf(n,t){return t=typeof t=="function"?t:X,Nr(n,hn,t)}function Zf(n){return Nr(n,ln|hn)}function Kf(n,t){return t=typeof t=="function"?t:X,Nr(n,ln|hn,t)}function Vf(n,t){return null==t||qr(n,t,Pc(t))}function Gf(n,t){return n===t||n!==n&&t!==t}function Hf(n){return null!=n&&oc(n.length)&&!uc(n);
}function Jf(n){return cc(n)&&Hf(n)}function Yf(n){return n===true||n===false||cc(n)&&we(n)==Pn}function Qf(n){return cc(n)&&1===n.nodeType&&!gc(n)}function Xf(n){if(null==n)return true;if(Hf(n)&&(bh(n)||typeof n=="string"||typeof n.splice=="function"||mh(n)||Ih(n)||dh(n)))return!n.length;var t=zs(n);if(t==Hn||t==rt)return!n.size;if(Mi(n))return!Me(n).length;for(var r in n)if(bl.call(n,r))return false;return true}function nc(n,t){return Se(n,t)}function tc(n,t,r){r=typeof r=="function"?r:X;var e=r?r(n,t):X;return e===X?Se(n,t,X,r):!!e;
}function rc(n){if(!cc(n))return false;var t=we(n);return t==Kn||t==Zn||typeof n.message=="string"&&typeof n.name=="string"&&!gc(n)}function ec(n){return typeof n=="number"&&Zl(n)}function uc(n){if(!fc(n))return false;var t=we(n);return t==Vn||t==Gn||t==Nn||t==nt}function ic(n){return typeof n=="number"&&n==kc(n)}function oc(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=Ln}function fc(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function cc(n){return null!=n&&typeof n=="object"}function ac(n,t){
return n===t||Ce(n,t,ji(t))}function lc(n,t,r){return r=typeof r=="function"?r:X,Ce(n,t,ji(t),r)}function sc(n){return vc(n)&&n!=+n}function hc(n){if(Es(n))throw new fl(rn);return Ue(n)}function pc(n){return null===n}function _c(n){return null==n}function vc(n){return typeof n=="number"||cc(n)&&we(n)==Jn}function gc(n){if(!cc(n)||we(n)!=Qn)return false;var t=El(n);if(null===t)return true;var r=bl.call(t,"constructor")&&t.constructor;return typeof r=="function"&&r instanceof r&&dl.call(r)==jl}function yc(n){
return ic(n)&&n>=-Ln&&n<=Ln}function dc(n){return typeof n=="string"||!bh(n)&&cc(n)&&we(n)==et}function bc(n){return typeof n=="symbol"||cc(n)&&we(n)==ut}function wc(n){return n===X}function mc(n){return cc(n)&&zs(n)==ot}function xc(n){return cc(n)&&we(n)==ft}function jc(n){if(!n)return[];if(Hf(n))return dc(n)?G(n):Tu(n);if(Ul&&n[Ul])return D(n[Ul]());var t=zs(n);return(t==Hn?M:t==rt?P:ra)(n)}function Ac(n){if(!n)return 0===n?n:0;if(n=Oc(n),n===Wn||n===-Wn){return(n<0?-1:1)*Cn}return n===n?n:0}function kc(n){
var t=Ac(n),r=t%1;return t===t?r?t-r:t:0}function Ic(n){return n?Fr(kc(n),0,Bn):0}function Oc(n){if(typeof n=="number")return n;if(bc(n))return Un;if(fc(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=fc(t)?t+"":t}if(typeof n!="string")return 0===n?n:+n;n=R(n);var r=Zt.test(n);return r||Vt.test(n)?Xr(n.slice(2),r?2:8):qt.test(n)?Un:+n}function Rc(n){return $u(n,qc(n))}function zc(n){return n?Fr(kc(n),-Ln,Ln):0===n?n:0}function Ec(n){return null==n?"":vu(n)}function Sc(n,t){var r=gs(n);return null==t?r:Ur(r,t);
}function Wc(n,t){return v(n,mi(t,3),ue)}function Lc(n,t){return v(n,mi(t,3),oe)}function Cc(n,t){return null==n?n:bs(n,mi(t,3),qc)}function Uc(n,t){return null==n?n:ws(n,mi(t,3),qc)}function Bc(n,t){return n&&ue(n,mi(t,3))}function Tc(n,t){return n&&oe(n,mi(t,3))}function $c(n){return null==n?[]:fe(n,Pc(n))}function Dc(n){return null==n?[]:fe(n,qc(n))}function Mc(n,t,r){var e=null==n?X:_e(n,t);return e===X?r:e}function Fc(n,t){return null!=n&&Ri(n,t,xe)}function Nc(n,t){return null!=n&&Ri(n,t,je);
}function Pc(n){return Hf(n)?Or(n):Me(n)}function qc(n){return Hf(n)?Or(n,true):Fe(n)}function Zc(n,t){var r={};return t=mi(t,3),ue(n,function(n,e,u){Tr(r,t(n,e,u),n)}),r}function Kc(n,t){var r={};return t=mi(t,3),ue(n,function(n,e,u){Tr(r,e,t(n,e,u))}),r}function Vc(n,t){return Gc(n,Uf(mi(t)))}function Gc(n,t){if(null==n)return{};var r=c(di(n),function(n){return[n]});return t=mi(t),Ye(n,r,function(n,r){return t(n,r[0])})}function Hc(n,t,r){t=ku(t,n);var e=-1,u=t.length;for(u||(u=1,n=X);++e<u;){var i=null==n?X:n[no(t[e])];
i===X&&(e=u,i=r),n=uc(i)?i.call(n):i}return n}function Jc(n,t,r){return null==n?n:fu(n,t,r)}function Yc(n,t,r,e){return e=typeof e=="function"?e:X,null==n?n:fu(n,t,r,e)}function Qc(n,t,e){var u=bh(n),i=u||mh(n)||Ih(n);if(t=mi(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:fc(n)&&uc(o)?gs(El(n)):{}}return(i?r:ue)(n,function(n,r,u){return t(e,n,r,u)}),e}function Xc(n,t){return null==n||yu(n,t)}function na(n,t,r){return null==n?n:du(n,t,Au(r))}function ta(n,t,r,e){return e=typeof e=="function"?e:X,
null==n?n:du(n,t,Au(r),e)}function ra(n){return null==n?[]:E(n,Pc(n))}function ea(n){return null==n?[]:E(n,qc(n))}function ua(n,t,r){return r===X&&(r=t,t=X),r!==X&&(r=Oc(r),r=r===r?r:0),t!==X&&(t=Oc(t),t=t===t?t:0),Fr(Oc(n),t,r)}function ia(n,t,r){return t=Ac(t),r===X?(r=t,t=0):r=Ac(r),n=Oc(n),Ae(n,t,r)}function oa(n,t,r){if(r&&typeof r!="boolean"&&Ui(n,t,r)&&(t=r=X),r===X&&(typeof t=="boolean"?(r=t,t=X):typeof n=="boolean"&&(r=n,n=X)),n===X&&t===X?(n=0,t=1):(n=Ac(n),t===X?(t=n,n=0):t=Ac(t)),n>t){
var e=n;n=t,t=e}if(r||n%1||t%1){var u=Ql();return Hl(n+u*(t-n+Qr("1e-"+((u+"").length-1))),t)}return tu(n,t)}function fa(n){return Qh(Ec(n).toLowerCase())}function ca(n){return n=Ec(n),n&&n.replace(Ht,ve).replace(Mr,"")}function aa(n,t,r){n=Ec(n),t=vu(t);var e=n.length;r=r===X?e:Fr(kc(r),0,e);var u=r;return r-=t.length,r>=0&&n.slice(r,u)==t}function la(n){return n=Ec(n),n&&kt.test(n)?n.replace(jt,ge):n}function sa(n){return n=Ec(n),n&&Lt.test(n)?n.replace(Wt,"\\$&"):n}function ha(n,t,r){n=Ec(n),t=kc(t);
var e=t?V(n):0;if(!t||e>=t)return n;var u=(t-e)/2;return ri(Nl(u),r)+n+ri(Fl(u),r)}function pa(n,t,r){n=Ec(n),t=kc(t);var e=t?V(n):0;return t&&e<t?n+ri(t-e,r):n}function _a(n,t,r){n=Ec(n),t=kc(t);var e=t?V(n):0;return t&&e<t?ri(t-e,r)+n:n}function va(n,t,r){return r||null==t?t=0:t&&(t=+t),Yl(Ec(n).replace(Ct,""),t||0)}function ga(n,t,r){return t=(r?Ui(n,t,r):t===X)?1:kc(t),eu(Ec(n),t)}function ya(){var n=arguments,t=Ec(n[0]);return n.length<3?t:t.replace(n[1],n[2])}function da(n,t,r){return r&&typeof r!="number"&&Ui(n,t,r)&&(t=r=X),
(r=r===X?Bn:r>>>0)?(n=Ec(n),n&&(typeof t=="string"||null!=t&&!Ah(t))&&(t=vu(t),!t&&T(n))?Iu(G(n),0,r):n.split(t,r)):[]}function ba(n,t,r){return n=Ec(n),r=null==r?0:Fr(kc(r),0,n.length),t=vu(t),n.slice(r,r+t.length)==t}function wa(n,t,e){var u=Z.templateSettings;e&&Ui(n,t,e)&&(t=X),n=Ec(n),t=Wh({},t,u,li);var i=Wh({},t.imports,u.imports,li),o=Pc(i),f=E(i,o);r(o,function(n){if(Mt.test(n))throw new fl(on)});var c,a,l=0,s=t.interpolate||Jt,h="__p+='",p=sl((t.escape||Jt).source+"|"+s.source+"|"+(s===Rt?Nt:Jt).source+"|"+(t.evaluate||Jt).source+"|$","g"),_=bl.call(t,"sourceURL")?"//# sourceURL="+(t.sourceURL+"").replace(/\s/g," ")+"\n":"";
n.replace(p,function(t,r,e,u,i,o){return e||(e=u),h+=n.slice(l,o).replace(Yt,U),r&&(c=true,h+="'+__e("+r+")+'"),i&&(a=true,h+="';"+i+";\n__p+='"),e&&(h+="'+((__t=("+e+"))==null?'':__t)+'"),l=o+t.length,t}),h+="';";var v=bl.call(t,"variable")&&t.variable;if(v){if(Mt.test(v))throw new fl(un)}else h="with(obj){"+h+"}";h=(a?h.replace(bt,""):h).replace(wt,"$1").replace(mt,"$1;"),h="function("+(v||"obj")+"){"+(v?"":"obj||(obj={});")+"var __t,__p=''"+(c?",__e=_.escape":"")+(a?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+h+"return __p}";
var g=Xh(function(){return cl(o,_+"return "+h).apply(X,f)});if(g.source=h,rc(g))throw g;return g}function ma(n){return Ec(n).toLowerCase()}function xa(n){return Ec(n).toUpperCase()}function ja(n,t,r){if(n=Ec(n),n&&(r||t===X))return R(n);if(!n||!(t=vu(t)))return n;var e=G(n),u=G(t);return Iu(e,W(e,u),L(e,u)+1).join("")}function Aa(n,t,r){if(n=Ec(n),n&&(r||t===X))return n.slice(0,H(n)+1);if(!n||!(t=vu(t)))return n;var e=G(n);return Iu(e,0,L(e,G(t))+1).join("")}function ka(n,t,r){if(n=Ec(n),n&&(r||t===X))return n.replace(Ct,"");
if(!n||!(t=vu(t)))return n;var e=G(n);return Iu(e,W(e,G(t))).join("")}function Ia(n,t){var r=kn,e=In;if(fc(t)){var u="separator"in t?t.separator:u;r="length"in t?kc(t.length):r,e="omission"in t?vu(t.omission):e}n=Ec(n);var i=n.length;if(T(n)){var o=G(n);i=o.length}if(r>=i)return n;var f=r-V(e);if(f<1)return e;var c=o?Iu(o,0,f).join(""):n.slice(0,f);if(u===X)return c+e;if(o&&(f+=c.length-f),Ah(u)){if(n.slice(f).search(u)){var a,l=c;for(u.global||(u=sl(u.source,Ec(Pt.exec(u))+"g")),u.lastIndex=0;a=u.exec(l);)var s=a.index;
c=c.slice(0,s===X?f:s)}}else if(n.indexOf(vu(u),f)!=f){var h=c.lastIndexOf(u);h>-1&&(c=c.slice(0,h))}return c+e}function Oa(n){return n=Ec(n),n&&At.test(n)?n.replace(xt,ye):n}function Ra(n,t,r){return n=Ec(n),t=r?X:t,t===X?$(n)?Q(n):_(n):n.match(t)||[]}function za(t){var r=null==t?0:t.length,e=mi();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new pl(en);return[e(n[0]),n[1]]}):[],uu(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})}function Ea(n){
return Pr(Nr(n,ln))}function Sa(n){return function(){return n}}function Wa(n,t){return null==n||n!==n?t:n}function La(n){return n}function Ca(n){return De(typeof n=="function"?n:Nr(n,ln))}function Ua(n){return qe(Nr(n,ln))}function Ba(n,t){return Ze(n,Nr(t,ln))}function Ta(n,t,e){var u=Pc(t),i=fe(t,u);null!=e||fc(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=fe(t,Pc(t)));var o=!(fc(e)&&"chain"in e&&!e.chain),f=uc(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;
if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Tu(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function $a(){return re._===this&&(re._=Al),this}function Da(){}function Ma(n){return n=kc(n),uu(function(t){return Ge(t,n)})}function Fa(n){return Bi(n)?m(no(n)):Qe(n)}function Na(n){return function(t){return null==n?X:_e(n,t)}}function Pa(){return[]}function qa(){return false}function Za(){return{}}function Ka(){return"";
}function Va(){return true}function Ga(n,t){if(n=kc(n),n<1||n>Ln)return[];var r=Bn,e=Hl(n,Bn);t=mi(t),n-=Bn;for(var u=I(e,t);++r<n;)t(r);return u}function Ha(n){return bh(n)?c(n,no):bc(n)?[n]:Tu(Cs(Ec(n)))}function Ja(n){var t=++wl;return Ec(n)+t}function Ya(n){return n&&n.length?Yr(n,La,me):X}function Qa(n,t){return n&&n.length?Yr(n,mi(t,2),me):X}function Xa(n){return w(n,La)}function nl(n,t){return w(n,mi(t,2))}function tl(n){return n&&n.length?Yr(n,La,Ne):X}function rl(n,t){return n&&n.length?Yr(n,mi(t,2),Ne):X;
}function el(n){return n&&n.length?k(n,La):0}function ul(n,t){return n&&n.length?k(n,mi(t,2)):0}x=null==x?re:be.defaults(re.Object(),x,be.pick(re,Zr));var il=x.Array,ol=x.Date,fl=x.Error,cl=x.Function,al=x.Math,ll=x.Object,sl=x.RegExp,hl=x.String,pl=x.TypeError,_l=il.prototype,vl=cl.prototype,gl=ll.prototype,yl=x["__core-js_shared__"],dl=vl.toString,bl=gl.hasOwnProperty,wl=0,ml=function(){var n=/[^.]+$/.exec(yl&&yl.keys&&yl.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),xl=gl.toString,jl=dl.call(ll),Al=re._,kl=sl("^"+dl.call(bl).replace(Wt,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Il=ie?x.Buffer:X,Ol=x.Symbol,Rl=x.Uint8Array,zl=Il?Il.allocUnsafe:X,El=F(ll.getPrototypeOf,ll),Sl=ll.create,Wl=gl.propertyIsEnumerable,Ll=_l.splice,Cl=Ol?Ol.isConcatSpreadable:X,Ul=Ol?Ol.iterator:X,Bl=Ol?Ol.toStringTag:X,Tl=function(){
try{var n=Ai(ll,"defineProperty");return n({},"",{}),n}catch(n){}}(),$l=x.clearTimeout!==re.clearTimeout&&x.clearTimeout,Dl=ol&&ol.now!==re.Date.now&&ol.now,Ml=x.setTimeout!==re.setTimeout&&x.setTimeout,Fl=al.ceil,Nl=al.floor,Pl=ll.getOwnPropertySymbols,ql=Il?Il.isBuffer:X,Zl=x.isFinite,Kl=_l.join,Vl=F(ll.keys,ll),Gl=al.max,Hl=al.min,Jl=ol.now,Yl=x.parseInt,Ql=al.random,Xl=_l.reverse,ns=Ai(x,"DataView"),ts=Ai(x,"Map"),rs=Ai(x,"Promise"),es=Ai(x,"Set"),us=Ai(x,"WeakMap"),is=Ai(ll,"create"),os=us&&new us,fs={},cs=to(ns),as=to(ts),ls=to(rs),ss=to(es),hs=to(us),ps=Ol?Ol.prototype:X,_s=ps?ps.valueOf:X,vs=ps?ps.toString:X,gs=function(){
function n(){}return function(t){if(!fc(t))return{};if(Sl)return Sl(t);n.prototype=t;var r=new n;return n.prototype=X,r}}();Z.templateSettings={escape:It,evaluate:Ot,interpolate:Rt,variable:"",imports:{_:Z}},Z.prototype=J.prototype,Z.prototype.constructor=Z,Y.prototype=gs(J.prototype),Y.prototype.constructor=Y,Ut.prototype=gs(J.prototype),Ut.prototype.constructor=Ut,nr.prototype.clear=tr,nr.prototype.delete=rr,nr.prototype.get=er,nr.prototype.has=ur,nr.prototype.set=ir,or.prototype.clear=fr,or.prototype.delete=cr,
or.prototype.get=ar,or.prototype.has=lr,or.prototype.set=sr,hr.prototype.clear=pr,hr.prototype.delete=_r,hr.prototype.get=vr,hr.prototype.has=gr,hr.prototype.set=yr,dr.prototype.add=dr.prototype.push=br,dr.prototype.has=wr,mr.prototype.clear=xr,mr.prototype.delete=jr,mr.prototype.get=Ar,mr.prototype.has=kr,mr.prototype.set=Ir;var ys=Pu(ue),ds=Pu(oe,true),bs=qu(),ws=qu(true),ms=os?function(n,t){return os.set(n,t),n}:La,xs=Tl?function(n,t){return Tl(n,"toString",{configurable:true,enumerable:false,value:Sa(t),
writable:true})}:La,js=uu,As=$l||function(n){return re.clearTimeout(n)},ks=es&&1/P(new es([,-0]))[1]==Wn?function(n){return new es(n)}:Da,Is=os?function(n){return os.get(n)}:Da,Os=Pl?function(n){return null==n?[]:(n=ll(n),i(Pl(n),function(t){return Wl.call(n,t)}))}:Pa,Rs=Pl?function(n){for(var t=[];n;)a(t,Os(n)),n=El(n);return t}:Pa,zs=we;(ns&&zs(new ns(new ArrayBuffer(1)))!=at||ts&&zs(new ts)!=Hn||rs&&zs(rs.resolve())!=Xn||es&&zs(new es)!=rt||us&&zs(new us)!=ot)&&(zs=function(n){var t=we(n),r=t==Qn?n.constructor:X,e=r?to(r):"";
if(e)switch(e){case cs:return at;case as:return Hn;case ls:return Xn;case ss:return rt;case hs:return ot}return t});var Es=yl?uc:qa,Ss=Qi(ms),Ws=Ml||function(n,t){return re.setTimeout(n,t)},Ls=Qi(xs),Cs=Pi(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(St,function(n,r,e,u){t.push(e?u.replace(Ft,"$1"):r||n)}),t}),Us=uu(function(n,t){return Jf(n)?Hr(n,ee(t,1,Jf,true)):[]}),Bs=uu(function(n,t){var r=jo(t);return Jf(r)&&(r=X),Jf(n)?Hr(n,ee(t,1,Jf,true),mi(r,2)):[]}),Ts=uu(function(n,t){
var r=jo(t);return Jf(r)&&(r=X),Jf(n)?Hr(n,ee(t,1,Jf,true),X,r):[]}),$s=uu(function(n){var t=c(n,ju);return t.length&&t[0]===n[0]?ke(t):[]}),Ds=uu(function(n){var t=jo(n),r=c(n,ju);return t===jo(r)?t=X:r.pop(),r.length&&r[0]===n[0]?ke(r,mi(t,2)):[]}),Ms=uu(function(n){var t=jo(n),r=c(n,ju);return t=typeof t=="function"?t:X,t&&r.pop(),r.length&&r[0]===n[0]?ke(r,X,t):[]}),Fs=uu(Io),Ns=gi(function(n,t){var r=null==n?0:n.length,e=$r(n,t);return nu(n,c(t,function(n){return Ci(n,r)?+n:n}).sort(Lu)),e}),Ps=uu(function(n){
return gu(ee(n,1,Jf,true))}),qs=uu(function(n){var t=jo(n);return Jf(t)&&(t=X),gu(ee(n,1,Jf,true),mi(t,2))}),Zs=uu(function(n){var t=jo(n);return t=typeof t=="function"?t:X,gu(ee(n,1,Jf,true),X,t)}),Ks=uu(function(n,t){return Jf(n)?Hr(n,t):[]}),Vs=uu(function(n){return mu(i(n,Jf))}),Gs=uu(function(n){var t=jo(n);return Jf(t)&&(t=X),mu(i(n,Jf),mi(t,2))}),Hs=uu(function(n){var t=jo(n);return t=typeof t=="function"?t:X,mu(i(n,Jf),X,t)}),Js=uu(Go),Ys=uu(function(n){var t=n.length,r=t>1?n[t-1]:X;return r=typeof r=="function"?(n.pop(),
r):X,Ho(n,r)}),Qs=gi(function(n){var t=n.length,r=t?n[0]:0,e=this.__wrapped__,u=function(t){return $r(t,n)};return!(t>1||this.__actions__.length)&&e instanceof Ut&&Ci(r)?(e=e.slice(r,+r+(t?1:0)),e.__actions__.push({func:nf,args:[u],thisArg:X}),new Y(e,this.__chain__).thru(function(n){return t&&!n.length&&n.push(X),n})):this.thru(u)}),Xs=Fu(function(n,t,r){bl.call(n,r)?++n[r]:Tr(n,r,1)}),nh=Ju(ho),th=Ju(po),rh=Fu(function(n,t,r){bl.call(n,r)?n[r].push(t):Tr(n,r,[t])}),eh=uu(function(t,r,e){var u=-1,i=typeof r=="function",o=Hf(t)?il(t.length):[];
return ys(t,function(t){o[++u]=i?n(r,t,e):Oe(t,r,e)}),o}),uh=Fu(function(n,t,r){Tr(n,r,t)}),ih=Fu(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),oh=uu(function(n,t){if(null==n)return[];var r=t.length;return r>1&&Ui(n,t[0],t[1])?t=[]:r>2&&Ui(t[0],t[1],t[2])&&(t=[t[0]]),He(n,ee(t,1),[])}),fh=Dl||function(){return re.Date.now()},ch=uu(function(n,t,r){var e=vn;if(r.length){var u=N(r,wi(ch));e|=wn}return ai(n,e,t,r,u)}),ah=uu(function(n,t,r){var e=vn|gn;if(r.length){var u=N(r,wi(ah));e|=wn;
}return ai(t,e,n,r,u)}),lh=uu(function(n,t){return Gr(n,1,t)}),sh=uu(function(n,t,r){return Gr(n,Oc(t)||0,r)});Cf.Cache=hr;var hh=js(function(t,r){r=1==r.length&&bh(r[0])?c(r[0],z(mi())):c(ee(r,1),z(mi()));var e=r.length;return uu(function(u){for(var i=-1,o=Hl(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);return n(t,this,u)})}),ph=uu(function(n,t){return ai(n,wn,X,t,N(t,wi(ph)))}),_h=uu(function(n,t){return ai(n,mn,X,t,N(t,wi(_h)))}),vh=gi(function(n,t){return ai(n,jn,X,X,X,t)}),gh=ii(me),yh=ii(function(n,t){
return n>=t}),dh=Re(function(){return arguments}())?Re:function(n){return cc(n)&&bl.call(n,"callee")&&!Wl.call(n,"callee")},bh=il.isArray,wh=ce?z(ce):ze,mh=ql||qa,xh=ae?z(ae):Ee,jh=le?z(le):Le,Ah=se?z(se):Be,kh=he?z(he):Te,Ih=pe?z(pe):$e,Oh=ii(Ne),Rh=ii(function(n,t){return n<=t}),zh=Nu(function(n,t){if(Mi(t)||Hf(t))return $u(t,Pc(t),n),X;for(var r in t)bl.call(t,r)&&Wr(n,r,t[r])}),Eh=Nu(function(n,t){$u(t,qc(t),n)}),Sh=Nu(function(n,t,r,e){$u(t,qc(t),n,e)}),Wh=Nu(function(n,t,r,e){$u(t,Pc(t),n,e);
}),Lh=gi($r),Ch=uu(function(n,t){n=ll(n);var r=-1,e=t.length,u=e>2?t[2]:X;for(u&&Ui(t[0],t[1],u)&&(e=1);++r<e;)for(var i=t[r],o=qc(i),f=-1,c=o.length;++f<c;){var a=o[f],l=n[a];(l===X||Gf(l,gl[a])&&!bl.call(n,a))&&(n[a]=i[a])}return n}),Uh=uu(function(t){return t.push(X,si),n(Mh,X,t)}),Bh=Xu(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=xl.call(t)),n[t]=r},Sa(La)),Th=Xu(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=xl.call(t)),bl.call(n,t)?n[t].push(r):n[t]=[r]},mi),$h=uu(Oe),Dh=Nu(function(n,t,r){
Ke(n,t,r)}),Mh=Nu(function(n,t,r,e){Ke(n,t,r,e)}),Fh=gi(function(n,t){var r={};if(null==n)return r;var e=false;t=c(t,function(t){return t=ku(t,n),e||(e=t.length>1),t}),$u(n,di(n),r),e&&(r=Nr(r,ln|sn|hn,hi));for(var u=t.length;u--;)yu(r,t[u]);return r}),Nh=gi(function(n,t){return null==n?{}:Je(n,t)}),Ph=ci(Pc),qh=ci(qc),Zh=Vu(function(n,t,r){return t=t.toLowerCase(),n+(r?fa(t):t)}),Kh=Vu(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Vh=Vu(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Gh=Ku("toLowerCase"),Hh=Vu(function(n,t,r){
return n+(r?"_":"")+t.toLowerCase()}),Jh=Vu(function(n,t,r){return n+(r?" ":"")+Qh(t)}),Yh=Vu(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),Qh=Ku("toUpperCase"),Xh=uu(function(t,r){try{return n(t,X,r)}catch(n){return rc(n)?n:new fl(n)}}),np=gi(function(n,t){return r(t,function(t){t=no(t),Tr(n,t,ch(n[t],n))}),n}),tp=Yu(),rp=Yu(true),ep=uu(function(n,t){return function(r){return Oe(r,n,t)}}),up=uu(function(n,t){return function(r){return Oe(n,r,t)}}),ip=ti(c),op=ti(u),fp=ti(h),cp=ui(),ap=ui(true),lp=ni(function(n,t){
return n+t},0),sp=fi("ceil"),hp=ni(function(n,t){return n/t},1),pp=fi("floor"),_p=ni(function(n,t){return n*t},1),vp=fi("round"),gp=ni(function(n,t){return n-t},0);return Z.after=Of,Z.ary=Rf,Z.assign=zh,Z.assignIn=Eh,Z.assignInWith=Sh,Z.assignWith=Wh,Z.at=Lh,Z.before=zf,Z.bind=ch,Z.bindAll=np,Z.bindKey=ah,Z.castArray=Nf,Z.chain=Qo,Z.chunk=uo,Z.compact=io,Z.concat=oo,Z.cond=za,Z.conforms=Ea,Z.constant=Sa,Z.countBy=Xs,Z.create=Sc,Z.curry=Ef,Z.curryRight=Sf,Z.debounce=Wf,Z.defaults=Ch,Z.defaultsDeep=Uh,
Z.defer=lh,Z.delay=sh,Z.difference=Us,Z.differenceBy=Bs,Z.differenceWith=Ts,Z.drop=fo,Z.dropRight=co,Z.dropRightWhile=ao,Z.dropWhile=lo,Z.fill=so,Z.filter=lf,Z.flatMap=sf,Z.flatMapDeep=hf,Z.flatMapDepth=pf,Z.flatten=_o,Z.flattenDeep=vo,Z.flattenDepth=go,Z.flip=Lf,Z.flow=tp,Z.flowRight=rp,Z.fromPairs=yo,Z.functions=$c,Z.functionsIn=Dc,Z.groupBy=rh,Z.initial=mo,Z.intersection=$s,Z.intersectionBy=Ds,Z.intersectionWith=Ms,Z.invert=Bh,Z.invertBy=Th,Z.invokeMap=eh,Z.iteratee=Ca,Z.keyBy=uh,Z.keys=Pc,Z.keysIn=qc,
Z.map=yf,Z.mapKeys=Zc,Z.mapValues=Kc,Z.matches=Ua,Z.matchesProperty=Ba,Z.memoize=Cf,Z.merge=Dh,Z.mergeWith=Mh,Z.method=ep,Z.methodOf=up,Z.mixin=Ta,Z.negate=Uf,Z.nthArg=Ma,Z.omit=Fh,Z.omitBy=Vc,Z.once=Bf,Z.orderBy=df,Z.over=ip,Z.overArgs=hh,Z.overEvery=op,Z.overSome=fp,Z.partial=ph,Z.partialRight=_h,Z.partition=ih,Z.pick=Nh,Z.pickBy=Gc,Z.property=Fa,Z.propertyOf=Na,Z.pull=Fs,Z.pullAll=Io,Z.pullAllBy=Oo,Z.pullAllWith=Ro,Z.pullAt=Ns,Z.range=cp,Z.rangeRight=ap,Z.rearg=vh,Z.reject=mf,Z.remove=zo,Z.rest=Tf,
Z.reverse=Eo,Z.sampleSize=jf,Z.set=Jc,Z.setWith=Yc,Z.shuffle=Af,Z.slice=So,Z.sortBy=oh,Z.sortedUniq=$o,Z.sortedUniqBy=Do,Z.split=da,Z.spread=$f,Z.tail=Mo,Z.take=Fo,Z.takeRight=No,Z.takeRightWhile=Po,Z.takeWhile=qo,Z.tap=Xo,Z.throttle=Df,Z.thru=nf,Z.toArray=jc,Z.toPairs=Ph,Z.toPairsIn=qh,Z.toPath=Ha,Z.toPlainObject=Rc,Z.transform=Qc,Z.unary=Mf,Z.union=Ps,Z.unionBy=qs,Z.unionWith=Zs,Z.uniq=Zo,Z.uniqBy=Ko,Z.uniqWith=Vo,Z.unset=Xc,Z.unzip=Go,Z.unzipWith=Ho,Z.update=na,Z.updateWith=ta,Z.values=ra,Z.valuesIn=ea,
Z.without=Ks,Z.words=Ra,Z.wrap=Ff,Z.xor=Vs,Z.xorBy=Gs,Z.xorWith=Hs,Z.zip=Js,Z.zipObject=Jo,Z.zipObjectDeep=Yo,Z.zipWith=Ys,Z.entries=Ph,Z.entriesIn=qh,Z.extend=Eh,Z.extendWith=Sh,Ta(Z,Z),Z.add=lp,Z.attempt=Xh,Z.camelCase=Zh,Z.capitalize=fa,Z.ceil=sp,Z.clamp=ua,Z.clone=Pf,Z.cloneDeep=Zf,Z.cloneDeepWith=Kf,Z.cloneWith=qf,Z.conformsTo=Vf,Z.deburr=ca,Z.defaultTo=Wa,Z.divide=hp,Z.endsWith=aa,Z.eq=Gf,Z.escape=la,Z.escapeRegExp=sa,Z.every=af,Z.find=nh,Z.findIndex=ho,Z.findKey=Wc,Z.findLast=th,Z.findLastIndex=po,
Z.findLastKey=Lc,Z.floor=pp,Z.forEach=_f,Z.forEachRight=vf,Z.forIn=Cc,Z.forInRight=Uc,Z.forOwn=Bc,Z.forOwnRight=Tc,Z.get=Mc,Z.gt=gh,Z.gte=yh,Z.has=Fc,Z.hasIn=Nc,Z.head=bo,Z.identity=La,Z.includes=gf,Z.indexOf=wo,Z.inRange=ia,Z.invoke=$h,Z.isArguments=dh,Z.isArray=bh,Z.isArrayBuffer=wh,Z.isArrayLike=Hf,Z.isArrayLikeObject=Jf,Z.isBoolean=Yf,Z.isBuffer=mh,Z.isDate=xh,Z.isElement=Qf,Z.isEmpty=Xf,Z.isEqual=nc,Z.isEqualWith=tc,Z.isError=rc,Z.isFinite=ec,Z.isFunction=uc,Z.isInteger=ic,Z.isLength=oc,Z.isMap=jh,
Z.isMatch=ac,Z.isMatchWith=lc,Z.isNaN=sc,Z.isNative=hc,Z.isNil=_c,Z.isNull=pc,Z.isNumber=vc,Z.isObject=fc,Z.isObjectLike=cc,Z.isPlainObject=gc,Z.isRegExp=Ah,Z.isSafeInteger=yc,Z.isSet=kh,Z.isString=dc,Z.isSymbol=bc,Z.isTypedArray=Ih,Z.isUndefined=wc,Z.isWeakMap=mc,Z.isWeakSet=xc,Z.join=xo,Z.kebabCase=Kh,Z.last=jo,Z.lastIndexOf=Ao,Z.lowerCase=Vh,Z.lowerFirst=Gh,Z.lt=Oh,Z.lte=Rh,Z.max=Ya,Z.maxBy=Qa,Z.mean=Xa,Z.meanBy=nl,Z.min=tl,Z.minBy=rl,Z.stubArray=Pa,Z.stubFalse=qa,Z.stubObject=Za,Z.stubString=Ka,
Z.stubTrue=Va,Z.multiply=_p,Z.nth=ko,Z.noConflict=$a,Z.noop=Da,Z.now=fh,Z.pad=ha,Z.padEnd=pa,Z.padStart=_a,Z.parseInt=va,Z.random=oa,Z.reduce=bf,Z.reduceRight=wf,Z.repeat=ga,Z.replace=ya,Z.result=Hc,Z.round=vp,Z.runInContext=p,Z.sample=xf,Z.size=kf,Z.snakeCase=Hh,Z.some=If,Z.sortedIndex=Wo,Z.sortedIndexBy=Lo,Z.sortedIndexOf=Co,Z.sortedLastIndex=Uo,Z.sortedLastIndexBy=Bo,Z.sortedLastIndexOf=To,Z.startCase=Jh,Z.startsWith=ba,Z.subtract=gp,Z.sum=el,Z.sumBy=ul,Z.template=wa,Z.times=Ga,Z.toFinite=Ac,Z.toInteger=kc,
Z.toLength=Ic,Z.toLower=ma,Z.toNumber=Oc,Z.toSafeInteger=zc,Z.toString=Ec,Z.toUpper=xa,Z.trim=ja,Z.trimEnd=Aa,Z.trimStart=ka,Z.truncate=Ia,Z.unescape=Oa,Z.uniqueId=Ja,Z.upperCase=Yh,Z.upperFirst=Qh,Z.each=_f,Z.eachRight=vf,Z.first=bo,Ta(Z,function(){var n={};return ue(Z,function(t,r){bl.call(Z.prototype,r)||(n[r]=t)}),n}(),{chain:false}),Z.VERSION=nn,r(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){Z[n].placeholder=Z}),r(["drop","take"],function(n,t){Ut.prototype[n]=function(r){
r=r===X?1:Gl(kc(r),0);var e=this.__filtered__&&!t?new Ut(this):this.clone();return e.__filtered__?e.__takeCount__=Hl(r,e.__takeCount__):e.__views__.push({size:Hl(r,Bn),type:n+(e.__dir__<0?"Right":"")}),e},Ut.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){var r=t+1,e=r==zn||r==Sn;Ut.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:mi(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){
var r="take"+(t?"Right":"");Ut.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Ut.prototype[n]=function(){return this.__filtered__?new Ut(this):this[r](1)}}),Ut.prototype.compact=function(){return this.filter(La)},Ut.prototype.find=function(n){return this.filter(n).head()},Ut.prototype.findLast=function(n){return this.reverse().find(n)},Ut.prototype.invokeMap=uu(function(n,t){return typeof n=="function"?new Ut(this):this.map(function(r){
return Oe(r,n,t)})}),Ut.prototype.reject=function(n){return this.filter(Uf(mi(n)))},Ut.prototype.slice=function(n,t){n=kc(n);var r=this;return r.__filtered__&&(n>0||t<0)?new Ut(r):(n<0?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==X&&(t=kc(t),r=t<0?r.dropRight(-t):r.take(t-n)),r)},Ut.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Ut.prototype.toArray=function(){return this.take(Bn)},ue(Ut.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=Z[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);
u&&(Z.prototype[t]=function(){var t=this.__wrapped__,o=e?[1]:arguments,f=t instanceof Ut,c=o[0],l=f||bh(t),s=function(n){var t=u.apply(Z,a([n],o));return e&&h?t[0]:t};l&&r&&typeof c=="function"&&1!=c.length&&(f=l=false);var h=this.__chain__,p=!!this.__actions__.length,_=i&&!h,v=f&&!p;if(!i&&l){t=v?t:new Ut(this);var g=n.apply(t,o);return g.__actions__.push({func:nf,args:[s],thisArg:X}),new Y(g,h)}return _&&v?n.apply(this,o):(g=this.thru(s),_?e?g.value()[0]:g.value():g)})}),r(["pop","push","shift","sort","splice","unshift"],function(n){
var t=_l[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);Z.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(bh(u)?u:[],n)}return this[r](function(r){return t.apply(bh(r)?r:[],n)})}}),ue(Ut.prototype,function(n,t){var r=Z[t];if(r){var e=r.name+"";bl.call(fs,e)||(fs[e]=[]),fs[e].push({name:t,func:r})}}),fs[Qu(X,gn).name]=[{name:"wrapper",func:X}],Ut.prototype.clone=Dt,Ut.prototype.reverse=Qt,Ut.prototype.value=Xt,Z.prototype.at=Qs,
Z.prototype.chain=tf,Z.prototype.commit=rf,Z.prototype.next=ef,Z.prototype.plant=of,Z.prototype.reverse=ff,Z.prototype.toJSON=Z.prototype.valueOf=Z.prototype.value=cf,Z.prototype.first=Z.prototype.head,Ul&&(Z.prototype[Ul]=uf),Z},be=de();typeof define=="function"&&typeof define.amd=="object"&&define.amd?(re._=be, define(function(){return be})):ue?((ue.exports=be)._=be,ee._=be):re._=be}).call(this);
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.moment=t()}(this,function(){"use strict";var H;function _(){return H.apply(null,arguments)}function y(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function F(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function c(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function L(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;for(var t in e)if(c(e,t))return;return 1}function g(e){return void 0===e}function w(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function V(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function G(e,t){for(var n=[],s=e.length,i=0;i<s;++i)n.push(t(e[i],i));return n}function E(e,t){for(var n in t)c(t,n)&&(e[n]=t[n]);return c(t,"toString")&&(e.toString=t.toString),c(t,"valueOf")&&(e.valueOf=t.valueOf),e}function l(e,t,n,s){return Wt(e,t,n,s,!0).utc()}function p(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function A(e){var t,n,s=e._d&&!isNaN(e._d.getTime());return s&&(t=p(e),n=j.call(t.parsedDateParts,function(e){return null!=e}),s=t.overflow<0&&!t.empty&&!t.invalidEra&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n),e._strict)&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e)?s:(e._isValid=s,e._isValid)}function I(e){var t=l(NaN);return null!=e?E(p(t),e):p(t).userInvalidated=!0,t}var j=Array.prototype.some||function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1},Z=_.momentProperties=[],z=!1;function q(e,t){var n,s,i,r=Z.length;if(g(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),g(t._i)||(e._i=t._i),g(t._f)||(e._f=t._f),g(t._l)||(e._l=t._l),g(t._strict)||(e._strict=t._strict),g(t._tzm)||(e._tzm=t._tzm),g(t._isUTC)||(e._isUTC=t._isUTC),g(t._offset)||(e._offset=t._offset),g(t._pf)||(e._pf=p(t)),g(t._locale)||(e._locale=t._locale),0<r)for(n=0;n<r;n++)g(i=t[s=Z[n]])||(e[s]=i);return e}function $(e){q(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===z&&(z=!0,_.updateOffset(this),z=!1)}function k(e){return e instanceof $||null!=e&&null!=e._isAMomentObject}function B(e){!1===_.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function e(r,a){var o=!0;return E(function(){if(null!=_.deprecationHandler&&_.deprecationHandler(null,r),o){for(var e,t,n=[],s=arguments.length,i=0;i<s;i++){if(e="","object"==typeof arguments[i]){for(t in e+="\n["+i+"] ",arguments[0])c(arguments[0],t)&&(e+=t+": "+arguments[0][t]+", ");e=e.slice(0,-2)}else e=arguments[i];n.push(e)}B(r+"\nArguments: "+Array.prototype.slice.call(n).join("")+"\n"+(new Error).stack),o=!1}return a.apply(this,arguments)},a)}var J={};function Q(e,t){null!=_.deprecationHandler&&_.deprecationHandler(e,t),J[e]||(B(t),J[e]=!0)}function a(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function X(e,t){var n,s=E({},e);for(n in t)c(t,n)&&(F(e[n])&&F(t[n])?(s[n]={},E(s[n],e[n]),E(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)c(e,n)&&!c(t,n)&&F(e[n])&&(s[n]=E({},s[n]));return s}function K(e){null!=e&&this.set(e)}_.suppressDeprecationWarnings=!1,_.deprecationHandler=null;var ee=Object.keys||function(e){var t,n=[];for(t in e)c(e,t)&&n.push(t);return n};function r(e,t,n){var s=""+Math.abs(e);return(0<=e?n?"+":"":"-")+Math.pow(10,Math.max(0,t-s.length)).toString().substr(1)+s}var te=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,ne=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,se={},ie={};function s(e,t,n,s){var i="string"==typeof s?function(){return this[s]()}:s;e&&(ie[e]=i),t&&(ie[t[0]]=function(){return r(i.apply(this,arguments),t[1],t[2])}),n&&(ie[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function re(e,t){return e.isValid()?(t=ae(t,e.localeData()),se[t]=se[t]||function(s){for(var e,i=s.match(te),t=0,r=i.length;t<r;t++)ie[i[t]]?i[t]=ie[i[t]]:i[t]=(e=i[t]).match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"");return function(e){for(var t="",n=0;n<r;n++)t+=a(i[n])?i[n].call(e,s):i[n];return t}}(t),se[t](e)):e.localeData().invalidDate()}function ae(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(ne.lastIndex=0;0<=n&&ne.test(e);)e=e.replace(ne,s),ne.lastIndex=0,--n;return e}var oe={D:"date",dates:"date",date:"date",d:"day",days:"day",day:"day",e:"weekday",weekdays:"weekday",weekday:"weekday",E:"isoWeekday",isoweekdays:"isoWeekday",isoweekday:"isoWeekday",DDD:"dayOfYear",dayofyears:"dayOfYear",dayofyear:"dayOfYear",h:"hour",hours:"hour",hour:"hour",ms:"millisecond",milliseconds:"millisecond",millisecond:"millisecond",m:"minute",minutes:"minute",minute:"minute",M:"month",months:"month",month:"month",Q:"quarter",quarters:"quarter",quarter:"quarter",s:"second",seconds:"second",second:"second",gg:"weekYear",weekyears:"weekYear",weekyear:"weekYear",GG:"isoWeekYear",isoweekyears:"isoWeekYear",isoweekyear:"isoWeekYear",w:"week",weeks:"week",week:"week",W:"isoWeek",isoweeks:"isoWeek",isoweek:"isoWeek",y:"year",years:"year",year:"year"};function o(e){return"string"==typeof e?oe[e]||oe[e.toLowerCase()]:void 0}function ue(e){var t,n,s={};for(n in e)c(e,n)&&(t=o(n))&&(s[t]=e[n]);return s}var le={date:9,day:11,weekday:11,isoWeekday:11,dayOfYear:4,hour:13,millisecond:16,minute:14,month:8,quarter:7,second:15,weekYear:1,isoWeekYear:1,week:5,isoWeek:5,year:1};var de=/\d/,t=/\d\d/,he=/\d{3}/,ce=/\d{4}/,fe=/[+-]?\d{6}/,n=/\d\d?/,me=/\d\d\d\d?/,_e=/\d\d\d\d\d\d?/,ye=/\d{1,3}/,ge=/\d{1,4}/,we=/[+-]?\d{1,6}/,pe=/\d+/,ke=/[+-]?\d+/,Me=/Z|[+-]\d\d:?\d\d/gi,ve=/Z|[+-]\d\d(?::?\d\d)?/gi,i=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,u=/^[1-9]\d?/,d=/^([1-9]\d|\d)/;function h(e,n,s){Ye[e]=a(n)?n:function(e,t){return e&&s?s:n}}function De(e,t){return c(Ye,e)?Ye[e](t._strict,t._locale):new RegExp(f(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function f(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function m(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function M(e){var e=+e,t=0;return t=0!=e&&isFinite(e)?m(e):t}var Ye={},Se={};function v(e,n){var t,s,i=n;for("string"==typeof e&&(e=[e]),w(n)&&(i=function(e,t){t[n]=M(e)}),s=e.length,t=0;t<s;t++)Se[e[t]]=i}function Oe(e,i){v(e,function(e,t,n,s){n._w=n._w||{},i(e,n._w,n,s)})}function be(e){return e%4==0&&e%100!=0||e%400==0}var D=0,Y=1,S=2,O=3,b=4,T=5,Te=6,xe=7,Ne=8;function We(e){return be(e)?366:365}s("Y",0,0,function(){var e=this.year();return e<=9999?r(e,4):"+"+e}),s(0,["YY",2],0,function(){return this.year()%100}),s(0,["YYYY",4],0,"year"),s(0,["YYYYY",5],0,"year"),s(0,["YYYYYY",6,!0],0,"year"),h("Y",ke),h("YY",n,t),h("YYYY",ge,ce),h("YYYYY",we,fe),h("YYYYYY",we,fe),v(["YYYYY","YYYYYY"],D),v("YYYY",function(e,t){t[D]=2===e.length?_.parseTwoDigitYear(e):M(e)}),v("YY",function(e,t){t[D]=_.parseTwoDigitYear(e)}),v("Y",function(e,t){t[D]=parseInt(e,10)}),_.parseTwoDigitYear=function(e){return M(e)+(68<M(e)?1900:2e3)};var x,Pe=Re("FullYear",!0);function Re(t,n){return function(e){return null!=e?(Ue(this,t,e),_.updateOffset(this,n),this):Ce(this,t)}}function Ce(e,t){if(!e.isValid())return NaN;var n=e._d,s=e._isUTC;switch(t){case"Milliseconds":return s?n.getUTCMilliseconds():n.getMilliseconds();case"Seconds":return s?n.getUTCSeconds():n.getSeconds();case"Minutes":return s?n.getUTCMinutes():n.getMinutes();case"Hours":return s?n.getUTCHours():n.getHours();case"Date":return s?n.getUTCDate():n.getDate();case"Day":return s?n.getUTCDay():n.getDay();case"Month":return s?n.getUTCMonth():n.getMonth();case"FullYear":return s?n.getUTCFullYear():n.getFullYear();default:return NaN}}function Ue(e,t,n){var s,i,r;if(e.isValid()&&!isNaN(n)){switch(s=e._d,i=e._isUTC,t){case"Milliseconds":return i?s.setUTCMilliseconds(n):s.setMilliseconds(n);case"Seconds":return i?s.setUTCSeconds(n):s.setSeconds(n);case"Minutes":return i?s.setUTCMinutes(n):s.setMinutes(n);case"Hours":return i?s.setUTCHours(n):s.setHours(n);case"Date":return i?s.setUTCDate(n):s.setDate(n);case"FullYear":break;default:return}t=n,r=e.month(),e=29!==(e=e.date())||1!==r||be(t)?e:28,i?s.setUTCFullYear(t,r,e):s.setFullYear(t,r,e)}}function He(e,t){var n;return isNaN(e)||isNaN(t)?NaN:(n=(t%(n=12)+n)%n,e+=(t-n)/12,1==n?be(e)?29:28:31-n%7%2)}x=Array.prototype.indexOf||function(e){for(var t=0;t<this.length;++t)if(this[t]===e)return t;return-1},s("M",["MM",2],"Mo",function(){return this.month()+1}),s("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),s("MMMM",0,0,function(e){return this.localeData().months(this,e)}),h("M",n,u),h("MM",n,t),h("MMM",function(e,t){return t.monthsShortRegex(e)}),h("MMMM",function(e,t){return t.monthsRegex(e)}),v(["M","MM"],function(e,t){t[Y]=M(e)-1}),v(["MMM","MMMM"],function(e,t,n,s){s=n._locale.monthsParse(e,s,n._strict);null!=s?t[Y]=s:p(n).invalidMonth=e});var Fe="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Le="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Ve=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Ge=i,Ee=i;function Ae(e,t){if(e.isValid()){if("string"==typeof t)if(/^\d+$/.test(t))t=M(t);else if(!w(t=e.localeData().monthsParse(t)))return;var n=(n=e.date())<29?n:Math.min(n,He(e.year(),t));e._isUTC?e._d.setUTCMonth(t,n):e._d.setMonth(t,n)}}function Ie(e){return null!=e?(Ae(this,e),_.updateOffset(this,!0),this):Ce(this,"Month")}function je(){function e(e,t){return t.length-e.length}for(var t,n,s=[],i=[],r=[],a=0;a<12;a++)n=l([2e3,a]),t=f(this.monthsShort(n,"")),n=f(this.months(n,"")),s.push(t),i.push(n),r.push(n),r.push(t);s.sort(e),i.sort(e),r.sort(e),this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function Ze(e,t,n,s,i,r,a){var o;return e<100&&0<=e?(o=new Date(e+400,t,n,s,i,r,a),isFinite(o.getFullYear())&&o.setFullYear(e)):o=new Date(e,t,n,s,i,r,a),o}function ze(e){var t;return e<100&&0<=e?((t=Array.prototype.slice.call(arguments))[0]=e+400,t=new Date(Date.UTC.apply(null,t)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)):t=new Date(Date.UTC.apply(null,arguments)),t}function qe(e,t,n){n=7+t-n;return n-(7+ze(e,0,n).getUTCDay()-t)%7-1}function $e(e,t,n,s,i){var r,t=1+7*(t-1)+(7+n-s)%7+qe(e,s,i),n=t<=0?We(r=e-1)+t:t>We(e)?(r=e+1,t-We(e)):(r=e,t);return{year:r,dayOfYear:n}}function Be(e,t,n){var s,i,r=qe(e.year(),t,n),r=Math.floor((e.dayOfYear()-r-1)/7)+1;return r<1?s=r+N(i=e.year()-1,t,n):r>N(e.year(),t,n)?(s=r-N(e.year(),t,n),i=e.year()+1):(i=e.year(),s=r),{week:s,year:i}}function N(e,t,n){var s=qe(e,t,n),t=qe(e+1,t,n);return(We(e)-s+t)/7}s("w",["ww",2],"wo","week"),s("W",["WW",2],"Wo","isoWeek"),h("w",n,u),h("ww",n,t),h("W",n,u),h("WW",n,t),Oe(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=M(e)});function Je(e,t){return e.slice(t,7).concat(e.slice(0,t))}s("d",0,"do","day"),s("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),s("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),s("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),s("e",0,0,"weekday"),s("E",0,0,"isoWeekday"),h("d",n),h("e",n),h("E",n),h("dd",function(e,t){return t.weekdaysMinRegex(e)}),h("ddd",function(e,t){return t.weekdaysShortRegex(e)}),h("dddd",function(e,t){return t.weekdaysRegex(e)}),Oe(["dd","ddd","dddd"],function(e,t,n,s){s=n._locale.weekdaysParse(e,s,n._strict);null!=s?t.d=s:p(n).invalidWeekday=e}),Oe(["d","e","E"],function(e,t,n,s){t[s]=M(e)});var Qe="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Xe="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Ke="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),et=i,tt=i,nt=i;function st(){function e(e,t){return t.length-e.length}for(var t,n,s,i=[],r=[],a=[],o=[],u=0;u<7;u++)s=l([2e3,1]).day(u),t=f(this.weekdaysMin(s,"")),n=f(this.weekdaysShort(s,"")),s=f(this.weekdays(s,"")),i.push(t),r.push(n),a.push(s),o.push(t),o.push(n),o.push(s);i.sort(e),r.sort(e),a.sort(e),o.sort(e),this._weekdaysRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+r.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+i.join("|")+")","i")}function it(){return this.hours()%12||12}function rt(e,t){s(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function at(e,t){return t._meridiemParse}s("H",["HH",2],0,"hour"),s("h",["hh",2],0,it),s("k",["kk",2],0,function(){return this.hours()||24}),s("hmm",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)}),s("hmmss",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)+r(this.seconds(),2)}),s("Hmm",0,0,function(){return""+this.hours()+r(this.minutes(),2)}),s("Hmmss",0,0,function(){return""+this.hours()+r(this.minutes(),2)+r(this.seconds(),2)}),rt("a",!0),rt("A",!1),h("a",at),h("A",at),h("H",n,d),h("h",n,u),h("k",n,u),h("HH",n,t),h("hh",n,t),h("kk",n,t),h("hmm",me),h("hmmss",_e),h("Hmm",me),h("Hmmss",_e),v(["H","HH"],O),v(["k","kk"],function(e,t,n){e=M(e);t[O]=24===e?0:e}),v(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),v(["h","hh"],function(e,t,n){t[O]=M(e),p(n).bigHour=!0}),v("hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s)),p(n).bigHour=!0}),v("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i)),p(n).bigHour=!0}),v("Hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s))}),v("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i))});i=Re("Hours",!0);var ot,ut={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Fe,monthsShort:Le,week:{dow:0,doy:6},weekdays:Qe,weekdaysMin:Ke,weekdaysShort:Xe,meridiemParse:/[ap]\.?m?\.?/i},W={},lt={};function dt(e){return e&&e.toLowerCase().replace("_","-")}function ht(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=dt(e[r]).split("-")).length,n=(n=dt(e[r+1]))?n.split("-"):null;0<t;){if(s=ct(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&function(e,t){for(var n=Math.min(e.length,t.length),s=0;s<n;s+=1)if(e[s]!==t[s])return s;return n}(i,n)>=t-1)break;t--}r++}return ot}function ct(t){var e,n;if(void 0===W[t]&&"undefined"!=typeof module&&module&&module.exports&&(n=t)&&n.match("^[^/\\\\]*$"))try{e=ot._abbr,require("./locale/"+t),ft(e)}catch(e){W[t]=null}return W[t]}function ft(e,t){return e&&((t=g(t)?P(e):mt(e,t))?ot=t:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),ot._abbr}function mt(e,t){if(null===t)return delete W[e],null;var n,s=ut;if(t.abbr=e,null!=W[e])Q("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=W[e]._config;else if(null!=t.parentLocale)if(null!=W[t.parentLocale])s=W[t.parentLocale]._config;else{if(null==(n=ct(t.parentLocale)))return lt[t.parentLocale]||(lt[t.parentLocale]=[]),lt[t.parentLocale].push({name:e,config:t}),null;s=n._config}return W[e]=new K(X(s,t)),lt[e]&&lt[e].forEach(function(e){mt(e.name,e.config)}),ft(e),W[e]}function P(e){var t;if(!(e=e&&e._locale&&e._locale._abbr?e._locale._abbr:e))return ot;if(!y(e)){if(t=ct(e))return t;e=[e]}return ht(e)}function _t(e){var t=e._a;return t&&-2===p(e).overflow&&(t=t[Y]<0||11<t[Y]?Y:t[S]<1||t[S]>He(t[D],t[Y])?S:t[O]<0||24<t[O]||24===t[O]&&(0!==t[b]||0!==t[T]||0!==t[Te])?O:t[b]<0||59<t[b]?b:t[T]<0||59<t[T]?T:t[Te]<0||999<t[Te]?Te:-1,p(e)._overflowDayOfYear&&(t<D||S<t)&&(t=S),p(e)._overflowWeeks&&-1===t&&(t=xe),p(e)._overflowWeekday&&-1===t&&(t=Ne),p(e).overflow=t),e}var yt=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,gt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,wt=/Z|[+-]\d\d(?::?\d\d)?/,pt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],kt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Mt=/^\/?Date\((-?\d+)/i,vt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,Dt={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Yt(e){var t,n,s,i,r,a,o=e._i,u=yt.exec(o)||gt.exec(o),o=pt.length,l=kt.length;if(u){for(p(e).iso=!0,t=0,n=o;t<n;t++)if(pt[t][1].exec(u[1])){i=pt[t][0],s=!1!==pt[t][2];break}if(null==i)e._isValid=!1;else{if(u[3]){for(t=0,n=l;t<n;t++)if(kt[t][1].exec(u[3])){r=(u[2]||" ")+kt[t][0];break}if(null==r)return void(e._isValid=!1)}if(s||null==r){if(u[4]){if(!wt.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),xt(e)}else e._isValid=!1}}else e._isValid=!1}function St(e,t,n,s,i,r){e=[function(e){e=parseInt(e,10);{if(e<=49)return 2e3+e;if(e<=999)return 1900+e}return e}(e),Le.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&e.push(parseInt(r,10)),e}function Ot(e){var t,n,s=vt.exec(e._i.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));s?(t=St(s[4],s[3],s[2],s[5],s[6],s[7]),function(e,t,n){if(!e||Xe.indexOf(e)===new Date(t[0],t[1],t[2]).getDay())return 1;p(n).weekdayMismatch=!0,n._isValid=!1}(s[1],t,e)&&(e._a=t,e._tzm=(t=s[8],n=s[9],s=s[10],t?Dt[t]:n?0:60*(((t=parseInt(s,10))-(n=t%100))/100)+n),e._d=ze.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),p(e).rfc2822=!0)):e._isValid=!1}function bt(e,t,n){return null!=e?e:null!=t?t:n}function Tt(e){var t,n,s,i,r,a,o,u,l,d,h,c=[];if(!e._d){for(s=e,i=new Date(_.now()),n=s._useUTC?[i.getUTCFullYear(),i.getUTCMonth(),i.getUTCDate()]:[i.getFullYear(),i.getMonth(),i.getDate()],e._w&&null==e._a[S]&&null==e._a[Y]&&(null!=(i=(s=e)._w).GG||null!=i.W||null!=i.E?(u=1,l=4,r=bt(i.GG,s._a[D],Be(R(),1,4).year),a=bt(i.W,1),((o=bt(i.E,1))<1||7<o)&&(d=!0)):(u=s._locale._week.dow,l=s._locale._week.doy,h=Be(R(),u,l),r=bt(i.gg,s._a[D],h.year),a=bt(i.w,h.week),null!=i.d?((o=i.d)<0||6<o)&&(d=!0):null!=i.e?(o=i.e+u,(i.e<0||6<i.e)&&(d=!0)):o=u),a<1||a>N(r,u,l)?p(s)._overflowWeeks=!0:null!=d?p(s)._overflowWeekday=!0:(h=$e(r,a,o,u,l),s._a[D]=h.year,s._dayOfYear=h.dayOfYear)),null!=e._dayOfYear&&(i=bt(e._a[D],n[D]),(e._dayOfYear>We(i)||0===e._dayOfYear)&&(p(e)._overflowDayOfYear=!0),d=ze(i,0,e._dayOfYear),e._a[Y]=d.getUTCMonth(),e._a[S]=d.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=c[t]=n[t];for(;t<7;t++)e._a[t]=c[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[O]&&0===e._a[b]&&0===e._a[T]&&0===e._a[Te]&&(e._nextDay=!0,e._a[O]=0),e._d=(e._useUTC?ze:Ze).apply(null,c),r=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[O]=24),e._w&&void 0!==e._w.d&&e._w.d!==r&&(p(e).weekdayMismatch=!0)}}function xt(e){if(e._f===_.ISO_8601)Yt(e);else if(e._f===_.RFC_2822)Ot(e);else{e._a=[],p(e).empty=!0;for(var t,n,s,i,r,a=""+e._i,o=a.length,u=0,l=ae(e._f,e._locale).match(te)||[],d=l.length,h=0;h<d;h++)n=l[h],(t=(a.match(De(n,e))||[])[0])&&(0<(s=a.substr(0,a.indexOf(t))).length&&p(e).unusedInput.push(s),a=a.slice(a.indexOf(t)+t.length),u+=t.length),ie[n]?(t?p(e).empty=!1:p(e).unusedTokens.push(n),s=n,r=e,null!=(i=t)&&c(Se,s)&&Se[s](i,r._a,r,s)):e._strict&&!t&&p(e).unusedTokens.push(n);p(e).charsLeftOver=o-u,0<a.length&&p(e).unusedInput.push(a),e._a[O]<=12&&!0===p(e).bigHour&&0<e._a[O]&&(p(e).bigHour=void 0),p(e).parsedDateParts=e._a.slice(0),p(e).meridiem=e._meridiem,e._a[O]=function(e,t,n){if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((e=e.isPM(n))&&t<12&&(t+=12),t=e||12!==t?t:0):t}(e._locale,e._a[O],e._meridiem),null!==(o=p(e).era)&&(e._a[D]=e._locale.erasConvertYear(o,e._a[D])),Tt(e),_t(e)}}function Nt(e){var t,n,s,i=e._i,r=e._f;if(e._locale=e._locale||P(e._l),null===i||void 0===r&&""===i)return I({nullInput:!0});if("string"==typeof i&&(e._i=i=e._locale.preparse(i)),k(i))return new $(_t(i));if(V(i))e._d=i;else if(y(r)){var a,o,u,l,d,h,c=e,f=!1,m=c._f.length;if(0===m)p(c).invalidFormat=!0,c._d=new Date(NaN);else{for(l=0;l<m;l++)d=0,h=!1,a=q({},c),null!=c._useUTC&&(a._useUTC=c._useUTC),a._f=c._f[l],xt(a),A(a)&&(h=!0),d=(d+=p(a).charsLeftOver)+10*p(a).unusedTokens.length,p(a).score=d,f?d<u&&(u=d,o=a):(null==u||d<u||h)&&(u=d,o=a,h)&&(f=!0);E(c,o||a)}}else if(r)xt(e);else if(g(r=(i=e)._i))i._d=new Date(_.now());else V(r)?i._d=new Date(r.valueOf()):"string"==typeof r?(n=i,null!==(t=Mt.exec(n._i))?n._d=new Date(+t[1]):(Yt(n),!1===n._isValid&&(delete n._isValid,Ot(n),!1===n._isValid)&&(delete n._isValid,n._strict?n._isValid=!1:_.createFromInputFallback(n)))):y(r)?(i._a=G(r.slice(0),function(e){return parseInt(e,10)}),Tt(i)):F(r)?(t=i)._d||(s=void 0===(n=ue(t._i)).day?n.date:n.day,t._a=G([n.year,n.month,s,n.hour,n.minute,n.second,n.millisecond],function(e){return e&&parseInt(e,10)}),Tt(t)):w(r)?i._d=new Date(r):_.createFromInputFallback(i);return A(e)||(e._d=null),e}function Wt(e,t,n,s,i){var r={};return!0!==t&&!1!==t||(s=t,t=void 0),!0!==n&&!1!==n||(s=n,n=void 0),(F(e)&&L(e)||y(e)&&0===e.length)&&(e=void 0),r._isAMomentObject=!0,r._useUTC=r._isUTC=i,r._l=n,r._i=e,r._f=t,r._strict=s,(i=new $(_t(Nt(i=r))))._nextDay&&(i.add(1,"d"),i._nextDay=void 0),i}function R(e,t,n,s){return Wt(e,t,n,s,!1)}_.createFromInputFallback=e("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),_.ISO_8601=function(){},_.RFC_2822=function(){};me=e("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:I()}),_e=e("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:I()});function Pt(e,t){var n,s;if(!(t=1===t.length&&y(t[0])?t[0]:t).length)return R();for(n=t[0],s=1;s<t.length;++s)t[s].isValid()&&!t[s][e](n)||(n=t[s]);return n}var Rt=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ct(e){var e=ue(e),t=e.year||0,n=e.quarter||0,s=e.month||0,i=e.week||e.isoWeek||0,r=e.day||0,a=e.hour||0,o=e.minute||0,u=e.second||0,l=e.millisecond||0;this._isValid=function(e){var t,n,s=!1,i=Rt.length;for(t in e)if(c(e,t)&&(-1===x.call(Rt,t)||null!=e[t]&&isNaN(e[t])))return!1;for(n=0;n<i;++n)if(e[Rt[n]]){if(s)return!1;parseFloat(e[Rt[n]])!==M(e[Rt[n]])&&(s=!0)}return!0}(e),this._milliseconds=+l+1e3*u+6e4*o+1e3*a*60*60,this._days=+r+7*i,this._months=+s+3*n+12*t,this._data={},this._locale=P(),this._bubble()}function Ut(e){return e instanceof Ct}function Ht(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ft(e,n){s(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+r(~~(e/60),2)+n+r(~~e%60,2)})}Ft("Z",":"),Ft("ZZ",""),h("Z",ve),h("ZZ",ve),v(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Vt(ve,e)});var Lt=/([\+\-]|\d\d)/gi;function Vt(e,t){var t=(t||"").match(e);return null===t?null:0===(t=60*(e=((t[t.length-1]||[])+"").match(Lt)||["-",0,0])[1]+M(e[2]))?0:"+"===e[0]?t:-t}function Gt(e,t){var n;return t._isUTC?(t=t.clone(),n=(k(e)||V(e)?e:R(e)).valueOf()-t.valueOf(),t._d.setTime(t._d.valueOf()+n),_.updateOffset(t,!1),t):R(e).local()}function Et(e){return-Math.round(e._d.getTimezoneOffset())}function At(){return!!this.isValid()&&this._isUTC&&0===this._offset}_.updateOffset=function(){};var It=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,jt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function C(e,t){var n,s=e;return Ut(e)?s={ms:e._milliseconds,d:e._days,M:e._months}:w(e)||!isNaN(+e)?(s={},t?s[t]=+e:s.milliseconds=+e):(t=It.exec(e))?(n="-"===t[1]?-1:1,s={y:0,d:M(t[S])*n,h:M(t[O])*n,m:M(t[b])*n,s:M(t[T])*n,ms:M(Ht(1e3*t[Te]))*n}):(t=jt.exec(e))?(n="-"===t[1]?-1:1,s={y:Zt(t[2],n),M:Zt(t[3],n),w:Zt(t[4],n),d:Zt(t[5],n),h:Zt(t[6],n),m:Zt(t[7],n),s:Zt(t[8],n)}):null==s?s={}:"object"==typeof s&&("from"in s||"to"in s)&&(t=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Gt(t,e),e.isBefore(t)?n=zt(e,t):((n=zt(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(R(s.from),R(s.to)),(s={}).ms=t.milliseconds,s.M=t.months),n=new Ct(s),Ut(e)&&c(e,"_locale")&&(n._locale=e._locale),Ut(e)&&c(e,"_isValid")&&(n._isValid=e._isValid),n}function Zt(e,t){e=e&&parseFloat(e.replace(",","."));return(isNaN(e)?0:e)*t}function zt(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function qt(s,i){return function(e,t){var n;return null===t||isNaN(+t)||(Q(i,"moment()."+i+"(period, number) is deprecated. Please use moment()."+i+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),n=e,e=t,t=n),$t(this,C(e,t),s),this}}function $t(e,t,n,s){var i=t._milliseconds,r=Ht(t._days),t=Ht(t._months);e.isValid()&&(s=null==s||s,t&&Ae(e,Ce(e,"Month")+t*n),r&&Ue(e,"Date",Ce(e,"Date")+r*n),i&&e._d.setTime(e._d.valueOf()+i*n),s)&&_.updateOffset(e,r||t)}C.fn=Ct.prototype,C.invalid=function(){return C(NaN)};Fe=qt(1,"add"),Qe=qt(-1,"subtract");function Bt(e){return"string"==typeof e||e instanceof String}function Jt(e){return k(e)||V(e)||Bt(e)||w(e)||function(t){var e=y(t),n=!1;e&&(n=0===t.filter(function(e){return!w(e)&&Bt(t)}).length);return e&&n}(e)||function(e){var t,n,s=F(e)&&!L(e),i=!1,r=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],a=r.length;for(t=0;t<a;t+=1)n=r[t],i=i||c(e,n);return s&&i}(e)||null==e}function Qt(e,t){var n,s;return e.date()<t.date()?-Qt(t,e):-((n=12*(t.year()-e.year())+(t.month()-e.month()))+(t-(s=e.clone().add(n,"months"))<0?(t-s)/(s-e.clone().add(n-1,"months")):(t-s)/(e.clone().add(1+n,"months")-s)))||0}function Xt(e){return void 0===e?this._locale._abbr:(null!=(e=P(e))&&(this._locale=e),this)}_.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",_.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";Ke=e("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function Kt(){return this._locale}var en=126227808e5;function tn(e,t){return(e%t+t)%t}function nn(e,t,n){return e<100&&0<=e?new Date(e+400,t,n)-en:new Date(e,t,n).valueOf()}function sn(e,t,n){return e<100&&0<=e?Date.UTC(e+400,t,n)-en:Date.UTC(e,t,n)}function rn(e,t){return t.erasAbbrRegex(e)}function an(){for(var e,t,n,s=[],i=[],r=[],a=[],o=this.eras(),u=0,l=o.length;u<l;++u)e=f(o[u].name),t=f(o[u].abbr),n=f(o[u].narrow),i.push(e),s.push(t),r.push(n),a.push(e),a.push(t),a.push(n);this._erasRegex=new RegExp("^("+a.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+i.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+s.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+r.join("|")+")","i")}function on(e,t){s(0,[e,e.length],0,t)}function un(e,t,n,s,i){var r;return null==e?Be(this,s,i).year:(r=N(e,s,i),function(e,t,n,s,i){e=$e(e,t,n,s,i),t=ze(e.year,0,e.dayOfYear);return this.year(t.getUTCFullYear()),this.month(t.getUTCMonth()),this.date(t.getUTCDate()),this}.call(this,e,t=r<t?r:t,n,s,i))}s("N",0,0,"eraAbbr"),s("NN",0,0,"eraAbbr"),s("NNN",0,0,"eraAbbr"),s("NNNN",0,0,"eraName"),s("NNNNN",0,0,"eraNarrow"),s("y",["y",1],"yo","eraYear"),s("y",["yy",2],0,"eraYear"),s("y",["yyy",3],0,"eraYear"),s("y",["yyyy",4],0,"eraYear"),h("N",rn),h("NN",rn),h("NNN",rn),h("NNNN",function(e,t){return t.erasNameRegex(e)}),h("NNNNN",function(e,t){return t.erasNarrowRegex(e)}),v(["N","NN","NNN","NNNN","NNNNN"],function(e,t,n,s){s=n._locale.erasParse(e,s,n._strict);s?p(n).era=s:p(n).invalidEra=e}),h("y",pe),h("yy",pe),h("yyy",pe),h("yyyy",pe),h("yo",function(e,t){return t._eraYearOrdinalRegex||pe}),v(["y","yy","yyy","yyyy"],D),v(["yo"],function(e,t,n,s){var i;n._locale._eraYearOrdinalRegex&&(i=e.match(n._locale._eraYearOrdinalRegex)),n._locale.eraYearOrdinalParse?t[D]=n._locale.eraYearOrdinalParse(e,i):t[D]=parseInt(e,10)}),s(0,["gg",2],0,function(){return this.weekYear()%100}),s(0,["GG",2],0,function(){return this.isoWeekYear()%100}),on("gggg","weekYear"),on("ggggg","weekYear"),on("GGGG","isoWeekYear"),on("GGGGG","isoWeekYear"),h("G",ke),h("g",ke),h("GG",n,t),h("gg",n,t),h("GGGG",ge,ce),h("gggg",ge,ce),h("GGGGG",we,fe),h("ggggg",we,fe),Oe(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=M(e)}),Oe(["gg","GG"],function(e,t,n,s){t[s]=_.parseTwoDigitYear(e)}),s("Q",0,"Qo","quarter"),h("Q",de),v("Q",function(e,t){t[Y]=3*(M(e)-1)}),s("D",["DD",2],"Do","date"),h("D",n,u),h("DD",n,t),h("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),v(["D","DD"],S),v("Do",function(e,t){t[S]=M(e.match(n)[0])});ge=Re("Date",!0);s("DDD",["DDDD",3],"DDDo","dayOfYear"),h("DDD",ye),h("DDDD",he),v(["DDD","DDDD"],function(e,t,n){n._dayOfYear=M(e)}),s("m",["mm",2],0,"minute"),h("m",n,d),h("mm",n,t),v(["m","mm"],b);var ln,ce=Re("Minutes",!1),we=(s("s",["ss",2],0,"second"),h("s",n,d),h("ss",n,t),v(["s","ss"],T),Re("Seconds",!1));for(s("S",0,0,function(){return~~(this.millisecond()/100)}),s(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),s(0,["SSS",3],0,"millisecond"),s(0,["SSSS",4],0,function(){return 10*this.millisecond()}),s(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),s(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),s(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),s(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),s(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),h("S",ye,de),h("SS",ye,t),h("SSS",ye,he),ln="SSSS";ln.length<=9;ln+="S")h(ln,pe);function dn(e,t){t[Te]=M(1e3*("0."+e))}for(ln="S";ln.length<=9;ln+="S")v(ln,dn);fe=Re("Milliseconds",!1),s("z",0,0,"zoneAbbr"),s("zz",0,0,"zoneName");u=$.prototype;function hn(e){return e}u.add=Fe,u.calendar=function(e,t){1===arguments.length&&(arguments[0]?Jt(arguments[0])?(e=arguments[0],t=void 0):function(e){for(var t=F(e)&&!L(e),n=!1,s=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"],i=0;i<s.length;i+=1)n=n||c(e,s[i]);return t&&n}(arguments[0])&&(t=arguments[0],e=void 0):t=e=void 0);var e=e||R(),n=Gt(e,this).startOf("day"),n=_.calendarFormat(this,n)||"sameElse",t=t&&(a(t[n])?t[n].call(this,e):t[n]);return this.format(t||this.localeData().calendar(n,this,R(e)))},u.clone=function(){return new $(this)},u.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Gt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=o(t)){case"year":r=Qt(this,s)/12;break;case"month":r=Qt(this,s);break;case"quarter":r=Qt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:m(r)},u.endOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year()+1,0,1)-1;break;case"quarter":t=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=n(this.year(),this.month()+1,1)-1;break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=36e5-tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5)-1;break;case"minute":t=this._d.valueOf(),t+=6e4-tn(t,6e4)-1;break;case"second":t=this._d.valueOf(),t+=1e3-tn(t,1e3)-1;break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.format=function(e){return e=e||(this.isUtc()?_.defaultFormatUtc:_.defaultFormat),e=re(this,e),this.localeData().postformat(e)},u.from=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.fromNow=function(e){return this.from(R(),e)},u.to=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.toNow=function(e){return this.to(R(),e)},u.get=function(e){return a(this[e=o(e)])?this[e]():this},u.invalidAt=function(){return p(this).overflow},u.isAfter=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()>e.valueOf():e.valueOf()<this.clone().startOf(t).valueOf())},u.isBefore=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()<e.valueOf():this.clone().endOf(t).valueOf()<e.valueOf())},u.isBetween=function(e,t,n,s){return e=k(e)?e:R(e),t=k(t)?t:R(t),!!(this.isValid()&&e.isValid()&&t.isValid())&&("("===(s=s||"()")[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===s[1]?this.isBefore(t,n):!this.isAfter(t,n))},u.isSame=function(e,t){var e=k(e)?e:R(e);return!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()===e.valueOf():(e=e.valueOf(),this.clone().startOf(t).valueOf()<=e&&e<=this.clone().endOf(t).valueOf()))},u.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},u.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},u.isValid=function(){return A(this)},u.lang=Ke,u.locale=Xt,u.localeData=Kt,u.max=_e,u.min=me,u.parsingFlags=function(){return E({},p(this))},u.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t,n=[];for(t in e)c(e,t)&&n.push({unit:t,priority:le[t]});return n.sort(function(e,t){return e.priority-t.priority}),n}(e=ue(e)),s=n.length,i=0;i<s;i++)this[n[i].unit](e[n[i].unit]);else if(a(this[e=o(e)]))return this[e](t);return this},u.startOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year(),0,1);break;case"quarter":t=n(this.year(),this.month()-this.month()%3,1);break;case"month":t=n(this.year(),this.month(),1);break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=n(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5);break;case"minute":t=this._d.valueOf(),t-=tn(t,6e4);break;case"second":t=this._d.valueOf(),t-=tn(t,1e3);break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.subtract=Qe,u.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},u.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},u.toDate=function(){return new Date(this.valueOf())},u.toISOString=function(e){var t;return this.isValid()?(t=(e=!0!==e)?this.clone().utc():this).year()<0||9999<t.year()?re(t,e?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):a(Date.prototype.toISOString)?e?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",re(t,"Z")):re(t,e?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ"):null},u.inspect=function(){var e,t,n;return this.isValid()?(t="moment",e="",this.isLocal()||(t=0===this.utcOffset()?"moment.utc":"moment.parseZone",e="Z"),t="["+t+'("]',n=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",this.format(t+n+"-MM-DD[T]HH:mm:ss.SSS"+(e+'[")]'))):"moment.invalid(/* "+this._i+" */)"},"undefined"!=typeof Symbol&&null!=Symbol.for&&(u[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),u.toJSON=function(){return this.isValid()?this.toISOString():null},u.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},u.unix=function(){return Math.floor(this.valueOf()/1e3)},u.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},u.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},u.eraName=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].name;if(t[n].until<=e&&e<=t[n].since)return t[n].name}return""},u.eraNarrow=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].narrow;if(t[n].until<=e&&e<=t[n].since)return t[n].narrow}return""},u.eraAbbr=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].abbr;if(t[n].until<=e&&e<=t[n].since)return t[n].abbr}return""},u.eraYear=function(){for(var e,t,n=this.localeData().eras(),s=0,i=n.length;s<i;++s)if(e=n[s].since<=n[s].until?1:-1,t=this.clone().startOf("day").valueOf(),n[s].since<=t&&t<=n[s].until||n[s].until<=t&&t<=n[s].since)return(this.year()-_(n[s].since).year())*e+n[s].offset;return this.year()},u.year=Pe,u.isLeapYear=function(){return be(this.year())},u.weekYear=function(e){return un.call(this,e,this.week(),this.weekday()+this.localeData()._week.dow,this.localeData()._week.dow,this.localeData()._week.doy)},u.isoWeekYear=function(e){return un.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},u.quarter=u.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},u.month=Ie,u.daysInMonth=function(){return He(this.year(),this.month())},u.week=u.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},u.isoWeek=u.isoWeeks=function(e){var t=Be(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},u.weeksInYear=function(){var e=this.localeData()._week;return N(this.year(),e.dow,e.doy)},u.weeksInWeekYear=function(){var e=this.localeData()._week;return N(this.weekYear(),e.dow,e.doy)},u.isoWeeksInYear=function(){return N(this.year(),1,4)},u.isoWeeksInISOWeekYear=function(){return N(this.isoWeekYear(),1,4)},u.date=ge,u.day=u.days=function(e){var t,n,s;return this.isValid()?(t=Ce(this,"Day"),null!=e?(n=e,s=this.localeData(),e="string"!=typeof n?n:isNaN(n)?"number"==typeof(n=s.weekdaysParse(n))?n:null:parseInt(n,10),this.add(e-t,"d")):t):null!=e?this:NaN},u.weekday=function(e){var t;return this.isValid()?(t=(this.day()+7-this.localeData()._week.dow)%7,null==e?t:this.add(e-t,"d")):null!=e?this:NaN},u.isoWeekday=function(e){var t,n;return this.isValid()?null!=e?(t=e,n=this.localeData(),n="string"==typeof t?n.weekdaysParse(t)%7||7:isNaN(t)?null:t,this.day(this.day()%7?n:n-7)):this.day()||7:null!=e?this:NaN},u.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},u.hour=u.hours=i,u.minute=u.minutes=ce,u.second=u.seconds=we,u.millisecond=u.milliseconds=fe,u.utcOffset=function(e,t,n){var s,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null==e)return this._isUTC?i:Et(this);if("string"==typeof e){if(null===(e=Vt(ve,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(s=Et(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),i!==e&&(!t||this._changeInProgress?$t(this,C(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,_.updateOffset(this,!0),this._changeInProgress=null)),this},u.utc=function(e){return this.utcOffset(0,e)},u.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e)&&this.subtract(Et(this),"m"),this},u.parseZone=function(){var e;return null!=this._tzm?this.utcOffset(this._tzm,!1,!0):"string"==typeof this._i&&(null!=(e=Vt(Me,this._i))?this.utcOffset(e):this.utcOffset(0,!0)),this},u.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?R(e).utcOffset():0,(this.utcOffset()-e)%60==0)},u.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},u.isLocal=function(){return!!this.isValid()&&!this._isUTC},u.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},u.isUtc=At,u.isUTC=At,u.zoneAbbr=function(){return this._isUTC?"UTC":""},u.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},u.dates=e("dates accessor is deprecated. Use date instead.",ge),u.months=e("months accessor is deprecated. Use month instead",Ie),u.years=e("years accessor is deprecated. Use year instead",Pe),u.zone=e("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?(this.utcOffset(e="string"!=typeof e?-e:e,t),this):-this.utcOffset()}),u.isDSTShifted=e("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){var e,t;return g(this._isDSTShifted)&&(q(e={},this),(e=Nt(e))._a?(t=(e._isUTC?l:R)(e._a),this._isDSTShifted=this.isValid()&&0<function(e,t,n){for(var s=Math.min(e.length,t.length),i=Math.abs(e.length-t.length),r=0,a=0;a<s;a++)(n&&e[a]!==t[a]||!n&&M(e[a])!==M(t[a]))&&r++;return r+i}(e._a,t.toArray())):this._isDSTShifted=!1),this._isDSTShifted});d=K.prototype;function cn(e,t,n,s){var i=P(),s=l().set(s,t);return i[n](s,e)}function fn(e,t,n){if(w(e)&&(t=e,e=void 0),e=e||"",null!=t)return cn(e,t,n,"month");for(var s=[],i=0;i<12;i++)s[i]=cn(e,i,n,"month");return s}function mn(e,t,n,s){t=("boolean"==typeof e?w(t)&&(n=t,t=void 0):(t=e,e=!1,w(n=t)&&(n=t,t=void 0)),t||"");var i,r=P(),a=e?r._week.dow:0,o=[];if(null!=n)return cn(t,(n+a)%7,s,"day");for(i=0;i<7;i++)o[i]=cn(t,(i+a)%7,s,"day");return o}d.calendar=function(e,t,n){return a(e=this._calendar[e]||this._calendar.sameElse)?e.call(t,n):e},d.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.match(te).map(function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e}).join(""),this._longDateFormat[e])},d.invalidDate=function(){return this._invalidDate},d.ordinal=function(e){return this._ordinal.replace("%d",e)},d.preparse=hn,d.postformat=hn,d.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return a(i)?i(e,t,n,s):i.replace(/%d/i,e)},d.pastFuture=function(e,t){return a(e=this._relativeTime[0<e?"future":"past"])?e(t):e.replace(/%s/i,t)},d.set=function(e){var t,n;for(n in e)c(e,n)&&(a(t=e[n])?this[n]=t:this["_"+n]=t);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},d.eras=function(e,t){for(var n,s=this._eras||P("en")._eras,i=0,r=s.length;i<r;++i){switch(typeof s[i].since){case"string":n=_(s[i].since).startOf("day"),s[i].since=n.valueOf();break}switch(typeof s[i].until){case"undefined":s[i].until=1/0;break;case"string":n=_(s[i].until).startOf("day").valueOf(),s[i].until=n.valueOf();break}}return s},d.erasParse=function(e,t,n){var s,i,r,a,o,u=this.eras();for(e=e.toUpperCase(),s=0,i=u.length;s<i;++s)if(r=u[s].name.toUpperCase(),a=u[s].abbr.toUpperCase(),o=u[s].narrow.toUpperCase(),n)switch(t){case"N":case"NN":case"NNN":if(a===e)return u[s];break;case"NNNN":if(r===e)return u[s];break;case"NNNNN":if(o===e)return u[s];break}else if(0<=[r,a,o].indexOf(e))return u[s]},d.erasConvertYear=function(e,t){var n=e.since<=e.until?1:-1;return void 0===t?_(e.since).year():_(e.since).year()+(t-e.offset)*n},d.erasAbbrRegex=function(e){return c(this,"_erasAbbrRegex")||an.call(this),e?this._erasAbbrRegex:this._erasRegex},d.erasNameRegex=function(e){return c(this,"_erasNameRegex")||an.call(this),e?this._erasNameRegex:this._erasRegex},d.erasNarrowRegex=function(e){return c(this,"_erasNarrowRegex")||an.call(this),e?this._erasNarrowRegex:this._erasRegex},d.months=function(e,t){return e?(y(this._months)?this._months:this._months[(this._months.isFormat||Ve).test(t)?"format":"standalone"])[e.month()]:y(this._months)?this._months:this._months.standalone},d.monthsShort=function(e,t){return e?(y(this._monthsShort)?this._monthsShort:this._monthsShort[Ve.test(t)?"format":"standalone"])[e.month()]:y(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},d.monthsParse=function(e,t,n){var s,i;if(this._monthsParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=l([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))?i:null:"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))||-1!==(i=x.call(this._longMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))||-1!==(i=x.call(this._shortMonthsParse,e))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=l([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(i="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(i.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},d.monthsRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsStrictRegex:this._monthsRegex):(c(this,"_monthsRegex")||(this._monthsRegex=Ee),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},d.monthsShortRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(c(this,"_monthsShortRegex")||(this._monthsShortRegex=Ge),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},d.week=function(e){return Be(e,this._week.dow,this._week.doy).week},d.firstDayOfYear=function(){return this._week.doy},d.firstDayOfWeek=function(){return this._week.dow},d.weekdays=function(e,t){return t=y(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"],!0===e?Je(t,this._week.dow):e?t[e.day()]:t},d.weekdaysMin=function(e){return!0===e?Je(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},d.weekdaysShort=function(e){return!0===e?Je(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},d.weekdaysParse=function(e,t,n){var s,i;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=l([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=l([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(i="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(i.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},d.weekdaysRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(c(this,"_weekdaysRegex")||(this._weekdaysRegex=et),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},d.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(c(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=tt),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},d.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(c(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=nt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},d.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},d.meridiem=function(e,t,n){return 11<e?n?"pm":"PM":n?"am":"AM"},ft("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===M(e%100/10)?"th":1==t?"st":2==t?"nd":3==t?"rd":"th")}}),_.lang=e("moment.lang is deprecated. Use moment.locale instead.",ft),_.langData=e("moment.langData is deprecated. Use moment.localeData instead.",P);var _n=Math.abs;function yn(e,t,n,s){t=C(t,n);return e._milliseconds+=s*t._milliseconds,e._days+=s*t._days,e._months+=s*t._months,e._bubble()}function gn(e){return e<0?Math.floor(e):Math.ceil(e)}function wn(e){return 4800*e/146097}function pn(e){return 146097*e/4800}function kn(e){return function(){return this.as(e)}}de=kn("ms"),t=kn("s"),ye=kn("m"),he=kn("h"),Fe=kn("d"),_e=kn("w"),me=kn("M"),Qe=kn("Q"),i=kn("y"),ce=de;function Mn(e){return function(){return this.isValid()?this._data[e]:NaN}}var we=Mn("milliseconds"),fe=Mn("seconds"),ge=Mn("minutes"),Pe=Mn("hours"),d=Mn("days"),vn=Mn("months"),Dn=Mn("years");var Yn=Math.round,Sn={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function On(e,t,n,s){var i=C(e).abs(),r=Yn(i.as("s")),a=Yn(i.as("m")),o=Yn(i.as("h")),u=Yn(i.as("d")),l=Yn(i.as("M")),d=Yn(i.as("w")),i=Yn(i.as("y")),r=(r<=n.ss?["s",r]:r<n.s&&["ss",r])||(a<=1?["m"]:a<n.m&&["mm",a])||(o<=1?["h"]:o<n.h&&["hh",o])||(u<=1?["d"]:u<n.d&&["dd",u]);return(r=(r=null!=n.w?r||(d<=1?["w"]:d<n.w&&["ww",d]):r)||(l<=1?["M"]:l<n.M&&["MM",l])||(i<=1?["y"]:["yy",i]))[2]=t,r[3]=0<+e,r[4]=s,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,r)}var bn=Math.abs;function Tn(e){return(0<e)-(e<0)||+e}function xn(){var e,t,n,s,i,r,a,o,u,l,d;return this.isValid()?(e=bn(this._milliseconds)/1e3,t=bn(this._days),n=bn(this._months),(o=this.asSeconds())?(s=m(e/60),i=m(s/60),e%=60,s%=60,r=m(n/12),n%=12,a=e?e.toFixed(3).replace(/\.?0+$/,""):"",u=Tn(this._months)!==Tn(o)?"-":"",l=Tn(this._days)!==Tn(o)?"-":"",d=Tn(this._milliseconds)!==Tn(o)?"-":"",(o<0?"-":"")+"P"+(r?u+r+"Y":"")+(n?u+n+"M":"")+(t?l+t+"D":"")+(i||s||e?"T":"")+(i?d+i+"H":"")+(s?d+s+"M":"")+(e?d+a+"S":"")):"P0D"):this.localeData().invalidDate()}var U=Ct.prototype;return U.isValid=function(){return this._isValid},U.abs=function(){var e=this._data;return this._milliseconds=_n(this._milliseconds),this._days=_n(this._days),this._months=_n(this._months),e.milliseconds=_n(e.milliseconds),e.seconds=_n(e.seconds),e.minutes=_n(e.minutes),e.hours=_n(e.hours),e.months=_n(e.months),e.years=_n(e.years),this},U.add=function(e,t){return yn(this,e,t,1)},U.subtract=function(e,t){return yn(this,e,t,-1)},U.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=o(e))||"quarter"===e||"year"===e)switch(t=this._days+s/864e5,n=this._months+wn(t),e){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(t=this._days+Math.round(pn(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},U.asMilliseconds=de,U.asSeconds=t,U.asMinutes=ye,U.asHours=he,U.asDays=Fe,U.asWeeks=_e,U.asMonths=me,U.asQuarters=Qe,U.asYears=i,U.valueOf=ce,U._bubble=function(){var e=this._milliseconds,t=this._days,n=this._months,s=this._data;return 0<=e&&0<=t&&0<=n||e<=0&&t<=0&&n<=0||(e+=864e5*gn(pn(n)+t),n=t=0),s.milliseconds=e%1e3,e=m(e/1e3),s.seconds=e%60,e=m(e/60),s.minutes=e%60,e=m(e/60),s.hours=e%24,t+=m(e/24),n+=e=m(wn(t)),t-=gn(pn(e)),e=m(n/12),n%=12,s.days=t,s.months=n,s.years=e,this},U.clone=function(){return C(this)},U.get=function(e){return e=o(e),this.isValid()?this[e+"s"]():NaN},U.milliseconds=we,U.seconds=fe,U.minutes=ge,U.hours=Pe,U.days=d,U.weeks=function(){return m(this.days()/7)},U.months=vn,U.years=Dn,U.humanize=function(e,t){var n,s;return this.isValid()?(n=!1,s=Sn,"object"==typeof e&&(t=e,e=!1),"boolean"==typeof e&&(n=e),"object"==typeof t&&(s=Object.assign({},Sn,t),null!=t.s)&&null==t.ss&&(s.ss=t.s-1),e=this.localeData(),t=On(this,!n,s,e),n&&(t=e.pastFuture(+this,t)),e.postformat(t)):this.localeData().invalidDate()},U.toISOString=xn,U.toString=xn,U.toJSON=xn,U.locale=Xt,U.localeData=Kt,U.toIsoString=e("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",xn),U.lang=Ke,s("X",0,0,"unix"),s("x",0,0,"valueOf"),h("x",ke),h("X",/[+-]?\d+(\.\d{1,3})?/),v("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e))}),v("x",function(e,t,n){n._d=new Date(M(e))}),_.version="2.30.1",H=R,_.fn=u,_.min=function(){return Pt("isBefore",[].slice.call(arguments,0))},_.max=function(){return Pt("isAfter",[].slice.call(arguments,0))},_.now=function(){return Date.now?Date.now():+new Date},_.utc=l,_.unix=function(e){return R(1e3*e)},_.months=function(e,t){return fn(e,t,"months")},_.isDate=V,_.locale=ft,_.invalid=I,_.duration=C,_.isMoment=k,_.weekdays=function(e,t,n){return mn(e,t,n,"weekdays")},_.parseZone=function(){return R.apply(null,arguments).parseZone()},_.localeData=P,_.isDuration=Ut,_.monthsShort=function(e,t){return fn(e,t,"monthsShort")},_.weekdaysMin=function(e,t,n){return mn(e,t,n,"weekdaysMin")},_.defineLocale=mt,_.updateLocale=function(e,t){var n,s;return null!=t?(s=ut,null!=W[e]&&null!=W[e].parentLocale?W[e].set(X(W[e]._config,t)):(t=X(s=null!=(n=ct(e))?n._config:s,t),null==n&&(t.abbr=e),(s=new K(t)).parentLocale=W[e],W[e]=s),ft(e)):null!=W[e]&&(null!=W[e].parentLocale?(W[e]=W[e].parentLocale,e===ft()&&ft(e)):null!=W[e]&&delete W[e]),W[e]},_.locales=function(){return ee(W)},_.weekdaysShort=function(e,t,n){return mn(e,t,n,"weekdaysShort")},_.normalizeUnits=o,_.relativeTimeRounding=function(e){return void 0===e?Yn:"function"==typeof e&&(Yn=e,!0)},_.relativeTimeThreshold=function(e,t){return void 0!==Sn[e]&&(void 0===t?Sn[e]:(Sn[e]=t,"s"===e&&(Sn.ss=t-1),!0))},_.calendarFormat=function(e,t){return(e=e.diff(t,"days",!0))<-6?"sameElse":e<-1?"lastWeek":e<0?"lastDay":e<1?"sameDay":e<2?"nextDay":e<7?"nextWeek":"sameElse"},_.prototype=u,_.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},_});
//# sourceMappingURL=moment.min.js.map
/**!

 @license
 handlebars v4.7.9

Copyright (C) 2011-2019 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
!function(a,b){"object"==typeof exports&&"object"==typeof module?module.exports=b():"function"==typeof define&&define.amd?define([],b):"object"==typeof exports?exports.Handlebars=b():a.Handlebars=b()}(this,function(){return function(a){function b(d){if(c[d])return c[d].exports;var e=c[d]={exports:{},id:d,loaded:!1};return a[d].call(e.exports,e,e.exports,b),e.loaded=!0,e.exports}var c={};return b.m=a,b.c=c,b.p="",b(0)}([function(a,b,c){"use strict";function d(){var a=r();return a.compile=function(b,c){return k.compile(b,c,a)},a.precompile=function(b,c){return k.precompile(b,c,a)},a.AST=i["default"],a.Compiler=k.Compiler,a.JavaScriptCompiler=m["default"],a.Parser=j.parser,a.parse=j.parse,a.parseWithoutProcessing=j.parseWithoutProcessing,a}var e=c(1)["default"];b.__esModule=!0;var f=c(2),g=e(f),h=c(83),i=e(h),j=c(84),k=c(89),l=c(90),m=e(l),n=c(87),o=e(n),p=c(82),q=e(p),r=g["default"].create,s=d();s.create=d,q["default"](s),s.Visitor=o["default"],s["default"]=s,b["default"]=s,a.exports=b["default"]},function(a,b){"use strict";b["default"]=function(a){return a&&a.__esModule?a:{"default":a}},b.__esModule=!0},function(a,b,c){"use strict";function d(){var a=new h.HandlebarsEnvironment;return n.extend(a,h),a.SafeString=j["default"],a.Exception=l["default"],a.Utils=n,a.escapeExpression=n.escapeExpression,a.VM=p,a.template=function(b){return p.template(b,a)},a}var e=c(3)["default"],f=c(1)["default"];b.__esModule=!0;var g=c(4),h=e(g),i=c(76),j=f(i),k=c(6),l=f(k),m=c(5),n=e(m),o=c(77),p=e(o),q=c(82),r=f(q),s=d();s.create=d,r["default"](s),s["default"]=s,b["default"]=s,a.exports=b["default"]},function(a,b){"use strict";b["default"]=function(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b["default"]=a,b},b.__esModule=!0},function(a,b,c){"use strict";function d(a,b,c){this.helpers=a||{},this.partials=b||{},this.decorators=c||{},i.registerDefaultHelpers(this),j.registerDefaultDecorators(this)}var e=c(1)["default"];b.__esModule=!0,b.HandlebarsEnvironment=d;var f=c(5),g=c(6),h=e(g),i=c(10),j=c(70),k=c(72),l=e(k),m=c(73),n="4.7.9";b.VERSION=n;var o=8;b.COMPILER_REVISION=o;var p=7;b.LAST_COMPATIBLE_COMPILER_REVISION=p;var q={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0 <4.3.0",8:">= 4.3.0"};b.REVISION_CHANGES=q;var r="[object Object]";d.prototype={constructor:d,logger:l["default"],log:l["default"].log,registerHelper:function(a,b){if(f.toString.call(a)===r){if(b)throw new h["default"]("Arg not supported with multiple helpers");f.extend(this.helpers,a)}else this.helpers[a]=b},unregisterHelper:function(a){delete this.helpers[a]},registerPartial:function(a,b){if(f.toString.call(a)===r)f.extend(this.partials,a);else{if("undefined"==typeof b)throw new h["default"]('Attempting to register a partial called "'+a+'" as undefined');this.partials[a]=b}},unregisterPartial:function(a){delete this.partials[a]},registerDecorator:function(a,b){if(f.toString.call(a)===r){if(b)throw new h["default"]("Arg not supported with multiple decorators");f.extend(this.decorators,a)}else this.decorators[a]=b},unregisterDecorator:function(a){delete this.decorators[a]},resetLoggedPropertyAccesses:function(){m.resetLoggedProperties()}};var s=l["default"].log;b.log=s,b.createFrame=f.createFrame,b.logger=l["default"]},function(a,b){"use strict";function c(a){return k[a]}function d(a){for(var b=1;b<arguments.length;b++)for(var c in arguments[b])Object.prototype.hasOwnProperty.call(arguments[b],c)&&(a[c]=arguments[b][c]);return a}function e(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1}function f(a){if("string"!=typeof a){if(a&&a.toHTML)return a.toHTML();if(null==a)return"";if(!a)return a+"";a=""+a}return m.test(a)?a.replace(l,c):a}function g(a){return!a&&0!==a||!(!p(a)||0!==a.length)}function h(a){var b=d({},a);return b._parent=a,b}function i(a,b){return a.path=b,a}function j(a,b){return(a?a+".":"")+b}b.__esModule=!0,b.extend=d,b.indexOf=e,b.escapeExpression=f,b.isEmpty=g,b.createFrame=h,b.blockParams=i,b.appendContextPath=j;var k={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},l=/[&<>"'`=]/g,m=/[&<>"'`=]/,n=Object.prototype.toString;b.toString=n;var o=function(a){return"function"==typeof a};o(/x/)&&(b.isFunction=o=function(a){return"function"==typeof a&&"[object Function]"===n.call(a)}),b.isFunction=o;var p=Array.isArray||function(a){return!(!a||"object"!=typeof a)&&"[object Array]"===n.call(a)};b.isArray=p},function(a,b,c){"use strict";function d(a,b){var c=b&&b.loc,g=void 0,h=void 0,i=void 0,j=void 0;c&&(g=c.start.line,h=c.end.line,i=c.start.column,j=c.end.column,a+=" - "+g+":"+i);for(var k=Error.prototype.constructor.call(this,a),l=0;l<f.length;l++)this[f[l]]=k[f[l]];Error.captureStackTrace&&Error.captureStackTrace(this,d);try{c&&(this.lineNumber=g,this.endLineNumber=h,e?(Object.defineProperty(this,"column",{value:i,enumerable:!0}),Object.defineProperty(this,"endColumn",{value:j,enumerable:!0})):(this.column=i,this.endColumn=j))}catch(m){}}var e=c(7)["default"];b.__esModule=!0;var f=["description","fileName","lineNumber","endLineNumber","message","name","number","stack"];d.prototype=new Error,b["default"]=d,a.exports=b["default"]},function(a,b,c){a.exports={"default":c(8),__esModule:!0}},function(a,b,c){var d=c(9);a.exports=function(a,b,c){return d.setDesc(a,b,c)}},function(a,b){var c=Object;a.exports={create:c.create,getProto:c.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:c.getOwnPropertyDescriptor,setDesc:c.defineProperty,setDescs:c.defineProperties,getKeys:c.keys,getNames:c.getOwnPropertyNames,getSymbols:c.getOwnPropertySymbols,each:[].forEach}},function(a,b,c){"use strict";function d(a){h["default"](a),j["default"](a),l["default"](a),n["default"](a),p["default"](a),r["default"](a),t["default"](a)}function e(a,b,c){a.helpers[b]&&(a.hooks[b]=a.helpers[b],c||(a.helpers[b]=void 0))}var f=c(1)["default"];b.__esModule=!0,b.registerDefaultHelpers=d,b.moveHelperToHooks=e;var g=c(11),h=f(g),i=c(12),j=f(i),k=c(65),l=f(k),m=c(66),n=f(m),o=c(67),p=f(o),q=c(68),r=f(q),s=c(69),t=f(s)},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5);b["default"]=function(a){a.registerHelper("blockHelperMissing",function(b,c){var e=c.inverse,f=c.fn;if(b===!0)return f(this);if(b===!1||null==b)return e(this);if(d.isArray(b))return b.length>0?(c.ids&&(c.ids=[c.name]),a.helpers.each(b,c)):e(this);if(c.data&&c.ids){var g=d.createFrame(c.data);g.contextPath=d.appendContextPath(c.data.contextPath,c.name),c={data:g}}return f(b,c)})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(13)["default"],e=c(43)["default"],f=c(55)["default"],g=c(60)["default"],h=c(1)["default"];b.__esModule=!0;var i=c(5),j=c(6),k=h(j);b["default"]=function(a){a.registerHelper("each",function(a,b){function c(b,c,d){n&&(n.key=b,n.index=c,n.first=0===c,n.last=!!d,o&&(n.contextPath=o+b)),m+=h(a[b],{data:n,blockParams:i.blockParams([a[b],b],[o+b,null])})}if(!b)throw new k["default"]("Must pass iterator to #each");var h=b.fn,j=b.inverse,l=0,m="",n=void 0,o=void 0;if(b.data&&b.ids&&(o=i.appendContextPath(b.data.contextPath,b.ids[0])+"."),i.isFunction(a)&&(a=a.call(this)),b.data&&(n=i.createFrame(b.data)),a&&"object"==typeof a)if(i.isArray(a))for(var p=a.length;l<p;l++)l in a&&c(l,l,l===a.length-1);else if("function"==typeof d&&a[e]){for(var q=[],r=f(a),s=r.next();!s.done;s=r.next())q.push(s.value);a=q;for(var p=a.length;l<p;l++)c(l,l,l===a.length-1)}else!function(){var b=void 0;g(a).forEach(function(a){void 0!==b&&c(b,l-1),b=a,l++}),void 0!==b&&c(b,l-1,!0)}();return 0===l&&(m=j(this)),m})},a.exports=b["default"]},function(a,b,c){a.exports={"default":c(14),__esModule:!0}},function(a,b,c){c(15),c(42),a.exports=c(21).Symbol},function(a,b,c){"use strict";var d=c(9),e=c(16),f=c(17),g=c(18),h=c(20),i=c(24),j=c(19),k=c(27),l=c(28),m=c(30),n=c(29),o=c(31),p=c(36),q=c(37),r=c(38),s=c(39),t=c(32),u=c(26),v=d.getDesc,w=d.setDesc,x=d.create,y=p.get,z=e.Symbol,A=e.JSON,B=A&&A.stringify,C=!1,D=n("_hidden"),E=d.isEnum,F=k("symbol-registry"),G=k("symbols"),H="function"==typeof z,I=Object.prototype,J=g&&j(function(){return 7!=x(w({},"a",{get:function(){return w(this,"a",{value:7}).a}})).a})?function(a,b,c){var d=v(I,b);d&&delete I[b],w(a,b,c),d&&a!==I&&w(I,b,d)}:w,K=function(a){var b=G[a]=x(z.prototype);return b._k=a,g&&C&&J(I,a,{configurable:!0,set:function(b){f(this,D)&&f(this[D],a)&&(this[D][a]=!1),J(this,a,u(1,b))}}),b},L=function(a){return"symbol"==typeof a},M=function(a,b,c){return c&&f(G,b)?(c.enumerable?(f(a,D)&&a[D][b]&&(a[D][b]=!1),c=x(c,{enumerable:u(0,!1)})):(f(a,D)||w(a,D,u(1,{})),a[D][b]=!0),J(a,b,c)):w(a,b,c)},N=function(a,b){s(a);for(var c,d=q(b=t(b)),e=0,f=d.length;f>e;)M(a,c=d[e++],b[c]);return a},O=function(a,b){return void 0===b?x(a):N(x(a),b)},P=function(a){var b=E.call(this,a);return!(b||!f(this,a)||!f(G,a)||f(this,D)&&this[D][a])||b},Q=function(a,b){var c=v(a=t(a),b);return!c||!f(G,b)||f(a,D)&&a[D][b]||(c.enumerable=!0),c},R=function(a){for(var b,c=y(t(a)),d=[],e=0;c.length>e;)f(G,b=c[e++])||b==D||d.push(b);return d},S=function(a){for(var b,c=y(t(a)),d=[],e=0;c.length>e;)f(G,b=c[e++])&&d.push(G[b]);return d},T=function(a){if(void 0!==a&&!L(a)){for(var b,c,d=[a],e=1,f=arguments;f.length>e;)d.push(f[e++]);return b=d[1],"function"==typeof b&&(c=b),!c&&r(b)||(b=function(a,b){if(c&&(b=c.call(this,a,b)),!L(b))return b}),d[1]=b,B.apply(A,d)}},U=j(function(){var a=z();return"[null]"!=B([a])||"{}"!=B({a:a})||"{}"!=B(Object(a))});H||(z=function(){if(L(this))throw TypeError("Symbol is not a constructor");return K(m(arguments.length>0?arguments[0]:void 0))},i(z.prototype,"toString",function(){return this._k}),L=function(a){return a instanceof z},d.create=O,d.isEnum=P,d.getDesc=Q,d.setDesc=M,d.setDescs=N,d.getNames=p.get=R,d.getSymbols=S,g&&!c(41)&&i(I,"propertyIsEnumerable",P,!0));var V={"for":function(a){return f(F,a+="")?F[a]:F[a]=z(a)},keyFor:function(a){return o(F,a)},useSetter:function(){C=!0},useSimple:function(){C=!1}};d.each.call("hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),function(a){var b=n(a);V[a]=H?b:K(b)}),C=!0,h(h.G+h.W,{Symbol:z}),h(h.S,"Symbol",V),h(h.S+h.F*!H,"Object",{create:O,defineProperty:M,defineProperties:N,getOwnPropertyDescriptor:Q,getOwnPropertyNames:R,getOwnPropertySymbols:S}),A&&h(h.S+h.F*(!H||U),"JSON",{stringify:T}),l(z,"Symbol"),l(Math,"Math",!0),l(e.JSON,"JSON",!0)},function(a,b){var c=a.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=c)},function(a,b){var c={}.hasOwnProperty;a.exports=function(a,b){return c.call(a,b)}},function(a,b,c){a.exports=!c(19)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(a,b){a.exports=function(a){try{return!!a()}catch(b){return!0}}},function(a,b,c){var d=c(16),e=c(21),f=c(22),g="prototype",h=function(a,b,c){var i,j,k,l=a&h.F,m=a&h.G,n=a&h.S,o=a&h.P,p=a&h.B,q=a&h.W,r=m?e:e[b]||(e[b]={}),s=m?d:n?d[b]:(d[b]||{})[g];m&&(c=b);for(i in c)j=!l&&s&&i in s,j&&i in r||(k=j?s[i]:c[i],r[i]=m&&"function"!=typeof s[i]?c[i]:p&&j?f(k,d):q&&s[i]==k?function(a){var b=function(b){return this instanceof a?new a(b):a(b)};return b[g]=a[g],b}(k):o&&"function"==typeof k?f(Function.call,k):k,o&&((r[g]||(r[g]={}))[i]=k))};h.F=1,h.G=2,h.S=4,h.P=8,h.B=16,h.W=32,a.exports=h},function(a,b){var c=a.exports={version:"1.2.6"};"number"==typeof __e&&(__e=c)},function(a,b,c){var d=c(23);a.exports=function(a,b,c){if(d(a),void 0===b)return a;switch(c){case 1:return function(c){return a.call(b,c)};case 2:return function(c,d){return a.call(b,c,d)};case 3:return function(c,d,e){return a.call(b,c,d,e)}}return function(){return a.apply(b,arguments)}}},function(a,b){a.exports=function(a){if("function"!=typeof a)throw TypeError(a+" is not a function!");return a}},function(a,b,c){a.exports=c(25)},function(a,b,c){var d=c(9),e=c(26);a.exports=c(18)?function(a,b,c){return d.setDesc(a,b,e(1,c))}:function(a,b,c){return a[b]=c,a}},function(a,b){a.exports=function(a,b){return{enumerable:!(1&a),configurable:!(2&a),writable:!(4&a),value:b}}},function(a,b,c){var d=c(16),e="__core-js_shared__",f=d[e]||(d[e]={});a.exports=function(a){return f[a]||(f[a]={})}},function(a,b,c){var d=c(9).setDesc,e=c(17),f=c(29)("toStringTag");a.exports=function(a,b,c){a&&!e(a=c?a:a.prototype,f)&&d(a,f,{configurable:!0,value:b})}},function(a,b,c){var d=c(27)("wks"),e=c(30),f=c(16).Symbol;a.exports=function(a){return d[a]||(d[a]=f&&f[a]||(f||e)("Symbol."+a))}},function(a,b){var c=0,d=Math.random();a.exports=function(a){return"Symbol(".concat(void 0===a?"":a,")_",(++c+d).toString(36))}},function(a,b,c){var d=c(9),e=c(32);a.exports=function(a,b){for(var c,f=e(a),g=d.getKeys(f),h=g.length,i=0;h>i;)if(f[c=g[i++]]===b)return c}},function(a,b,c){var d=c(33),e=c(35);a.exports=function(a){return d(e(a))}},function(a,b,c){var d=c(34);a.exports=Object("z").propertyIsEnumerable(0)?Object:function(a){return"String"==d(a)?a.split(""):Object(a)}},function(a,b){var c={}.toString;a.exports=function(a){return c.call(a).slice(8,-1)}},function(a,b){a.exports=function(a){if(void 0==a)throw TypeError("Can't call method on  "+a);return a}},function(a,b,c){var d=c(32),e=c(9).getNames,f={}.toString,g="object"==typeof window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],h=function(a){try{return e(a)}catch(b){return g.slice()}};a.exports.get=function(a){return g&&"[object Window]"==f.call(a)?h(a):e(d(a))}},function(a,b,c){var d=c(9);a.exports=function(a){var b=d.getKeys(a),c=d.getSymbols;if(c)for(var e,f=c(a),g=d.isEnum,h=0;f.length>h;)g.call(a,e=f[h++])&&b.push(e);return b}},function(a,b,c){var d=c(34);a.exports=Array.isArray||function(a){return"Array"==d(a)}},function(a,b,c){var d=c(40);a.exports=function(a){if(!d(a))throw TypeError(a+" is not an object!");return a}},function(a,b){a.exports=function(a){return"object"==typeof a?null!==a:"function"==typeof a}},function(a,b){a.exports=!0},function(a,b){},function(a,b,c){a.exports={"default":c(44),__esModule:!0}},function(a,b,c){c(45),c(51),a.exports=c(29)("iterator")},function(a,b,c){"use strict";var d=c(46)(!0);c(48)(String,"String",function(a){this._t=String(a),this._i=0},function(){var a,b=this._t,c=this._i;return c>=b.length?{value:void 0,done:!0}:(a=d(b,c),this._i+=a.length,{value:a,done:!1})})},function(a,b,c){var d=c(47),e=c(35);a.exports=function(a){return function(b,c){var f,g,h=String(e(b)),i=d(c),j=h.length;return i<0||i>=j?a?"":void 0:(f=h.charCodeAt(i),f<55296||f>56319||i+1===j||(g=h.charCodeAt(i+1))<56320||g>57343?a?h.charAt(i):f:a?h.slice(i,i+2):(f-55296<<10)+(g-56320)+65536)}}},function(a,b){var c=Math.ceil,d=Math.floor;a.exports=function(a){return isNaN(a=+a)?0:(a>0?d:c)(a)}},function(a,b,c){"use strict";var d=c(41),e=c(20),f=c(24),g=c(25),h=c(17),i=c(49),j=c(50),k=c(28),l=c(9).getProto,m=c(29)("iterator"),n=!([].keys&&"next"in[].keys()),o="@@iterator",p="keys",q="values",r=function(){return this};a.exports=function(a,b,c,s,t,u,v){j(c,b,s);var w,x,y=function(a){if(!n&&a in C)return C[a];switch(a){case p:return function(){return new c(this,a)};case q:return function(){return new c(this,a)}}return function(){return new c(this,a)}},z=b+" Iterator",A=t==q,B=!1,C=a.prototype,D=C[m]||C[o]||t&&C[t],E=D||y(t);if(D){var F=l(E.call(new a));k(F,z,!0),!d&&h(C,o)&&g(F,m,r),A&&D.name!==q&&(B=!0,E=function(){return D.call(this)})}if(d&&!v||!n&&!B&&C[m]||g(C,m,E),i[b]=E,i[z]=r,t)if(w={values:A?E:y(q),keys:u?E:y(p),entries:A?y("entries"):E},v)for(x in w)x in C||f(C,x,w[x]);else e(e.P+e.F*(n||B),b,w);return w}},function(a,b){a.exports={}},function(a,b,c){"use strict";var d=c(9),e=c(26),f=c(28),g={};c(25)(g,c(29)("iterator"),function(){return this}),a.exports=function(a,b,c){a.prototype=d.create(g,{next:e(1,c)}),f(a,b+" Iterator")}},function(a,b,c){c(52);var d=c(49);d.NodeList=d.HTMLCollection=d.Array},function(a,b,c){"use strict";var d=c(53),e=c(54),f=c(49),g=c(32);a.exports=c(48)(Array,"Array",function(a,b){this._t=g(a),this._i=0,this._k=b},function(){var a=this._t,b=this._k,c=this._i++;return!a||c>=a.length?(this._t=void 0,e(1)):"keys"==b?e(0,c):"values"==b?e(0,a[c]):e(0,[c,a[c]])},"values"),f.Arguments=f.Array,d("keys"),d("values"),d("entries")},function(a,b){a.exports=function(){}},function(a,b){a.exports=function(a,b){return{value:b,done:!!a}}},function(a,b,c){a.exports={"default":c(56),__esModule:!0}},function(a,b,c){c(51),c(45),a.exports=c(57)},function(a,b,c){var d=c(39),e=c(58);a.exports=c(21).getIterator=function(a){var b=e(a);if("function"!=typeof b)throw TypeError(a+" is not iterable!");return d(b.call(a))}},function(a,b,c){var d=c(59),e=c(29)("iterator"),f=c(49);a.exports=c(21).getIteratorMethod=function(a){if(void 0!=a)return a[e]||a["@@iterator"]||f[d(a)]}},function(a,b,c){var d=c(34),e=c(29)("toStringTag"),f="Arguments"==d(function(){return arguments}());a.exports=function(a){var b,c,g;return void 0===a?"Undefined":null===a?"Null":"string"==typeof(c=(b=Object(a))[e])?c:f?d(b):"Object"==(g=d(b))&&"function"==typeof b.callee?"Arguments":g}},function(a,b,c){a.exports={"default":c(61),__esModule:!0}},function(a,b,c){c(62),a.exports=c(21).Object.keys},function(a,b,c){var d=c(63);c(64)("keys",function(a){return function(b){return a(d(b))}})},function(a,b,c){var d=c(35);a.exports=function(a){return Object(d(a))}},function(a,b,c){var d=c(20),e=c(21),f=c(19);a.exports=function(a,b){var c=(e.Object||{})[a]||Object[a],g={};g[a]=b(c),d(d.S+d.F*f(function(){c(1)}),"Object",g)}},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(6),f=d(e);b["default"]=function(a){a.registerHelper("helperMissing",function(){if(1!==arguments.length)throw new f["default"]('Missing helper: "'+arguments[arguments.length-1].name+'"')})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(5),f=c(6),g=d(f);b["default"]=function(a){a.registerHelper("if",function(a,b){if(2!=arguments.length)throw new g["default"]("#if requires exactly one argument");return e.isFunction(a)&&(a=a.call(this)),!b.hash.includeZero&&!a||e.isEmpty(a)?b.inverse(this):b.fn(this)}),a.registerHelper("unless",function(b,c){if(2!=arguments.length)throw new g["default"]("#unless requires exactly one argument");return a.helpers["if"].call(this,b,{fn:c.inverse,inverse:c.fn,hash:c.hash})})},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){a.registerHelper("log",function(){for(var b=[void 0],c=arguments[arguments.length-1],d=0;d<arguments.length-1;d++)b.push(arguments[d]);var e=1;null!=c.hash.level?e=c.hash.level:c.data&&null!=c.data.level&&(e=c.data.level),b[0]=e,a.log.apply(a,b)})},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){a.registerHelper("lookup",function(a,b,c){return a?c.lookupProperty(a,b):a})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(5),f=c(6),g=d(f);b["default"]=function(a){a.registerHelper("with",function(a,b){if(2!=arguments.length)throw new g["default"]("#with requires exactly one argument");e.isFunction(a)&&(a=a.call(this));var c=b.fn;if(e.isEmpty(a))return b.inverse(this);var d=b.data;return b.data&&b.ids&&(d=e.createFrame(b.data),d.contextPath=e.appendContextPath(b.data.contextPath,b.ids[0])),c(a,{data:d,blockParams:e.blockParams([a],[d&&d.contextPath])})})},a.exports=b["default"]},function(a,b,c){"use strict";function d(a){g["default"](a)}var e=c(1)["default"];b.__esModule=!0,b.registerDefaultDecorators=d;var f=c(71),g=e(f)},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5);b["default"]=function(a){a.registerDecorator("inline",function(a,b,c,e){var f=a;return b.partials||(b.partials={},f=function(e,f){var g=c.partials;c.partials=d.extend({},g,b.partials);var h=a(e,f);return c.partials=g,h}),b.partials[e.args[0]]=e.fn,f})},a.exports=b["default"]},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5),e={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(a){if("string"==typeof a){var b=d.indexOf(e.methodMap,a.toLowerCase());a=b>=0?b:parseInt(a,10)}return a},log:function(a){if(a=e.lookupLevel(a),"undefined"!=typeof console&&e.lookupLevel(e.level)<=a){var b=e.methodMap[a];console[b]||(b="log");for(var c=arguments.length,d=Array(c>1?c-1:0),f=1;f<c;f++)d[f-1]=arguments[f];console[b].apply(console,d)}}};b["default"]=e,a.exports=b["default"]},function(a,b,c){"use strict";function d(a){var b=i(null);b.__proto__=!1,l.extend(b,a.allowedProtoProperties);var c=i(null);return c.constructor=!1,c.__defineGetter__=!1,c.__defineSetter__=!1,c.__lookupGetter__=!1,c.__lookupSetter__=!1,l.extend(c,a.allowedProtoMethods),{properties:{whitelist:b,defaultValue:a.allowProtoPropertiesByDefault},methods:{whitelist:c,defaultValue:a.allowProtoMethodsByDefault}}}function e(a,b,c){return"function"==typeof a?f(b.methods,c):f(b.properties,c)}function f(a,b){return void 0!==a.whitelist[b]?a.whitelist[b]===!0:void 0!==a.defaultValue?a.defaultValue:(g(b),!1)}function g(a){o[a]!==!0&&(o[a]=!0,n["default"].log("error",'Handlebars: Access has been denied to resolve the property "'+a+'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'))}function h(){j(o).forEach(function(a){delete o[a]})}var i=c(74)["default"],j=c(60)["default"],k=c(1)["default"];b.__esModule=!0,b.createProtoAccessControl=d,b.resultIsAllowed=e,b.resetLoggedProperties=h;var l=c(5),m=c(72),n=k(m),o=i(null)},function(a,b,c){a.exports={"default":c(75),__esModule:!0}},function(a,b,c){var d=c(9);a.exports=function(a,b){return d.create(a,b)}},function(a,b){"use strict";function c(a){this.string=a}b.__esModule=!0,c.prototype.toString=c.prototype.toHTML=function(){return""+this.string},b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(a){var b=a&&a[0]||1,c=w.COMPILER_REVISION;if(!(b>=w.LAST_COMPATIBLE_COMPILER_REVISION&&b<=w.COMPILER_REVISION)){if(b<w.LAST_COMPATIBLE_COMPILER_REVISION){var d=w.REVISION_CHANGES[c],e=w.REVISION_CHANGES[b];throw new v["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+d+") or downgrade your runtime to an older version ("+e+").")}throw new v["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+a[1]+").")}}function e(a,b){function c(c,d,e){e.hash&&(d=t.extend({},d,e.hash),e.ids&&(e.ids[0]=!0)),c=b.VM.resolvePartial.call(this,c,d,e),e.hooks=this.hooks,e.protoAccessControl=this.protoAccessControl;var f=b.VM.invokePartial.call(this,c,d,e);if(null==f&&b.compile&&(e.partials[e.name]=b.compile(c,a.compilerOptions,b),f=e.partials[e.name](d,e)),null!=f){if(e.indent){for(var g=f.split("\n"),h=0,i=g.length;h<i&&(g[h]||h+1!==i);h++)g[h]=e.indent+g[h];f=g.join("\n")}return f}throw new v["default"]("The partial "+e.name+" could not be compiled when running in runtime-only mode")}function d(b){function c(b){return""+a.main(g,b,g.helpers,g.partials,f,i,h)}var e=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],f=e.data;d._setup(e),!e.partial&&a.useData&&(f=k(b,f));var h=void 0,i=a.useBlockParams?[]:void 0;return a.useDepths&&(h=e.depths?b!=e.depths[0]?[b].concat(e.depths):e.depths:[b]),(c=l(a.main,c,g,e.depths||[],f,i))(b,e)}if(!b)throw new v["default"]("No environment passed to template");if(!a||!a.main)throw new v["default"]("Unknown template object: "+typeof a);a.main.decorator=a.main_d,b.VM.checkRevision(a.compiler);var e=a.compiler&&7===a.compiler[0],g={strict:function(a,b,c){if(!(a&&b in a))throw new v["default"]('"'+b+'" not defined in '+a,{loc:c});return g.lookupProperty(a,b)},lookupProperty:function(a,b){var c=a[b];return null==c?c:Object.prototype.hasOwnProperty.call(a,b)?c:z.resultIsAllowed(c,g.protoAccessControl,b)?c:void 0},lookup:function(a,b){for(var c=a.length,d=0;d<c;d++){var e=a[d]&&g.lookupProperty(a[d],b);if(null!=e)return e}},lambda:function(a,b){return"function"==typeof a?a.call(b):a},escapeExpression:t.escapeExpression,invokePartial:c,fn:function(b){var c=a[b];return c.decorator=a[b+"_d"],c},programs:[],program:function(a,b,c,d,e){var g=this.programs[a],h=this.fn(a);return b||e||d||c?g=f(this,a,h,b,c,d,e):g||(g=this.programs[a]=f(this,a,h)),g},data:function(a,b){for(;a&&b--;)a=a._parent;return a},mergeIfNeeded:function(a,b){var c=a||b;return a&&b&&a!==b&&(c=t.extend({},b,a)),c},nullContext:o({}),noop:b.VM.noop,compilerInfo:a.compiler};return d.isTop=!0,d._setup=function(c){if(c.partial)g.protoAccessControl=c.protoAccessControl,g.helpers=c.helpers,g.partials=c.partials,g.decorators=c.decorators,g.hooks=c.hooks;else{var d={};m(d,b.helpers,g),m(d,c.helpers,g),g.helpers=d,a.usePartial&&(g.partials=g.mergeIfNeeded(c.partials,b.partials)),(a.usePartial||a.useDecorators)&&(g.decorators=t.extend({},b.decorators,c.decorators)),g.hooks={},g.protoAccessControl=z.createProtoAccessControl(c);var f=c.allowCallsToHelperMissing||e;x.moveHelperToHooks(g,"helperMissing",f),x.moveHelperToHooks(g,"blockHelperMissing",f)}},d._child=function(b,c,d,e){if(a.useBlockParams&&!d)throw new v["default"]("must pass block params");if(a.useDepths&&!e)throw new v["default"]("must pass parent depths");return f(g,b,a[b],c,0,d,e)},d}function f(a,b,c,d,e,f,g){function h(b){var e=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],h=g;return!g||b==g[0]||b===a.nullContext&&null===g[0]||(h=[b].concat(g)),c(a,b,a.helpers,a.partials,e.data||d,f&&[e.blockParams].concat(f),h)}return h=l(c,h,a,g,d,f),h.program=b,h.depth=g?g.length:0,h.blockParams=e||0,h}function g(a,b,c){return a?a.call||c.name||(c.name=a,a=j(c.partials,a)):a="@partial-block"===c.name?j(c.data,"partial-block"):j(c.partials,c.name),a}function h(a,b,c){var d=j(c.data,"partial-block");c.partial=!0,c.ids&&(c.data.contextPath=c.ids[0]||c.data.contextPath);var e=void 0;if(c.fn&&c.fn!==i&&!function(){c.data=w.createFrame(c.data);var a=c.fn;e=c.data["partial-block"]=function(b){var c=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];return c.data=w.createFrame(c.data),c.data["partial-block"]=d,a(b,c)},a.partials&&(c.partials=t.extend({},c.partials,a.partials))}(),void 0===a&&e&&(a=e),void 0===a)throw new v["default"]("The partial "+c.name+" could not be found");if(a instanceof Function)return a(b,c)}function i(){return""}function j(a,b){if(a&&Object.prototype.hasOwnProperty.call(a,b))return a[b]}function k(a,b){return b&&"root"in b||(b=b?w.createFrame(b):{},b.root=a),b}function l(a,b,c,d,e,f){if(a.decorator){var g={};b=a.decorator(b,g,c,d&&d[0],e,f,d),t.extend(b,g)}return b}function m(a,b,c){b&&p(b).forEach(function(d){var e=b[d];a[d]=n(e,c)})}function n(a,b){var c=b.lookupProperty;return y.wrapHelper(a,function(a){return a.lookupProperty=c,a})}var o=c(78)["default"],p=c(60)["default"],q=c(3)["default"],r=c(1)["default"];b.__esModule=!0,b.checkRevision=d,b.template=e,b.wrapProgram=f,b.resolvePartial=g,b.invokePartial=h,b.noop=i;var s=c(5),t=q(s),u=c(6),v=r(u),w=c(4),x=c(10),y=c(81),z=c(73)},function(a,b,c){a.exports={"default":c(79),__esModule:!0}},function(a,b,c){c(80),a.exports=c(21).Object.seal},function(a,b,c){var d=c(40);c(64)("seal",function(a){return function(b){return a&&d(b)?a(b):b}})},function(a,b){"use strict";function c(a,b){if("function"!=typeof a)return a;var c=function(){var c=arguments[arguments.length-1];return arguments[arguments.length-1]=b(c),a.apply(this,arguments)};return c}b.__esModule=!0,b.wrapHelper=c},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){!function(){"object"!=typeof globalThis&&(Object.prototype.__defineGetter__("__magic__",function(){return this}),__magic__.globalThis=__magic__,delete Object.prototype.__magic__)}();var b=globalThis.Handlebars;a.noConflict=function(){return globalThis.Handlebars===a&&(globalThis.Handlebars=b),a}},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0;var c={helpers:{helperExpression:function(a){return"SubExpression"===a.type||("MustacheStatement"===a.type||"BlockStatement"===a.type)&&!!(a.params&&a.params.length||a.hash)},scopedId:function(a){return/^\.|this\b/.test(a.original)},simpleId:function(a){return 1===a.parts.length&&!c.helpers.scopedId(a)&&!a.depth}}};b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b){if("Program"===a.type)return f(a),a;m["default"].yy=u,u.locInfo=function(a){return new u.SourceLocation(b&&b.srcName,a)};var c=m["default"].parse(a);return c}function e(a,b){var c=d(a,b),e=new o["default"](b);return e.accept(c)}function f(a){g(a)}function g(a){if(null!=a){if(Array.isArray(a))return void a.forEach(g);if("object"==typeof a){if("PathExpression"===a.type){if(!h(a.depth))throw new s["default"]("Invalid AST: PathExpression.depth must be an integer");if(!Array.isArray(a.parts))throw new s["default"]("Invalid AST: PathExpression.parts must be an array");for(var b=0;b<a.parts.length;b++)if("string"!=typeof a.parts[b])throw new s["default"]("Invalid AST: PathExpression.parts must only contain strings")}else if("NumberLiteral"===a.type){if("number"!=typeof a.value||!isFinite(a.value))throw new s["default"]("Invalid AST: NumberLiteral.value must be a number")}else if("BooleanLiteral"===a.type&&"boolean"!=typeof a.value)throw new s["default"]("Invalid AST: BooleanLiteral.value must be a boolean");i(a).forEach(function(b){"loc"!==b&&g(a[b])})}}}function h(a){return"number"==typeof a&&isFinite(a)&&Math.floor(a)===a&&a>=0}var i=c(60)["default"],j=c(1)["default"],k=c(3)["default"];b.__esModule=!0,b.parseWithoutProcessing=d,b.parse=e;var l=c(85),m=j(l),n=c(86),o=j(n),p=c(88),q=k(p),r=c(6),s=j(r),t=c(5);b.parser=m["default"];var u={};t.extend(u,q)},function(a,b){"use strict";b.__esModule=!0;var c=function(){function a(){this.yy={}}var b={trace:function(){},yy:{},symbols_:{error:2,root:3,program:4,EOF:5,program_repetition0:6,statement:7,mustache:8,block:9,rawBlock:10,partial:11,partialBlock:12,content:13,COMMENT:14,CONTENT:15,openRawBlock:16,rawBlock_repetition0:17,END_RAW_BLOCK:18,OPEN_RAW_BLOCK:19,helperName:20,openRawBlock_repetition0:21,openRawBlock_option0:22,CLOSE_RAW_BLOCK:23,openBlock:24,block_option0:25,closeBlock:26,openInverse:27,block_option1:28,OPEN_BLOCK:29,openBlock_repetition0:30,openBlock_option0:31,openBlock_option1:32,CLOSE:33,OPEN_INVERSE:34,openInverse_repetition0:35,openInverse_option0:36,openInverse_option1:37,openInverseChain:38,OPEN_INVERSE_CHAIN:39,openInverseChain_repetition0:40,openInverseChain_option0:41,openInverseChain_option1:42,inverseAndProgram:43,INVERSE:44,inverseChain:45,inverseChain_option0:46,OPEN_ENDBLOCK:47,OPEN:48,mustache_repetition0:49,mustache_option0:50,OPEN_UNESCAPED:51,mustache_repetition1:52,mustache_option1:53,CLOSE_UNESCAPED:54,OPEN_PARTIAL:55,partialName:56,partial_repetition0:57,partial_option0:58,openPartialBlock:59,OPEN_PARTIAL_BLOCK:60,openPartialBlock_repetition0:61,openPartialBlock_option0:62,param:63,sexpr:64,OPEN_SEXPR:65,sexpr_repetition0:66,sexpr_option0:67,CLOSE_SEXPR:68,hash:69,hash_repetition_plus0:70,hashSegment:71,ID:72,EQUALS:73,blockParams:74,OPEN_BLOCK_PARAMS:75,blockParams_repetition_plus0:76,CLOSE_BLOCK_PARAMS:77,path:78,dataName:79,STRING:80,NUMBER:81,BOOLEAN:82,UNDEFINED:83,NULL:84,DATA:85,pathSegments:86,SEP:87,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"COMMENT",15:"CONTENT",18:"END_RAW_BLOCK",19:"OPEN_RAW_BLOCK",23:"CLOSE_RAW_BLOCK",29:"OPEN_BLOCK",33:"CLOSE",34:"OPEN_INVERSE",39:"OPEN_INVERSE_CHAIN",44:"INVERSE",47:"OPEN_ENDBLOCK",48:"OPEN",51:"OPEN_UNESCAPED",54:"CLOSE_UNESCAPED",55:"OPEN_PARTIAL",60:"OPEN_PARTIAL_BLOCK",65:"OPEN_SEXPR",68:"CLOSE_SEXPR",72:"ID",73:"EQUALS",75:"OPEN_BLOCK_PARAMS",77:"CLOSE_BLOCK_PARAMS",80:"STRING",81:"NUMBER",82:"BOOLEAN",83:"UNDEFINED",84:"NULL",85:"DATA",
87:"SEP"},productions_:[0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[13,1],[10,3],[16,5],[9,4],[9,4],[24,6],[27,6],[38,6],[43,2],[45,3],[45,1],[26,3],[8,5],[8,5],[11,5],[12,3],[59,5],[63,1],[63,1],[64,5],[69,1],[71,3],[74,3],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[56,1],[56,1],[79,2],[78,1],[86,3],[86,1],[6,0],[6,2],[17,0],[17,2],[21,0],[21,2],[22,0],[22,1],[25,0],[25,1],[28,0],[28,1],[30,0],[30,2],[31,0],[31,1],[32,0],[32,1],[35,0],[35,2],[36,0],[36,1],[37,0],[37,1],[40,0],[40,2],[41,0],[41,1],[42,0],[42,1],[46,0],[46,1],[49,0],[49,2],[50,0],[50,1],[52,0],[52,2],[53,0],[53,1],[57,0],[57,2],[58,0],[58,1],[61,0],[61,2],[62,0],[62,1],[66,0],[66,2],[67,0],[67,1],[70,1],[70,2],[76,1],[76,2]],performAction:function(a,b,c,d,e,f,g){var h=f.length-1;switch(e){case 1:return f[h-1];case 2:this.$=d.prepareProgram(f[h]);break;case 3:this.$=f[h];break;case 4:this.$=f[h];break;case 5:this.$=f[h];break;case 6:this.$=f[h];break;case 7:this.$=f[h];break;case 8:this.$=f[h];break;case 9:this.$={type:"CommentStatement",value:d.stripComment(f[h]),strip:d.stripFlags(f[h],f[h]),loc:d.locInfo(this._$)};break;case 10:this.$={type:"ContentStatement",original:f[h],value:f[h],loc:d.locInfo(this._$)};break;case 11:this.$=d.prepareRawBlock(f[h-2],f[h-1],f[h],this._$);break;case 12:this.$={path:f[h-3],params:f[h-2],hash:f[h-1]};break;case 13:this.$=d.prepareBlock(f[h-3],f[h-2],f[h-1],f[h],!1,this._$);break;case 14:this.$=d.prepareBlock(f[h-3],f[h-2],f[h-1],f[h],!0,this._$);break;case 15:this.$={open:f[h-5],path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 16:this.$={path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 17:this.$={path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 18:this.$={strip:d.stripFlags(f[h-1],f[h-1]),program:f[h]};break;case 19:var i=d.prepareBlock(f[h-2],f[h-1],f[h],f[h],!1,this._$),j=d.prepareProgram([i],f[h-1].loc);j.chained=!0,this.$={strip:f[h-2].strip,program:j,chain:!0};break;case 20:this.$=f[h];break;case 21:this.$={path:f[h-1],strip:d.stripFlags(f[h-2],f[h])};break;case 22:this.$=d.prepareMustache(f[h-3],f[h-2],f[h-1],f[h-4],d.stripFlags(f[h-4],f[h]),this._$);break;case 23:this.$=d.prepareMustache(f[h-3],f[h-2],f[h-1],f[h-4],d.stripFlags(f[h-4],f[h]),this._$);break;case 24:this.$={type:"PartialStatement",name:f[h-3],params:f[h-2],hash:f[h-1],indent:"",strip:d.stripFlags(f[h-4],f[h]),loc:d.locInfo(this._$)};break;case 25:this.$=d.preparePartialBlock(f[h-2],f[h-1],f[h],this._$);break;case 26:this.$={path:f[h-3],params:f[h-2],hash:f[h-1],strip:d.stripFlags(f[h-4],f[h])};break;case 27:this.$=f[h];break;case 28:this.$=f[h];break;case 29:this.$={type:"SubExpression",path:f[h-3],params:f[h-2],hash:f[h-1],loc:d.locInfo(this._$)};break;case 30:this.$={type:"Hash",pairs:f[h],loc:d.locInfo(this._$)};break;case 31:this.$={type:"HashPair",key:d.id(f[h-2]),value:f[h],loc:d.locInfo(this._$)};break;case 32:this.$=d.id(f[h-1]);break;case 33:this.$=f[h];break;case 34:this.$=f[h];break;case 35:this.$={type:"StringLiteral",value:f[h],original:f[h],loc:d.locInfo(this._$)};break;case 36:this.$={type:"NumberLiteral",value:Number(f[h]),original:Number(f[h]),loc:d.locInfo(this._$)};break;case 37:this.$={type:"BooleanLiteral",value:"true"===f[h],original:"true"===f[h],loc:d.locInfo(this._$)};break;case 38:this.$={type:"UndefinedLiteral",original:void 0,value:void 0,loc:d.locInfo(this._$)};break;case 39:this.$={type:"NullLiteral",original:null,value:null,loc:d.locInfo(this._$)};break;case 40:this.$=f[h];break;case 41:this.$=f[h];break;case 42:this.$=d.preparePath(!0,f[h],this._$);break;case 43:this.$=d.preparePath(!1,f[h],this._$);break;case 44:f[h-2].push({part:d.id(f[h]),original:f[h],separator:f[h-1]}),this.$=f[h-2];break;case 45:this.$=[{part:d.id(f[h]),original:f[h]}];break;case 46:this.$=[];break;case 47:f[h-1].push(f[h]);break;case 48:this.$=[];break;case 49:f[h-1].push(f[h]);break;case 50:this.$=[];break;case 51:f[h-1].push(f[h]);break;case 58:this.$=[];break;case 59:f[h-1].push(f[h]);break;case 64:this.$=[];break;case 65:f[h-1].push(f[h]);break;case 70:this.$=[];break;case 71:f[h-1].push(f[h]);break;case 78:this.$=[];break;case 79:f[h-1].push(f[h]);break;case 82:this.$=[];break;case 83:f[h-1].push(f[h]);break;case 86:this.$=[];break;case 87:f[h-1].push(f[h]);break;case 90:this.$=[];break;case 91:f[h-1].push(f[h]);break;case 94:this.$=[];break;case 95:f[h-1].push(f[h]);break;case 98:this.$=[f[h]];break;case 99:f[h-1].push(f[h]);break;case 100:this.$=[f[h]];break;case 101:f[h-1].push(f[h])}},table:[{3:1,4:2,5:[2,46],6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:10,13:11,14:[1,12],15:[1,20],16:17,19:[1,23],24:15,27:16,29:[1,21],34:[1,22],39:[2,2],44:[2,2],47:[2,2],48:[1,13],51:[1,14],55:[1,18],59:19,60:[1,24]},{1:[2,1]},{5:[2,47],14:[2,47],15:[2,47],19:[2,47],29:[2,47],34:[2,47],39:[2,47],44:[2,47],47:[2,47],48:[2,47],51:[2,47],55:[2,47],60:[2,47]},{5:[2,3],14:[2,3],15:[2,3],19:[2,3],29:[2,3],34:[2,3],39:[2,3],44:[2,3],47:[2,3],48:[2,3],51:[2,3],55:[2,3],60:[2,3]},{5:[2,4],14:[2,4],15:[2,4],19:[2,4],29:[2,4],34:[2,4],39:[2,4],44:[2,4],47:[2,4],48:[2,4],51:[2,4],55:[2,4],60:[2,4]},{5:[2,5],14:[2,5],15:[2,5],19:[2,5],29:[2,5],34:[2,5],39:[2,5],44:[2,5],47:[2,5],48:[2,5],51:[2,5],55:[2,5],60:[2,5]},{5:[2,6],14:[2,6],15:[2,6],19:[2,6],29:[2,6],34:[2,6],39:[2,6],44:[2,6],47:[2,6],48:[2,6],51:[2,6],55:[2,6],60:[2,6]},{5:[2,7],14:[2,7],15:[2,7],19:[2,7],29:[2,7],34:[2,7],39:[2,7],44:[2,7],47:[2,7],48:[2,7],51:[2,7],55:[2,7],60:[2,7]},{5:[2,8],14:[2,8],15:[2,8],19:[2,8],29:[2,8],34:[2,8],39:[2,8],44:[2,8],47:[2,8],48:[2,8],51:[2,8],55:[2,8],60:[2,8]},{5:[2,9],14:[2,9],15:[2,9],19:[2,9],29:[2,9],34:[2,9],39:[2,9],44:[2,9],47:[2,9],48:[2,9],51:[2,9],55:[2,9],60:[2,9]},{20:25,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:36,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:37,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{4:38,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{15:[2,48],17:39,18:[2,48]},{20:41,56:40,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:44,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{5:[2,10],14:[2,10],15:[2,10],18:[2,10],19:[2,10],29:[2,10],34:[2,10],39:[2,10],44:[2,10],47:[2,10],48:[2,10],51:[2,10],55:[2,10],60:[2,10]},{20:45,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:46,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:47,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:41,56:48,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[2,78],49:49,65:[2,78],72:[2,78],80:[2,78],81:[2,78],82:[2,78],83:[2,78],84:[2,78],85:[2,78]},{23:[2,33],33:[2,33],54:[2,33],65:[2,33],68:[2,33],72:[2,33],75:[2,33],80:[2,33],81:[2,33],82:[2,33],83:[2,33],84:[2,33],85:[2,33]},{23:[2,34],33:[2,34],54:[2,34],65:[2,34],68:[2,34],72:[2,34],75:[2,34],80:[2,34],81:[2,34],82:[2,34],83:[2,34],84:[2,34],85:[2,34]},{23:[2,35],33:[2,35],54:[2,35],65:[2,35],68:[2,35],72:[2,35],75:[2,35],80:[2,35],81:[2,35],82:[2,35],83:[2,35],84:[2,35],85:[2,35]},{23:[2,36],33:[2,36],54:[2,36],65:[2,36],68:[2,36],72:[2,36],75:[2,36],80:[2,36],81:[2,36],82:[2,36],83:[2,36],84:[2,36],85:[2,36]},{23:[2,37],33:[2,37],54:[2,37],65:[2,37],68:[2,37],72:[2,37],75:[2,37],80:[2,37],81:[2,37],82:[2,37],83:[2,37],84:[2,37],85:[2,37]},{23:[2,38],33:[2,38],54:[2,38],65:[2,38],68:[2,38],72:[2,38],75:[2,38],80:[2,38],81:[2,38],82:[2,38],83:[2,38],84:[2,38],85:[2,38]},{23:[2,39],33:[2,39],54:[2,39],65:[2,39],68:[2,39],72:[2,39],75:[2,39],80:[2,39],81:[2,39],82:[2,39],83:[2,39],84:[2,39],85:[2,39]},{23:[2,43],33:[2,43],54:[2,43],65:[2,43],68:[2,43],72:[2,43],75:[2,43],80:[2,43],81:[2,43],82:[2,43],83:[2,43],84:[2,43],85:[2,43],87:[1,50]},{72:[1,35],86:51},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{52:52,54:[2,82],65:[2,82],72:[2,82],80:[2,82],81:[2,82],82:[2,82],83:[2,82],84:[2,82],85:[2,82]},{25:53,38:55,39:[1,57],43:56,44:[1,58],45:54,47:[2,54]},{28:59,43:60,44:[1,58],47:[2,56]},{13:62,15:[1,20],18:[1,61]},{33:[2,86],57:63,65:[2,86],72:[2,86],80:[2,86],81:[2,86],82:[2,86],83:[2,86],84:[2,86],85:[2,86]},{33:[2,40],65:[2,40],72:[2,40],80:[2,40],81:[2,40],82:[2,40],83:[2,40],84:[2,40],85:[2,40]},{33:[2,41],65:[2,41],72:[2,41],80:[2,41],81:[2,41],82:[2,41],83:[2,41],84:[2,41],85:[2,41]},{20:64,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:65,47:[1,66]},{30:67,33:[2,58],65:[2,58],72:[2,58],75:[2,58],80:[2,58],81:[2,58],82:[2,58],83:[2,58],84:[2,58],85:[2,58]},{33:[2,64],35:68,65:[2,64],72:[2,64],75:[2,64],80:[2,64],81:[2,64],82:[2,64],83:[2,64],84:[2,64],85:[2,64]},{21:69,23:[2,50],65:[2,50],72:[2,50],80:[2,50],81:[2,50],82:[2,50],83:[2,50],84:[2,50],85:[2,50]},{33:[2,90],61:70,65:[2,90],72:[2,90],80:[2,90],81:[2,90],82:[2,90],83:[2,90],84:[2,90],85:[2,90]},{20:74,33:[2,80],50:71,63:72,64:75,65:[1,43],69:73,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{72:[1,79]},{23:[2,42],33:[2,42],54:[2,42],65:[2,42],68:[2,42],72:[2,42],75:[2,42],80:[2,42],81:[2,42],82:[2,42],83:[2,42],84:[2,42],85:[2,42],87:[1,50]},{20:74,53:80,54:[2,84],63:81,64:75,65:[1,43],69:82,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:83,47:[1,66]},{47:[2,55]},{4:84,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{47:[2,20]},{20:85,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:86,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{26:87,47:[1,66]},{47:[2,57]},{5:[2,11],14:[2,11],15:[2,11],19:[2,11],29:[2,11],34:[2,11],39:[2,11],44:[2,11],47:[2,11],48:[2,11],51:[2,11],55:[2,11],60:[2,11]},{15:[2,49],18:[2,49]},{20:74,33:[2,88],58:88,63:89,64:75,65:[1,43],69:90,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{65:[2,94],66:91,68:[2,94],72:[2,94],80:[2,94],81:[2,94],82:[2,94],83:[2,94],84:[2,94],85:[2,94]},{5:[2,25],14:[2,25],15:[2,25],19:[2,25],29:[2,25],34:[2,25],39:[2,25],44:[2,25],47:[2,25],48:[2,25],51:[2,25],55:[2,25],60:[2,25]},{20:92,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,31:93,33:[2,60],63:94,64:75,65:[1,43],69:95,70:76,71:77,72:[1,78],75:[2,60],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,66],36:96,63:97,64:75,65:[1,43],69:98,70:76,71:77,72:[1,78],75:[2,66],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,22:99,23:[2,52],63:100,64:75,65:[1,43],69:101,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,92],62:102,63:103,64:75,65:[1,43],69:104,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,105]},{33:[2,79],65:[2,79],72:[2,79],80:[2,79],81:[2,79],82:[2,79],83:[2,79],84:[2,79],85:[2,79]},{33:[2,81]},{23:[2,27],33:[2,27],54:[2,27],65:[2,27],68:[2,27],72:[2,27],75:[2,27],80:[2,27],81:[2,27],82:[2,27],83:[2,27],84:[2,27],85:[2,27]},{23:[2,28],33:[2,28],54:[2,28],65:[2,28],68:[2,28],72:[2,28],75:[2,28],80:[2,28],81:[2,28],82:[2,28],83:[2,28],84:[2,28],85:[2,28]},{23:[2,30],33:[2,30],54:[2,30],68:[2,30],71:106,72:[1,107],75:[2,30]},{23:[2,98],33:[2,98],54:[2,98],68:[2,98],72:[2,98],75:[2,98]},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],73:[1,108],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{23:[2,44],33:[2,44],54:[2,44],65:[2,44],68:[2,44],72:[2,44],75:[2,44],80:[2,44],81:[2,44],82:[2,44],83:[2,44],84:[2,44],85:[2,44],87:[2,44]},{54:[1,109]},{54:[2,83],65:[2,83],72:[2,83],80:[2,83],81:[2,83],82:[2,83],83:[2,83],84:[2,83],85:[2,83]},{54:[2,85]},{5:[2,13],14:[2,13],15:[2,13],19:[2,13],29:[2,13],34:[2,13],39:[2,13],44:[2,13],47:[2,13],48:[2,13],51:[2,13],55:[2,13],60:[2,13]},{38:55,39:[1,57],43:56,44:[1,58],45:111,46:110,47:[2,76]},{33:[2,70],40:112,65:[2,70],72:[2,70],75:[2,70],80:[2,70],81:[2,70],82:[2,70],83:[2,70],84:[2,70],85:[2,70]},{47:[2,18]},{5:[2,14],14:[2,14],15:[2,14],19:[2,14],29:[2,14],34:[2,14],39:[2,14],44:[2,14],47:[2,14],48:[2,14],51:[2,14],55:[2,14],60:[2,14]},{33:[1,113]},{33:[2,87],65:[2,87],72:[2,87],80:[2,87],81:[2,87],82:[2,87],83:[2,87],84:[2,87],85:[2,87]},{33:[2,89]},{20:74,63:115,64:75,65:[1,43],67:114,68:[2,96],69:116,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,117]},{32:118,33:[2,62],74:119,75:[1,120]},{33:[2,59],65:[2,59],72:[2,59],75:[2,59],80:[2,59],81:[2,59],82:[2,59],83:[2,59],84:[2,59],85:[2,59]},{33:[2,61],75:[2,61]},{33:[2,68],37:121,74:122,75:[1,120]},{33:[2,65],65:[2,65],72:[2,65],75:[2,65],80:[2,65],81:[2,65],82:[2,65],83:[2,65],84:[2,65],85:[2,65]},{33:[2,67],75:[2,67]},{23:[1,123]},{23:[2,51],65:[2,51],72:[2,51],80:[2,51],81:[2,51],82:[2,51],83:[2,51],84:[2,51],85:[2,51]},{23:[2,53]},{33:[1,124]},{33:[2,91],65:[2,91],72:[2,91],80:[2,91],81:[2,91],82:[2,91],83:[2,91],84:[2,91],85:[2,91]},{33:[2,93]},{5:[2,22],14:[2,22],15:[2,22],19:[2,22],29:[2,22],34:[2,22],39:[2,22],44:[2,22],47:[2,22],48:[2,22],51:[2,22],55:[2,22],60:[2,22]},{23:[2,99],33:[2,99],54:[2,99],68:[2,99],72:[2,99],75:[2,99]},{73:[1,108]},{20:74,63:125,64:75,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,23],14:[2,23],15:[2,23],19:[2,23],29:[2,23],34:[2,23],39:[2,23],44:[2,23],47:[2,23],48:[2,23],51:[2,23],55:[2,23],60:[2,23]},{47:[2,19]},{47:[2,77]},{20:74,33:[2,72],41:126,63:127,64:75,65:[1,43],69:128,70:76,71:77,72:[1,78],75:[2,72],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,24],14:[2,24],15:[2,24],19:[2,24],29:[2,24],34:[2,24],39:[2,24],44:[2,24],47:[2,24],48:[2,24],51:[2,24],55:[2,24],60:[2,24]},{68:[1,129]},{65:[2,95],68:[2,95],72:[2,95],80:[2,95],81:[2,95],82:[2,95],83:[2,95],84:[2,95],85:[2,95]},{68:[2,97]},{5:[2,21],14:[2,21],15:[2,21],19:[2,21],29:[2,21],34:[2,21],39:[2,21],44:[2,21],47:[2,21],48:[2,21],51:[2,21],55:[2,21],60:[2,21]},{33:[1,130]},{33:[2,63]},{72:[1,132],76:131},{33:[1,133]},{33:[2,69]},{15:[2,12],18:[2,12]},{14:[2,26],15:[2,26],19:[2,26],29:[2,26],34:[2,26],47:[2,26],48:[2,26],51:[2,26],55:[2,26],60:[2,26]},{23:[2,31],33:[2,31],54:[2,31],68:[2,31],72:[2,31],75:[2,31]},{33:[2,74],42:134,74:135,75:[1,120]},{33:[2,71],65:[2,71],72:[2,71],75:[2,71],80:[2,71],81:[2,71],82:[2,71],83:[2,71],84:[2,71],85:[2,71]},{33:[2,73],75:[2,73]},{23:[2,29],33:[2,29],54:[2,29],65:[2,29],68:[2,29],72:[2,29],75:[2,29],80:[2,29],81:[2,29],82:[2,29],83:[2,29],84:[2,29],85:[2,29]},{14:[2,15],15:[2,15],19:[2,15],29:[2,15],34:[2,15],39:[2,15],44:[2,15],47:[2,15],48:[2,15],51:[2,15],55:[2,15],60:[2,15]},{72:[1,137],77:[1,136]},{72:[2,100],77:[2,100]},{14:[2,16],15:[2,16],19:[2,16],29:[2,16],34:[2,16],44:[2,16],47:[2,16],48:[2,16],51:[2,16],55:[2,16],60:[2,16]},{33:[1,138]},{33:[2,75]},{33:[2,32]},{72:[2,101],77:[2,101]},{14:[2,17],15:[2,17],19:[2,17],29:[2,17],34:[2,17],39:[2,17],44:[2,17],47:[2,17],48:[2,17],51:[2,17],55:[2,17],60:[2,17]}],defaultActions:{4:[2,1],54:[2,55],56:[2,20],60:[2,57],73:[2,81],82:[2,85],86:[2,18],90:[2,89],101:[2,53],104:[2,93],110:[2,19],111:[2,77],116:[2,97],119:[2,63],122:[2,69],135:[2,75],136:[2,32]},parseError:function(a,b){throw new Error(a)},parse:function(a){function b(){var a;return a=c.lexer.lex()||1,"number"!=typeof a&&(a=c.symbols_[a]||a),a}var c=this,d=[0],e=[null],f=[],g=this.table,h="",i=0,j=0,k=0;this.lexer.setInput(a),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,this.yy.parser=this,"undefined"==typeof this.lexer.yylloc&&(this.lexer.yylloc={});var l=this.lexer.yylloc;f.push(l);var m=this.lexer.options&&this.lexer.options.ranges;"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var n,o,p,q,r,s,t,u,v,w={};;){if(p=d[d.length-1],this.defaultActions[p]?q=this.defaultActions[p]:(null!==n&&"undefined"!=typeof n||(n=b()),q=g[p]&&g[p][n]),"undefined"==typeof q||!q.length||!q[0]){var x="";if(!k){v=[];for(s in g[p])this.terminals_[s]&&s>2&&v.push("'"+this.terminals_[s]+"'");x=this.lexer.showPosition?"Parse error on line "+(i+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+v.join(", ")+", got '"+(this.terminals_[n]||n)+"'":"Parse error on line "+(i+1)+": Unexpected "+(1==n?"end of input":"'"+(this.terminals_[n]||n)+"'"),this.parseError(x,{text:this.lexer.match,token:this.terminals_[n]||n,line:this.lexer.yylineno,loc:l,expected:v})}}if(q[0]instanceof Array&&q.length>1)throw new Error("Parse Error: multiple actions possible at state: "+p+", token: "+n);switch(q[0]){case 1:d.push(n),e.push(this.lexer.yytext),f.push(this.lexer.yylloc),d.push(q[1]),n=null,o?(n=o,o=null):(j=this.lexer.yyleng,h=this.lexer.yytext,i=this.lexer.yylineno,l=this.lexer.yylloc,k>0&&k--);break;case 2:if(t=this.productions_[q[1]][1],w.$=e[e.length-t],w._$={first_line:f[f.length-(t||1)].first_line,last_line:f[f.length-1].last_line,first_column:f[f.length-(t||1)].first_column,last_column:f[f.length-1].last_column},m&&(w._$.range=[f[f.length-(t||1)].range[0],f[f.length-1].range[1]]),r=this.performAction.call(w,h,j,i,this.yy,q[1],e,f),"undefined"!=typeof r)return r;t&&(d=d.slice(0,-1*t*2),e=e.slice(0,-1*t),f=f.slice(0,-1*t)),d.push(this.productions_[q[1]][0]),e.push(w.$),f.push(w._$),u=g[d[d.length-2]][d[d.length-1]],d.push(u);break;case 3:return!0}}return!0}},c=function(){var a={EOF:1,parseError:function(a,b){if(!this.yy.parser)throw new Error(a);this.yy.parser.parseError(a,b)},setInput:function(a){return this._input=a,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var a=this._input[0];this.yytext+=a,this.yyleng++,this.offset++,this.match+=a,this.matched+=a;var b=a.match(/(?:\r\n?|\n).*/g);return b?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),a},unput:function(a){var b=a.length,c=a.split(/(?:\r\n?|\n)/g);this._input=a+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-b-1),this.offset-=b;var d=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),c.length-1&&(this.yylineno-=c.length-1);var e=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:c?(c.length===d.length?this.yylloc.first_column:0)+d[d.length-c.length].length-c[0].length:this.yylloc.first_column-b},this.options.ranges&&(this.yylloc.range=[e[0],e[0]+this.yyleng-b]),this},more:function(){return this._more=!0,this},less:function(a){this.unput(this.match.slice(a))},pastInput:function(){var a=this.matched.substr(0,this.matched.length-this.match.length);return(a.length>20?"...":"")+a.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var a=this.match;return a.length<20&&(a+=this._input.substr(0,20-a.length)),(a.substr(0,20)+(a.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var a=this.pastInput(),b=new Array(a.length+1).join("-");return a+this.upcomingInput()+"\n"+b+"^"},next:function(){if(this.done)return this.EOF;this._input||(this.done=!0);var a,b,c,d,e;this._more||(this.yytext="",this.match="");for(var f=this._currentRules(),g=0;g<f.length&&(c=this._input.match(this.rules[f[g]]),!c||b&&!(c[0].length>b[0].length)||(b=c,d=g,this.options.flex));g++);return b?(e=b[0].match(/(?:\r\n?|\n).*/g),e&&(this.yylineno+=e.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:e?e[e.length-1].length-e[e.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+b[0].length},this.yytext+=b[0],this.match+=b[0],this.matches=b,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._input=this._input.slice(b[0].length),this.matched+=b[0],a=this.performAction.call(this,this.yy,this,f[d],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),a?a:void 0):""===this._input?this.EOF:this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var a=this.next();return"undefined"!=typeof a?a:this.lex()},begin:function(a){this.conditionStack.push(a)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(a){this.begin(a)}};return a.options={},a.performAction=function(a,b,c,d){function e(a,c){return b.yytext=b.yytext.substring(a,b.yyleng-c+a)}switch(c){case 0:if("\\\\"===b.yytext.slice(-2)?(e(0,1),this.begin("mu")):"\\"===b.yytext.slice(-1)?(e(0,1),this.begin("emu")):this.begin("mu"),b.yytext)return 15;break;case 1:return 15;case 2:return this.popState(),15;case 3:return this.begin("raw"),15;case 4:return this.popState(),"raw"===this.conditionStack[this.conditionStack.length-1]?15:(e(5,9),"END_RAW_BLOCK");case 5:return 15;case 6:return this.popState(),14;case 7:return 65;case 8:return 68;case 9:return 19;case 10:return this.popState(),this.begin("raw"),23;case 11:return 55;case 12:return 60;case 13:return 29;case 14:return 47;case 15:return this.popState(),44;case 16:return this.popState(),44;case 17:return 34;case 18:return 39;case 19:return 51;case 20:return 48;case 21:this.unput(b.yytext),this.popState(),this.begin("com");break;case 22:return this.popState(),14;case 23:return 48;case 24:return 73;case 25:return 72;case 26:return 72;case 27:return 87;case 28:break;case 29:return this.popState(),54;case 30:return this.popState(),33;case 31:return b.yytext=e(1,2).replace(/\\"/g,'"'),80;case 32:return b.yytext=e(1,2).replace(/\\'/g,"'"),80;case 33:return 85;case 34:return 82;case 35:return 82;case 36:return 83;case 37:return 84;case 38:return 81;case 39:return 75;case 40:return 77;case 41:return 72;case 42:return b.yytext=b.yytext.replace(/\\([\\\]])/g,"$1"),72;case 43:return"INVALID";case 44:return 5}},a.rules=[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{(?=[^\/]))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]+?(?=(\{\{\{\{)))/,/^(?:[\s\S]*?--(~)?\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#>)/,/^(?:\{\{(~)?#\*?)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{(~)?!--)/,/^(?:\{\{(~)?![\s\S]*?\}\})/,/^(?:\{\{(~)?\*?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)|])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:undefined(?=([~}\s)])))/,/^(?:null(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:as\s+\|)/,/^(?:\|)/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,/^(?:\[(\\\]|[^\]])*\])/,/^(?:.)/,/^(?:$)/],a.conditions={mu:{rules:[7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44],inclusive:!1},emu:{rules:[2],inclusive:!1},com:{rules:[6],inclusive:!1},raw:{rules:[3,4,5],inclusive:!1},INITIAL:{rules:[0,1,44],inclusive:!0}},a}();return b.lexer=c,a.prototype=b,b.Parser=a,new a}();b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(){var a=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.options=a}function e(a,b,c){void 0===b&&(b=a.length);var d=a[b-1],e=a[b-2];return d?"ContentStatement"===d.type?(e||!c?/\r?\n\s*?$/:/(^|\r?\n)\s*?$/).test(d.original):void 0:c}function f(a,b,c){void 0===b&&(b=-1);var d=a[b+1],e=a[b+2];return d?"ContentStatement"===d.type?(e||!c?/^\s*?\r?\n/:/^\s*?(\r?\n|$)/).test(d.original):void 0:c}function g(a,b,c){var d=a[null==b?0:b+1];if(d&&"ContentStatement"===d.type&&(c||!d.rightStripped)){var e=d.value;d.value=d.value.replace(c?/^\s+/:/^[ \t]*\r?\n?/,""),d.rightStripped=d.value!==e}}function h(a,b,c){var d=a[null==b?a.length-1:b-1];if(d&&"ContentStatement"===d.type&&(c||!d.leftStripped)){var e=d.value;return d.value=d.value.replace(c?/\s+$/:/[ \t]+$/,""),d.leftStripped=d.value!==e,d.leftStripped}}var i=c(1)["default"];b.__esModule=!0;var j=c(87),k=i(j);d.prototype=new k["default"],d.prototype.Program=function(a){var b=!this.options.ignoreStandalone,c=!this.isRootSeen;this.isRootSeen=!0;for(var d=a.body,i=0,j=d.length;i<j;i++){var k=d[i],l=this.accept(k);if(l){var m=e(d,i,c),n=f(d,i,c),o=l.openStandalone&&m,p=l.closeStandalone&&n,q=l.inlineStandalone&&m&&n;l.close&&g(d,i,!0),l.open&&h(d,i,!0),b&&q&&(g(d,i),h(d,i)&&"PartialStatement"===k.type&&(k.indent=/([ \t]+$)/.exec(d[i-1].original)[1])),b&&o&&(g((k.program||k.inverse).body),h(d,i)),b&&p&&(g(d,i),h((k.inverse||k.program).body))}}return a},d.prototype.BlockStatement=d.prototype.DecoratorBlock=d.prototype.PartialBlockStatement=function(a){this.accept(a.program),this.accept(a.inverse);var b=a.program||a.inverse,c=a.program&&a.inverse,d=c,i=c;if(c&&c.chained)for(d=c.body[0].program;i.chained;)i=i.body[i.body.length-1].program;var j={open:a.openStrip.open,close:a.closeStrip.close,openStandalone:f(b.body),closeStandalone:e((d||b).body)};if(a.openStrip.close&&g(b.body,null,!0),c){var k=a.inverseStrip;k.open&&h(b.body,null,!0),k.close&&g(d.body,null,!0),a.closeStrip.open&&h(i.body,null,!0),!this.options.ignoreStandalone&&e(b.body)&&f(d.body)&&(h(b.body),g(d.body))}else a.closeStrip.open&&h(b.body,null,!0);return j},d.prototype.Decorator=d.prototype.MustacheStatement=function(a){return a.strip},d.prototype.PartialStatement=d.prototype.CommentStatement=function(a){var b=a.strip||{};return{inlineStandalone:!0,open:b.open,close:b.close}},b["default"]=d,a.exports=b["default"]},function(a,b,c){"use strict";function d(){this.parents=[]}function e(a){this.acceptRequired(a,"path"),this.acceptArray(a.params),this.acceptKey(a,"hash")}function f(a){e.call(this,a),this.acceptKey(a,"program"),this.acceptKey(a,"inverse")}function g(a){this.acceptRequired(a,"name"),this.acceptArray(a.params),this.acceptKey(a,"hash")}var h=c(1)["default"];b.__esModule=!0;var i=c(6),j=h(i);d.prototype={constructor:d,mutating:!1,acceptKey:function(a,b){var c=this.accept(a[b]);if(this.mutating){if(c&&!d.prototype[c.type])throw new j["default"]('Unexpected node type "'+c.type+'" found when accepting '+b+" on "+a.type);a[b]=c}},acceptRequired:function(a,b){if(this.acceptKey(a,b),!a[b])throw new j["default"](a.type+" requires "+b)},acceptArray:function(a){for(var b=0,c=a.length;b<c;b++)this.acceptKey(a,b),a[b]||(a.splice(b,1),b--,c--)},accept:function(a){if(a){if(!this[a.type])throw new j["default"]("Unknown type: "+a.type,a);this.current&&this.parents.unshift(this.current),this.current=a;var b=this[a.type](a);return this.current=this.parents.shift(),!this.mutating||b?b:b!==!1?a:void 0}},Program:function(a){this.acceptArray(a.body)},MustacheStatement:e,Decorator:e,BlockStatement:f,DecoratorBlock:f,PartialStatement:g,PartialBlockStatement:function(a){g.call(this,a),this.acceptKey(a,"program")},ContentStatement:function(){},CommentStatement:function(){},SubExpression:e,PathExpression:function(){},StringLiteral:function(){},NumberLiteral:function(){},BooleanLiteral:function(){},UndefinedLiteral:function(){},NullLiteral:function(){},Hash:function(a){this.acceptArray(a.pairs)},HashPair:function(a){this.acceptRequired(a,"value")}},b["default"]=d,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b){if(b=b.path?b.path.original:b,a.path.original!==b){var c={loc:a.path.loc};throw new q["default"](a.path.original+" doesn't match "+b,c)}}function e(a,b){this.source=a,this.start={line:b.first_line,column:b.first_column},this.end={line:b.last_line,column:b.last_column}}function f(a){return/^\[.*\]$/.test(a)?a.substring(1,a.length-1):a}function g(a,b){return{open:"~"===a.charAt(2),close:"~"===b.charAt(b.length-3)}}function h(a){return a.replace(/^\{\{~?!-?-?/,"").replace(/-?-?~?\}\}$/,"")}function i(a,b,c){c=this.locInfo(c);for(var d=a?"@":"",e=[],f=0,g=0,h=b.length;g<h;g++){var i=b[g].part,j=b[g].original!==i;if(d+=(b[g].separator||"")+i,j||".."!==i&&"."!==i&&"this"!==i)e.push(i);else{if(e.length>0)throw new q["default"]("Invalid path: "+d,{loc:c});".."===i&&f++}}return{type:"PathExpression",data:a,depth:f,parts:e,original:d,loc:c}}function j(a,b,c,d,e,f){var g=d.charAt(3)||d.charAt(2),h="{"!==g&&"&"!==g,i=/\*/.test(d);return{type:i?"Decorator":"MustacheStatement",path:a,params:b,hash:c,escaped:h,strip:e,loc:this.locInfo(f)}}function k(a,b,c,e){d(a,c),e=this.locInfo(e);var f={type:"Program",body:b,strip:{},loc:e};return{type:"BlockStatement",path:a.path,params:a.params,hash:a.hash,program:f,openStrip:{},inverseStrip:{},closeStrip:{},loc:e}}function l(a,b,c,e,f,g){e&&e.path&&d(a,e);var h=/\*/.test(a.open);b.blockParams=a.blockParams;var i=void 0,j=void 0;if(c){if(h)throw new q["default"]("Unexpected inverse block on decorator",c);c.chain&&(c.program.body[0].closeStrip=e.strip),j=c.strip,i=c.program}return f&&(f=i,i=b,b=f),{type:h?"DecoratorBlock":"BlockStatement",path:a.path,params:a.params,hash:a.hash,program:b,inverse:i,openStrip:a.strip,inverseStrip:j,closeStrip:e&&e.strip,loc:this.locInfo(g)}}function m(a,b){if(!b&&a.length){var c=a[0].loc,d=a[a.length-1].loc;c&&d&&(b={source:c.source,start:{line:c.start.line,column:c.start.column},end:{line:d.end.line,column:d.end.column}})}return{type:"Program",body:a,strip:{},loc:b}}function n(a,b,c,e){return d(a,c),{type:"PartialBlockStatement",name:a.path,params:a.params,hash:a.hash,program:b,openStrip:a.strip,closeStrip:c&&c.strip,loc:this.locInfo(e)}}var o=c(1)["default"];b.__esModule=!0,b.SourceLocation=e,b.id=f,b.stripFlags=g,b.stripComment=h,b.preparePath=i,b.prepareMustache=j,b.prepareRawBlock=k,b.prepareBlock=l,b.prepareProgram=m,b.preparePartialBlock=n;var p=c(6),q=o(p)},function(a,b,c){"use strict";function d(){}function e(a,b,c){if(null==a||"string"!=typeof a&&"Program"!==a.type)throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+a);b=b||{},"data"in b||(b.data=!0),b.compat&&(b.useDepths=!0);var d=c.parse(a,b),e=(new c.Compiler).compile(d,b);return(new c.JavaScriptCompiler).compile(e,b)}function f(a,b,c){function d(){var d=c.parse(a,b),e=(new c.Compiler).compile(d,b),f=(new c.JavaScriptCompiler).compile(e,b,void 0,!0);return c.template(f)}function e(a,b){return f||(f=d()),f.call(this,a,b)}if(void 0===b&&(b={}),null==a||"string"!=typeof a&&"Program"!==a.type)throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+a);b=m.extend({},b),"data"in b||(b.data=!0),b.compat&&(b.useDepths=!0);var f=void 0;return e._setup=function(a){return f||(f=d()),f._setup(a)},e._child=function(a,b,c,e){return f||(f=d()),
f._child(a,b,c,e)},e}function g(a,b){if(a===b)return!0;if(m.isArray(a)&&m.isArray(b)&&a.length===b.length){for(var c=0;c<a.length;c++)if(!g(a[c],b[c]))return!1;return!0}}function h(a){if(!a.path.parts){var b=a.path;a.path={type:"PathExpression",data:!1,depth:0,parts:[b.original+""],original:b.original+"",loc:b.loc}}}var i=c(74)["default"],j=c(1)["default"];b.__esModule=!0,b.Compiler=d,b.precompile=e,b.compile=f;var k=c(6),l=j(k),m=c(5),n=c(83),o=j(n),p=[].slice;d.prototype={compiler:d,equals:function(a){var b=this.opcodes.length;if(a.opcodes.length!==b)return!1;for(var c=0;c<b;c++){var d=this.opcodes[c],e=a.opcodes[c];if(d.opcode!==e.opcode||!g(d.args,e.args))return!1}b=this.children.length;for(var c=0;c<b;c++)if(!this.children[c].equals(a.children[c]))return!1;return!0},guid:0,compile:function(a,b){return this.sourceNode=[],this.opcodes=[],this.children=[],this.options=b,this.stringParams=b.stringParams,this.trackIds=b.trackIds,b.blockParams=b.blockParams||[],b.knownHelpers=m.extend(i(null),{helperMissing:!0,blockHelperMissing:!0,each:!0,"if":!0,unless:!0,"with":!0,log:!0,lookup:!0},b.knownHelpers),this.accept(a)},compileProgram:function(a){var b=new this.compiler,c=b.compile(a,this.options),d=this.guid++;return this.usePartial=this.usePartial||c.usePartial,this.children[d]=c,this.useDepths=this.useDepths||c.useDepths,d},accept:function(a){if(!this[a.type])throw new l["default"]("Unknown type: "+a.type,a);this.sourceNode.unshift(a);var b=this[a.type](a);return this.sourceNode.shift(),b},Program:function(a){this.options.blockParams.unshift(a.blockParams);for(var b=a.body,c=b.length,d=0;d<c;d++)this.accept(b[d]);return this.options.blockParams.shift(),this.isSimple=1===c,this.blockParams=a.blockParams?a.blockParams.length:0,this},BlockStatement:function(a){h(a);var b=a.program,c=a.inverse;b=b&&this.compileProgram(b),c=c&&this.compileProgram(c);var d=this.classifySexpr(a);"helper"===d?this.helperSexpr(a,b,c):"simple"===d?(this.simpleSexpr(a),this.opcode("pushProgram",b),this.opcode("pushProgram",c),this.opcode("emptyHash"),this.opcode("blockValue",a.path.original)):(this.ambiguousSexpr(a,b,c),this.opcode("pushProgram",b),this.opcode("pushProgram",c),this.opcode("emptyHash"),this.opcode("ambiguousBlockValue")),this.opcode("append")},DecoratorBlock:function(a){var b=a.program&&this.compileProgram(a.program),c=this.setupFullMustacheParams(a,b,void 0),d=a.path;this.useDecorators=!0,this.opcode("registerDecorator",c.length,d.original)},PartialStatement:function(a){this.usePartial=!0;var b=a.program;b&&(b=this.compileProgram(a.program));var c=a.params;if(c.length>1)throw new l["default"]("Unsupported number of partial arguments: "+c.length,a);c.length||(this.options.explicitPartialContext?this.opcode("pushLiteral","undefined"):c.push({type:"PathExpression",parts:[],depth:0}));var d=a.name.original,e="SubExpression"===a.name.type;e&&this.accept(a.name),this.setupFullMustacheParams(a,b,void 0,!0);var f=a.indent||"";this.options.preventIndent&&f&&(this.opcode("appendContent",f),f=""),this.opcode("invokePartial",e,d,f),this.opcode("append")},PartialBlockStatement:function(a){this.PartialStatement(a)},MustacheStatement:function(a){this.SubExpression(a),a.escaped&&!this.options.noEscape?this.opcode("appendEscaped"):this.opcode("append")},Decorator:function(a){this.DecoratorBlock(a)},ContentStatement:function(a){a.value&&this.opcode("appendContent",a.value)},CommentStatement:function(){},SubExpression:function(a){h(a);var b=this.classifySexpr(a);"simple"===b?this.simpleSexpr(a):"helper"===b?this.helperSexpr(a):this.ambiguousSexpr(a)},ambiguousSexpr:function(a,b,c){var d=a.path,e=d.parts[0],f=null!=b||null!=c;this.opcode("getContext",d.depth),this.opcode("pushProgram",b),this.opcode("pushProgram",c),d.strict=!0,this.accept(d),this.opcode("invokeAmbiguous",e,f)},simpleSexpr:function(a){var b=a.path;b.strict=!0,this.accept(b),this.opcode("resolvePossibleLambda")},helperSexpr:function(a,b,c){var d=this.setupFullMustacheParams(a,b,c),e=a.path,f=e.parts[0];if(this.options.knownHelpers[f])this.opcode("invokeKnownHelper",d.length,f);else{if(this.options.knownHelpersOnly)throw new l["default"]("You specified knownHelpersOnly, but used the unknown helper "+f,a);e.strict=!0,e.falsy=!0,this.accept(e),this.opcode("invokeHelper",d.length,e.original,o["default"].helpers.simpleId(e))}},PathExpression:function(a){this.addDepth(a.depth),this.opcode("getContext",a.depth);var b=a.parts[0],c=o["default"].helpers.scopedId(a),d=!a.depth&&!c&&this.blockParamIndex(b);d?this.opcode("lookupBlockParam",d,a.parts):b?a.data?(this.options.data=!0,this.opcode("lookupData",a.depth,a.parts,a.strict)):this.opcode("lookupOnContext",a.parts,a.falsy,a.strict,c):this.opcode("pushContext")},StringLiteral:function(a){this.opcode("pushString",a.value)},NumberLiteral:function(a){this.opcode("pushLiteral",a.value)},BooleanLiteral:function(a){this.opcode("pushLiteral",a.value)},UndefinedLiteral:function(){this.opcode("pushLiteral","undefined")},NullLiteral:function(){this.opcode("pushLiteral","null")},Hash:function(a){var b=a.pairs,c=0,d=b.length;for(this.opcode("pushHash");c<d;c++)this.pushParam(b[c].value);for(;c--;)this.opcode("assignToHash",b[c].key);this.opcode("popHash")},opcode:function(a){this.opcodes.push({opcode:a,args:p.call(arguments,1),loc:this.sourceNode[0].loc})},addDepth:function(a){a&&(this.useDepths=!0)},classifySexpr:function(a){var b=o["default"].helpers.simpleId(a.path),c=b&&!!this.blockParamIndex(a.path.parts[0]),d=!c&&o["default"].helpers.helperExpression(a),e=!c&&(d||b);if(e&&!d){var f=a.path.parts[0],g=this.options;g.knownHelpers[f]?d=!0:g.knownHelpersOnly&&(e=!1)}return d?"helper":e?"ambiguous":"simple"},pushParams:function(a){for(var b=0,c=a.length;b<c;b++)this.pushParam(a[b])},pushParam:function(a){var b=null!=a.value?a.value:a.original||"";if(this.stringParams)b.replace&&(b=b.replace(/^(\.?\.\/)*/g,"").replace(/\//g,".")),a.depth&&this.addDepth(a.depth),this.opcode("getContext",a.depth||0),this.opcode("pushStringParam",b,a.type),"SubExpression"===a.type&&this.accept(a);else{if(this.trackIds){var c=void 0;if(!a.parts||o["default"].helpers.scopedId(a)||a.depth||(c=this.blockParamIndex(a.parts[0])),c){var d=a.parts.slice(1).join(".");this.opcode("pushId","BlockParam",c,d)}else b=a.original||b,b.replace&&(b=b.replace(/^this(?:\.|$)/,"").replace(/^\.\//,"").replace(/^\.$/,"")),this.opcode("pushId",a.type,b)}this.accept(a)}},setupFullMustacheParams:function(a,b,c,d){var e=a.params;return this.pushParams(e),this.opcode("pushProgram",b),this.opcode("pushProgram",c),a.hash?this.accept(a.hash):this.opcode("emptyHash",d),e},blockParamIndex:function(a){for(var b=0,c=this.options.blockParams.length;b<c;b++){var d=this.options.blockParams[b],e=d&&m.indexOf(d,a);if(d&&e>=0)return[b,e]}}}},function(a,b,c){"use strict";function d(a){this.value=a}function e(){}function f(a,b,c,d,e){var f=b.popStack(),g=c.length;a&&g--;for(var h=d;h<g;h++)f=b.nameLookup(f,c[h],e);return a?[b.aliasable("container.strict"),"(",f,", ",b.quotedString(c[g]),", ",JSON.stringify(b.source.currentLocation)," )"]:f}var g=c(60)["default"],h=c(1)["default"];b.__esModule=!0;var i=c(4),j=c(6),k=h(j),l=c(5),m=c(91),n=h(m);e.prototype={nameLookup:function(a,b){return this.internalNameLookup(a,b)},depthedLookup:function(a){return[this.aliasable("container.lookup"),"(depths, ",JSON.stringify(a),")"]},compilerInfo:function(){var a=i.COMPILER_REVISION,b=i.REVISION_CHANGES[a];return[a,b]},appendToBuffer:function(a,b,c){return l.isArray(a)||(a=[a]),a=this.source.wrap(a,b),this.environment.isSimple?["return ",a,";"]:c?["buffer += ",a,";"]:(a.appendToBuffer=!0,a)},initializeBuffer:function(){return this.quotedString("")},internalNameLookup:function(a,b){return this.lookupPropertyFunctionIsUsed=!0,["lookupProperty(",a,",",JSON.stringify(b),")"]},lookupPropertyFunctionIsUsed:!1,compile:function(a,b,c,d){this.environment=a,this.options=b,this.stringParams=this.options.stringParams,this.trackIds=this.options.trackIds,this.precompile=!d,this.name=this.environment.name,this.isChild=!!c,this.context=c||{decorators:[],programs:[],environments:[]},this.preamble(),this.stackSlot=0,this.stackVars=[],this.aliases={},this.registers={list:[]},this.hashes=[],this.compileStack=[],this.inlineStack=[],this.blockParams=[],this.compileChildren(a,b),this.useDepths=this.useDepths||a.useDepths||a.useDecorators||this.options.compat,this.useBlockParams=this.useBlockParams||a.useBlockParams;var e=a.opcodes,f=void 0,g=void 0,h=void 0,i=void 0;for(h=0,i=e.length;h<i;h++)f=e[h],this.source.currentLocation=f.loc,g=g||f.loc,this[f.opcode].apply(this,f.args);if(this.source.currentLocation=g,this.pushSource(""),this.stackSlot||this.inlineStack.length||this.compileStack.length)throw new k["default"]("Compile completed with content left on stack");this.decorators.isEmpty()?this.decorators=void 0:(this.useDecorators=!0,this.decorators.prepend(["var decorators = container.decorators, ",this.lookupPropertyFunctionVarDeclaration(),";\n"]),this.decorators.push("return fn;"),d?this.decorators=Function.apply(this,["fn","props","container","depth0","data","blockParams","depths",this.decorators.merge()]):(this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"),this.decorators.push("}\n"),this.decorators=this.decorators.merge()));var j=this.createFunctionContext(d);if(this.isChild)return j;var l={compiler:this.compilerInfo(),main:j};this.decorators&&(l.main_d=this.decorators,l.useDecorators=!0);var m=this.context,n=m.programs,o=m.decorators;for(h=0,i=n.length;h<i;h++)l[h]=n[h],o[h]&&(l[h+"_d"]=o[h],l.useDecorators=!0);return this.environment.usePartial&&(l.usePartial=!0),this.options.data&&(l.useData=!0),this.useDepths&&(l.useDepths=!0),this.useBlockParams&&(l.useBlockParams=!0),this.options.compat&&(l.compat=!0),d?l.compilerOptions=this.options:(l.compiler=JSON.stringify(l.compiler),this.source.currentLocation={start:{line:1,column:0}},l=this.objectLiteral(l),b.srcName?(l=l.toStringWithSourceMap({file:b.destName}),l.map=l.map&&l.map.toString()):l=l.toString()),l},preamble:function(){this.lastContext=0,this.source=new n["default"](this.options.srcName),this.decorators=new n["default"](this.options.srcName)},createFunctionContext:function(a){var b=this,c="",d=this.stackVars.concat(this.registers.list);d.length>0&&(c+=", "+d.join(", "));var e=0;g(this.aliases).forEach(function(a){var d=b.aliases[a];d.children&&d.referenceCount>1&&(c+=", alias"+ ++e+"="+a,d.children[0]="alias"+e)}),this.lookupPropertyFunctionIsUsed&&(c+=", "+this.lookupPropertyFunctionVarDeclaration());var f=["container","depth0","helpers","partials","data"];(this.useBlockParams||this.useDepths)&&f.push("blockParams"),this.useDepths&&f.push("depths");var h=this.mergeSource(c);return a?(f.push(h),Function.apply(this,f)):this.source.wrap(["function(",f.join(","),") {\n  ",h,"}"])},mergeSource:function(a){var b=this.environment.isSimple,c=!this.forceBuffer,d=void 0,e=void 0,f=void 0,g=void 0;return this.source.each(function(a){a.appendToBuffer?(f?a.prepend("  + "):f=a,g=a):(f&&(e?f.prepend("buffer += "):d=!0,g.add(";"),f=g=void 0),e=!0,b||(c=!1))}),c?f?(f.prepend("return "),g.add(";")):e||this.source.push('return "";'):(a+=", buffer = "+(d?"":this.initializeBuffer()),f?(f.prepend("return buffer + "),g.add(";")):this.source.push("return buffer;")),a&&this.source.prepend("var "+a.substring(2)+(d?"":";\n")),this.source.merge()},lookupPropertyFunctionVarDeclaration:function(){return"\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim()},blockValue:function(a){var b=this.aliasable("container.hooks.blockHelperMissing"),c=[this.contextName(0)];this.setupHelperArgs(a,0,c);var d=this.popStack();c.splice(1,0,d),this.push(this.source.functionCall(b,"call",c))},ambiguousBlockValue:function(){var a=this.aliasable("container.hooks.blockHelperMissing"),b=[this.contextName(0)];this.setupHelperArgs("",0,b,!0),this.flushInline();var c=this.topStack();b.splice(1,0,c),this.pushSource(["if (!",this.lastHelper,") { ",c," = ",this.source.functionCall(a,"call",b),"}"])},appendContent:function(a){this.pendingContent?a=this.pendingContent+a:this.pendingLocation=this.source.currentLocation,this.pendingContent=a},append:function(){if(this.isInline())this.replaceStack(function(a){return[" != null ? ",a,' : ""']}),this.pushSource(this.appendToBuffer(this.popStack()));else{var a=this.popStack();this.pushSource(["if (",a," != null) { ",this.appendToBuffer(a,void 0,!0)," }"]),this.environment.isSimple&&this.pushSource(["else { ",this.appendToBuffer("''",void 0,!0)," }"])}},appendEscaped:function(){this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"),"(",this.popStack(),")"]))},getContext:function(a){this.lastContext=a},pushContext:function(){this.pushStackLiteral(this.contextName(this.lastContext))},lookupOnContext:function(a,b,c,d){var e=0;d||!this.options.compat||this.lastContext?this.pushContext():this.push(this.depthedLookup(a[e++])),this.resolvePath("context",a,e,b,c)},lookupBlockParam:function(a,b){this.useBlockParams=!0,this.push(["blockParams[",a[0],"][",a[1],"]"]),this.resolvePath("context",b,1)},lookupData:function(a,b,c){a?this.pushStackLiteral("container.data(data, "+a+")"):this.pushStackLiteral("data"),this.resolvePath("data",b,0,!0,c)},resolvePath:function(a,b,c,d,e){var g=this;if(this.options.strict||this.options.assumeObjects)return void this.push(f(this.options.strict&&e,this,b,c,a));for(var h=b.length,i=function(c){g.replaceStack(function(e){var f=g.nameLookup(e,b[c],a);return d?[" && ",f]:[" != null ? ",f," : ",e]})},j=c;j<h;j++)i(j)},resolvePossibleLambda:function(){this.push([this.aliasable("container.lambda"),"(",this.popStack(),", ",this.contextName(0),")"])},pushStringParam:function(a,b){this.pushContext(),this.pushString(b),"SubExpression"!==b&&("string"==typeof a?this.pushString(a):this.pushStackLiteral(a))},emptyHash:function(a){this.trackIds&&this.push("{}"),this.stringParams&&(this.push("{}"),this.push("{}")),this.pushStackLiteral(a?"undefined":"{}")},pushHash:function(){this.hash&&this.hashes.push(this.hash),this.hash={values:{},types:[],contexts:[],ids:[]}},popHash:function(){var a=this.hash;this.hash=this.hashes.pop(),this.trackIds&&this.push(this.objectLiteral(a.ids)),this.stringParams&&(this.push(this.objectLiteral(a.contexts)),this.push(this.objectLiteral(a.types))),this.push(this.objectLiteral(a.values))},pushString:function(a){this.pushStackLiteral(this.quotedString(a))},pushLiteral:function(a){this.pushStackLiteral(a)},pushProgram:function(a){null!=a?this.pushStackLiteral(this.programExpression(a)):this.pushStackLiteral(null)},registerDecorator:function(a,b){var c=this.nameLookup("decorators",b,"decorator"),d=this.setupHelperArgs(b,a);this.decorators.push(["var decorator = ",c,";"]),this.decorators.push(['if (typeof decorator !== "function") { throw new Error(',this.quotedString('Missing decorator: "'+b+'"'),"); }"]),this.decorators.push(["fn = ",this.decorators.functionCall("decorator","",["fn","props","container",d])," || fn;"])},invokeHelper:function(a,b,c){var d=this.popStack(),e=this.setupHelper(a,b),f=[];c&&f.push(e.name),f.push(d),this.options.strict||f.push(this.aliasable("container.hooks.helperMissing"));var g=["(",this.itemsSeparatedBy(f,"||"),")"],h=this.source.functionCall(g,"call",e.callParams);this.push(h)},itemsSeparatedBy:function(a,b){var c=[];c.push(a[0]);for(var d=1;d<a.length;d++)c.push(b,a[d]);return c},invokeKnownHelper:function(a,b){var c=this.setupHelper(a,b);this.push(this.source.functionCall(c.name,"call",c.callParams))},invokeAmbiguous:function(a,b){this.useRegister("helper");var c=this.popStack();this.emptyHash();var d=this.setupHelper(0,a,b),e=this.lastHelper=this.nameLookup("helpers",a,"helper"),f=["(","(helper = ",e," || ",c,")"];this.options.strict||(f[0]="(helper = ",f.push(" != null ? helper : ",this.aliasable("container.hooks.helperMissing"))),this.push(["(",f,d.paramsInit?["),(",d.paramsInit]:[],"),","(typeof helper === ",this.aliasable('"function"')," ? ",this.source.functionCall("helper","call",d.callParams)," : helper))"])},invokePartial:function(a,b,c){var d=[],e=this.setupParams(b,1,d);a&&(b=this.popStack(),delete e.name),c&&(e.indent=JSON.stringify(c)),e.helpers="helpers",e.partials="partials",e.decorators="container.decorators",a?d.unshift(b):d.unshift(this.nameLookup("partials",b,"partial")),this.options.compat&&(e.depths="depths"),e=this.objectLiteral(e),d.push(e),this.push(this.source.functionCall("container.invokePartial","",d))},assignToHash:function(a){var b=this.popStack(),c=void 0,d=void 0,e=void 0;this.trackIds&&(e=this.popStack()),this.stringParams&&(d=this.popStack(),c=this.popStack());var f=this.hash;c&&(f.contexts[a]=c),d&&(f.types[a]=d),e&&(f.ids[a]=e),f.values[a]=b},pushId:function(a,b,c){"BlockParam"===a?this.pushStackLiteral("blockParams["+b[0]+"].path["+b[1]+"]"+(c?" + "+JSON.stringify("."+c):"")):"PathExpression"===a?this.pushString(b):"SubExpression"===a?this.pushStackLiteral("true"):this.pushStackLiteral("null")},compiler:e,compileChildren:function(a,b){for(var c=a.children,d=void 0,e=void 0,f=0,g=c.length;f<g;f++){d=c[f],e=new this.compiler;var h=this.matchExistingProgram(d);if(null==h){var i=this.context.programs.push("")-1;d.index=i,d.name="program"+i,this.context.programs[i]=e.compile(d,b,this.context,!this.precompile),this.context.decorators[i]=e.decorators,this.context.environments[i]=d,this.useDepths=this.useDepths||e.useDepths,this.useBlockParams=this.useBlockParams||e.useBlockParams,d.useDepths=this.useDepths,d.useBlockParams=this.useBlockParams}else d.index=h.index,d.name="program"+h.index,this.useDepths=this.useDepths||h.useDepths,this.useBlockParams=this.useBlockParams||h.useBlockParams}},matchExistingProgram:function(a){for(var b=0,c=this.context.environments.length;b<c;b++){var d=this.context.environments[b];if(d&&d.equals(a))return d}},programExpression:function(a){var b=this.environment.children[a],c=[b.index,"data",b.blockParams];return(this.useBlockParams||this.useDepths)&&c.push("blockParams"),this.useDepths&&c.push("depths"),"container.program("+c.join(", ")+")"},useRegister:function(a){this.registers[a]||(this.registers[a]=!0,this.registers.list.push(a))},push:function(a){return a instanceof d||(a=this.source.wrap(a)),this.inlineStack.push(a),a},pushStackLiteral:function(a){this.push(new d(a))},pushSource:function(a){this.pendingContent&&(this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent),this.pendingLocation)),this.pendingContent=void 0),a&&this.source.push(a)},replaceStack:function(a){var b=["("],c=void 0,e=void 0,f=void 0;if(!this.isInline())throw new k["default"]("replaceStack on non-inline");var g=this.popStack(!0);if(g instanceof d)c=[g.value],b=["(",c],f=!0;else{e=!0;var h=this.incrStack();b=["((",this.push(h)," = ",g,")"],c=this.topStack()}var i=a.call(this,c);f||this.popStack(),e&&this.stackSlot--,this.push(b.concat(i,")"))},incrStack:function(){return this.stackSlot++,this.stackSlot>this.stackVars.length&&this.stackVars.push("stack"+this.stackSlot),this.topStackName()},topStackName:function(){return"stack"+this.stackSlot},flushInline:function(){var a=this.inlineStack;this.inlineStack=[];for(var b=0,c=a.length;b<c;b++){var e=a[b];if(e instanceof d)this.compileStack.push(e);else{var f=this.incrStack();this.pushSource([f," = ",e,";"]),this.compileStack.push(f)}}},isInline:function(){return this.inlineStack.length},popStack:function(a){var b=this.isInline(),c=(b?this.inlineStack:this.compileStack).pop();if(!a&&c instanceof d)return c.value;if(!b){if(!this.stackSlot)throw new k["default"]("Invalid stack pop");this.stackSlot--}return c},topStack:function(){var a=this.isInline()?this.inlineStack:this.compileStack,b=a[a.length-1];return b instanceof d?b.value:b},contextName:function(a){return this.useDepths&&a?"depths["+a+"]":"depth"+a},quotedString:function(a){return this.source.quotedString(a)},objectLiteral:function(a){return this.source.objectLiteral(a)},aliasable:function(a){var b=this.aliases[a];return b?(b.referenceCount++,b):(b=this.aliases[a]=this.source.wrap(a),b.aliasable=!0,b.referenceCount=1,b)},setupHelper:function(a,b,c){var d=[],e=this.setupHelperArgs(b,a,d,c),f=this.nameLookup("helpers",b,"helper"),g=this.aliasable(this.contextName(0)+" != null ? "+this.contextName(0)+" : (container.nullContext || {})");return{params:d,paramsInit:e,name:f,callParams:[g].concat(d)}},setupParams:function(a,b,c){var d={},e=[],f=[],g=[],h=!c,i=void 0;h&&(c=[]),d.name=this.quotedString(a),d.hash=this.popStack(),this.trackIds&&(d.hashIds=this.popStack()),this.stringParams&&(d.hashTypes=this.popStack(),d.hashContexts=this.popStack());var j=this.popStack(),k=this.popStack();(k||j)&&(d.fn=k||"container.noop",d.inverse=j||"container.noop");for(var l=b;l--;)i=this.popStack(),c[l]=i,this.trackIds&&(g[l]=this.popStack()),this.stringParams&&(f[l]=this.popStack(),e[l]=this.popStack());return h&&(d.args=this.source.generateArray(c)),this.trackIds&&(d.ids=this.source.generateArray(g)),this.stringParams&&(d.types=this.source.generateArray(f),d.contexts=this.source.generateArray(e)),this.options.data&&(d.data="data"),this.useBlockParams&&(d.blockParams="blockParams"),d},setupHelperArgs:function(a,b,c,d){var e=this.setupParams(a,b,c);return e.loc=JSON.stringify(this.source.currentLocation),e=this.objectLiteral(e),d?(this.useRegister("options"),c.push("options"),["options=",e]):c?(c.push(e),""):e}},function(){for(var a="break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "),b=e.RESERVED_WORDS={},c=0,d=a.length;c<d;c++)b[a[c]]=!0}(),e.isValidJavaScriptVariableName=function(a){return!e.RESERVED_WORDS[a]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a)},b["default"]=e,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b,c){if(g.isArray(a)){for(var d=[],e=0,f=a.length;e<f;e++)d.push(b.wrap(a[e],c));return d}return"boolean"==typeof a||"number"==typeof a?a+"":a}function e(a){this.srcFile=a,this.source=[]}var f=c(60)["default"];b.__esModule=!0;var g=c(5),h=void 0;try{}catch(i){}h||(h=function(a,b,c,d){this.src="",d&&this.add(d)},h.prototype={add:function(a){g.isArray(a)&&(a=a.join("")),this.src+=a},prepend:function(a){g.isArray(a)&&(a=a.join("")),this.src=a+this.src},toStringWithSourceMap:function(){return{code:this.toString()}},toString:function(){return this.src}}),e.prototype={isEmpty:function(){return!this.source.length},prepend:function(a,b){this.source.unshift(this.wrap(a,b))},push:function(a,b){this.source.push(this.wrap(a,b))},merge:function(){var a=this.empty();return this.each(function(b){a.add(["  ",b,"\n"])}),a},each:function(a){for(var b=0,c=this.source.length;b<c;b++)a(this.source[b])},empty:function(){var a=this.currentLocation||{start:{}};return new h(a.start.line,a.start.column,this.srcFile)},wrap:function(a){var b=arguments.length<=1||void 0===arguments[1]?this.currentLocation||{start:{}}:arguments[1];return a instanceof h?a:(a=d(a,this,b),new h(b.start.line,b.start.column,this.srcFile,a))},functionCall:function(a,b,c){return c=this.generateList(c),this.wrap([a,b?"."+b+"(":"(",c,")"])},quotedString:function(a){return'"'+(a+"").replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},objectLiteral:function(a){var b=this,c=[];f(a).forEach(function(e){var f=d(a[e],b);"undefined"!==f&&c.push([b.quotedString(e),":",f])});var e=this.generateList(c);return e.prepend("{"),e.add("}"),e},generateList:function(a){for(var b=this.empty(),c=0,e=a.length;c<e;c++)c&&b.add(","),b.add(d(a[c],this));return b},generateArray:function(a){var b=this.generateList(a);return b.prepend("["),b.add("]"),b}},b["default"]=e,a.exports=b["default"]}])});
/*! js-cookie v3.0.8 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)"__proto__"!==o&&(e[o]=n[o])}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(u in o||(o[u]=n.read(c,u)),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));

/**
 * GizmoGrid AMD shim.
 * Loaded AFTER jquery, lodash, moment, handlebars, js-cookie (which register as globals)
 * and BEFORE gizmoGrid.js (which uses AMD define()).
 *
 * Provides:
 *  - window.__env for gizmoGrid's base_url
 *  - window.ggDom.element shim (maps to jQuery)
 *  - Fake AMD define() that resolves deps from globals
 *
 * NOTE: We intentionally do NOT expose a global `window.angular`. gizmoGrid was
 * originally written against AngularJS's `angular.element`, but no AngularJS
 * library is present here — `ggDom.element` is just a jQuery alias. Avoiding the
 * `angular` global prevents security scanners from false-flagging AngularJS.
 */
(function () {
  window.__env = window.__env || { apiUrl: '/gtw' };
  window.is_export = false;

  if (!window.ggDom) {
    window.ggDom = { element: window.jQuery };
  } else if (!window.ggDom.element) {
    window.ggDom.element = window.jQuery;
  }

  var depMap = {
    'jquery': window.jQuery,
    'lodash': window._,
    'moment': window.moment,
    'handlebars': window.Handlebars,
    'js.cookie': window.Cookies
  };

  window.define = function (name, deps, factory) {
    if (typeof name !== 'string') {
      factory = deps;
      deps = name;
      name = null;
    }
    if (typeof deps === 'function') {
      factory = deps;
      deps = [];
    }
    if (typeof factory === 'function') {
      var resolved = (deps || []).map(function (d) {
        return depMap[d] || window[d];
      });
      factory.apply(null, resolved);
    }
  };
  window.define.amd = {};

  // gizmoGrid issues its requests with raw $.ajax, so they never reach Angular's
  // HttpClient interceptor and arrive without an Authorization header. Mirror the
  // interceptor here so legacy endpoints (commentByKey, commentReply,
  // resolveComment, loadFileAttachments, ...) are authorized like Angular calls.
  // georaclehrid stays on AuthInterceptor only; it is a local identity header and
  // is not part of this port.
  var jq = window.jQuery;
  if (jq) {
    var INTERNAL_API_PREFIXES = [
      '/gtw/',
      '/gtw-efile-api/',
      '/batch/',
      '/admin/',
      '/custom/',
      '/pdf-engine/',
      '/bulk-pdf-engine/',
      '/scheduler/'
    ];

    var isInternalUrl = function (url) {
      var pathname = url;
      if (/^https?:\/\//i.test(url)) {
        try {
          var parsed = new URL(url);
          if (parsed.origin !== window.location.origin) {
            return false;
          }
          pathname = parsed.pathname;
        } catch (e) {
          return false;
        }
      }
      return INTERNAL_API_PREFIXES.some(function (prefix) {
        return pathname.indexOf(prefix) === 0;
      });
    };

    var readCookie = function (name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[2]) : null;
    };

    var requestToken = function (length) {
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var bytes = new Uint8Array(length);
      crypto.getRandomValues(bytes);
      var result = '';
      for (var i = 0; i < length; i++) {
        result += chars[bytes[i] % chars.length];
      }
      return result;
    };

    jq.ajaxPrefilter(function (options) {
      // A throwing prefilter aborts the request, so never let this break the grid.
      try {
        var url = options.url || '';
        if (!isInternalUrl(url)) {
          return;
        }

        var headers = options.headers = options.headers || {};
        var authorization = sessionStorage.getItem('Authorization') || '';
        var clientKey = sessionStorage.getItem('client_key') || '';

        if (authorization && url.indexOf('gtw-websockets') === -1) {
          headers['Authorization'] = authorization;
        }
        if (clientKey) {
          headers['client_key'] = clientKey;
        }
        headers['X-Requested-With'] = 'XMLHttpRequest';
        headers['ist-req-tkn'] = requestToken(30);

        var method = (options.type || 'GET').toUpperCase();
        if (method !== 'GET' && method !== 'HEAD') {
          // gizmoGrid hardcodes a long-expired token; use the real cookie value.
          var xsrfToken = readCookie('XSRF-TOKEN');
          if (xsrfToken) {
            headers['X-XSRF-TOKEN'] = xsrfToken;
          } else {
            delete headers['X-XSRF-TOKEN'];
          }
        }

        options.xhrFields = options.xhrFields || {};
        options.xhrFields.withCredentials = true;
      } catch (e) {
        /* leave the request untouched */
      }
    });
  }

  // Bootstrap dropdown polyfill — gizmoGrid uses data-toggle="dropdown"
  // which requires Bootstrap JS to toggle the .open / .show class.
  // Since Bootstrap JS is not loaded, replicate the dropdown toggle here.
  var $ = window.jQuery;
  if ($) {
    var OPEN_SEL = '.dropdown.open, .dropdown.show, .dropup.open, .dropup.show, .gg-dd-open';

    $(document).on('click', '[data-toggle="dropdown"]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $parent = $(this).closest('.dropdown, .dropup');
      if (!$parent.length) {
        $parent = $(this).parent();
      }

      var wasOpen = $parent.hasClass('open') || $parent.hasClass('show') || $parent.hasClass('gg-dd-open');

      $(OPEN_SEL).not($parent).removeClass('open show gg-dd-open');

      if (wasOpen) {
        $parent.removeClass('open show gg-dd-open');
      } else {
        $parent.addClass($parent.hasClass('dropdown') ? 'open show' : 'gg-dd-open open');
      }
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('[data-toggle="dropdown"], .dropdown-menu, .gg-menu-container').length) {
        $(OPEN_SEL).removeClass('open show gg-dd-open');
      }
    });
  }
})();

define('gizmoGrid',['jquery','lodash','moment', 'handlebars','js.cookie'], function ($,_, moment, Handlebars, Cookies){

    $.gizmoGrid = function (el, options){
        // Global Private Variables
        var windowHeight, windowWidth, base = this;
        base.layout = [];
        base.elements = [];
        base.base_url = window.__env.apiUrl;
        base.preventDefaultContext = true;
        base.logLevel = 0;
        base.$el = $(el);
        base.userAccessLevel = 1;
        base.sso_id = "";
        base.headerRow = {};
        base.headerRow.height = 30;
            base.data = [];
        base.data.newRow = [];
        base.data.settings = {};
        base.data.dataArr = [];
        base.data.safeCopyArr = [];
        base.data.displayArr = [];
        base.data.headerArray = [];
        base.data.headerArray = [];
        base.data.headerArrayDisplay = [];

        base.data.fixedHeaderArrayDisplay = [];
        base.data.fixedHeaderSafeCopyArr = [];
        base.vDragg = {};
        base.vDragg.draggerPositionY = 0;
        base.vDragg.scrollPositionY = 0;
        base.vDragg.startIndex = 0;
        base.vDragg.endIndex = 0;
        base.hDragg = {};
        base.hDragg.draggerPositionX = 0;
        base.hDragg.scrollPositionX = 0;
        base.hDragg.startIndex = 0;
        base.hDragg.endIndex = 0;
        base.hDragg.maxStartIndex = 0;
        base.horizontalWidthArray = [];
        base.actionTemplates = [];
        base.data.pivotGroup = {};
        base.data.isCollapsed = false;
        base.pivotChecked = "disabled";
        base.deleteCount = 0;

        if(window.is_export){
            ggDom.element('.tools-export').addClass('gg-export-to-excel');
            ggDom.element('.tools-export').append('<i class="fa fa-spinner fa-spin"></i>');
        }

        base.dateFormats = [
            {"name":"mm/dd/yyyy",value:"MM/DD/YYYY"},
            {"name":"Month Day, Year",value:"LL"}
        ]


        base.columnFormats = [
            {"display_name":"String", "data_type":"string","format":"","edit_type":"text","validation":"","col_class":""},
            {"display_name":"Number with Commas", "data_type":"number","format":"numberWithCommas","edit_type":"text","validation":"numeric","col_class":"right-align"},
            {"display_name":"Float with Commas ", "data_type":"number","format":"floatWithCommas","edit_type":"text","validation":"numeric","col_class":"right-align"},
            {"display_name":"Date", "data_type":"date","format":"","edit_type":"text","validation":"date","col_class":""}
        ];


        base.validationMessages = {
            numeric:"<b>Error:</b> Numeric values only",
            date:"<b>Error:</b> Please add a valid date in the following format: <b>" + base.dateFormats[0].name + "</b>",
            uppercase:"<b>Error:</b> Uppercase only",
            lowercase:"<b>Error:</b> Lowercase only",
        }


        base.tableState = {
            sort: {},
            search: {},
            colSearch: [],
            pagination: {
                start: 0
            }
        };

        base.selected = {
            color: "green",
            select_type:null,
            row_id:null,
            col_id:null,
            obj_id:null,
            data_type:null,
            edit_type:null,
            validation:null,
            action:null,
            format:null,
            value:null,
            oldValue:null,
            rowData:null,
            editable:"n",
            element:null
        };

        base.batchSelect = [];
        base.selectedGroup = [];
        base.batchActions = [];
        base.batchSelectMode = false;
        base.removeBatchSelection = false;

        base.tools = {
            color:null,
            align:null,
            fullScreen:null,
            format:null
        }

        base.cellData = {

        };


        base.tags = {

        }

        function paintColor(_color){
            if(_color != 'none') {
                var color = 'text-color-' + _color;
                var previousColor = 'text-color-' + base.tools.color;
                base.tools.color = _color;
                base.elements.paintBrush.removeClass(previousColor);
                base.elements.paintBrush.addClass(color);
            }
        }


////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// BASE INIT FUNCTION /////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////


        base.init = function (){

            base.options = $.extend({},$.gizmoGrid.defaultOptions, options);
            base.elements.alertContainer = base.$el.find('.gg-alert-container');
            //////////////////////// ATTACH TEMPLATES ////////////////////////////////////
            base.$el.append(colSizeHandlerTemplate);
            base.$el.append(rowSizeHandlerTemplate);
            base.$el.append(colReorderHandlerTemplate);
            base.$el.append(colIndicatorTemplate);
            base.$el.append(colFixedHandlerTemplate);
            base.$el.append(editTemplate);
            base.$el.append(contextMenuTemplate);
            base.$el.append(messageItemTemplate);
            base.$el.append(errorItemTemplate); // error template
            base.$el.append(modalFilterTemplate); //TO BE DELETED WHEN modalTemplate IS functional
            base.$el.append(modalTemplate);
            base.$el.prepend(loadingTemplate);
            base.$el.prepend(selectFiltersTemplate);
            base.$el.prepend(hiddenTextAreaTemplate);
            base.$el.prepend(refreshIconTemplate);
            base.$el.prepend(largeTextDisplay);



            base.elements.tools = base.$el.find('.gg-tools');
            base.elements.dndDraggerHeader = base.$el.find('.gg-dragger-bg');
            base.elements.header = base.$el.find('.gg-header');
            base.elements.headerLeft = base.$el.find('.gg-header-left-col');
            base.elements.headerRight = base.$el.find('.gg-header-right-col');
            base.elements.footer = base.$el.find('.gg-footer');
            base.elements.hScroll = base.$el.find('.gg-hScroll');
            base.elements.body = base.$el.find('.gg-body');
            base.elements.ggleftcol = base.$el.find('.gg-left-col');
            base.elements.ggrightcol = base.$el.find('.gg-right-col');
            base.elements.vScroll = base.$el.find('.gg-vScroll');
            base.elements.vdragger = base.$el.find('.vScroll-dragger');
            base.elements.vbtns = base.$el.find('.v-scroll-btns');
            base.elements.vtrack = base.$el.find('.vScroll-track');
            base.elements.resizeColLine =  base.$el.find('.resize-col-line');
            base.elements.resizeRowLine =  base.$el.find('.resize-row-line');
            base.elements.resizeColBlock =  base.$el.find('.reorder-col-block');
            base.elements.colLine =  base.$el.find('.col-line');
            base.elements.fixColHandler =  base.$el.find('.fixed-col-handler');
            base.elements.hdragger = base.$el.find('.hScroll-dragger');
            base.elements.hdragger = base.$el.find('.hScroll-dragger');
            base.elements.hbtns = base.$el.find('.h-scroll-btns');
            base.elements.htrack = base.$el.find('.hScroll-track');
            base.elements.editValue = editTemplate;
            // not used  base.elements.formContainer = base.$el.find('.gg-form-container');
            base.elements.footerDelete = base.$el.find('.delete-count');
            base.elements.footerDetails = base.$el.find('.footer-details');
            base.elements.globalSearch = base.$el.find('.gg-global-search');
            base.elements.footerContainer = base.$el.find('.gg-filter-container');
            base.elements.paintBrush = base.$el.find('.fa-paint-brush');
            base.elements.contextMenu = contextMenuTemplate;
            base.elements.messageItemContainer = messageItemTemplate;
            base.elements.errorcontainer = errorItemTemplate; // error template
            base.elements.selection = base.$el.find('.gg-selection');
            base.elements.recordDetails = base.$el.find('#recordDetails');
            base.elements.FilterModalService = modalFilterTemplate;
            base.elements.modalContainer = modalTemplate;
            base.elements.refreshIcon = refreshIconTemplate;
            base.elements.dataLoader = loadingTemplate;
            base.elements.fliterOverlay = selectFiltersTemplate;
            base.elements.hiddenTA = base.$el.find('.gg-hidden-ta-cnt textarea');
            base.elements.dataLoader.css('display','none');
            base.elements.totalText = base.$el.find('.gg-total-text');

            base.elements.lgTxtCnt = base.$el.find('.gg-lg-text-cnt');
            base.elements.lgTxt = base.$el.find('.gg-lg-text');
            base.elements.lgTxtBtns = base.$el.find('.gg-lg-text-btns');
            base.elements.colTemplateSelect = base.$el.find('#gg-template-select');


            base.gridFiltersDivHeight = 32;// added this to fix VScroll on gridStandardScreens, as on initial load gridFiltersDiv is not loading.
            base.loader.setSize();
            base.focus = {
                gridBody:  base.elements.body,
                hiddenTA:  base.elements.hiddenTA,
                tools: base.elements.tools
            };
        }



        base.headerService = {
            templateArray: [],
            templateIndex: 0,
            expanded : false,
            dragArray:[],
            colToolsContainer: $("<div class='gg-col-order-cont' style='right:15%'> "+
            "	<div class='gg-col-header-cont'> "+
            "		<div class='pull-left' > "+
            "			<h3>Reorder / Hide Show Columns / Create Custom Column Templates</h3> "+
            "		</div> "+
            "		<div class='pull-right'> "+
            "			<i style='cursor: pointer; font-size: 18px; transition: transform .4s ease;' class='fa fa-times gg-col-close'></i> "+
            "		</div> "+
            "	</div> "+
            "   <div class='scrol-wrapper'>"+
            "   <div class='panel panel-default' style='margin: 15px;'> "+
            "       <div class='panel-heading'> " +
            "           <span><i class='fa fa-arrows'></i>&nbsp;<b>Ctrl click</b>&nbsp;to drag multiple columns, &nbsp;<i class='fa fa-check-square-o'></i>&nbsp;click to show/hide columns</span> "+
            "			<div style='float: right;'> "+
            "				<div action='showAllCols' class='btn btn-xs gg-col-show-all btn-default'><i class='fa fa-check-square-o'></i>- Show All</div> "+
            "				<div action='hideAllCols' class='btn btn-xs btn-default gg-col-hide-all'><i class='fa fa-square-o'></i>- Hide All</div> "+
            "			</div> "+
            "       </div> "+
            "       <div class='panel-body'> "+
            "	        <div class='gg-col-headers'></div> "+
            "       </div> "+
            "   </div> "+
            "   <div class='panel panel-default' style='margin: 15px;'> "+
            "       <div class='panel-heading'> "+
            "           Header Selection: "+
            "       </div>" +
            "       <div class='panel-body'>" +
            "		    <div> "+
            "			    <div class='gg-col-temp-cont'> <label>Select Column Template:</label>  <br /> "+
            "				    <select name='gg-col-select' class='form-control input-sm gg-col-select' id='colTempSelect'><option value='0'>Select Template</option></select> "+
            "			    </div> "+
            "			    <div class='gg-col-create-cont'> <label>Create New Template:</label> <i class='small-text'>*Save column order, column width and which columns are visible or hidden </i>  <br /> "+
            "				    <input class='form-control input-sm ' placeholder='enter template name' type='text' id='gg-col-temp-input'> "+
            "				    <div class='gg-col-default-temp'  ><input type='checkbox' id='colDefaultSaveTemplate'  > (Default) </div> "+
            "				    <div class='gg-col-default-temp gg-col-system-temp'  ><input type='checkbox' id='colSystemSaveTemplate'  > (system) </div> "+
            "			    </div> "+
            "			    <div  class='gg-col-update-cont'> <label>Update Template:</label> <i class='small-text'>*Adjust the columns above and then hit update to save the changes</i><br /> "+
            "				    <input class='form-control input-sm' placeholder='enter template name' type='text' id='gg-col-update-input'> "+
            "				    <div class='gg-col-default-temp'  ><input type='checkbox' id='colDefaultEditTemplate'  > (default) </div> "+
            "				    <div class='gg-col-default-temp gg-col-system-temp'  ><input type='checkbox' id='colSystemEditTemplate'  > (system) </div> "+
            "			    </div>  "+
            "		    </div> "+
            "       </div>"+
            "       <div class='panel-footer'> "+
            "           <div class='gg-col-temp-cont'> "+
            "			    <div class='btn btn-sm btn-success gg-col-action' action='edit' style='display:none'>Edit Template</div> "+
            "			    <div class='btn btn-sm btn-info gg-col-action' action='create'>Create New</div> "+
            "           </div> "+
            "           <div class='gg-col-create-cont'> "+
            "	            <div class='btn btn-sm btn-success gg-col-action' action='save'>Save</div> "+
            "	            <div class='btn btn-sm btn-warning gg-col-action' action='cancel'>Cancel</div> "+
            "           </div> "+
            "           <div class='gg-col-update-cont'>"+
            "				<div class='btn btn-sm btn-success gg-col-action' action='update'>Update</div> "+
            "				<div class='btn btn-sm btn-danger gg-col-action' action='delete'>Delete</div> "+
            "				<div class='btn btn-sm btn-warning gg-col-action' action='cancel'>Cancel</div> "+
            "           </div>"+
            "       </div>" +
            "   </div>" +
            "   </div>"+
            "   <hr>" +
            "	<div class='gg-col-tools-btns row'> "+
            "		<div class='btn btn-sm btn-warning gg-col-reset'>Reset to Default</div> "+
            "		<div class='btn btn-sm btn-default gg-col-close'>Close</div> "+
            "	</div> "+
            "</div> "),

            dragColToolCont: $("<div class='gg-col-order-drag-cont'><div>"),
            overlayElement: $("<div class='gg-col-order-overlay'><div>"),

            // Used to resize the modal content when left nav-menu Closed/Opened..(added by Omi)
            modalResize: function(data) {
                if(data == "closed") {
                    base.$el.find('.gg-col-order-cont').addClass('adjust-modal');
                } else {
                    base.$el.find('.gg-col-order-cont').removeClass('adjust-modal');
                }
            },

            colToolTemplateControls: function(_type){
                if(_type === 'select'){
                    base.$el.find('.gg-col-temp-cont').show();
                    base.$el.find('.gg-col-update-cont').hide();
                    base.$el.find('.gg-col-create-cont').hide();
                }else if(_type === 'create'){
                    base.$el.find('.gg-col-temp-cont').hide();
                    base.$el.find('.gg-col-update-cont').hide();
                    base.$el.find('.gg-col-create-cont').show();
                    base.$el.find('#colDefaultSaveTemplate').prop( "checked", false );
                }else if(_type === 'cancel'){
                    base.$el.find('.gg-col-temp-cont').show();
                    base.$el.find('.gg-col-update-cont').hide();
                    base.$el.find('.gg-col-create-cont').hide();
                    base.$el.find('#gg-col-temp-input').val("");
                }else if(_type === 'edit'){
                    var checked = this.templateArray[this.templateIndex].default_template === 1 ? true : false;
                    base.$el.find('#colDefaultEditTemplate').prop( "checked", checked );
                    var system = this.templateArray[this.templateIndex].system === 1 ? true : false;
                    base.$el.find('#colSystemEditTemplate').prop( "checked", system );
                    base.$el.find('.gg-col-temp-cont').hide();
                    base.$el.find('.gg-col-update-cont').show();
                    base.$el.find('.gg-col-create-cont').hide();
                    var tempname = base.$el.find('#gg-col-update-input').val( this.templateArray[this.templateIndex].name);
                }else if(_type === 'save'){
                    var tempname = base.$el.find('#gg-col-temp-input').val();
                    this.colToolsSave(tempname);
                }else if(_type === 'delete'){
                    this.colToolDeleteTemplates();
                }else if(_type === 'update'){
                    this.colToolUpdateTemplates();
                }


                if( base.userAccessLevel <= 2) {
                    base.$el.find('.gg-col-system-temp').hide();
                }

            },

            colToolTemplateReset: function(_index){
                this.templateIndex = _index;
                base.$el.find('.gg-col-temp-cont').show();
                base.$el.find('.gg-col-update-cont').hide();
                base.$el.find('.gg-col-create-cont').hide();
                base.$el.find('#gg-col-temp-input').val("");
                this.buildTemplateSelection(_index);
                if(_index === 0 ){
                    this.colToolsReset();
                }
            },

            colToolUpdateTemplates: function(){
                var template = this.templateArray[this.templateIndex];
                var search = _.find( this.templateArray, {name: template.name});
                if( typeof search !== 'undefined' && search != template ){
                    addAlert("alert-warn","<b>Error:</b> You already have a template with this name  ",'5000' );
                    return false;
                }

                var name = sanitize(base.$el.find('#gg-col-update-input').val());


                var templateArr = base.data.headerArraySafe.map(function(header) {
                    return { // return what new object will look like
                        width:  header.width,
                        display: header.display,
                        map:header.map
                    };
                });

                template.name = name;
                template.columns = templateArr;

                /* column template header & fixed columns 6/13/2019  */
                template.fixed_columns = base.data.fixedHeaderArrayDisplay.length;
                template.header_height = base.headerRow.height;
                /* ends here */

                template.default_template =  base.$el.find('#colDefaultEditTemplate').is(':checked') === true ? 1 : 0;
                template.system = ( base.$el.find('#colSystemEditTemplate').is(':checked') &&  base.userAccessLevel >= 3 ) === true ? 1 : 0;


                base.api.callBack( 'update',template,'columnTemplate');
                this.buildTemplateSelection(this.templateIndex);
                this.colToolTemplateReset(this.templateIndex);
            },

            colToolDeleteTemplates: function(){
                var template = this.templateArray[this.templateIndex];
                if(template.system === 1 &&  base.userAccessLevel < 3){
                    addAlert("alert-error"," You can not delete System Templates ",4000 );
                    return false;
                }
                this.templateArray.splice(this.templateIndex,1);
                this.colToolTemplateReset(0);
                base.api.callBack( 'delete',template,'columnTemplate');
            },


            colToolSetTemplates: function(){
                var defaultIndex = _.findIndex( base.headerService.templateArray, { 'default_template': 1 });
                if(defaultIndex > 0 && options.data.firstLoad && options.data.firstLoad === 1){
                    this.buildTemplateSelection(defaultIndex);
                    this.colToolsApply(defaultIndex);
                }else{
                    this.buildTemplateSelection("");

                    //EXPAND COLS ONLOAD
                    if(options.data.settings && options.data.settings.expand_cols && options.data.settings.expand_cols === 1){
                        base.headerService.expanded = false;
                        base.headerService.expandCols();
                    }

                }
            },

            buildTemplateSelection: function(_index){
                $('#colTempSelect').html("<option value=''>select template...</option>");
                if(this.templateArray.length){
                    _.forEach(this.templateArray , function(value, key) {
                        var name = (value.system === 1 ) ?  value.name +" (system)" :  value.name;
                        name = (value.default_template === 1 ) ?  name +" (default)" :  name;
                        var style = (value.default_template === 1 ) ? {style:"background-color:#4af352"} : {style:"background-color:#fff"};
                        base.$el.find('#colTempSelect').append($("<option/>", {
                            value: key,
                            text:  name,
                            attr: style
                        }));

                    });
                    base.$el.find('#colTempSelect').val(_index);
                }

                this.buildTemplateDropdown(this.templateIndex);
            },


            buildTemplateDropdown: function(_index){
                base.elements.colTemplateSelect.html("<option value=''>select template...</option>");
                if(this.templateArray.length){
                    var li = "";
                    _.forEach(this.templateArray , function(value, key) {
                        var name = (value.system === 1 ) ?  value.name +" (system)" :  value.name;
                        name = (value.default_template === 1 ) ?  name +" (default)" :  name;

                        var selected = (  base.headerService.templateIndex == key ) ? 'active' : '';
                        li += '<li action="apply-template" index="'+key+'"  class="tools-action '+selected+'"><a>'+sanitize(name)+'</a> <li>';
                        base.options.fixedColumn = (  base.headerService.templateIndex == key ) && (value && value.fixed_columns > 0)?value.fixed_columns:options.data!=undefined?options.data.settings.fixed_columns:base.options.fixedColumn;//this.selectedTemplate.fixed_columns;
                        base.headerRow.height = (  base.headerService.templateIndex == key) && (value && value.header_height>0) ?value.header_height:options.data!=undefined?parseInt(options.data.settings.header_height): base.options.defaultRowHeight;

                    });
                    li +=' <li role="separator" class="divider"></li><li class="dotted">Use the <i class="fa fa-eye"></i> icon to edit or create column templates</li>';

                    base.elements.colTemplateSelect.html(li);
                }
            },


            colToolsReset: function(){
                this.colToolsApply(0);
            },

            colToolsSave: function (_tempName) {
                let formatCheckerGrid = /[<>]/;
                var checkedFlagGrid = formatCheckerGrid.test(_tempName);
                if(!checkedFlagGrid) {
                    //checkIfNameExits
                    if(_tempName.length <= 3){
                        addAlert("alert-error"," Template name must have at least 3 characters ",4000 );
                        return false;
                    }
                    if( typeof  _.find( this.templateArray, {name: _tempName})  !== 'undefined'  ){
                        addAlert("alert-warn","<b>Error:</b> You already have a template with this name  ",'5000' );
                        return false;
                    }

                    var templateArr = base.data.headerArraySafe.map(function(header) {
                        return { // return what new object will look like
                            width:  header.width,
                            display: header.display,
                            map:header.map
                        };
                    });




                    var defaultTemplate =   base.$el.find('#colDefaultSaveTemplate').is(':checked') === true ? 1 : 0;
                    var system =   ( base.$el.find('#colSystemSaveTemplate').is(':checked') &&  base.userAccessLevel >= 3 ) === true ? 1 : 0;


                    var newTemp = {
                        name:_tempName,
                        template_key:randomString(),
                        system:system,
                        columns:templateArr,
                        default_template:defaultTemplate,
                        height: base.headerRow.height || base.options.vDraggerMinHeight
                    }

                    this.templateArray.push(newTemp);
                    this.templateIndex =  this.templateArray.length - 1;
                    base.api.callBack( 'create',newTemp,'columnTemplate');
                    if(newTemp.system === 1 ){
                        base.$el.find('.gg-col-action[action="edit"]').hide();
                    }else{
                        base.$el.find('.gg-col-action[action="edit"]').show();
                    }
                    this.buildTemplateSelection(this.templateIndex);
                    this.colToolTemplateControls('select');
                } else {
                    addAlert("alert-warn", "Do not use special characters like <, > for Create New Template field", 4000);
                }

            },




            colToolsApply: function(_template){
                    if(_template === ""){
                        return false;
                    }
                    this.templateIndex = _template;
                    var headerArray = base.data.headerArraySafe;
                    var templateArray = this.templateArray[_template].columns;
                  //  base.headerRow.height = this.templateArray[_template].height ;

                   /*  apply fixed heights & columns for column template  6/13/2019 */
                     base.headerRow.height = (this.templateArray[_template].header_height>0  ? this.templateArray[_template].header_height : parseInt(options.data.settings.header_height));
                     base.options.fixedColumn = (this.templateArray[_template].fixed_columns>0)?this.templateArray[_template].fixed_columns:options.data.settings.fixed_columns;//this.selectedTemplate.fixed_columns
                     /* ends Here */

                     _.forEach(templateArray, function (value, key) {
                        var object = _.find(base.data.headerArraySafe, {map: value.map});
                        if (object && object.map.toLowerCase() != 'object_id') {
                            object.width = value.width;
                            object.display = value.display;
                            //Sort Object;
                            var toMove = _.findIndex(base.data.headerArraySafe, object);
                            if (toMove >= 0) {
                                arraymove(base.data.headerArraySafe, toMove, key);
                            }
                        }

                    });



                var system = this.templateArray[_template].system;



                if( _template == 0 ||  ( this.templateArray[_template].system == 1 &&  base.userAccessLevel < 3)){
                    base.$el.find('.gg-col-action[action="edit"]').hide();
                }else{
                    base.$el.find('.gg-col-action[action="edit"]').show();
                }
                base.selected.row_id = null;
                setDefaultSelect();
                buildGrid();
                base.headerService.renderColTools();
                base.headerService.buildTemplateDropdown();
            },



            uncheckAll: function(){
                _.forEach(base.data.headerArraySafe , function(value, key) {
                    if(key != 0 && key != 1){
                        value.display = "n";
                    }else{
                        value.display = "y";
                    }

                });
                base.headerService.renderColTools();
                buildGrid();
            },


            checkAll: function(){
                _.forEach(base.data.headerArraySafe , function(value, key) {
                    value.display = "y";
                });
                base.headerService.renderColTools();
                buildGrid();
            },



            colToolsOpen: function(){
                base.headerService.colToolsContainer.show('fast');
                base.headerService.overlayElement.show('fast');
            },


            colToolsClose: function(){
                //hide();
                base.headerService.overlayElement.hide('fast');
                base.headerService.colToolsContainer.hide('fast');


            },

            containsElement : function(map){
                if( _.includes(this.dragArray, map)  ){
                    return true;
                }else{
                    return false;
                }
            },


            addDragElement: function(_element){
                var map = _element.attr('map');
                if(this.containsElement(map)){
                    return false;
                }
                base.headerService.dragColToolCont.append(_element);
                this.dragArray.push(map);
                var headerCont = base.headerService.colToolsContainer.find('.gg-col-headers');
                var btnCont = base.headerService.colToolsContainer.find('.gg-col-tools-btns');
                var top = 15;
                this.dragColToolCont.show();
                base.headerService.dragColToolCont.css('top', ( top + btnCont.position().top ) + 'px');
                base.headerService.dragColToolCont.css('left', 15 + 'px');
            },

            dragColTool: function(_left,_top){
                var offset = this.colToolsContainer.offset();
                base.headerService.dragColToolCont.css('left', (_left - offset.left + 5)   + 'px');
                base.headerService.dragColToolCont.css('top', (_top - offset.top + 5 )  + 'px');
            },


            dropColTool: function(map,display){
                var that = this;
                var  children = that.dragColToolCont.children();
                var dropArray = [];
                this.dragArray = [];

                var toWhere = _.findIndex(base.data.headerArraySafe, { 'map': map });

                if( map == "" || children.length <= 0 ){
                    that.dragColToolCont.html("");
                    base.headerService.renderColTools();
                    ////console.log("I WAS CALLED");
                    return false;
                }


                for (var i = 0; i < children.length; i++) {
                    var mapMove = $(children[i]).attr('map');
                    dropArray.push(map);
                    var toMove = _.findIndex(base.data.headerArraySafe, { 'map': mapMove });
                    ////console.log(" toMove : " , toMove);
                    arraymove(base.data.headerArraySafe,toMove, toWhere + i);
                }

                that.renderColTools();
                buildGrid();
            },


            hideShowCol: function(map,display){
                var object = _.find(base.data.headerArraySafe,{map:map});
                object.display = ( display  === 'y') ? 'n' : 'y';
                base.headerService.renderColTools();
                buildGrid();
            },

            renderColTools: function(){

                var that = this;
                that.dragColToolCont.html("");
                var headerCont = base.headerService.colToolsContainer.find('.gg-col-headers');
                headerCont.html("");
                this.dragColToolCont.hide();


                _.forEach(base.data.headerArraySafe, function(value, key){
                    if(key != 0) {
                        var header = $("<div class='gg-col-tools-header' map='"+value.map+"' display='"+value.display+"'><div>")
                        if(value.display === 'y'){
                            header.append('<i class="fa fa-check-square-o gg-check-show-hide "></i>')
                        }else{
                            header.addClass('gg-col-header-fade');
                            header.append('<i class="fa fa-square-o gg-check-show-hide "></i>')
                        }
                        header.append(value.label);
                        headerCont.append(header);
                    }
                });
                base.$el.append( that.colToolsContainer);
                base.$el.append( that.overlayElement);
                that.colToolsContainer.append(that.dragColToolCont);
                if(options.data && options.data.fromModal && options.data.fromModal == true) { //alignments adjustments for grid on modal..
                    that.colToolsContainer.css('top', 15 + 'px');
                    that.colToolsContainer.css('left', 15 + 'px');
                } else {
                    that.colToolsContainer.css('top',(base.elements.body.offset().top - base.elements.header.height()) + 'px');
                    that.colToolsContainer.css('left', 260 + 'px');
                }
            },



            //START HERE
            formatCol: function(_colObj,_type,_name ){
                if( _name && _name.length < 1 ){
                    addAlert("alert-error"," Please add a column name   ",4000 );
                    return false;
                }
                _colObj.data_type = base.columnFormats[_type].data_type;
                _colObj.edit_type = base.columnFormats[_type].edit_type;
                _colObj.format = base.columnFormats[_type].format;
                _colObj.validation = base.columnFormats[_type].validation;
                _colObj.label = sanitize(_name);
                buildGrid();
            },

            buildFormatSelection: function(){
                var colFormatTemplate  = '<lable>Column Type</lable><select name="select" class="input-sm form-control gg-modal-select">';
                for( var i = 0; i <  base.columnFormats.length ; i++){
                    colFormatTemplate += "<option value='"+i+"'>"+base.columnFormats[i].display_name+"</option>";
                }
                colFormatTemplate += "</select>"
                return colFormatTemplate;
            },




            removeCol: function(_index,colObj){
                //console.log("_index: " , _index)
                //console.log("colObj: " , colObj)
                //TODO:remove data from array also. and set selected cell to cell not in column being removed. That throws an error.
                base.data.headerArraySafe.splice(_index, 1);
                buildGrid();
            },

            addCol: function(_label,_data_type,_index){
                var map = "add_col_" + base.edit.createUniqueColId(3);
                var newCol = {
                    "label": _label,
                    "full-label": _label,
                    "removable":true,
                    "object_id":map,
                    "map": map,
                    "width": 100,
                    "header_class": "",
                    "col_class": "",
                    "display": "y",
                    "data_type": "string",
                    "edit_type": "text",
                    "format": "",
                    "validation": "",
                    "editable": "y",
                    "call_back": ""
                };

                base.data.headerArraySafe.splice(_index, 0, newCol);
                buildGrid();
                dropdownAction('formatCol','','', newCol, newCol.map);



            },


            fill: function(_fill_value,curDataCol){
                _.each(base.data.dataArr, function(item) {
                    item[base.selected.colData.map] = _fill_value;
                });
                buildGrid();
            },



            expandCols: function() {
                this.expanded = !this.expanded;

                if(this.expanded ){
                    this._savedWidths = {};
                    base.data.headerArraySafe.forEach(function(value) {
                        base.headerService._savedWidths[value.map] = value.width;
                    });
                    base.data.headerArray.forEach(function(value) {
                        var buffer = 8;
                        var characterWidth = 8;

                        if(value.label != null ){
                            var label = value.label.replace(/<(?:.|\n)*?>/gm, '');
                            var labelLength = (label.length * characterWidth) + buffer ;
                            if( labelLength >  value.width ){
                                value.width = labelLength;
                            }
                        }
                    });
                }else{
                    if(this._savedWidths){
                        base.data.headerArraySafe.forEach(function(value) {
                            if(base.headerService._savedWidths[value.map] !== undefined){
                                value.width = base.headerService._savedWidths[value.map];
                            }
                        });
                        this._savedWidths = null;
                    }
                }

                buildGrid();
            }



        }


        base.largeText = {
            showComponent:false,
            editBtn:'<div class="btn btn-info btn-xs gg-lg-text-edit" >Edit</div>',
            saveBtn:'<div class="btn btn-success btn-xs gg-lg-text-save" >Save</div>',
            cancelBtn:'<div class="btn btn-warning btn-xs gg-lg-text-cancel" >Cancel</div>',

            show:  function() {
                this.view();
                this.position();
            },


            view: function(){
                base.elements.lgTxt.css('overflow-y','auto');
                base.elements.lgTxtBtns.html(base.largeText.editBtn);
                base.elements.lgTxtCnt.css('display','block');
                this.showComponent = true;

                // SECURITY: render the cell value as text, not HTML, so embedded
                // markup is shown literally instead of being parsed by the browser.
                // The previous .html(sanitize(...)) relied on a weak regex blocklist
                // that is bypassable (HTML tag injection finding ASAP-FIND-25-06-0191066).
                base.elements.lgTxt.text(base.selected.value == null ? '' : String(base.selected.value));
            },


            hide:  function() {
                base.elements.lgTxtCnt.css('display','none');
                base.elements.lgTxt.html("");
                this.showComponent = false;
            },

            position: function(){

                if(base.selected.element && base.selected.element.offset()){
                    var positionX = base.selected.element.offset().left  +  base.selected.element.width();
                    var positionY = base.selected.element.offset().top  +  base.selected.element.height();
                    if( (positionX +  base.elements.lgTxtCnt.width()) > windowWidth  ){
                        positionX = (base.selected.element.offset().left - base.elements.lgTxtCnt.width());
                    }
                    if( (positionY +  base.elements.lgTxtCnt.height()) > windowHeight  ) {
                        positionY = ( windowHeight - 10)  -  base.elements.lgTxtCnt.height();
                    }
                    base.elements.lgTxtCnt.css('left', positionX +'px');
                    base.elements.lgTxtCnt.css('top', positionY +'px');
                }

            },

            edit: function(event){
                var value = (typeof base.selected.value === "undefined") ? "" : base.selected.value;
                base.elements.lgTxtBtns.html(base.largeText.saveBtn + " " + base.largeText.cancelBtn);
                // SECURITY: build an empty textarea, then set the value as a DOM
                // property via .val() so the content is never parsed as HTML
                // (prevents </textarea> breakout / HTML tag injection).
                base.elements.lgTxt.html('<textarea style="width:'+base.elements.lgTxt.width()+'px; height:'+base.elements.lgTxt.height()+'px"  ></textarea>');
                base.elements.lgTxt.children(0).val(value);
                base.elements.lgTxt.css('overflow','hidden');
            },


            save: function(){
                var val = base.elements.lgTxt.children(0).val();
                var callName = base.selected.colData.call_back;
                var data = {
                    colData:base.selected.colData,
                    rowData:base.selected.rowData,
                    newVal:val
                }
                base.selected.value = val;
                base.edit.setValue(val);
                base.largeText.view();
                buildGrid();
                base.focus.gridBody.focus();

            },

            cancel: function(){
                base.elements.lgTxt.html("");
                base.elements.lgTxtBtns.html(base.largeText.editBtn);
                base.largeText.view();
            }




        }


        base.renderSelected = {
            renderType: "",
            renderPosition: {},
            defaultCell:{},

            setDefaultCell: function (defaultCell) {
                base.renderSelected.defaultCell = defaultCell;
            },


            selectedAll: function () {
                base.renderSelected.clearAll();
                base.renderSelected.renderType = "rowGroup";
                base.renderSelected.renderType = "all";
                base.selectedGroup = 'all';
                var offsetWidth = base.$el.find('.div-col-prime').width();
                var selection = $('<div class="gg-selection"><div>');
                selection.height(base.elements.body.height());
                selection.width(base.elements.body.width() - ( base.elements.vtrack.width() + offsetWidth) );
                selection.css('top',base.elements.body.offset().top+'px');
                selection.css('left',(base.elements.body.offset().left + offsetWidth) +'px');
                base.$el.prepend(selection);
                base.focus.gridBody.focus();
            },


            clearSelection: function(){
                $( "div" ).remove( ".gg-selection" );
                $( "div" ).remove( ".gg-cell-selection" );
            },


            clearAll:function(){
                this.renderType = "";
                this.renderPosition = {};
                this.clearSelection();
            },


            selectCellGroup: function (fromCellRow,fromCellCol,toCellRow,toCellCol) {
                base.renderSelected.clearAll();
                base.renderSelected.renderType = "cellGroup";
                var fromRow = _.findIndex(base.data.dataArr, { object_id: fromCellRow})
                var toRow = _.findIndex(base.data.dataArr, { object_id: toCellRow})
                var fromCol = _.findIndex(base.data.headerArray, { map: fromCellCol})
                var toCol = _.findIndex(base.data.headerArray, { map: toCellCol})

                var hDirection = "Right",
                    direction = "down";

                if( Math.sign(toRow - fromRow ) === -1){
                    var newFromRow = toRow
                    var newToRow = fromRow
                    fromRow = newFromRow;
                    toRow = newToRow;
                    direction = "up";
                }

                if( Math.sign(toCol - fromCol ) === -1){
                    var newFromCol = toCol
                    var newToCol = fromCol
                    fromCol = newFromCol;
                    toCol = newToCol;
                    hDirection = "Left";
                }


                base.renderSelected.renderPosition = {y1:fromRow,y2:toRow,x1:fromCol,x2:toCol};
                if( fromCellRow == toCellRow && fromCellCol == toCellCol ){
                    base.renderSelected.renderType = "";
                    base.renderSelected.renderPosition = {}
                }
                base.renderSelected.renderSelected();
            },


            setCellGroup: function(){
                var fromRow = base.renderSelected.renderPosition.y1;
                var toRow =  base.renderSelected.renderPosition.y2;
                var fromCol =  base.renderSelected.renderPosition.x1;
                var toCol =  base.renderSelected.renderPosition.x2;

                if(base.renderSelected.renderType === "cellGroup" ) {
                    base.selectedGroup = [];

                    for (var i = parseInt(fromRow); i <= parseInt(toRow); i++) {
                        for (var p = parseInt(fromCol); p <= parseInt(toCol); p++) {
                            var row_id = base.data.dataArr[i].object_id;
                            var col_id = base.data.headerArray[p].map;
                            setSelected(col_id, row_id, 'cell', true);
                        }

                    }
                }

                base.mathFormulas.selectedSum();
            },


            renderCellGroup : function () {
                base.renderSelected.clearSelection();
                var fromRow = base.renderSelected.renderPosition.y1;
                var toRow =  base.renderSelected.renderPosition.y2;
                var fromCol =  base.renderSelected.renderPosition.x1;
                var toCol =  base.renderSelected.renderPosition.x2;

                if( ! _.inRange(fromRow, base.vDragg.startIndex, base.vDragg.endIndex) ){
                    fromRow = base.vDragg.startIndex;
                    if(  fromRow  > toRow || ! _.inRange(toRow , base.vDragg.startIndex, base.vDragg.endIndex)  ){
                        return false;
                    }
                }

                if( ! _.inRange(toRow , base.vDragg.startIndex, base.vDragg.endIndex) ){
                    toRow = base.vDragg.endIndex - 1;
                    if(  fromRow  > toRow  ){
                        return false;
                    }
                }


                //TODO: MAKE SELECTION STAY WHEN OUT OF ONE BOUND ELEMENT LIKE WE DO WITH ROW ^



                if( typeof base.data.dataArr[fromRow] !== undefined  && typeof base.data.dataArr[toRow] !== undefined && base.data.dataArr.length >= 0 ) {

                    var fromRowObj = base.data.dataArr[fromRow].object_id;
                    var toRowObj = base.data.dataArr[toRow].object_id;
                    var fromColObj = base.data.headerArray[fromCol].map;
                    var toColObj = base.data.headerArray[toCol].map;
                    var left = base.elements.body.offset().left;
                    var elementFrom = $(".div-col[obj_id=" + fromRowObj + "-" + fromColObj + "]");
                    var elementTo = $(".div-col[obj_id=" + toRowObj + "-" + toColObj + "]");

                    if (typeof elementFrom.offset() !== "undefined" && typeof elementTo.offset() !== "undefined") {
                        var width = elementTo.offset().left - elementFrom.offset().left + elementTo.width();
                        var height = Math.abs(elementFrom.offset().top - (elementTo.offset().top + elementTo.height()));
                        var selection = $('<div class="gg-selection"><div>');
                        selection.width(width);
                        selection.css('left', (elementFrom.offset().left - left  ) + 'px');
                        selection.css('top', elementFrom.position().top + 'px');
                        selection.height(height);
                        base.elements.body.prepend(selection);
                    }

                }



            },


            selectRowGroup: function (from,to) {
                base.renderSelected.clearAll();
                base.renderSelected.renderType = "rowGroup";
                var fromRow = _.findIndex(base.data.dataArr, { object_id: from})
                var toRow = _.findIndex(base.data.dataArr, { object_id: to})
                var direction = "down";

                if( Math.sign(toRow - fromRow ) === -1){
                    var newFromRow = toRow
                    var newToRow = fromRow
                    fromRow = newFromRow;
                    toRow = newToRow;
                    direction = "up";
                }

                base.renderSelected.renderPosition = {y1:fromRow,y2:toRow};
                base.renderSelected. renderSelected();

            },


            setSelectedGroup: function(){
                var fromRow = base.renderSelected.renderPosition.y1;
                var toRow =  base.renderSelected.renderPosition.y2;
                base.selectedGroup = [];
                for (var i = parseInt(fromRow); i <= parseInt(toRow); i++){
                    var rowObj = base.data.dataArr[i];
                    selectRowGroup(rowObj.object_id);
                }
            },

            setColGroup: function(map,multi){


                base.renderSelected.clearAll();
                this.renderType = "colGroup";
                selectCol(map,multi);
                base.renderSelected.renderSelected();
                base.mathFormulas.selectedSum();
            },

            renderColGroup: function () {
                base.renderSelected.clearSelection();
                _.forEach(base.selectedGroup, function(value, key) {
                    if( value.select_type === "header"){
                        base.renderSelected.renderCol(value);
                    }
                });
            },

            renderCol: function (_object) {
                var element = $(".headerCol" + attrEquals("map", _object.col_id), base.$el);
                var left = base.elements.body.offset().left;

                if (typeof element.offset() !== "undefined") {
                    var selection = $('<div class="gg-selection"><div>');
                    selection.height(base.elements.body.height());
                    selection.width(element.width());
                    selection.css('top', '0px');
                    selection.css('left', (element.offset().left - left) + 'px');
                    base.elements.body.prepend(selection);
                }
            },


            renderRowGroup: function () {
                var fromRow = base.renderSelected.renderPosition.y1;
                var toRow =  base.renderSelected.renderPosition.y2;
                if( ! _.inRange(fromRow, base.vDragg.startIndex, base.vDragg.endIndex) ){
                    fromRow = base.vDragg.startIndex;
                    if(  fromRow  > toRow || ! _.inRange(toRow , base.vDragg.startIndex, base.vDragg.endIndex)  ){
                        return false;
                    }
                }

                if( ! _.inRange(toRow , base.vDragg.startIndex, base.vDragg.endIndex) ){
                    toRow = base.vDragg.endIndex - 1;
                    if(  fromRow  > toRow  ){
                        return false;
                    }
                }




                //console.log("base.data.dataArr[fromRow] " ,  base.data.dataArr[fromRow]);
                //console.log("base.data.dataArr[toRow] " ,  base.data.dataArr[toRow]);


                if( typeof base.data.dataArr[fromRow] !== undefined  &&  typeof base.data.dataArr[toRow] !== undefined ) {

                    var fromObj = base.data.dataArr[fromRow].object_id;
                    var toObj = base.data.dataArr[toRow].object_id;

                    var left = base.elements.body.offset().left;
                    var elementFrom = $(".div-col-prime[rowobj=" + fromObj + "]");


                    if (typeof elementFrom.offset() !== "undefined") {

                        var elementTo = $(".div-col-prime[rowobj=" + toObj + "]");
                        var height = Math.abs(elementFrom.offset().top - (elementTo.offset().top + elementTo.height()));
                        var selection = $('<div class="gg-selection"><div>');
                        selection.width(base.elements.body.width() - (base.elements.vtrack.width() + elementFrom.width()));
                        selection.css('left', (elementFrom.position().left + elementFrom.width() ) + 'px');
                        selection.css('top', elementFrom.position().top + 'px');
                        selection.height(height);
                        base.elements.body.prepend(selection);

                    }


                }

            },

            renderCell : function () {
                $( "div" ).remove( ".gg-cell-selection" );
                var left = base.elements.body.offset().left;
                var obj_id = base.renderSelected.defaultCell.row_id + "-" + base.renderSelected.defaultCell.col_id
                var element = $(attrEquals("obj_id", obj_id), base.$el);

                if ( typeof element.offset() !== "undefined" ) {
                    var selection = $('<div class="gg-selection gg-cell-selection"><div>');
                    selection.height(element.parent().height());
                    if(base.renderSelected.defaultCell.col_id && base.renderSelected.defaultCell.col_id == "group") {
                        selection.width(element[0].clientWidth);
                    } else {
                        selection.width(element.width());
                    }                    
                    selection.css('top', (element.position().top) + 'px');
                    selection.css('left', (element.offset().left - left) + 'px');
                    base.elements.body.prepend(selection);


                    this.setHeaderRowIndicators();

                }
            },


            renderSelected: function(){
                base.renderSelected.clearSelection();
                if(base.renderSelected.renderType === "rowGroup"){
                    base.renderSelected.renderRowGroup()
                }else if (base.renderSelected.renderType === "colGroup"){
                    base.renderSelected.renderColGroup();
                }else if(base.renderSelected.renderType === "cellGroup" ){
                    base.renderSelected.renderCellGroup();
                }

                base.renderSelected.renderCell();
            },

            setHeaderRowIndicators: function(){
                $(".div-col-prime" + attrEquals("rowobj", base.selected.row_id), base.$el).addClass('selected-prime-row');
                $(".headerCol" + attrEquals("map", base.selected.col_id), base.$el).addClass('selected-col-header');
            }

        }



        base.loadGrid = function (){
            //base.batchSelect = [];


            if( !options.data || ((options.data.settings.grid_type !== 'import') && (options.data.dataArr.length < 1)) ){
                addAlert("alert-warning","Data Error: No data found with this filter criteria", 8000);
                base.$el.find('.gg-body').css('min-height','60px');
                // Clear stale footer filter chips when re-loading into an empty
                // dataset; otherwise chips from the previous grid state remain
                // visible with mismatched/empty labels (predicates no longer
                // map to columns in the new headerArray).
                if (base.elements && base.elements.footerContainer) {
                    base.elements.footerContainer.html("");
                }
                // Keep batch actions (e.g. Add schdm Template Id) available when
                // the payload has no rows. loadGrid returns before buildGrid.
                if (options.data && base.menuService) {
                    base.menuService.buildBatchActionsMenu();
                }
                return false;
            }


            //DB GRID SETTING OVERRIDESorting does not work as expected in Dashboard, screen and grid on sort by name / string values. Lower case and upper case words are out of order. Below screenshot has action name sorted descending as Z- A. The sorting is not correct as highlighted in the screenshot.	Open	Low	 	Yet to Analyze	Dharmesh

            if( options.data.settings ) {



                if (options.data.settings.default_row_height && options.data.settings.default_row_height.length) {
                    base.options.defaultRowHeight = options.data.settings.default_row_height;
                }


                //Heath S Added 2/11/2019 - Sets default header height from gris settings
                base.headerRow.height = parseInt(options.data.settings.header_height) ||   base.options.vDraggerMinHeight


                if (options.data.settings.fixed_columns && options.data.settings.fixed_columns > 0) {
                    base.options.fixedColumn = options.data.settings.fixed_columns;
                }

                if (options.data.settings.grid_type && options.data.settings.grid_type.length) {
                    base.options.gridType = options.data.settings.grid_type;

                   // base.$el.find('.gt-col-temp-drop').css('display','none');

                    if( base.options.gridType === 'import' && options.data.dataArr.length < 1){
                        options.data.dataArr.push({object_id:"1"});
                        //options.data.dataArr.push({object_id:"2"});
                       // options.data.dataArr.push({object_id:"3"});
                    }


                    if( base.options.gridType === 'batch-save' ){
                        base.$el.find('.gt-col-temp-drop').css('display','none');
                    }

                    /*TODO: Remove this
                    if( base.options.gridType === 'import'){
                        base.$el.find('.gg-paste-save-btn').css('display','inline-block');
                    }else{
                        base.$el.find('.gg-paste-save-btn').css('display','none');
                    }
                    */

                }


                if(!options.data.settings || options.data.settings.comments !== 1){
                    base.$el.find('.tools-comments').css('display','none');
                }
                if(!options.data.settings || options.data.settings.attachments !== 1){
                    base.$el.find('.tools-attachments').css('display','none');
                }

                base.$el.find('.gg-override-filter').css('display','none');

                /************************ dvalaboju001 11/14/2019 *************************/
                if(!options.data.settings){
                    base.$el.find('.tools-export').css('display','none');
                }


                if (options.data.settings.max_xls_rows && options.data.settings.max_xls_rows.length) {
                    base.options.maxXlsRows = options.data.settings.max_xls_rows;
                }

            }

            base.loader.hideLoader();
            base.elements.fliterOverlay.css('display', 'none');

            //////////////////////// SETUP DATA  ////////////////////////////////////
            base.data.dataArr = options.data.dataArr;
            base.data.headerArraySafe = options.data.headerArray;
            base.data.messageObject = options.data.messageObject;
            base.data.attachmentObject = options.data.attachmentObject;
            base.data.errorObject = options.data.errorObject;
            base.data.headerArray = _.filter(base.data.headerArraySafe, { display: 'y' });
            base.data.safeCopyArr = _.clone( base.data.dataArr);
            base.headerService.templateArray = options.data.columnTemplates;
            base.data.newRow = [];
            base.data.pivotGroup = options.data.pivotGroup;
            base.data.isCollapsed = false;
            base.data.auditCellsObject = options.data.auditCellsObject;


            if (typeof options.data.vDragg === "undefined" || _.isEmpty(options.data.vDragg)){
                options.data.vDragg =  base.vDragg;
            }

            if (typeof options.data.hDragg === "undefined" || _.isEmpty(options.data.hDragg)){
                options.data.hDragg =  base.hDragg;
            }


            //:TODO [batch_select] move this block of code in to a method in base.headerService Obj
            if(typeof options.data.settings !== "undefined" && typeof options.data.settings.batch_select !== "undefined" && options.data.settings.batch_select === 1 ) {
                base.batchSelectMode = true;
                if(  typeof _.find(base.data.headerArraySafe, {map:"batchSelect"}) == "undefined" ) {
                    var batchSelectObj = {
                        map: "batchSelect",
                        display: "y",
                        col_class: "batchSelect",
                        call_back: "",
                        edit_type: "batchSelect",
                        header_class: "batchSelect ",
                        editable: "y",
                        label: "", //<i class='fa fa-check '></i> removed since this shows as icon in grid
                        width: 40,
                        format: "batchSelect",
                        object_id: "batchSelect"
                    }

                    base.data.headerArraySafe.splice(1, 0, batchSelectObj);

                    //push the new batchSelect Col type into templateArray
                    if( base.headerService.templateArray && base.headerService.templateArray.length ){
                        base.headerService.templateArray[0].columns.splice(1, 0, batchSelectObj);
                    }



                }
            }


            base.cellData = options.data.cellData;
            base.tableState = options.data.tableState;
            base.userAccessLevel = options.data.userAccessLevel;
            base.sso_id = options.data.sso_id;
            base.headerService.templateIndex = 0;
            base.batch.setBatchSelected();
            base.headerService.renderColTools();
            base.selected = options.data.selected;
            base.vDragg = options.data.vDragg;
            base.hDragg = options.data.hDragg;
            base.headerService.colToolSetTemplates();
            base.batchSelect = options.data.batchSelect;
            base.actionTemplates = options.data.actionTemplates;

            base.buildDom.batchRowSelectable(base.data.dataArr);


            base.actionsService.buildMenu();
            paintColor(base.selected.color);
            pipe();
            buildGrid();
            base.focus.gridBody.focus();

        };


        var validateData = function(){
            addAlert("alert-danger","<b>Error:</b> Your data did not contain a header  ",'5000' );
        }


        base.loader = {
            visible: true,
            setSize: function () {
                base.elements.dataLoader.width(base.$el.width() + 30);
                base.elements.dataLoader.height($(window).height() - base.$el.offset().top);
                //filterOverlay
                base.elements.fliterOverlay.width(base.$el.width() + 30);
                base.elements.fliterOverlay.height($(window).height() - (base.$el.offset().top + base.gridFiltersDivHeight));

            },

            showLoader: function() {
                base.largeText.hide();
                base.gridFiltersDivHeight = 0;// need to make this to 0,otherwise white space gets added to grid bottom on window resize/showLoader
                this.setSize();
                base.elements.dataLoader.css('display','block');
                this.visible = true
                //filterOverlay
                base.elements.fliterOverlay.css('display','none');
            },

            hideLoader: function() {
                base.elements.dataLoader.fadeOut( "slow", function() {
                    // Animation complete.
                });
                this.visible = false;
            }

        }





        //TODO: REMOVE THIS - This has been moved to importController
        base.pasteXls =  {
            extensionId: 'npkadhmnkkhdbojjjmenafcnjadkcfme', //GOOD
            // extensionId: '123123123123', //FAKE
            allowed: true,
            hasExtension:false,
            requiredVersion: 0.1,
            checkForExtension: function() {
                /*var that = this;
                if( window.chrome ){
                    chrome.runtime.sendMessage(
                        this.extensionId,
                        {method: 'getVersion'},
                        function (response) {
                            if (response) {
                                if (response >= that.requiredVersion) {
                                    that.hasExtension = true;
                                }else{
                                }
                            }else{
                                //////////console.log("the required version of the chrome extension " + that.extensionId + " is not installed" ) ;
                            }
                        }
                    )
                }*/
                return false;
            },



            paste: function () {
                //IF WE ARE IN CHROME
                if( this.hasExtension ){
                    this.readClipboard();
                }else{
                    this.openPasteWindow();
                }
            },


            openPasteWindow: function(){
                //////////console.log("openpaste window message")
            },


            readClipboard: function() {
                var  that = base.pasteXls;
                chrome.runtime.sendMessage(
                    this.extensionId,
                    { method: 'getClipboard' },
                    function(response) {
                        that.processXls(response);
                    }
                )
            },



            validate: function(value,validation){
                var returnVal = "";
                if(validation == 'numeric' ){
                    if( !isNaN(value)){
                        returnVal =  Number(value);
                    }
                    return returnVal;
                }else if(validation == 'date' ){
                    return returnVal;
                }
                return value;
            },



            processXls: function(_data){

                if(base.options.gridType != 'import' ) {
                    addAlert("alert-warn"," The structure of this Grid is not editable ",4000 );
                    return false;
                }

                //TODO: add check for tabdlim
                base.cellData = {};
                var rows = _data.split("\n");
                var headerArray = base.data.headerArray;
                var dataArray = [];



                //TODO - CHECK IF WE HAVE
                // 1. COLUMN SELECTION
                // 2. ROW SELECTION
                // 3. GROUP OF CELLS





                console.log("base.selected " , base.selected);

                console.log(" base.selectedGroup " ,  base.selectedGroup);





                // options.data.dataArr = [];
                //Clear the array but do not break the
                while (options.data.dataArr.length > 0) {
                    options.data.dataArr.pop();
                }

                for (var i = 0; i < rows.length;  i++) {
                    var newRow = {};
                    var cells = rows[i].split("\t");
                    newRow[headerArray[0].map] = (i+1).toString();

                    for (var c = 0; c < cells.length;  c++) {
                        var hI = c+1;
                        if(headerArray[hI] !== undefined ) {
                            if (headerArray[hI].validation) {
                                var rawValue = cells[c];
                                var value = this.validate(cells[c], headerArray[hI].validation);
                                newRow[headerArray[hI].map] = value;
                            } else {
                                newRow[headerArray[hI].map] = cells[c];
                            }
                        }
                    }
                    options.data.dataArr.push(newRow);
                }


                base.data.dataArr =  options.data.dataArr;
                base.data.safeCopyArr = base.data.dataArr;
                pipe();


            },

            save: function(){

                /*
                base.api.callBack( 'ftReclassSave',base.data.dataArr,'batch-import');
                setTimeout(function(){
                    addAlert("alert-success","Fast-Track Import was successfully saved",4000 );
                }, 1000);
                */

            }

        }

        base.pasteXls.checkForExtension();

////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// MAP   /////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

        // base.tags['2-MARS'] = {title:"first tags", comment:"some text" , type:"action", row_obj:"2"};
        // base.tags['3-ACCOUNT'] = {title:"first tags", comment:"some text" , type:"action", row_obj:"2"};
        // base.tags['6-ACCT_DESC'] = {title:"first tags", comment:"some text" , type:"action" , row_obj:"7"};

        function renderTagMap(_object){
            for(var propt in base.tags){
                buildMap(base.tags[propt])
            }
            function buildMap(obj){
            }
            base.$el.find('.gg-vScroll-container').append("<div class='map'></div>");
        }


        renderTagMap();

////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// PRIVATE FUNCTIONS /////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////   BUILD GRID   //////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////


        function getBoundedHostBudget(hostEl, chromeHeight, minBodyHeight){
            var bodyEl = base.elements.body && base.elements.body[0];
            if(!hostEl || !bodyEl || typeof hostEl.clientHeight !== 'number'){
                return null;
            }

            var probeSmall = minBodyHeight;
            var probeLarge = minBodyHeight * 2;
            var priorHeight = bodyEl.style.height;

            bodyEl.style.height = probeSmall + 'px';
            var clientSmall = hostEl.clientHeight;
            bodyEl.style.height = probeLarge + 'px';
            var clientLarge = hostEl.clientHeight;
            bodyEl.style.height = priorHeight;

            var followsBodyHeight = (clientLarge - clientSmall) > (probeLarge - probeSmall) / 2;
            if(followsBodyHeight || clientSmall <= chromeHeight + minBodyHeight){
                return null;
            }
            return clientSmall - chromeHeight;
        }


        function buildGrid(){

            base.layout.offset = base.$el.offset();
            windowHeight = $(window).height() - 1;
            windowWidth = $(window).width();

            //Set Scroll Height //////////////////////////////////////
            var headerHeight = base.headerRow.height ||  base.elements.header.height();

            var copyRightFooterHeight = document.getElementsByClassName('copyright')[0] ? document.getElementsByClassName('copyright')[0].clientHeight 
                                        :document.getElementsByClassName('cookieAcceptance')[0]? document.getElementsByClassName('cookieAcceptance')[0].clientHeight 
                                        : 0;
           
            //base.layout.scrollWindow = windowHeight - (base.layout.offset.top + base.elements.tools.outerHeight() + headerHeight + base.elements.footer.outerHeight() + base.elements.hScroll.height());
            base.layout.scrollWindow = windowHeight - (base.layout.offset.top + base.elements.tools.outerHeight() + headerHeight + base.elements.footer.outerHeight() + base.elements.hScroll.height() + 
                                        copyRightFooterHeight);
            // Bounded hosts (e.g. efile `.gg-host-wrap`): reconcile viewport-based
            // body height with the host's own height budget — cap when the host is
            // shorter than the window budget, and stretch when the host is taller
            // (avoids white space below `.gg-footer`).
            var chromeHeight = base.elements.tools.outerHeight() + headerHeight + base.elements.footer.outerHeight() + base.elements.hScroll.height();
            var hostEl = base.$el[0];
            var minBodyHeight = 80;
            var hostBudget = getBoundedHostBudget(hostEl, chromeHeight, minBodyHeight);
            if (hostBudget !== null) {
                var viewportBudget = base.layout.scrollWindow;
                // Efile / other bounded shells: `offset().top` + copyright math can
                // yield a viewportBudget *smaller* than the space inside a fixed-height
                // host (e.g. `.gg-host-wrap { height: calc(100vh - 200px) }`). Using
                // Math.min(viewport, host) then left a short `.gg-body` and white gap
                // below `.gg-footer`. When the host is visibly taller than the viewport
                // budget, stretch the body to fill the host; otherwise keep the cap so
                // unbounded tall hosts still respect the window budget.
                if (hostBudget > viewportBudget + 2) {
                    base.layout.scrollWindow = Math.max(minBodyHeight, hostBudget);
                } else {
                    base.layout.scrollWindow = Math.max(minBodyHeight, Math.min(viewportBudget, hostBudget));
                }
            }
            //Added check to adjust the grid height when appearing on modal..
            if(options.data && options.data.fromModal !=undefined && options.data.fromModal){ //these styles will apply only when call the grid on Modal 8/19/2021
                base.elements.body.height('calc(100vh - 310px)');
            }else{
               base.elements.body.height(base.layout.scrollWindow );
            }
            base.layout.rowsPerPage = Math.round((base.layout.scrollWindow / base.options.defaultRowHeight) + base.options.rowBuffer);
            base.layout.startIndex = 0;
            base.layout.endIndex = base.layout.startIndex +  base.layout.rowsPerPage;

            if( base.vDragg.endIndex === 0 || base.data.pivotGroup && base.data.pivotGroup.groupRows && base.data.pivotGroup.groupRows.length>0){
                base.vDragg.endIndex = base.layout.rowsPerPage;
            }
            if(!_.isEmpty(base.data.pivotGroup)){
                if(base.data.pivotGroup != undefined && (base.data.pivotGroup.groupRows.length >0 || base.data.pivotGroup.columnToRows.length >0) && (base.selVal && base.selVal == true)) {
                    base.pivotChecked = "enabled";
                } else if(base.data.pivotGroup != undefined && (base.data.pivotGroup.groupRows.length == 0 || base.data.pivotGroup.columnToRows.length == 0) && (base.selVal && base.selVal == false)){
                    base.pivotChecked = "disabled";
                } else if(base.data.pivotGroup != undefined && (base.data.pivotGroup.groupRows.length > 0 || base.data.pivotGroup.columnToRows.length > 0) && (base.selVal == undefined)) {
                    base.pivotChecked = "enabled";
                }
            }
           
            // displayIssueCols();
            setHeader();
            setColWidthArr();
            base.layout.gridHeight = setRowHeightArr();
            setGridLayout();
            buildVScrollBar();
            buildHScrollBar();
            buildHeaderDom();
            setDefaultSelect();//This was commented out; Heath uncommented 2/1/2019
            buildBodyDom();
            positionColFreezeHandle();
            base.menuService.buildBatchActionsMenu();
        }








        function chunk(arr, start, end) {
            var returnArray = [];
            for(var i =  start; i < end; i++){
                returnArray.push(arr[i]);
            }
            return returnArray;
        }

        function setHeader(){
            var start = 0;
            if(base.data.headerArraySafe){
                let obj = {};
                obj = _.find(base.data.headerArraySafe,{map:"group"});
                const index = _.findIndex(base.data.headerArraySafe,{map:"group"})
                if(!_.isEmpty(obj) && index > 1){
                    _.remove(base.data.headerArraySafe,{map:"group"});
                    base.data.headerArraySafe.splice(1, 0, obj);
                }
            }
            base.data.headerArray = _.filter(base.data.headerArraySafe, { 'display': 'y' });
            var end =  base.data.headerArray.length;
            var fixedColumns = ( base.options.fixedColumn > base.data.headerArray.length )? base.data.headerArray.length : base.options.fixedColumn;
            base.data.fixedHeaderArrayDisplay = chunk(base.data.headerArray,start,fixedColumns);
            base.data.headerArrayDisplay = chunk(base.data.headerArray,fixedColumns,end);
            base.data.fixedHeaderSafeCopyArr = _.clone(base.data.headerArrayDisplay);
        }

/////////////////////////////////////   BUILD HEADER DOM  ////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////

        function setGridLayout(){
            //HEADER ELEMENTS///////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////
            base.elements.headerLeft.width(getGridWidth(base.data.fixedHeaderArrayDisplay));
            base.elements.headerRight.width(getGridWidth(base.data.headerArrayDisplay));
            base.elements.headerLeft.css('left','0px');
            base.elements.headerRight.css('left',getGridWidth(base.data.fixedHeaderArrayDisplay)+'px');

            //DATA ELEMENTS///////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////
            base.elements.ggleftcol.width(getGridWidth(base.data.fixedHeaderArrayDisplay));
            base.elements.ggrightcol.width(getGridWidth(base.data.headerArrayDisplay));
            base.elements.ggleftcol.css('left','0px');
            base.elements.ggrightcol.css('left',getGridWidth(base.data.fixedHeaderArrayDisplay)+'px');
        }


        function getGridWidth(_array){
            var sum = 0;
            var defW = parseFloat(base.options.defaultColWidth);
            if (!isFinite(defW) || defW < 0) {
                defW = 100;
            }
            for (var i = 0; i < _array.length; i++) {
                var w = _array[i] && _array[i].width;
                var n = parseFloat(w);
                if (!isFinite(n) || n < 0) {
                    n = defW;
                }
                sum += n;
            }
            return sum;
        }

        function getGridHeight(){
            var sum = 0;
            for(var i = 0;  i < base.data.dataArr.length; i++ ){
                sum += (base.data.dataArr[i].height);
            }
            return sum;
        }

        function removeProperty(_array,_value){
            //dataArr
            for(var i = 0;  i < _array.length; i++ ){
                _.forOwn(_array[i], function(n, key) {
                    if( _.includes(n,_value) ){
                        ////////////////////////////consolee.log(key);
                        ////////////////////////////consolee.log(n);
                        _array[i][key] = _array[i][key].replace(_value,'')
                    }
                });
            }

        }



        base.dataProvider = {

            getData: function(_url,_type,_data){

                var returnData = "";
                if(_data == undefined ){
                    _data = {}
                }


                //START HERE GET TOOKEN FROM COOKIE
                var promise =   $.ajax({
                    url: _url,
                    type: _type,
                    data: _data,
                    headers:{'X-XSRF-TOKEN':"d3288042-a98c-4db9-a392-dd01b4bf850c"}
                });

                return promise;
            }
        }




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////// messageService /////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //   base.messageService.hideMessages();




        base.actionsService = {

            selectedTemplate:null,


            buildMenu: function(){
                if( base.userAccessLevel < 1){
                    base.$el.find('#actionsCreate').hide();
                }

                //New li element created to display selected grid actions item from the dropdown menu - (Added by OMI).
                var menuContainerSelectedElement = base.$el.find('#selectedActMenuItem');
                menuContainerSelectedElement.html("");
                menuContainerSelectedElement.hide();



                if(base.actionTemplates && !_.isEmpty(base.actionTemplates) ){
                    var selectedItem;
                    base.$el.find('#actionsMenu').show();


//                    if(this.selectedTemplate !== null){
                    if(this.selectedTemplate !== null){
                        base.$el.find('#actionsMenu').addClass('gg-drop-down-on')
                    } else {
                        base.$el.find('#actionsMenu').removeClass('gg-drop-down-on');
                    }

                    var menuContainerElement = base.$el.find('#actionsDropMenu');
                    menuContainerElement.html("");

                    _.forEach(base.actionTemplates, function(value, key) {
                        var checked = ( base.actionsService.selectedTemplate === value) ? "<i class=\"fa fa-check\"></i>" : "";
                       // var system = ( value.system === 1) ? "<i class=\"fa fa-circle \" style='color:red; margin-left: 10px'></i>" :  "<i class=\"fa fa-circle \" style='color:red; margin-left: 10px'></i>" ;
                       var pivot = ( value.action_type === 'pivot') ? "<i class=\"fa fa-ravelry\" style=\"font-size: 8px;\"></i>" : "";
                        console.log("value.system " , value.system   );


                        var listElement = '<li class="tools-action selected" action="actionTemplate" action_template_key="'+value.action_template_key+'"><a>'+checked+' '+value.name+'<span style=\"float:right\">'+pivot+'</span>'+'</a>'+'</li> '
                        menuContainerElement.append(listElement);

                        if(base.actionsService.selectedTemplate) {
                            //Stores the selected grid actions name value.
                            selectedItem = base.actionsService.selectedTemplate.name;
                        }
                    });

                    // Binding up the stored value to li element..
                    var selectedElement = '<b> - ( '+selectedItem+' ) </b>';
                    if(base.actionsService.selectedTemplate && base.actionsService.selectedTemplate != null) {
                        menuContainerSelectedElement.show();
                        menuContainerSelectedElement.append(selectedElement);
                    }

                    var clear = '<li class="divider"></li><li class="tools-action" action="clearActionTemplate"><a><i style="color:red" class="fa fa-times"></i> <i class="fa fa-times" style="display:none"></i> Clear Action</a></li>';

                    if(this.selectedTemplate){
                        menuContainerElement.append(clear);
                    }

                }
                else{

                    //base.$el.find('#actionsMenu').hide();
                    var clear = '<li class="divider"></li><li class="tools-action" action="clearActionTemplate"><a><i style="color:red" class="fa fa-times"></i> <i class="fa fa-times" style="display:none"></i> Clear Action</a></li>';

                    if(this.selectedTemplate){
                        menuContainerElement.append(clear);
                    }

                }


            },


            applyActionTemplate: function(_action_template_key){


                console.log("I AM CALLED  ");


                console.log("_action_template_key " , _action_template_key);
                console.log("base.actionTemplates " , base.actionTemplates);
                console.log("action_template " , action_template);



                var action_template  = _.find( base.actionTemplates , {'action_template_key' : parseInt(_action_template_key)});
                
                /* 3/2/2020 */


                this.selectedTemplate = action_template;
                /* pivot templates 2021 dvalaboju */
                if(action_template.action_type && action_template.action_type == 'pivot'){
                    base.tableState.colSearch = [];

                    var pivotGroupObject ={};
                    if(action_template && action_template.grid_data){
                        pivotGroupObject =   JSON.parse(action_template.grid_data);
    
                        _.each(base.actionTemplates, function(item){
                            if(item.action_template_key == action_template.action_template_key){
                                item.selectedAction = true;
                            }else{
                                item.selectedAction = false;
                                item.map = '';
                            }
                        })
                            base.hasActionSelected = true;
                            options.data.hasActionSelected = true;
                            this.buildMenu();
        
                    }
                    options.data.actionTemplates = base.actionTemplates;
      
                  
                    base.pivotChecked = "enabled";
                    //sending clearActionTemplate true value as a parameter to let apply pivotpanel temp about clear action dropdown menu selection.
                    base.api.callBack('callName',{pivotGroupObject:pivotGroupObject, clearActionTemplate: false},'applyPivotTemplate');
                }else{
                    base.isPreviousPivotTemplate = false
                        var gridData =   JSON.parse(action_template.grid_data);

                        _.each(base.actionTemplates, function(item){
                            if(item.action_template_key == action_template.action_template_key){
                                item.selectedAction = true;
                                item.map = gridData.tableState.colSearch[0].predicate;
                            }else{
                                if(item.selectedAction && item.action_type =='pivot'){
                                    base.isPreviousPivotTemplate = true;
                                }
                                item.selectedAction = false;
                                item.map = '';
                            }
                        })
                        if(base.isPreviousPivotTemplate){
                            var emptyPivotObject = {
                                agg:{ // aggregated fields
            
                                },
                                collapsed: [ false, false],
                                groupRows: [],
                                columnToRows: []
                                }  
                            base.api.callBack('callName',{pivotGroupObject:emptyPivotObject, clearActionTemplate: true},'applyPivotTemplate');
                        }
        
        
        
        
                        //: START - stringify null hack :===========================================================================
                        // - this is a temp hack to change back tableState.colSearch with values of null to undefined.
                        // JSON.stringify() automatically does this because JSON doesn't have a concept of undefined
                        //
                        // Restore ALL saved colSearch entries (string, numeric, array). Previously only
                        // type=="array" filters were restored, so context-menu text/numeric filters
                        // saved correctly but did not re-apply when the grid action was selected.
                if( gridData.tableState && gridData.tableState.colSearch && gridData.tableState.colSearch.length >= 1 ){
                    var restoredTableState = _.cloneDeep(gridData.tableState);
                    _.forEach(restoredTableState.colSearch, function (value, key) {
                        if(value.type == "array" && value.value && value.value.length){
                            _.forEach(value.value, function (valueA, keyB) {
                                /* NOTE: some grids have passing the null values so its causing the above commented code.
                                        we need to apply the undefined values only when the column have undefined value and ationTemplate 
                                        (tableState value should be null) */
                                var hasUndefined = _.uniq(_.map(base.data.dataArr,value["predicate"]));
                                if((hasUndefined &&  hasUndefined.indexOf(undefined)>-1) && valueA === null){
                                    value.value[keyB] = undefined;
                                }
                            });
                        }
                    });
                    base.tableState = restoredTableState;
                    options.data.tableState = restoredTableState;
                    base.hasActionSelected = true;
                    options.data.hasActionSelected = true;
                    gridData.hasActionSelected = true;
                    pipe();
                    this.applyColTemplate(gridData.templateArr);
                    this.buildMenu();
                }
            }
        },



            applyColTemplate: function(_headerTemplateArray){

                if(!_headerTemplateArray){
                    return false;
                }

                _.forEach(_headerTemplateArray, function (value, key) {
                    var object = _.find(base.data.headerArraySafe, {map: value.map});
                    if (object && object.map.toLowerCase() != 'object_id') {
                        object.width = value.width;
                        object.display = value.display;
                        //Sort Object;
                        var toMove = _.findIndex(base.data.headerArraySafe, object);
                        if (toMove >= 0) {
                            arraymove(base.data.headerArraySafe, toMove, key);
                        }
                    }
                });


                base.selected.row_id = null;
                setDefaultSelect();

                /*  apply fixed heights & columns for grid action 6/13/2019  parseInt(options.data.settings.header_height)*/
                if(base && base.options){
                    base.options.fixedColumn = (this.selectedTemplate!=null && this.selectedTemplate.fixed_columns>0)?this.selectedTemplate.fixed_columns: options.data.settings.fixed_columns;//this.selectedTemplate.fixed_columns;
                    base.headerRow.height = ( this.selectedTemplate!=null && this.selectedTemplate.header_height>0)?this.selectedTemplate.header_height : parseInt(options.data.settings.header_height);
                }

                /* ends Here */
                buildGrid();

            },

            clearActionTemplate: function () {
                /* if we clear the gridaction make template selection false */
                _.each(base.actionTemplates, function(item){
                    if(item.selectedAction){
                        item.selectedAction = false;
                        item.map='';
                    }
                })
                   options.data.actionTemplates = base.actionTemplates;
                /* pivot template check for clear */
                if(this.selectedTemplate && this.selectedTemplate.action_type == 'pivot')
                {
                    this.selectedTemplate = null;
                    var emptyPivotObject = {
                        agg:{ // aggregated fields
    
                        },
                        collapsed: [ false, false],
                        groupRows: [],
                        columnToRows: []
                        }   
                        this.buildMenu();
                        base.pivotChecked = "disabled";
                        //sending clearActionTemplate true value as a parameter to let apply pivotpanel temp about clear action dropdown menu selection.
                        base.api.callBack('callName',{pivotGroupObject:emptyPivotObject, clearActionTemplate: true},'applyPivotTemplate');
                }else{  /* existing flow-- grid actions */
                    this.selectedTemplate = null;
                    clearAll()
                    base.headerService.colToolsReset();
                    this.buildMenu();
                    base.$el.find('#actionsMenu').removeClass('gg-drop-down-on');
    
                   /*  _.each(base.pivotActionTemplates, function(item){
                        if(item.selectedAction){
                            item.selectedAction = false;
                            item.map='';
                        }
                    }) */
                }
               
                
                
            },
            /* is calling when first time load and to clear the previous selected template */
            clearSelectedTemplate: function(){
                _.each(base.actionTemplates, function(item){
                    if(item.selectedAction){
                        item.selectedAction = false;
                        item.map='';
                    }
                })
                this.selectedTemplate = null;
               base.$el.find('#actionsMenu').removeClass('gg-drop-down-on');
            },

            clearSelectedTemp:function(){
                base.actionsService.clearActionTemplate()
                this.selectedTemplate = null;
                this.buildMenu();
                base.$el.find('#actionsMenu').removeClass('gg-drop-down-on');
            },


        }
        base.messageService = {
            messageURL: base.base_url + "/commentByKey",
            replyURL: base.base_url + "/commentReply",
            reolveURL: base.base_url + "/resolveComment",
            position: {},
            context:{},
            commentRowsOnly:false,
            attachmentURL:base.base_url +"/loadFileAttachments",
            removeDocURL: base.base_url +"/dltGridDocuments",
            downloadAttachURL : base.base_url+'/downloadCommentAttachement',



            toggleCommentRows: function(){
                base.tableState.comments = !base.tableState.comments;
                this.toggleCommentFilterIcon();
                pipe();
            },


            showCommentRows: function(){
                base.tableState.comments = true;
                this.toggleCommentFilterIcon();
                pipe();
            },

             /* added by Divya toggle the attachments 9/22/2019*/
            toggleAttachmentRows: function(){
                base.tableState.attachments = !base.tableState.attachments;
                this.toggleAttachmentFilterIcon();
                pipe();
            },

            showAttachmentRows: function(){
                base.tableState.attachments = true;
                this.toggleAttachmentFilterIcon();
                pipe();
            },

             /* added by dvalaboju001 toggle the audi cells 05/2021*/
             toggleOverrideCellstRows: function(){
                base.tableState.auditCells = !base.tableState.auditCells;
                this.toggleOverrideCellstFilterIcon();
                pipe();
            },

            showOverrideCellRows: function(){
                base.tableState.auditCells = true;
               this.toggleOverrideCellstFilterIcon();
                pipe();
            },

             /* added by Divya toggle the attachments 9/22/2019*/
            hideCommentRows: function(){
                base.tableState.comments = false;
                this.toggleCommentFilterIcon();
                pipe();
            },

            hideAttachmentRows: function(){
                base.tableState.attachments = false;
                this.toggleAttachmentFilterIcon();
                pipe();
            },



            toggleCommentFilterIcon: function(){
                if(!base.tableState.comments){
                    base.$el.find('.gg-comment-filter i.fa-filter').show();
                    base.$el.find('.gg-comment-filter i.fa-times').hide();
                }else{
                    base.$el.find('.gg-comment-filter i.fa-filter').hide();
                    base.$el.find('.gg-comment-filter i.fa-times').show();
                }
            },

            toggleAttachmentFilterIcon: function(){
                if(!base.tableState.attachments){
                    base.$el.find('.gg-attachment-filter i.fa-filter').show();
                    base.$el.find('.gg-attachment-filter i.fa-times').hide();
                }else{
                    base.$el.find('.gg-attachment-filter i.fa-filter').hide();
                    base.$el.find('.gg-attachment-filter i.fa-times').show();
                }
            },

            toggleOverrideCellstFilterIcon: function(){
                if(!base.tableState.auditCells){
                    base.$el.find('.gg-override-filter i.fa-filter').show();
                    base.$el.find('.gg-override-filter i.fa-times').hide();
                }else{
                    base.$el.find('.gg-override-filter i.fa-filter').hide();
                    base.$el.find('.gg-override-filter i.fa-times').show();
                }
            },

            hideMessages: function(){
                base.data.messageObject = [];
                buildGrid();
            },

            hideAttachments: function(){
                base.data.attachmentObject = [];
                buildGrid();
            },

            setMessageLevel: function(_action){
                    options.data.settings.commentType = _action
                    base.api.callBack('callName',{type:_action},'reloadComment');
                    this.setMessageDisplay(_action);
                    if(_action === 'none'){
                        this.hideCommentRows();
                    }
            },


            setMessageDisplay: function(_action){
                var element = $('.gg-comment-display[action="'+_action+'"]');
                $(".gg-comment-display i" ).hide();
                element.find("i").show();
            },

            setAttachmentDisplay: function(_action){
                var element = $('.gg-attachment-display[action="'+_action+'"]');
                $(".gg-attachment-display i" ).hide();
                element.find("i").show();
            },

            setExportDisplay: function(_action){
                var element = $('.gg-export-action[action="'+_action+'"]');
                $(".gg-export-action i" ).hide();
                element.find("i").show();
            },

            /* setAttachmentLevel: function(_action){
                base.api.callBack('callName',{type:_action},'reloadAttachment');
                this.setAttachmentDisplay(_action);
                if(_action === 'none'){
                    this.hideCommentRows();
                }
            }, */

            showMyMessages: function(){

            },


            showAssignedMessages: function(){

            },


            showAllMessages: function(){
                base.data.messageObject = [];
                base.dataProvider.getData(this.messageURL,'POST',{comment_key:_comment_key}).then(function (_data){
                });
            },

            showAllAttachmets: function(){
                base.data.attachmentObject = [];
                base.dataProvider.getData(this.attachmentURL,'POST',{parent_key:_parentKey,parent_type:_parentKey}).then(function (_data){
                    console.log("_data of attachment",_data);
                });
            },

            goToComment: function(_data){


                console.log("//////////////////////////////////////////////////////////////////////////////////////////////");
                console.log("_data " , _data);
                console.log("//////////////////////////////////////////////////////////////////////////////////////////////");


                if( _.isEmpty(_data) ){
                    addAlert("alert-warn"," Opps! it appears the context is broken ",4000 );
                    return false;
                }

                if(_data.tableState && !_.isEmpty(_data.tableState) ){

                    //: START - stringify null hack :===========================================================================
                    // - this is a temp hack to change back tableState.colSearch with values of null to undefined.
                    // JSON.stringify() automatically does this because JSON doesn't have a concept of undefined

                    if(_data.tableState.colSearch){
                        _.forEach(_data.tableState.colSearch, function (value, key) {
                            if(value.type == "array" && value.value.length){
                                _.forEach(value.value, function (valueA, keyB) {
                                    console.log("value.value  : " , value.value)
                                    if( valueA === null){
                                        value.value[keyB] = undefined;
                                    }
                                })
                            }
                        });
                    }
                    //: END - stringify null hack :===========================================================================

                    base.tableState = _data.tableState;
                    pipe();
                }

                if(_data.type === "link"){
                    return true;
                }


                var vIndex = _.findIndex(base.data.dataArr, { object_id: _data.row_id });
                var hIndex = _.findIndex(base.data.headerArray, { map: _data.col_id }) ;

                if(  vIndex >= 0 && hIndex >= 0 ){
                    vIndex += - Math.round(base.layout.rowsPerPage / 2) + 2
                    hIndex += - ( base.options.fixedColumn + 3)

                    if( vIndex < 0){
                        vIndex = 0;
                    }

                    if( hIndex < 0){
                        hIndex = 0;
                    }
                    setHScroll(hIndex);
                    setVScroll(vIndex);

                    setSelected( _data.col_id,_data.row_id,'cell');

                    highlight(base.selected.element,'pink');

                    setTimeout(function(){
                        base.selected.element.addClass('gg-cell-blink');
                    }, 700);

                }else{
                    addAlert("alert-warn"," Opps! it appears the context is broken ",4000 );
                }
            },


            renderAddMessageTemplate: function(){
                this.toggleOpen();
                this.setPosition();
                this.position.$messageDetails.html("");
                //console.log(base.elements.messageItemContainer)

                this.context = {
                    tableState: _.cloneDeep(base.tableState),
                    selected: _.cloneDeep(base.selected)
                }

                var callName = 'addComment';
                base.api.callBack(callName,this.context,'comment' );
            },


            addAttachment: function(){
                this.toggleOpen();
                this.setPosition();
                this.position.$messageDetails.html("");

                this.data = {
                        colData:base.selected.colData,
                        rowData:base.selected.rowData,
                        tableState: _.cloneDeep(base.tableState),
                        selected: _.cloneDeep(base.selected),
                        attachmentValue: options.data.settings.attachments,
                        callName: 'addAttachment'
                }

                var callName = 'addAttachment';
                base.api.callBack(callName,this.data,'attachment' );
            },
	      editAttachments:function(parent_key,parent_type){
                var callName = 'editAttachment';
                base.api.callBack(callName,{parent_key:parent_key ,parent_type:parent_type},'attachment');
                this.destroyMessages();
            },

            previewAttachments:function(parent_key,file_name){
                var callName ='previewAttachment';
                base.api.callBack(callName,{parent_key:parent_key,file_name:file_name},'preview');
                this.destroyMessages();
            },

            auditCellsModal: function(){
                this.context = {
                    tableState: _.cloneDeep(base.tableState),
                    selected: _.cloneDeep(base.selected)
                }

                var callName = 'auditCells';
                base.api.callBack(callName, this.context,'auditcell' );
            },

            setPosition : function(){
                if (!base || !base.elements || !base.elements.messageItemContainer) return;
                this.position = {
                    "$container": base.elements.messageItemContainer,
                    "$messageList": base.elements.messageItemContainer.find('.gg-list-container'),
                    "$messageDetails": base.elements.messageItemContainer.find('.gg-detail-container'),
                    "$backdrop": base.elements.messageItemContainer.find('.gg-message-detail-backdrop'),
                    "positionX": null,
                    "positionY": null,
                    "cellWidth": null,
                    "obj_id": null,
                    "message_id":null,
                    "open":false,
                    "messageArr":[]
                }
                // Prevents the background scroll when message template is open.
                $(base.elements.messageItemContainer).bind("mousewheel", function() {
                    return false;
                });
            },

            loadMessage: function(_comment_key){
                this.position.comment_key = _comment_key;
                this.getMessageData(_comment_key);
            },


            getMessageData: function(_comment_key){
                var _this = this
                //console.log(_comment_key  )

                /* */
                base.dataProvider.getData(this.messageURL,'POST',{comment_key:_comment_key}).then(function (_data){
                    //console.log("_data " , _data);
                    if(_data.comment && _data.comment.comment_key && _data.comment.comment_key > 0){
                        _data.comment.userAccessLevel = base.userAccessLevel;
                        _data.comment.curUser = base.sso_id;
                        _this.renderMessage(_data.comment);
                    }else{
                        addAlert("alert-warn"," The selected comment could not be found ",4000 );
                    }

                })
            },

            loadAttachment: function(_parent_key,_parent_type){
                this.position.parent_key = _parent_key;
                this.position.parent_type = _parent_type
                this.getAttachmentData(_parent_key,_parent_type);
            },

            getAttachmentData: function(_parent_key,_parent_type){
                var _this = this;
                base.dataProvider.getData(this.attachmentURL,'POST',{parent_key:_parent_key,parent_type:_parent_type}).then(function (_data){
                     console.log("_data -----------" , _data);
                     //_data.attachment.userAccessLevel = base.userAccessLevel;
                    // _data.attachment.curUser = base.sso_id;
                     _this.renderAttachment(_data.comment.attachmentList);
                    //  if(_data.attachment && _data.attachment.parent_key && _data.attachment.parent_key > 0){

                    //  }else{
                    //      addAlert("alert-warn"," The selected attachment could not be found ",4000 );
                    //  }
                 })
            },


            toggleOpen: function(){
                this.position.open = !this.position.open;
            },

            renderMessage:function(_data){

                console.log("_data" , _data)

                var theTemplate = Handlebars.compile(detailMessageHBTemplate);
                var theCompiledHtml = theTemplate(_data);
                this.position.$messageDetails.html(theCompiledHtml);
                this.position.$messageList.css('left','-'+this.position.$container.width()+'px');
                this.position.$backdrop.show();
                this.position.$messageDetails.css('left','0px');
                this.positionMenu();
            },


          /*   renderMessages:function(_obj_id,_x,_y,_width,_height){
                this.setPosition();
                this.position.$messageDetails.html("");
                this.position.positionX = _x;
                this.position.positionY = _y;
                this.position.cellWidth = _width;
                this.position.obj_id = _obj_id;
                this.position.$messageDetails.html("");
                this.position.messageArr = base.data.messageObject[_obj_id],
                this.position.$container.css('display', 'block');
                this.position.$messageList.css('left', '0px');
                this.position.$messageDetails.css('left', this.position.$container.width() + 'px');
                var theTemplate = Handlebars.compile(listMessageHBTemplate);
                var theCompiledHtml = theTemplate(this.position.messageArr);
                this.position.$messageList.html(theCompiledHtml);
                this.positionMenu();
            }, */
            renderMessages:function(_obj_id,_x,_y,_width,_height){
                this.setPosition();
                this.position.$messageDetails.html("");
                this.position.positionX = _x;
                this.position.positionY = _y;
                this.position.cellWidth = _width;
                this.position.obj_id = _obj_id;
                this.position.$messageDetails.html("");
                this.position.messageArr = {};
                this.position.isAttachment=false;
                this.position.hasMessages=false;
                this.position.hasError=false;
                var theCompiledHtml = null;
                if(base.data.errorObject && base.data.errorObject[_obj_id] && !this.position.hasError){
                    // if(this.position.hasError){
                   // this.position.$errorContainer.css('display', 'block');
                    this.position.hasError = true;
                    this.position["$container"]= base.elements.errorcontainer;
                    theCompiledHtml = base.data.errorObject[_obj_id];
                    this.position.$backdrop= base.elements.errorcontainer.find('.gg-message-detail-backdrop');
                    this.position.$messageList= base.elements.errorcontainer.find('.gg-list-container');
                    this.position.$messageList.html(theCompiledHtml);
                }
                if(base.data.messageObject[_obj_id]){
                    this.position.messageArr = base.data.messageObject[_obj_id];
                    this.position.hasMessages=true;
                }
                if(base.data && base.data.attachmentObject && base.data.attachmentObject[_obj_id]){
                    this.position.messageArr = _.extend({}, this.position.messageArr, base.data.attachmentObject[_obj_id]);
                    this.position.isAttachment=true;
                }

                this.position.$container.css('display', 'block');
                this.position.$messageList.css('left', '0px');
                this.position.$backdrop.hide();
                this.position.$messageDetails.css('left', this.position.$container.width() + 'px');

                if(this.position.hasMessages){
                    var theTemplate = Handlebars.compile(listMessageHBTemplate);
                    theCompiledHtml = theTemplate(this.position.messageArr);
                    this.position.$messageList.html(theCompiledHtml);
                }
                if(this.position.isAttachment){
                    var theTemplate = Handlebars.compile(listAttachmentHBTemplate);
                    theCompiledHtml = theTemplate(this.position.messageArr);
                    this.position.$messageList.append(theCompiledHtml);
                }
                if(theCompiledHtml){
                    this.positionMenu();
                }
            },



            back:function(){
                var theTemplate = Handlebars.compile(listMessageHBTemplate);
                var theCompiledHtml = theTemplate(this.position.messageArr);
                this.position.$messageList.html(theCompiledHtml);
                this.positionMenu();
                this.position.$messageList.css('left', '0px');
                this.position.$backdrop.hide();
                this.position.$messageDetails.css('left', this.position.$container.width() + 'px');
            },


            hoverShow:function(_obj_id,_x,_y,_width,_height){
                if(!this.position.open) {
                    this.renderMessages(_obj_id, _x, _y, _width, _height);
                }
            },

            hoverHide:function(_obj_id,_x,_y,_width,_height){
                if(!this.position.open) {
                    this.destroyMessages();
                }
            },


            destroyMessages:function(){
                if (!base || !base.elements) return;
                this.setPosition();
                if (!this.position) return;
                this.position.$container.css('display', 'none');
                $('.gg-error-container').css('display', 'none');
         //       this.position.$errorContainer.css('dispaly','none');
                this.position.$messageList.html("");
                this.position.$messageDetails.html("");
            },


            editMessage:function(comment_key){
               //console.log("comment_key open modal:" , comment_key);
                var callName = 'editComment';
                base.api.callBack(callName,{comment_key:comment_key},'comment');
                this.destroyMessages();
            },

            resolve:function(comment_key,task_status,task_action_item){
               console.log("Resolve just send to DB:" , comment_key);
                var dataObj = {"comment_key": comment_key,"task_status":task_status,"task_action_item":task_action_item}
                base.dataProvider.getData(this.reolveURL,'post',dataObj).then(function (_data){
                    if( _data.callSuccess != 1  ){
                        addAlert("alert-error"," Comment could not be resolved",4000 );
                    }else{
                        var action = (options.data.settings.commentType) ? options.data.settings.commentType : 'all';
                        base.api.callBack('callName',{type:action},'reloadComment');
                        addAlert("alert-success","Comment was successfully resolved ",4000 );
                    }
                })

                this.destroyMessages();
            },


            deleteMessage:function(comment_key){
                //////////console.log("deleteMessage");
            },


            editReply:function(_comment_key,_message){

              // console.log("_comment_key  " , _comment_key);
              // console.log("_message  " , _message);

                var MS = this;
                if(_message == '' ){
                    addAlert("alert-warn"," Please add a reply message ",4000 );
                    return;
                }

                var comment_key =  this.position.comment_key
                var dataObj = {"comment_key":_comment_key,"message":_message,'type':'update'}
                base.dataProvider.getData(this.replyURL,'post',dataObj).then(function (_data){
                    if( _data.callSuccess != 1  ){
                        addAlert("alert-error"," Reply message was not saved ",4000 );
                    }else{
                        addAlert("alert-success","Reply message was successfully saved ",4000 );
                        MS.loadMessage(comment_key)
                    }
                })


            },

            deleteReply:function(_comment_key){
                var MS = this;
                var comment_key =  this.position.comment_key
                var dataObj = {"comment_key": _comment_key,'type':'delete'}
                base.dataProvider.getData(this.replyURL,'post',dataObj).then(function (_data){
                    if( _data.callSuccess != 1  ){
                        addAlert("alert-error"," Reply message could not be deleted",4000 );
                    }else{
                        addAlert("alert-success","Reply message was successfully deleted ",4000 );
                        MS.loadMessage(comment_key)
                    }
                })
            },


            addReply:function(_replyMessage){
                var MS = this;
                if(_replyMessage == '' ){
                    addAlert("alert-warn"," Please add a reply message ",4000 );
                    return;
                }
                var comment_key =  this.position.comment_key
                var dataObj = {"comment_key": comment_key, "message":_replyMessage, 'type':'add' }
                base.dataProvider.getData(this.replyURL,'post',dataObj).then(function (_data){
                    if( _data.callSuccess != 1  ){
                        addAlert("alert-error"," Reply message was not saved ",4000 );
                    }else{
                        addAlert("alert-success","Reply message was successfully saved ",4000 );
                        MS.loadMessage(comment_key)
                    }
                })

            },
            deleteAttachmentByname:function(_file_name,_parent_key,_parent_type) {
                var Att = this;
                var dataObj= {"file_name":_file_name,"parent_key":_parent_key,"parent_type":_parent_type}
               console.log("+++delte json +++++",_file_name,_parent_key,_parent_type);
               base.dataProvider.getData(this.removeDocURL,'post',dataObj).then(function(_data){
                    if(_data.success !=1){
                        addAlert("alert-error","Document could not be deleted",4000);
                    }else{
                        addAlert("alert-success","Document was successfully deleted",4000);
                        base.api.callBack('callName',{},'reloadAttachment');
                        Att.loadAttachment(_parent_key,_parent_type)
                    }
                })

            },
            downLoadAttachment:function(file_name,parent_key){
                var secondaryWindow = window.open(this.downloadAttachURL + '?fileName=' +file_name+"&commentKey="+parent_key+"&client_key="+sessionStorage.getItem('client_key'));
                if (secondaryWindow == null) {
                    return;
                }
                // Check if there was a problem downloading the attachment.
                secondaryWindow.onload = function () {
                    if (secondaryWindow.document.body.innerHTML.length > 0) {
                            $scope.$broadcast('gtw.admin.client.downloadLogo.failed');
                            secondaryWindow.close();
                    }
                };

            },
            downloadAllDoc:function(id){

                console.log("rowdIDDDFD"+id);
                var secondaryWindow = window.open(base.base_url+'/downloadAllDocuments' + '?commentKey='+id+"&client_key="+sessionStorage.getItem('client_key'));
                
                if (secondaryWindow == null) {
                    return;
                }
                // Check if there was a problem downloading the attachment.
                secondaryWindow.onload = function () {
                    if (secondaryWindow.document.body.innerHTML.length > 0) {
                            $scope.$broadcast('gtw.admin.client.downloadLogo.failed');
                            secondaryWindow.close();
                    }
                };
            },

            downloadDoc:function(fileName){
                var secondaryWindow = window.open(base.base_url+'/download'+'?'+'file_name=' + fileName + "&client_key=" + sessionStorage.getItem('client_key'));
                if (secondaryWindow == null) {
                    return;
                }
                // Check if there was a problem downloading the attachment.
                secondaryWindow.onload = function () {
                    if (secondaryWindow.document.body.innerHTML.length > 0) {
                            $scope.$broadcast('gtw.admin.client.downloadLogo.failed');
                            secondaryWindow.close();
                    }
                };
            },



            positionMenu: function (){

                var positionX  = this.position.positionX + this.position.cellWidth,
                    positionY  = this.position.positionY;

                //POSITION LEFT OF CELL IF CONTAINER GOES OUTSIDE THE GRID
                if( positionX + this.position.$container.width() > windowWidth){
                    positionX  = this.position.positionX - this.position.$container.width();
                }


                var $messageDetailsScroll = base.elements.messageItemContainer.find('.gg-message-scroll'),
                    $messageDetailsTop= base.elements.messageItemContainer.find('.gg-message-top'),
                    $messageDetailsForm = base.elements.messageItemContainer.find('.gg-reply-form'),
                    $messagesScroll = base.elements.messageItemContainer.find('.gg-messages-scroll');


                //SET OUTER CONTAINER HEIGHT
                if( this.position.$messageDetails.height() >  this.position.$messageList.height() ){
                    if(this.position.$messageDetails.height() > base.elements.body.height() ){
                        var  innerHeight = base.elements.body.height() - ( $messageDetailsTop.height()  + $messageDetailsForm.height() )
                        $messageDetailsScroll.height(innerHeight);
                    }
                    this.position.$container.height(this.position.$messageDetails.height());
                }else{
                    if(this.position.$messageList.height() > base.elements.body.height() ){
                        var  innerHeight = base.elements.body.height();
                        $messagesScroll.height(innerHeight);
                    }
                    this.position.$container.height(this.position.$messageList.height());
                }


                if( positionY +  this.position.$container.height() >  windowHeight){
                    var overFlow = (positionY +  this.position.$container.height()) - windowHeight;
                    positionY-=overFlow;
                }


                this.position.$container.css('top',positionY+'px');
                this.position.$container.css('left',positionX+'px');

            }



        }

        /*****************************dvalaboju001 export execl moved to dropdown  11/14/2019******************************************* */

        base.exportToExcel = {
            exportExcel : function(_url, isFilteredGrid){
            ggDom.element('.tools-export').addClass('gg-export-to-excel');
            ggDom.element('.tools-export').append('<i class="fa fa-spinner fa-spin"></i>');
            window.is_export = true;
            var action_id = ggDom.element('#action_id')[0].innerHTML;
            var grid_id = ggDom.element('#grid_id')[0].innerHTML;
            var screen_key = ggDom.element('#screen_key')[0].innerHTML;
            var sso_id = ggDom.element('#sso_id')[0].innerHTML;
            var all_filter_data = (ggDom.element('#all_filter_data')[0].innerHTML).replace(/&amp;/g, '&');
            var display_filter_data = (ggDom.element('#display_filter_data')[0].innerHTML).replace(/&amp;/g, '&');
            var display_all_me_code = (ggDom.element('#display_all_me_code')[0].innerHTML).replace(/&amp;/g, '&');
            var display_scenario = (ggDom.element('#display_scenario')[0].innerHTML).replace(/&amp;/g, '&');
            var display_filingGrp = (ggDom.element('#display_filingGrp')[0].innerHTML).replace(/&amp;/g, '&');

            var filterArrayAll = all_filter_data.split('&');
            var filterArrayDisplay = display_filter_data.split('&');
            var _params = {};
            var gridData = []
            /*dvalaboju001 2/1/2020*/
            var screen_name = ggDom.element('#screen_name')[0].innerHTML;
            var client_name = ggDom.element("#client_name")[0].innerHTML;
            var screenObj = ggDom.element('#screenObj')[0].innerHTML;
            console.log("screen_name",screen_name);
            console.log("client_name",client_name);
            console.log("screenObj",screenObj);
            console.log("filterArrayDisplay",filterArrayDisplay);
            var colFilters = [];
            const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const fd = new FormData();
            const api_base_url = base.base_url;

            //Export to excel API call
            var exportApiCall = function(export_post_data){
                _params = _.extend({
                    jsonObj: jsonObj,
                    headerArray : JSON.stringify(headArra),
                    gridSettings : (base.data.settings)
                }, _params);

                if(export_post_data){
                    fd.append("jsonObj", jsonObj);
                    fd.append("headerArray", JSON.stringify(headArra));
                    fd.append("gridSettings", (base.data.settings));
                }

                var promise= $.ajax({
                    method: 'post',
                    url: base.base_url+_url,
                    data: export_post_data ? fd : _params,
                    processData: export_post_data ? false : undefined,
                    contentType: export_post_data ? false : undefined,
                    cache: export_post_data ? false : undefined,
                    enctype: export_post_data ? 'multipart/form-data' : 'application/json'
                })
                .done(function( data ) {
                    if( data.callSuccess != 1 ){
                        ggDom.element('.tools-export').removeClass('gg-export-to-excel');
                        ggDom.element('.tools-export').find('i').remove();
                        window.is_export = false;
                        addAlert("alert-error"," Data can not be exported, please contact System administrator", 6000);
                    }else{
                        
                        //window.open(downloadURL,'blank');
                        let apiTokenUrl = api_base_url + '/getAPIAuthToken';
                        base.dataProvider.getData(apiTokenUrl,'GET',{}).then(function (_data){
                            console.log("_data of apiTokenUrl apiTokenUrl",_data);
                            let downloadURL = api_base_url + '/download' + '?' + 'file_name=' + data.file_name + "&client_key=" + sessionStorage.getItem('client_key') +
                                '&apiToken=' + encodeURIComponent(_data.apiToken)+'&georaclehrid=' +sso_id ;
                            window.open(downloadURL,'blank');
                        });
                        // fetch(downloadURL, {
                            // method: 'GET',
                            // headers: {
                                // 'Authorization': sessionStorage.getItem('Authorization')//`Bearer`
                            // }
                        // })
                        // .then(response => response.blob())
                        // .then(blob => {
                            // const blobUrl = URL.createObjectURL(blob);
                            // const link = document.createElement('a');
                            // link.href = blobUrl;
                            // link.download = data.file_name;//'filename.ext';  // provide the file name here
                            // link.style.display = 'none';
                            // document.body.appendChild(link);
                            // link.click();
                            // document.body.removeChild(link);
                        // })
                        
                        ggDom.element('.tools-export').removeClass('gg-export-to-excel');
                        ggDom.element('.tools-export').find('i').remove();
                        window.is_export = false;
                    }
                });
            }

            const convertBytes = function(bytes) {
                const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
                if (bytes == 0) {
                    return "n/a";
                }
                const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                if (i == 0) {
                    return bytes + " " + sizes[i];
                }
                return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
            }

            const replacer = (key, value) => typeof value === 'undefined' ? null : value;

            //Added by Vijay to included the filtered column details
            if(isFilteredGrid){
                if(base.tableState && base.tableState.colSearch.length){//Check null, undefined and predicate
                    for(var i = 0; i < base.tableState.colSearch.length; i++){
                        filterArrayDisplay[filterArrayDisplay.length] = "colFilter_"+base.tableState.colSearch[i].predicate+"="+base.tableState.colSearch[i].value.toString();
                        let key =base.tableState.colSearch[i].predicate;
                        let value  = base.tableState.colSearch[i].value.toString();
                        let obj ={};
                        obj[key] = value;
                        colFilters.push(obj);
                        //gridData = JSON.stringify(base.data.dataArr);
                    }
                }
            }else{
                //gridData = JSON.stringify(base.data.safeCopyArr);
            }

            if(display_all_me_code){
            	filterArrayDisplay[filterArrayDisplay.length] = "display_mE_code="+display_all_me_code;
            }
            if(display_scenario){
            	filterArrayDisplay[filterArrayDisplay.length] = "display_scenario_description="+display_scenario;
            }
            if(display_filingGrp){
            	filterArrayDisplay[filterArrayDisplay.length] = "display_filing_group_description="+display_filingGrp;
            }

            //---------------------------------------------------------
            var jsonData = {};
            for(var i = 0; i < filterArrayAll.length; i++){
                var filterItem = filterArrayAll[i];
                if(filterItem && filterItem.indexOf('=') > -1){
                    var filterParts = filterItem.split('=');
                    var filterKey = filterParts[0];
                    var filterValue = filterParts.length > 1 ? filterParts[1] : '';
                    // Skip undefined, null, empty, or 'undefined' string values
                    if(filterValue && filterValue !== '' && filterValue !== 'undefined' && filterValue !== 'null'){
                        jsonData[filterKey] = filterValue;
                    }
                }
            }
            for(var i = 0; i < filterArrayDisplay.length; i++){
                var filterItem = filterArrayDisplay[i];
                if(filterItem && filterItem.indexOf('=') > -1){
                    var filterParts = filterItem.split('=');
                    var filterKey = filterParts[0];
                    var filterValue = filterParts.length > 1 ? filterParts[1] : '';
                    // Skip undefined, null, empty, or 'undefined' string values
                    if(filterValue && filterValue !== '' && filterValue !== 'undefined' && filterValue !== 'null'){
                        jsonData[filterKey] = filterValue;
                    }
                }
            }
            /* 2/3/2020 */
          //  var merDisplayArray = _.concat({}, base.data.fixedHeaderArrayDisplay, base.data.headerArrayDisplay);
          var merDisplayArray = _.concat({}, base.data.fixedHeaderArrayDisplay,base.data.fixedHeaderSafeCopyArr);
            var headerDisplArr= [];
            var displayGridData = [];
            _.each(merDisplayArray,function(item){
                if(item.label != null){
                    headerDisplArr.push({
                        object_id : item.object_id,
                        label:item.label,
                        data_type : item.data_type,
                        format : item.format,
                        map : item.map,
                        width : item.width
                    })
                }
            })
           // displayGridData = gridData;

            /* ends here  */
            var _params = {};
            var jsonObj = JSON.stringify(jsonData);
            var headArra = [];
            var filteredMap = [];
            var filteredData = [];
            var tempArr = [];
            var gridObject = {header:[], data:[]};
            var is_import_screen = !action_id && (jsonData.screen_type === "grid-import" || jsonData.screen_type === "grid-import-pivot" || jsonData.screen_type === "grid-import-td");
            
            // Fix for exporting the data in dual screen load implementation.
            if(jsonData.screen_key === '11169' || jsonData.screen_key === '11471'){
                is_import_screen = true;
            }

            /* dvalaboju001 11/15/2019   to pass required grid headers from the UI */
            _.each(base.data.headerArray,function(item){
                headArra.push({
                    object_id : item.object_id,
                    label:item.label,
                    data_type : item.data_type,
                    format : item.format,
                    map : item.map,
                    width : item.width
                });
                filteredMap.push(item.map);
            })
            gridObject.header.push(filteredMap);
            _url = _url + '?' + 'action_id=' + action_id + '&' + 'grid_id=' + grid_id + '&' + 'sso_id=' + sso_id + '&screen_key=' + screen_key /*+ all_filter_data + display_filter_data*/;

            if(isFilteredGrid || is_import_screen){
                addAlert("alert-info","Please wait until the file downloads", 6000);
                //if((JSON.stringify(base.data.dataArr).length > 25000000) && !is_import_screen){
                if(base.data.dataArr.length > 50000 && !is_import_screen){
                    //console.log('Filtered Data Size : '+ convertBytes(JSON.stringify(base.data.dataArr).length));
                    console.log('File Sent : NO, Data Compression : NO');
                    _url = _url + '&is_compressed=' + 'false' + '&filtered_export=' + 'false'
                    exportApiCall(false);
                }else{
                    //console.log('Filtered Data Size: '+ convertBytes(JSON.stringify(base.data.dataArr).length));
                    console.log('File Sent : YES, Data Compression : YES');
                    _.each(isFilteredGrid ? base.data.dataArr : base.data.safeCopyArr, function(obj){
                        tempArr = [];
                        _.each(filteredMap, function(map){
                            tempArr.push(obj[map]);
                        })
                        filteredData.push(tempArr);
                    })
                    gridObject.data = filteredData;
                    var compressedData = JSON.stringify(gridObject, replacer);
                    console.log('Compressed Data Size : '+ convertBytes(compressedData.length));
                    var blob = new Blob( [ compressedData ], {
                        type: EXCEL_TYPE
                    });

                    fd.append("file", blob);

                    _url = _url + '&is_compressed=' + 'true' + '&filtered_export=' + 'true'
                    exportApiCall(true);
                }
            }else{
                addAlert("alert-info","Please wait until the file downloads",6000);
                exportApiCall(false);
            }
            //-----------------------------------------------------

            /**
             * This is using webworker and exceljs.min.js and file saver. START
             */

            /*const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            //if (base.data.dataArr.length <=1000 && window.Worker) {
            if (!window.Worker) {
                var tableData = JSON.parse(gridData);
                screenObj = JSON.parse(screenObj);
                screenObj['export_date'] = moment().format('MM/DD/YYYY LT');
                var strFilename = screenObj['report_name'].replace(/[^a-zA-Z0-9]/g,'-') + "-" +moment().format('YYYY-MM-DD-hh-mm')+".xlsx";

                var myWorker = new Worker('./lib/webworker/exportToExcel.js');
                if(isFilteredGrid){
                    screenObj.filters = Object.assign({},screenObj['filters'],...colFilters);
                }
                myWorker.postMessage({tableData,screenObj,headerDisplArr});
                myWorker.onmessage = function(e) {
                    console.log('messgae recived');
                    if(e.data.error){
                        addAlert("alert-error"," Data can not be exported, please contact System administrator",4000 );
                    }
                    const blob = new Blob([e.data],{type: EXCEL_TYPE});
                    try {
                        saveAs(blob, strFilename);
                        myWorker.terminate();
                    }catch(error){
                        addAlert("alert-error"," Data can not be exported, please contact System administrator",4000 );
                    }

                }
            } else {
                console.log('Your browser doesn\'t support web workers.');*/

            }
        }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////// menuService //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        base.menuService = {

            buildBatchActionsMenu: function() {

                base.batchActions = (options.data.settings && options.data.settings.grid_action ) ? options.data.settings.grid_action : [];
                if(base.batchActions.length === 0 ){
                    base.$el.find('#batch-actions').hide();
                    return false;
                }else{
                    base.$el.find('#batch-actions').show();
                }

                var menuContainerElement = base.$el.find('#gg-modal-actions');
                var menuString = "";

                menuContainerElement.html(menuString);

                _.forEach(base.batchActions, function(value, key) {
                    var icon = (value.icon && value.icon != "" ) ? value.icon : "fa fa-dot-circle-o ";
                    var listElement = '<li class="tools-action" action="batch-action" value="'+key+'"><i class="'+icon+'"></i>'+sanitize(value.name)+'</li>'
                    menuContainerElement.append(listElement);
                })

            }


        }



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////// ModalService //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        base.ModalService = {

            openModalService: function(_title,_map,_action,_template){

               //console.log("_title : " , _title);
               //console.log("_map : " , _map);
               //console.log("_action : " , _action);
               //console.log("base.data.headerArray : " , base.data.headerArray);

                base.elements.modalContainer.show();
                this.setActions(_action,_map);
                var headerObj = _.find(base.data.headerArray,{ 'map': _map });


                var title =  base.elements.modalContainer.find('.gg-title');
                base.elements.modalContainer.attr('map',headerObj.map);
                title.html(_title);
                base.elements.modalContainer.find('.gg-modal-ggBody').css('display','block');
                base.elements.modalContainer.find('.gg-modal-ggBody').html(_template);
                this.positionModal();
            },


            setActions: function(_action,_map){
               //console.log(   base.elements.modalContainer.find('.gg-modal-footer') );
                if(_action == "formatCol"){
                    var footer = '<div action="formatCol" map="'+_map+'" class="gg-modal-action btn btn-xs btn-info">Ok</div><div action="close" style="margin-left:5px" class="gg-modal-action btn btn-xs btn-danger">Cancel</div>';
                    base.elements.modalContainer.find('.gg-modal-footer').html(footer);
                }
            },


            positionModal: function() {
                var left = (base.elements.body.width() / 2 - base.elements.modalContainer.width() / 2) ;
                var top = (base.$el.height() / 2) - base.elements.modalContainer.height() / 2;
                base.elements.modalContainer.css('left',left)
                base.elements.modalContainer.css('top',top)
            },


            dragModal : function(_top,_left) {
                base.elements.modalContainer.css('left',_left  + 'px');
                base.elements.modalContainer.css('top',_top  + 'px');
            },


            closeModalService: function(_map,_action){
                base.elements.modalContainer.hide();
                base.elements.modalContainer.find('.gg-modal-ggBody').html("");
                base.focus.gridBody.focus();
            }


        }



//TODO REMOVE ALL MODAL FUNCTIONS: WE WILL USE MODALSERVICE FOR THIS. THIS WILL JUST CONTAIN TO TEXT AND NUMBER FILTERS
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////// FilterModalService //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        base.FilterModalService = {

            openFilterModalService: function(_map,_action){
                base.elements.FilterModalService.show();
                var headerObj = _.find(base.data.headerArray,{ 'map': _map });
                var title = base.elements.FilterModalService.find('.gg-title');
                base.elements.FilterModalService.attr('map',headerObj.map);
                title.html("Show Results Where : <span class='gg-orange'>" + headerObj.label +"</span>");
                this.buildMenu(headerObj,_action);
                this.positionModal();
            },

            filter: function(_map,_action){
                var input = base.elements.FilterModalService.find('.gg-modal-input').val();
                var select = base.elements.FilterModalService.find('.gg-modal-select').val();
                var headerObj = _.find(base.data.headerArray,{ 'map': _map });

                if( select != 'blank' &&  select != '!blank'  ){
                    if( !this.validate(select,input,headerObj.data_type)){
                        return false;
                    }
                }

                colSearchText(_map,input,select,headerObj.data_type);
                this.closeFilterModalService(_map,'close');
            },


            validate: function(_select,_data,_type){
                if( _data.length === 0  && ( _select !==  'blank' &&  _select !==  '!blank'   )){
                    addAlert("alert-danger","<b>Error:</b> please enter search value ");
                    return false;
                }

                if( _type === 'number' && !IsNumeric(_data) ){
                    addAlert("alert-danger","<b>Error:</b> please enter a numeric value ");
                    return false;
                }
                return true;
            },

            positionModal: function() {
                var left = (base.elements.body.width() / 2) ;
                var top = (base.$el.height() / 2) - base.elements.FilterModalService.height() / 2;
                base.elements.FilterModalService.css('left',left)
                base.elements.FilterModalService.css('top',top)
            },


            dragModal : function(_top,_left) {
                base.elements.FilterModalService.css('left',_left  + 'px');
                base.elements.FilterModalService.css('top',_top  + 'px');
            },


            closeFilterModalService: function(_map,_action){
                base.elements.FilterModalService.hide();
                base.focus.gridBody.focus();
            },


            buildMenu: function(_headerObj,_action){
                if( _headerObj.data_type === 'string' ){
                    base.elements.FilterModalService.find('#gg-modal-select').html(modalFilterString);
                }else if( _headerObj.data_type === 'number' ){
                    base.elements.FilterModalService.find('#gg-modal-select').html(modalFilterNumber);
                }else if( _headerObj.data_type === 'date' ){
                    base.elements.FilterModalService.find('#gg-modal-select').html(modalFilterDate);
                }

                var select = base.elements.FilterModalService.find('.gg-modal-select');
                select.val(_action);
                base.elements.FilterModalService.find('.gg-modal-input').val("");

            }
        }




        base.gridActions = {

            launchGridActionModal: function(){

                var templateArr = base.data.headerArraySafe.map(function(header) {
                    return { // return what new object will look like
                        width:  header.width,
                        display: header.display,
                        map:header.map
                    };
                });


                var data = {};
                data.templateArr = templateArr;
                data.tableState =  base.tableState;
                data.cellData=base.cellData;

                /* save the grid Action tempalte fixed columns & header height 6/13/2019*/

                if( base.actionsService &&  base.actionsService.selectedTemplate){
                    base.actionsService.selectedTemplate.fixed_columns = base.data.fixedHeaderArrayDisplay.length;
                    base.actionsService.selectedTemplate.header_height = base.headerRow.height;
                }
                /* ends here */

                base.api.callBack("gridActionModal",data,"openGridModal");

            },

            renderDropDown: function(){


            },


            displayCreateAction: function(){


            }

        }
        base.pivotActions = {

            launchPivotActionModal: function(){

                var templateArr = base.data.headerArraySafe.map(function(header) {
                    return { // return what new object will look like
                        width:  header.width,
                        display: header.display,
                        map:header.map
                    };
                });


                var data = {};
                data.templateArr = templateArr;
                data.tableState =  base.tableState;
                data.cellData=base.cellData;

                /* save the grid Action tempalte fixed columns & header height 6/13/2019*/

                if( base.actionsService &&  base.actionsService.selectedTemplate){
                    base.actionsService.selectedTemplate.fixed_columns = base.data.fixedHeaderArrayDisplay.length;
                    base.actionsService.selectedTemplate.header_height = base.headerRow.height;
                }
                /* ends here */

                base.api.callBack("gridPivotActionModal",data,"openGridModal");

            },

            renderDropDown: function(){


            },


            displayCreateAction: function(){


            }

        }


        base.api = {

            loadData: function(data){
                options.data = data.data;

                //To clear the delete count display block
                base.deleteCount = 0;
                base.elements.footerDelete.html("")
                base.elements.footerDelete.removeClass('gg-delete-count')

                base.loadGrid();
                },

                showLoader: function(fromModal){
                    base.api.dataRefresh(false);
                    if(fromModal!=undefined && fromModal){ /* only for grid on Modal */
                        base.$el.find(hiddenTextAreaTemplate).css('display','none');
                    }
                    base.loader.showLoader();
                },
            /* 5/12/2020  is called when the first time grid loads*/
            clearSlectedActionTemplateFirst: function () {
                base.actionsService.clearSelectedTemplate();

            },
            /* 5/13/2020 is called when we have any tablestate change from the databuoy */
            clearSelectedTemplateFromData : function(){
                base.actionsService.clearActionTemplate();
            },




            goToActionTemplate: function(_action_template_key) {
                base.actionsService.applyActionTemplate(_action_template_key);
            },


            goToComment: function(_data){
                base.messageService.goToComment(_data);
            },



            hideLoader: function(fromModal){
                base.api.dataRefresh(false);
                if(fromModal!=undefined && fromModal){
                    delete base.focus.hiddenTA;
                    delete base.elements.hiddenTA;
                }
                base.loader.hideLoader();
            },

            removeNewRow: function(_object){


                console.log("WAS THIS TRIGGERED " , _object);

                var indexD = _.findIndex(base.data.newRow, _object);
                if (indexD > -1) {
                    base.data.newRow.splice(indexD, 1)
                }
            },

            gridRefreshPipe: function(data){

                base.data.dataArr =  options.data.dataArr;
                base.data.safeCopyArr =  base.data.dataArr;


                base.actionsService.buildMenu();
                pipe();
            },

            gridRefresh: function(data){
                buildGrid();
            },

            // Will get called from gridDirective - used for header modal..
            adjustModal: function(data) {
                base.headerService.modalResize(data);
            },


            loadActonTemplates: function(templates){

                base.actionTemplates = templates;
                base.actionsService.buildMenu();

            },


            loadComments: function(comments,type){
                if(base && base.data && options.data){
                    base.messageService.setMessageDisplay(type);
                    base.data.messageObject = comments;
                    buildGrid();
                    if(base.tableState.comments && !_.isEmpty(comments)){
                        base.messageService.showCommentRows()
                    }
                }
            },
            /* load attachments added by Divya 9/22/2019 */

            loadAttachments: function(attachments){
                if(base && base.data && options.data){
                    base.messageService.setAttachmentDisplay();
                    base.data.attachmentObject = attachments;
                    buildGrid();
                    if(base.tableState.attachments && !_.isEmpty(attachments)){
                        base.messageService.showAttachmentRows()
                    }
                }
            },

            /* load audit cells 5/31/2021 */
            loadAuditCells:function(auditcellObj,type){
                if(base && base.data ){
                    base.data.auditCellsObject = auditcellObj;
                    if(!_.isEmpty(auditcellObj)){
                        base.$el.find('.gg-override-filter').css('display','');
                    } else {
                        base.$el.find('.gg-override-filter').css('display','none');
                    }
                    buildGrid();
                    if(base.tableState.auditCells && !_.isEmpty(auditcellObj)){
                        base.messageService.showOverrideCellRows()
                    }
                }
            },


            hideOverLay: function() {
                base.elements.fliterOverlay.css('display', 'none');
            },

            dataRefresh: function(show) {
                if(show){
                    base.elements.refreshIcon.css('display', 'block');
                }else{
                    base.elements.refreshIcon.css('display', 'none');
                }

                base.elements.refreshIcon.css('left', (base.$el.width() + base.$el.offset().left) / 2 + 'px');
                base.elements.refreshIcon.css('top', (base.$el.height() + base.$el.offset().top) / 2 + 'px');
            },



            callBack: function(callName,data,type){
                (typeof options.callBack === 'function') && options.callBack.call( this, {callName:callName,data:data,type:type} );
            },



            batchAction: function(_index){


                var action = base.batchActions[_index] || {};
                var dataRequired =  action.row_data_required;
                var callback = action.call_back || "";
                var actionName = String(action.name || "").toLowerCase();
                var loadedRows = (options.data && options.data.dataArr) ? options.data.dataArr.length : 0;
                // "Add schdm Template Id" creates a row; it does not edit one.
                // An empty grid cannot satisfy row_data_required, so open the modal.
                var allowWithoutRows = loadedRows < 1 && (
                    String(callback).toLowerCase() === "addschdmtemplateid" ||
                    actionName.indexOf("add schdm template") !== -1
                );

                var returnObj =  _.find(base.batchSelect, { 'row_id': base.selected.row_id});

                if( dataRequired == 1 && !allowWithoutRows && typeof returnObj == "undefined" ){
                    base.batch.selectRow();
                }

                var data = [];

                if( dataRequired == 1 && !allowWithoutRows && (!base.batchSelect || base.batchSelect.length <= 0) ){
                    addAlert("alert-warn","Please select one or more rows ",4000 );
                    return false;
                }

                //We will add any batch action of the batch-save type grid here
                if(callback === "batchSaveDelete" || callback === "batchSaveUnDelete" ) {
                    this.callBack(callback, base.batchSelect,"batchSave");
                    base.batch.unselectAll();
                }else{
                    this.callBack(callback, allowWithoutRows ? [] : base.batchSelect,"form");
                }


            },


            getExportData: function() {
                return {
                    dataArr: base.data.dataArr,
                    safeCopyArr: base.data.safeCopyArr,
                    headerArray: base.data.headerArray,
                    settings: base.data.settings
                };
            },

            getTableState: function() {
                return base.tableState;
            },

            //////////////////////////////////////////////// base.api ///////////////////////////////////////////////////////////






            deleteRows: function(deleteArray){


                if(deleteArray.length) {
                    ////////console.log("=============WE ARE IN THE DELETE")
                    for (var i = 0; i < deleteArray.length; i++) {

                        //console.log("options.data.dataArr " , options.data.dataArr);
                        //console.log("deleteArray[i] " , deleteArray[i]);

                        var indexD = _.findIndex(options.data.dataArr, deleteArray[i]);



                        //console.log("indexD " , indexD);
                        //console.log("options.data.dataArr " , options.data.dataArr);



                        if (indexD > -1) {
                            //console.log("WE DELETED :" ,  options.data.dataArr[indexD]);
                            options.data.dataArr.splice(indexD, 1)
                        }
                    }


                    base.data.dataArr =  options.data.dataArr;
                    base.batch.setSelectedFromBatch();
                    base.data.safeCopyArr =  _.clone( base.data.dataArr);

                    pipe();
                    buildGrid();
                }

            },



            updateData: function(_update) {
                ////////console.log("_update" , _update);


                var data =   _update.data,
                    filter = _update.filter,
                    prvIndex = 0,
                    itemsToCheck = [];
                    base.data.errorObject = _update.errorObject; // error

                 /* after grid refresh -need to apply the batch select rules again-- added on 01/04/2019 */
                if(options.data.settings.batch_select == 1){
                    base.buildDom.batchRowSelectable(data)
                }

                if(typeof filter !== 'undefined' &&  filter !== null ){
                    ////////console.log(" WE NEED TO CHECK: " , filter)
                        ////////console.log(" WE NEED TO CHECK: " , filter)
                        if(_.isArray(filter)){
                             _.filter(options.data.dataArr,function(item){
                                _.each(filter,function(value){
                                    var objeKey = Object.keys(value);
                                    if(item[objeKey] == value[objeKey]){
                                        itemsToCheck.push(item);
                                    }
                                })
                            })
                        }
                        else if(_.isObject(filter)){
                            itemsToCheck =  _.filter(options.data.dataArr, filter);
                        }
                        
                        ////////console.log(" itemsToCheck: " , itemsToCheck)
                    }
                    /* else{
                        itemsToCheck = _update.data;
                    } */

                var diffrence = _.differenceBy(itemsToCheck, data, 'object_id');
                //var diffrenceAdd = _.differenceBy(data, itemsToCheck, 'object_id');




                //TODO: impliment a binary search or at least just loop over the diffrence
                // https://medium.com/@jeffrey.allen.lewis/javascript-algorithms-explained-binary-search-25064b896470

                if(data.length > 0 ){
                    /////////////////////// UPDATE - INSERT ////////////////////////////////////////////
                    for(var i = 0 ; i < data.length ; i++) {
                        var index = _.findIndex(options.data.dataArr, { object_id: data[i].object_id});
                        if(index > -1 ){
                            ////////////// UPDATE ELEMENTS
                            ////////console.log("SHOULD BE UPDATING : " ,data[i] )
                            prvIndex = index;
                            options.data.dataArr[index] = data[i];
                            //////////console.log('UPDATE : ' ,options.data.dataArr);
                        }else{
                            ////////////// ADD ELEMENTS
                            ////////console.log('INSERT : ' , data[i]);
                            options.data.dataArr.splice(prvIndex+1, 0,  data[i]);
                        }
                    }
                    /////////////////////// DELETE  ////////////////////////////////////////////
                  //  if( itemsToCheck.length && data.length ){
                    if( itemsToCheck.length>0 && data.length>0 ){
                        ////////console.log("=============WE ARE IN THE DELETE")
                        var toRemove = _.differenceBy(itemsToCheck, data, 'object_id');
                        for(var i = 0 ; i < toRemove.length ; i++) {
                            var indexD = _.findIndex(options.data.dataArr, { object_id: toRemove[i].object_id});
                            if(indexD > -1 ){
                                ////////console.log("WE DELETED :" ,  options.data.dataArr[indexD]);
                                options.data.dataArr.splice(indexD,1)
                            }
                        }
                    }

                    base.data.dataArr =  options.data.dataArr;
                    /////////////////////// BATCH OPERATIONS ////////////////////////////////////
                    base.removeBatchSelection = true;
                    base.batch.setSelectedFromBatch();
                    /////////////////////// BATCH OPERATIONS ////////////////////////////////////
                    base.data.safeCopyArr =  _.clone( base.data.dataArr);
                    pipe();
                }
                /* added by Divya 8/7/2019 if gridUpdate retuns the empty data objet  for DELETE */
                else {
                    if(_update && _update.filter &&  _update.filter.object_id){
                        var findRemoveObject =   _update.filter.object_id;
                        var indexD = _.findIndex(options.data.dataArr, { object_id: findRemoveObject});
                            if(indexD > -1 ){
                                ////////console.log("WE DELETED :" ,  options.data.dataArr[indexD]);
                                options.data.dataArr.splice(indexD,1)
                            }

                        base.data.dataArr =  options.data.dataArr;
                        base.data.dataArr.map(i => i.SCENARIO_TYPE_CODE = options.data.settings.display_issue_columns === 1 ? 'EXAM' : '');
                        /////////////////////// BATCH OPERATIONS ////////////////////////////////////
                        base.batch.setSelectedFromBatch();
                        /////////////////////// BATCH OPERATIONS ////////////////////////////////////
                        base.data.safeCopyArr =  _.clone( base.data.dataArr);
                        pipe();
                    }

                }
            },


            destroy: function() {
                if (base && base.$el) {
                    base.$el.off();
                }
                $(window).off("base.resize");
                $(window).unbind('mousemove', base && base.hScrollDrag);
                $(window).unbind('mousemove', base && base.vScrollDrag);
                options.data = null;
                if (base && base.$el) {
                    base.$el.html("");
                }
                base.data = [];
                base = null;
            },

            releaseData: function() {
                base.data = [];
            }

        }


        ///////////////////////////////////////////////////////////////////////////////////
        ////////////////////////  buildUniqueFilterMenu  /////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////
        ///ON CLICK we will build this menu. We will cache the unigue col values.

        base.uniqueFilters = {
            selected:{},
            all_selected: true,
            filterArr:[],


            getFilterObj: function(_map,_arr,_searchString) {
                var returnObj =  _.find(this.filterArr, { 'map': _map});

                // creating the grid filter dropdown values, this will fix the dropdown values being cleared switching betwwen two screens.
                var x = _.find(base.tableState.colSearch, { 'predicate': _map });

                if(x && (!_.isEmpty(x) || x.length>0) && ((base.tableState && base.tableState.colSearch && base.tableState.colSearch.length>0  && options.data.firstLoad != 1))){

                    var searchObj = {};
                    searchObj.map = _map;
                    searchObj.data_type = _.result(_.find(base.data.headerArray,{ 'map': _map }), 'data_type');
                    searchObj.selected = [];
                    searchObj.allSelected = true;
                    searchObj.searchString = _searchString;
                    //if(_.find(base.tableState.colSearch, { 'predicate': _map })){
                        searchObj.selected = _.filter(base.tableState.colSearch,{predicate:_map})[0].value;
                        var tableStateIndex = _.findIndex(base.tableState.colSearch, { 'predicate': _map });
                        if(tableStateIndex == 0){
                            searchObj.uniqueColData =  this.getUniqueFilters(_map,base.data.safeCopyArr,searchObj.data_type);
                        }else{
                            searchObj.uniqueColData =  this.getUniqueFilters(_map,_arr,searchObj.data_type);
                        }
                    //}
                    this.filterArr.push(searchObj);
                    return searchObj;
                }// end of check(creating the grid filter dropdown values, this will fix the dropdown values being cleared switching betwwen two screens.)
                if(returnObj === undefined) {
                    var searchObj = {};
                    searchObj.map = _map;
                    searchObj.data_type = _.result(_.find(base.data.headerArray,{ 'map': _map }), 'data_type');
                    // searchObj.uniqueColData = this.getUniqueFilters(_map,_arr,searchObj.data_type);
                    searchObj.selected = [];
                    searchObj.allSelected = true;
                    searchObj.searchString = _searchString;
                    this.filterArr.push(searchObj);
                    return searchObj;
                }
                else{
                    return returnObj;
                }
            },

            applyFilter: function(_map) {

                var returnObj =  _.find(this.filterArr, { 'map': _map});

                //if WE ARE EQUALE DO NOT APPLY FILTER




                if(returnObj.selected.length == returnObj.uniqueColData.length ){
                    //remove filter
                    clearFilter('search',_map);
                    return false;
                }




                colSearchMultiFilter(_map,returnObj.selected,"[]",'array',false);

            },

            searchUniqueFilters: function(filterObj,_searchString){
                var rows = _searchString.split("\n");

                //WE HAVE TAB DELIMITED DATA FROM
                if(rows.length > 1 ){
                    return this.selectFromArray( filterObj.map,filterObj.uniqueColData,rows );
                }

                if( _searchString.length > 0){
                    return _.findArrayByPartialValue(filterObj.uniqueColData, _searchString);
                }
                return (filterObj.uniqueColData) ? filterObj.uniqueColData : [] ;
            },

            getUniqueFilters: function(_map,_arr,_data_type){
                var uniqueVals = _.uniqueColVal(_arr,_map,_data_type);
                
                function sortNumber(a,b) {
                    return a - b;
                }
                if( _data_type === 'string' ){
                   uniqueVals.sort(); 
                }else{
                    uniqueVals.sort(sortNumber);
                    
                }
                /* moving the null/undefined values to first postition 3/19/2021 */
                if (uniqueVals.indexOf(null) > 0) {
                    uniqueVals.splice(uniqueVals.indexOf(null), 1);
                    uniqueVals.unshift(null);
                }
                if (uniqueVals.indexOf(undefined) > 0) {
                    uniqueVals.splice(uniqueVals.indexOf(undefined), 1);
                    uniqueVals.unshift(undefined);
                }
                return uniqueVals;
            },

            addSelected: function(_map,_value){
                var returnObj =  _.find(this.filterArr, { 'map': _map});
                returnObj.data_type = _.result(_.find(base.data.headerArray,{ 'map': _map }), 'data_type');
                if( returnObj.data_type === 'number' && (_value !== 'undefined' && _value !== 'null')){ // added null check on 3/17/2021( we do not need to do the parseFloat when the value is null)
                    //HS- changed to allow floating-point numbers
                        _value = parseFloat(_value);                             
                }
               
                returnObj.selected.push(_value);
                if(returnObj.selected.length == returnObj.uniqueColData.length ){
                    $('input.gg-multi-checkbox_all' ,base.$el).prop('checked', true);
                    returnObj.allSelected == true;
                }else{
                    returnObj.allSelected == false;
                }

                return true;
            },

            removeSelected: function(_map,_value){
                var returnObj =  _.find(this.filterArr, { 'map': _map});
                if( returnObj.data_type === 'number'  && (_value !== 'undefined' && _value !== 'null') ){
                    //HS- changed to allow floating-point numbers
                    // _value = parseInt(_value);
                    _value = parseFloat(_value);
                }
                returnObj.selected =  _.without(returnObj.selected,_value);
                //BLANKS: FOR ANY UNDEFINED VALUES IN A COLUMN - WE NEED TO REMOVE undefined  with the function below because  _.without will not remove it
                if (_value === 'undefined') {
                    var indexArray = returnObj.selected.indexOf(undefined);
                    if (indexArray > -1) {
                        returnObj.selected.splice(indexArray, 1);
                    }
                }
                // nulls: for any null values in a column- we need to remove null with the function below _.without will not remove it -3/17/2021
                if(_value === 'null'){
                    var indeNullArr = returnObj.selected.indexOf(null);
                    if (indeNullArr > -1) {
                        returnObj.selected.splice(indeNullArr, 1);
                    }
                }
                return true;
            },

            selectAll: function(_map,_array,_selectAll){
                var returnObj =  _.find(this.filterArr, { 'map': _map});
                returnObj.selected = [];
                if( _selectAll === true){
                    _array.forEach(function (arrayElem){
                        returnObj.selected.push(arrayElem)
                    });
                }
                return true;
            },


            selectFromArray: function(_map,_array,_selectArray){
               //console.log("=================================selectFromArray===========================");
               //console.log("_map " , _map);
               //console.log("_array " , _array);
               //console.log("_selectArray " , _selectArray);


                var returnObj =  _.find(this.filterArr, { 'map': _map});

               //console.log("returnObj " , returnObj);


                returnObj.selected = [];


                if(_selectArray.length ){
                    _selectArray.forEach(function (arrayElem){
                            if(  _.includes(returnObj.uniqueColData,arrayElem ) ){
                               //console.log("========= " , arrayElem);
                               returnObj.selected.push(arrayElem)
                            }
                    });
                }


                return  returnObj.selected

            },




            buildMenu: function(_map,_arr,_searchString,_selectAll,_firstLoad){
                //todo: THIS IS HAPPNING ON OK CLICK - AND SHHOULD NOT

                var filterObj = this.getFilterObj(_map,_arr,_searchString);

                var index = _.findIndex(base.tableState.colSearch, { predicate: _map});
                if( index < 0  ){
                    filterObj.uniqueColData = this.getUniqueFilters(_map,_arr,filterObj.data_type);
                }

                var array = this.searchUniqueFilters(filterObj,_searchString);
                var checkBoxHtml = ""
                var isSelectedAll = '';
                var colSearch = _.find(base.tableState.colSearch, { 'predicate': _map });

                if( colSearch === undefined &&  _firstLoad){
                    isSelectedAll = 'checked';
                    this.selectAll(_map,array,true);
                }

                if( _selectAll === true || _selectAll === false ){
                    this.selectAll(_map,array,_selectAll);
                    if(_selectAll === true ){
                        isSelectedAll = 'checked';
                    }
                }

                checkBoxHtml = "<div> <input tab-index='0' type='checkbox' name='all ' " +isSelectedAll+ " class='gg-multi-checkbox_all' value='Select All'> Select All</div>";



               // var test = "";
                if( array.length < base.options.maxUniqueColFilters ){
                    var loopindex = 1;
                    array.forEach(function (arrayElem){

                        //TODO CREATE VIRTUAL SCROLLER FOR THIS
                        // if( loopindex++ < 100 ) {
                        var isSelected = '';
                        if (filterObj.selected.indexOf(arrayElem) != -1) {
                            isSelected = 'checked';
                        }
                        var displayText = arrayElem;
                        if (displayText === undefined || displayText === '' || displayText === null) {
                            displayText = '(Blanks)'
                        }

                        // checkBoxHtml += " <div> <input type='checkbox' class='gg-multi-checkbox' " + isSelected + " name='" + arrayElem + "' value='" + arrayElem + "'> " + displayText + " </div>";

                        //This will allow the strings with all the expressions (Added By Omprakash - 06/17/2019)
                        checkBoxHtml += `<div> <input type="checkbox" class="gg-multi-checkbox" name="${arrayElem}" value="${arrayElem}" ${isSelected}>${displayText}</div>`;

                       // test+='{"label":"'+arrayElem+'","value":"'+arrayElem+'"},';

                    })
                       // console.log(test);
                }else{
                    checkBoxHtml = "<b>begin typing to select filters </b> <br />  <i style='font-size: 10px'>right click empty cell to filter out blanks</i>";
                }


                if(array && array.length <= 0 ){
                    checkBoxHtml = "no items matched search";
                }

                base.$el.find('.gg-multi-select').html(checkBoxHtml);
            }
        }


        function buildHeaderDom(){
            base.elements.headerLeft.empty();
            base.elements.headerRight.empty();
            var colHeaderHeight = 0;
            base.data.headerArrayDisplay  = base.data.fixedHeaderSafeCopyArr.slice( base.hDragg.startIndex, base.hDragg.endIndex);
            var height = colHeaderHeight > 0 ? colHeaderHeight:( base.headerRow.height || base.options.vDraggerMinHeight);
            base.$el.find('.overflow').css('height', height);

            $.each(base.data.fixedHeaderArrayDisplay, function( index, value ){
                options.data.settings.fixed_columns = base.data.fixedHeaderArrayDisplay.length /* freeze panes 3/2/2020 */
                var header_class = value.header_class;
                if( base.selected.col_id == value.map ){
                    header_class += 'selected-col-header'
                }

                if( value.editable === 'y'){
                    header_class += ' edit-col-header'
                }

                var col = $("<div class='headerCol endCap'></div>");
                col.attr({ colObj: value.object_id, map: value.map });
                if( index !== 0 ){
                    var col = $("<div class='headerCol dragOrder " +header_class+"'></div>");
                    col.attr({ colObj: value.object_id, map: value.map });
                    col.html(headerLabelHtml(value));
                    var colWidthDom = $("<div class='col-resize-handle'></div>");
                    var sort = buildSortIcon(value);
                    var menu = buildDropDownMenu(value);
                    col.append(colWidthDom);
                    col.prepend(menu);
                    col.prepend(sort);
                    colWidthDom.css('height', height);
                } else {
                    var rowHeightDom = "<div class='row-resize-handle'></div>"
                    col.append(rowHeightDom);
                }
                // $('.dropdown-toggle').dropdown();


                col.css('width',value.width);
                col.css('height', height);
                base.elements.headerLeft.append(col)
                base.elements.headerLeft.attr('rowobj', '-1') // to enable header drag drop
            })


            $.each(base.data.headerArrayDisplay, function( index, value ) {
                var header_class = ( value.header_class !== undefined)  ? value.header_class : "";
                if( base.selected.col_id == value.map ){
                    header_class += ' selected-col-header'
                }

                if( value.editable === 'y'){
                    header_class += ' edit-col-header'
                }


                var sort = buildSortIcon(value),
                    menu = buildDropDownMenu(value),
                    col = $("<div class='headerCol dragOrder " +header_class+"'></div>"),
                    colWidthDom = $("<div class='col-resize-handle'></div>");
                col.attr({ colObj: value.object_id, map: value.map });
                col.html(headerLabelHtml(value));
                col.append(colWidthDom);
                col.prepend(menu);
                col.prepend(sort);
                //$('.dropdown-toggle').dropdown();
                col.css('width',value.width);
                col.css('height', height);
                colWidthDom.css('height', height);
                base.elements.headerRight.append(col)
                // base.elements.headerRight.attr('rowobj', '-1')
            });

            /////////////////////////////////////////////////////////////////////////////////////////////
            ////////////////////////////START SCRIPT FOR 2nd LEVEL DROPMENU/////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////

            base.$el.find('a.trigger').on('click', function(event){
                var current = $(this).next();
                var grandparent=$(this).parent().parent();
                if( $(this).hasClass('left-caret') ){
                    current.hide();
                    $(this).removeClass('left-caret');
                    $(this).addClass('right-caret');
                }else{
                    current.show();
                    $(this).addClass('left-caret');
                    $(this).removeClass('right-caret');
                }
                grandparent.find('.left-caret').not(this).toggleClass('right-caret left-caret');
                grandparent.find(".sub-menu:visible").not(current).hide();
                event.stopPropagation();
            });


            $(".dropdown-menu > li > a:not(.trigger)" , base.$el ).on("click",function(){
                var root=$(this).closest('.dropdown');
                root.find('.left-caret').toggleClass('right-caret left-caret');
                root.find('.sub-menu:visible').hide();
            });



            /*

             // ADD TOOLTIP

             data-toggle='tooltip' data-placement='top' title='"+value.label+"'

             $('body').tooltip({
             selector: '.headerCol'
             });
             */

            ////////////////////////////END SCRIPT FOR 2nd LEVEL DROPMENU/////////////////////////////

        }


        function buildSortIcon(value){
            var sort = "<div class='pull-left sortHeader stopEvent' style='margin-left:5px'><i class='fa fa-sort '></i></div>"
            if( base.tableState.sort.predicate && base.tableState.sort.predicate ===  value.map ){
                if( base.tableState.sort.reverse == true ){
                    var sort = "<div class='sortHeader stopEvent' style='margin-left:5px'><i class='fa fa-sort-alpha-desc'></i></div>"
                }else{
                    var sort = "<div class='sortHeader stopEvent' style='margin-left:5px'><i class='fa fa-sort-alpha-asc'></i></div>"
                }
            }
            return sort;
        }

        function buildDropDownMenu(value){
            var element = $(dropDownTemplate);
            element.attr("colObj",value.object_id);
            // IF NOT data_type === number then hide

            if( value.data_type !== 'number' ){
                element.find('.gg-menu-greater').hide();
                element.find('.gg-menu-less').hide();
            }

            if(!value.removable){
                element.find('.gg-menu-action[action="removeCol"]').hide();
                element.find('.gg-menu-action[action="formatCol"]').hide();
            }


            if(value.edit_type !== "batchSelect"){
                element.find('.gg-menu-action[action="select-all"]').hide();
                element.find('.gg-menu-action[action="un-select-all"]').hide();
            }

            var filters;
            if( value.data_type === 'number'  ){

                filters =   '<a class="trigger right-caret">Number Filters</a> '+
                    '<ul class="dropdown-menu sub-menu">'+
                    '<li class="open-input" action=":"><a >Contains</a></li> '+
                    '<li class="open-input" action="!:" ><a >Does NOT Contain</a></li> '+
                    '<li role="presentation" class="divider"></li> '+
                    '<li class="open-input" action="=" ><a>Equals...</a></li> '+
                    '<li class="open-input" action="!="><a>Does NOT Equal...</a></li> '+
                    '<li role="presentation" class="divider"></li> '+
                    '<li class="open-input" action=">=" ><a>Greater Than...</a></li> '+
                    '<li class="open-input" action="<="><a>Less Than...</a></li> '+
                    '<li role="presentation" class="divider"></li> '+
                    '<li class="open-input" action="blank" ><a>Blank</a></li> '+
                    '<li class="open-input" action="!blank"><a>Not Blank</a></li> '+
                    '</ul>';


            }else if( value.data_type === 'string' ) {

                filters = '<a class="trigger right-caret">Text Filters</a> '+
                    '<ul class="dropdown-menu sub-menu">'+
                    '<li class="open-input" action=":"><a>Contains </a></li> '+
                    '<li class="open-input" action="!:" ><a>Does NOT Contain</a></li> '+
                    '<li role="presentation" class="divider"></li> '+
                    '<li class="open-input" action="=" ><a>Equals...</a></li> '+
                    '<li class="open-input" action="!="><a>Does NOT Equal...</a></li> '+
                    '<li role="presentation" class="divider"></li> '+
                    '<li class="open-input" action="blank" ><a>Blank</a></li> '+
                    '<li class="open-input" action="!blank"><a>Not Blank</a></li> '+
                    '</ul>';


            }else if( value.data_type === 'date' ) {

                //////////console.log("I AM A DATE! WE NEED TO MAKE DATA FILTERS")

            }

            element.find('#dropDownFilters').html(filters);

            if(base.tableState.sort.predicate == value.map){
                element.find('.gg-remove-sort a').html(' <i class="fa fa-times"></i> Remove Sort');
            }else{
                element.find('.gg-remove-sort a').hide();
            }


            var model =  _.filter(base.tableState.colSearch, { predicate: value.map })


            if( model != undefined && !_.isEmpty(model) ){
                var parentElement = element.find('.gg-remove-filter a')
                parentElement.html(' <i class="fa fa-times"></i> Remove Filter');
                parentElement.parent().attr('map',model.predicate);
                var thisElement = element.find('.caret');
                element.find('.btn-default').addClass('btn-filterOn')
                thisElement.removeClass('caret');
                thisElement.addClass('fa fa-filter');
                thisElement.parent().addClass('selected-filter');

                if( model.operator === ':'){
                    element.find('.gg-column-search').val(model.value)
                }

                if( model.operator === '>='){
                    element.find('.gg-search-greater').val(model.value);
                }

                if( model.operator === '<='){
                    element.find('.gg-search-less').val(model.value);
                }


            }







            return element;
        }


///////////////////////////////////////////////////////////////////////////////////////////////////
//// ++ END ++ ///////////////////   BUILD HEADER DOM  ////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////// FORMATS /////////////////////////

        function numberWithCommas(x) {
            //TODO: Combind into one reg X - didnt have time

            if( x === 0 || typeof x === 'undefined' || x === '' || isNaN(x)){
                return x;
            }
            var c = parseFloat(x).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            c = c.replace("-", "");

            if( x < 0 ){
                c = "<span class='neg-num-color'>("+c+")</span>";
            }
            return c
        }



      /*  function floatWithCommas(x) {
            //TODO: Combind into one reg X - didnt have time
            if( x === 0 || typeof x === 'undefined' || x === '' || isNaN(x) ){
                return x;
            }
            var c = parseFloat(x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            c = c.replace("-", "");
            if( x < 0 ){
                c = "<span class='neg-num-color'>("+c+")</span>";
            }
            return c
        }
    */
    /* added on 1/3/2019  */
        function floatWithCommas(x) {
            //TODO: Combind into one reg X - didnt have time
            if( x === 0 || typeof x === 'undefined' || x === '' || isNaN(x) ){
                return x;
            }
            var parts = x.toString().split(".");
            var c;
            if(parts[1]){
                parts[0] = parts[0] && parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                parts[1] = parts[1] && parts[1].length>=10 ? parts[1].slice(0,10) : parts[1];
                c = parts.join(".");
                c = c.replace("-", "");
            }else{
                c = parseFloat(parts).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                c = c.replace("-", "");
            }

             if( x < 0 ){
                c = "<span class='neg-num-color'>("+c+")</span>";
             }
             return c;
        }


        function dateFormat(x) {
            if( isBlank(x) ){
                return "";
            }


            if(_.isObject(x) ){
                return x;
            }
            
            var format = base.dateFormats[0].value;

            if(x.includes("T")){
                return  moment.parseZone(x).format(format);
            }else{
                return moment(x, 'MM/DD/YYYY').format(format);
            }
        }



        function formatter(_data,_format,_rows,value){
            var formatString = _data;

            if(_format == 'numberWithCommas'){
                formatString = numberWithCommas(_data);
            }else if(_format == 'floatWithCommas') {
                formatString = floatWithCommas(_data);
            }else if(_format == 'date') {
                formatString = dateFormat(_data);
            }else if(_format == 'percentage') {
                formatString =  ( _data ) ?  _data + '%' : "" ;
            }else if(_format == 'batchSelect' &&  typeof _rows != 'undefined' ) {


                if(!_rows.ggNotEditable ){
                    formatString = (_data == "true") ? '<i class="gg-cell-check fa fa-check-square-o "><i/>' : '<i class="fa fa-square-o"><i/>';
                }else{
                    formatString =  '<i style="opacity:.2" class="gg-cell-check fa fa-square-o "><i/>';
                }

            }else if(_format == 'locked') {
                formatString = (_data == 1) ? '<i class="fa fa fa-lock fa-lg"><i/>' : '<i class=" fa fa-unlock fa-lg"><i/>';
            }else if(_format == 'checkbox') {
                /* 4/13/2020 checking the conditional checkbox */
                var isEdit=true;
                if(value.edit_rules!=null){
                    isEdit = base.buildDom.isRowColEditable(_rows,value.edit_rules)
                }

                if(isEdit && (_data!=null || _data != '')){
                    formatString = (_data == 1) ? '<i class="gg-cell-check gg-check-click fa fa-check-square-o fa-lg"><i/>' : '<i class="gg-check-click fa fa-square-o fa-lg"><i/>';
                }

            }else if(_format == 'color-error') {

              // formatString = (_data == 1) ? '<i class="fa fa-check" style="color:#1ca5cf; font-size:16px" aria-hidden="true"></i>' : '<i class="fa fa-circle-o" style="color:#f20b7f; font-size:16px" aria-hidden="true"></i>';

              if(_data == ""){
                // formatString = '<span style="background-color: #c52a1a;color: white;padding: 2px 12px;border-radius: 10px;"></span>';
              formatString = '<span ></span>';
   
            }else if(_data == "1"){
                    formatString = '<span style="background-color: #22992e;color: white;padding: 2px 12px;border-radius: 10px;">NO ERROR</span>';
                }else if(_data == "0" ){
                    formatString = '<span style="background-color: #c52a1a;color: white;padding: 2px 12px;border-radius: 10px;">ERROR</span>';

                }



            }else if(_format == 'color-dot') {

                // formatString = (_data == 1) ? '<i class="fa fa-check" style="color:#1ca5cf; font-size:16px" aria-hidden="true"></i>' : '<i class="fa fa-circle-o" style="color:#f20b7f; font-size:16px" aria-hidden="true"></i>';
  
                 if(_data == ""){
                    formatString = '<i class="fa fa-circle-o" style="color:#f20b7f; font-size:16px" aria-hidden="true"></i>';
                }else if(_data == "1"){
                    formatString = ' <i class="fa fa-check" style="color:#32cb33; font-size:16px" aria-hidden="true"></i>';
                }else if(_data == "0" ){
                    formatString = '<i class="fa fa-times-circle" style="color:#f20b7f; font-size:16px" aria-hidden="true"></i>';
 
                }
  
  
  
              }

            return formatString;
        }




///////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////   BUILD DOM    ///////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////
////////////////// WE WILL MOVE ALL GLOBAL BUILD FUNCTION INTO base.buildDom


        base.buildDom = {
            visible: true,




            batchRowSelectable: function (_dataArray) {
                if( options.data.settings.batch_select === 1 &&  options.data.settings.batch_select_rules ){
                    _.forEach(_dataArray, function (_value, _key) {
                        _value.ggNotEditable = base.buildDom.isEditable(options.data.settings.batch_select_rules, _value);
                    })
                }
            },


            batchSelectable: function(_object) {
                if( options.data.settings.batch_select === 1 &&  options.data.settings.batch_select_rules ) {
                    _object.ggNotEditable = base.buildDom.isEditable(options.data.settings.batch_select_rules,_object)
                }
            },



            isRowColEditable: function(_object,_rule_object){
                return !this.isEditable(_rule_object,_object);
            },

            isEditable: function(_rule_object,_object){
                if(!_rule_object) return false;
                var andList = _rule_object.AND;
                var orList = _rule_object.OR;
                var andResultList = [];
                var orResultList=[];
                var andResult=true;
                var orResult=true;
                var checkCondition = function(value) {
                    var notEditable = false;
                    if(value.operator === "=" &&  value.value !==  _object[value.map]){
                        notEditable = true;
                    }else if(value.operator === "!=" && value.value ==  _object[value.map]){
                        notEditable = true;
                    }else if(value.operator === "<=" && value.value >=  _object[value.map]){
                        notEditable = true;
                    }else if(value.operator === ">=" && value.value <=  _object[value.map]){
                        notEditable = true;
                    }else if(value.operator === ">" && value.value <  _object[value.map]){
                        notEditable = true;
                    }else if(value.operator === "<" && value.value >  _object[value.map]){
                        notEditable = true;
                    }
                    return notEditable;
                }
                if(_.isArray(_rule_object)){
                    _.each(_rule_object,function(item){
                        andResultList.push(checkCondition(item));
                    });
                   return _.filter(andResultList).length > 0;;
                }
                if(andList && andList.length===0 && orList && orList.length===0){
                    return true;
                }
                if(andList){
                    _.each(andList,function(item){
                        andResultList.push(checkCondition(item));
                    });
                    andResult = _.filter(andResultList).length===andList.length;
                    if(andList.length && !andResult){
                        return false;
                    }
                }
                if(orList && orList.length){
                    let isEditable = false;
                    _.each(orList,function(item){
                        if(!isEditable){
                            isEditable = checkCondition(item);
                        }
                    });
                    if(isEditable){ //checkCondition() return notEditable value, if any one of OR condition is passed, return true---
                        return false;
                    }
                }
                if(andResult && orResult){
                    return true;
                }
            }
        },

        function debug(e) {
            //////////////////////////////////////////////console.log(e);
        }



        function iconFormater(_icon){
            var icon = "";

            if(_icon === "edit" ){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-pencil"></i></div>');
            }else if(_icon === "info"){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-info-circle"></i></div>');
            }else if(_icon === "remove"){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-times"></i></div>');
            }else if(_icon === "question"){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-question-circle"></i></div>');
            }else if(_icon === "eye"){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-eye"></i></div>');
            }else if(_icon === "folder"){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-folder-open"></i></div>');
            }else if(_icon === "download"){
               icon = $('<div class="grid-download-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-cloud-download"></i></div>');
            }else if(_icon === "downloadFile"){
                icon = $('<div class="grid-download-file-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-cloud-download"></i></div>');
             }else if(_icon === "file"){
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-file"></i></div>');
             }
            else{
                icon = $('<div class="grid-action-btn grid-form-btn" action="" pramaters="" ><i class="fa fa-pencil"></i></div>');
            }
            return icon;

        }



        function buildBodyDom(){
            base.elements.ggleftcol.html("");
            base.elements.ggrightcol.html("");


            if(base.data.isCollapsed){
                base.data.displayArr = base.data.dataArr.slice(base.vDragg.startIndex, base.vDragg.endIndex);
            }
             else if(!_.isEmpty(base.data.pivotGroup) && (base.data && base.data.pivotGroup && (base.data.pivotGroup.groupRows.length>0 || base.data.pivotGroup.columnToRows.length>0))){

                base.data.displayArr = base.data.dataArr.slice(base.vDragg.startIndex, base.vDragg.endIndex);
            }else{
                base.data.displayArr  = base.data.dataArr.slice( base.vDragg.startIndex, base.vDragg.endIndex);
            }
            var rownum = 1*base.vDragg.startIndex;


            //TODO: REBUILD RENDER ENGINE: fix firefox scroll speed. Line below is major contributor to the slow speed
            // var order = _.findIndex(base.data.dataArr, { object_id: value.object_id }) + 1;
            // next is the $.each loops and ifs

            $.each(base.data.displayArr, function( index, value ) {
                // var order = _.findIndex(base.data.dataArr, { object_id: value.object_id }) + 1;
                rownum++;
                buildRow(value,rownum);

            });

            base.renderSelected.renderSelected();
        }



        function buildRow(_object,_rownum){


            var formBtn = $('<div class="grid-action-btn grid-form-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-pencil "></i></div>');
            var infoBtn = $('<div class="grid-action-btn grid-form-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-info-circle "></i></div>');
            var commentsBtn =  $('<div class="grid-form-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-comment-o"></i></div>');
            var attachmentsBtn =  $('<div class="grid-form-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-paperclip"></i></div>');
            //var drillDownBtn =  $('<div class="grid-drilldown-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-link"></i></div>');
            var row_class = "";
            var col_class= "";


            if( _object.row_class && _object.row_class.length){
                row_class = _object.row_class;
            }

            if(_object.col_class && _object.col_class.length){
                col_class = _object.col_class;
            }

            /*
             if( _.find(base.selectedGroup,{'row_id':_object.object_id, 'select_type':'row' }) ){
             row_class += row_class + ' selected-row';
             }
             */


            if( _.find(base.batchSelect,{'row_id':_object.object_id }) ){
                row_class += row_class + ' batch-row';
            }


            var row = $('<div  rowObj="'+_object.object_id+'" class="div-row  '+row_class+'"></div>'),
                rowFixed = $('<div  rowObj="'+_object.object_id+'" class="div-row '+row_class+'"></div>')
                ,index = 1;

            if(!_.isEmpty(base.data.pivotGroup)){
                row = $('<div  rowObj="'+_object.object_id+'" class="div-row" groupId="'+_object.group_id+'"></div>'),
                rowFixed = $('<div  rowObj="'+_object.object_id+'" class="div-row"  groupId="'+_object.group_id+'"></div>')
                ,index = 1;

            } 

            ///// BUILD FIXED COLS ROWS ///////////////////////////////////////////////////////////////////
            $.each( base.data.fixedHeaderArrayDisplay , function( key, value ) {
                var drillDownBtn =  $('<div class="grid-drilldown-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-link"></i></div>');
                var linkBtn =  $('<div class="grid-link-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-link"></i></div>');
                var obj_id = _object.object_id+'-'+value.map;

                var isExpand = _object.isCollapsed ? "fa-chevron-down" : "fa-chevron-right";
                //DATA FORMATTER ////////////////////////////////////////////////////////////////////////////////////
                var dataValue = ( _object[value.map] == undefined ? "" : sanitize(_object[value.map]));


                if(value.format && value.format.length){
                    dataValue = formatter(dataValue,value.format,_object,value);
                }


                //BUILD DOM ////////////////////////////////////////////////////////////////////////
                if(value.map && value.map == "group" && dataValue != ""){
                    if(_object.children.length>0){
                        var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'"  colObj="'+value.map+'" parent="'+_object.parent_id+'"class="div-col" style="padding-left: '+_object.padLeft+'px"><div class="div-col-data">'+
                            '<i class="custom-fa-class fa '+isExpand+'" style="cursor:pointer; padding-right: 3px; font-size: 13px;"></i>'
                              +_object.label+' ('+_object.children.length+')'+'</div></div>')
                    }
                    else{
                        var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'"  colObj="'+value.map+'" parent="'+_object.parent_id+'"class="div-col" style="padding-left: '+_object.padLeft+'px"><div class="div-col-data">'+
                            dataValue+'</div></div>')
                    }
                }else{
                    
                }
                if( index == 1){
                    var rowHeightDom = "<div class='row-resize-handle'  ></div>"
                    var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'" colObj="'+value.map+'"class="div-col-prime"><div class="div-col-data">'+_rownum+'</div></div>')
                    col.append(rowHeightDom);
                }else{
                    var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'"  colObj="'+value.map+'"class="div-col"><div class="div-col-data">'+dataValue+'</div></div>')
                }

                if(value.map && value.map == "group" && dataValue != ""){
                    var rowHeightDom = "<div class='row-resize-handle'  ></div>"

                    if(_object.children.length>0){
                        var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'"  colObj="'+value.map+'" parent="'+_object.parent_id+'"class="div-col" style="padding-left: '+_object.padLeft+'px"><div class="div-col-data">'+
                            '<i class="custom-fa-class fa '+isExpand+'" style="cursor:pointer; padding-right: 3px; font-size: 13px;"></i>'
                              +_object.label+' ('+_object.children.length+')'+'</div></div>');
                              col.append(rowHeightDom);

                    }
                    else{
                        var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'"  colObj="'+value.map+'" parent="'+_object.parent_id+'"class="div-col" style="padding-left: '+_object.padLeft+'px"><div class="div-col-data">'+
                            dataValue+'</div></div>')
                    }
                }

                //buildBodyDom
                // CELL CLASS/////////////////////////////////////////////
                if( base.cellData[obj_id]) {
                    col.addClass(base.cellData[obj_id].cssClass);
                }else if( value.col_class){
                    col.addClass(value.col_class);
                }


                // tagsS ///////////////////////////////////////////////////

                // //////////console.log("base.data.messageObject[obj_id]: " , base.data.messageObject[obj_id] , " " , obj_id)

                if(base.data.messageObject[obj_id]){
                    var tags = '<div class="gg-tag-icon"><div>';
                    col.addClass('gg-hot-spot');
                    col.append(tags);
                }


                if(base.data && base.data.attachmentObject &&  base.data.attachmentObject[obj_id]){
                    var tags = '<div class="gg-tag-attachment"><div>';
                    col.addClass('gg-hot-spot');
                    col.append(tags);
                }

                if(base.data && base.data.auditCellsObject &&  base.data.auditCellsObject[obj_id]){
                    var tags = '<div class="gg-tag-audit"><div>';
                    col.append(tags);
                }

                /*highlight cell if we have an error   */

                 if(base.data.errorObject && base.data.errorObject[obj_id]){
                    var tags = '<div class="gg-tag-error"><div>';
                    col.addClass('gg-hot-spot');
                 //   col.addClass('gg-error-spot');
                    col.append(tags);
                }

                 /* 9/8/2019  conditional drilldown symbol*/
                 if(value.drilldown && value.drilldown !== null && value.apply_rules == 1  && value.drilldown_rule == 1){
                    var x = base.buildDom.isEditable(value.edit_rules, _object);
                    if(x){
                        col.prepend(drillDownBtn);
                        col.addClass('drillDown');
                    }
                }else if(value.drilldown){
                    col.prepend(drillDownBtn);
                    col.addClass('drillDown');
                }

                if( value.link ){
                    col.append(linkBtn);
                    col.addClass('link');
                }


                if( value.editable === 'y' ){
                    if(  typeof value.edit_rules == "undefined" || base.buildDom.isRowColEditable(_object,value.edit_rules)  ) {
                        if (value.edit_type === 'form' && value.call_back) {
                            col.append(iconFormater(value.edit_icon))
                        }
                        var editIcon = '<div class="gg-edit-icon"><div>';
                        col.append(editIcon);
                    }
                }






                if( value.call_back && value.edit_type === 'comments'){
                    col.append(commentsBtn);
                }


                col.css('width',value.width+'px');
                rowFixed.append(col);

                if(_object.height ){
                    rowFixed.height(_object.height);
                }else{
                    rowFixed.height(base.options.defaultRowHeight);
                }

                index++;
            });

            ///// BUILD H-SCROLL COLS ROWS ///////////////////////////////////////////////////////////////////
            $.each( base.data.headerArrayDisplay , function( key, value ) {

                var formBtn = $('<div class="grid-action-btn grid-form-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-pencil "></i></div>');
                var infoBtn = $('<div class="grid-action-btn grid-form-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-info-circle "></i></div>');
                var obj_id = _object.object_id+'-'+value.map;
                var drillDownBtn =  $('<div class="grid-drilldown-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-link"></i></div>');
                var linkBtn =  $('<div class="grid-link-btn" action="NEEDTOADD" pramaters="" ><i class="fa fa-link"></i></div>');
                var downloadBtn = $('<div class="grid-download-actn" action="NEEDTOADD" pramaters="" ><i class="fa fa-link"></i></div>');
                var rowClass = "";

                var col_class= (_object.col_class && value.map=='error_msg')?_object.col_class:'';


                //DATA FORMATTER ////////////////////////////////////////////////////////////////////////////////////
                var dataValue = ( _object[value.map] == undefined ? "" : sanitize(_object[value.map]));

                if(value.format && value.format.length){

                    dataValue = formatter(dataValue,value.format,_object,value);
                }


              //  var col = $('<div obj_id="'+_object.object_id+'-'+value.map+'" rowObj="'+_object.object_id+'"  colObj="' +value.map+'" class="div-col"><div class="div-col-data">'+dataValue+'</div></div>')

              /*  MY CHAGES for highligh only  error_message cell if we have an error instead of highlight the entire  column
                    var col = $('<div obj_id="'+_object.object_id+'-'+value.map+'" rowObj="'+_object.object_id+'"  colObj="' +value.map+'" class="div-col '+col_class+'"><div class="div-col-data">'+dataValue+'</div></div>')
                    col.css('width',value.width+'px');
              */

              var col = $('<div obj_id="'+_object.object_id+'-'+value.map+'" rowObj="'+_object.object_id+'"  colObj="' +value.map+'" class="div-col"><div class="div-col-data">'+dataValue+'</div></div>')
              col.css('width',value.width+'px');

                if(value.map && value.map == "group" && dataValue != ""){
                    if(_object.children.length>0){
                        var col = $('<div obj_id="'+obj_id+'" rowObj="'+_object.object_id+'"  colObj="'+value.map+'" parent="'+_object.parent_id+'"class="div-col" style="padding-left: '+_object.padLeft+'px"><div class="div-col-data">'+
                            '<i class="custom-fa-class fa '+isExpand+'" style="cursor:pointer; padding-right: 3px; font-size: 13px;"></i>'
                            +_object.label+' ('+_object.children.length+')'+'</div></div>');
                            col.css('width',value.width+'px');

                    }
                }

                if(base.data.messageObject[obj_id]){
                    var tags = '<div class="gg-tag-icon"><div>';
                    col.addClass('gg-hot-spot');
                    col.append(tags);
                }
                 /* highlight cell if we have an attachment */

                if(base.data && base.data.attachmentObject &&  base.data.attachmentObject[obj_id]){
                    var tags = '<div class="gg-tag-attachment"><div>';
                    col.addClass('gg-hot-spot');
                    col.append(tags);
                }

                if(base.data && base.data.auditCellsObject &&  base.data.auditCellsObject[obj_id]){
                    var tags = '<div class="gg-tag-audit"><div>';
                    col.append(tags);
                }
                /*highlight cell if we have an error   */

                if(base.data.errorObject && base.data.errorObject[obj_id]){
                    var tags = '<div class="gg-tag-error"><div>';
                    col.addClass('gg-hot-spot');
                   // col.addClass('gg-error-spot');
	                    col.append(tags);
                }



                /*

                 if( value.call_back && value.edit_type === 'form'){
                    if( typeof value.edit_validation == "undefined" || editValidate(_object,value.edit_validation)  ) {
                        col.append(formBtn);
                    }
                }
                 */
                 /* 9/8/2019  conditional drilldown symbol*/
               // if(_object.GGCELCOLORTOTAL == 1 && value.drilldown && value.drilldown !== null && value.apply_rules == 1){
                if(value.drilldown && value.drilldown !== null && value.apply_rules == 1 && value.drilldown_rule == 1){
                    var x = base.buildDom.isEditable(value.edit_rules, _object);
                    if(x){
                        col.prepend(drillDownBtn);
                        col.addClass('drillDown');
                    }
                 }else if( value.drilldown){
                     col.prepend(drillDownBtn);
                     col.addClass('drillDown');
                 }

                if( value.link ){
                    col.append(linkBtn);
                    col.addClass('link');
                }


                if( value.editable === 'y' ){
                    if(  typeof value.edit_rules == "undefined" || base.buildDom.isRowColEditable(_object,value.edit_rules)  ) {
                        if (value.edit_type === 'form' && value.call_back) {
                            col.append(iconFormater(value.edit_icon));
                        }
                        var editIcon = '<div class="gg-edit-icon"><div>';
                        col.append(editIcon);
                    }
                }


              /*   if(value.drilldown && value.drilldown !== null ){
                    col.prepend(drillDownBtn);
                    col.addClass('drillDown');
                }

              */

                /* 9/8/2019  conditional drilldown symbol*/
                if(value.drilldown && value.drilldown !== null && value.apply_rules == 1  && value.drilldown_rule == 1){
                    var x = base.buildDom.isEditable(value.edit_rules, _object);
                    if(x){
                        col.prepend(drillDownBtn);
                        col.addClass('drillDown');
                    }
                }else if( value.drilldown){
                    col.prepend(drillDownBtn);
                    col.addClass('drillDown');
                }
                if( value.link ){
                    col.append(linkBtn);
                    col.addClass('link');
                }


                if( value.call_back && value.edit_type === 'comments'){
                    col.append(commentsBtn);
                }


                if( base.cellData[obj_id]) {
                    col.addClass(base.cellData[obj_id].cssClass);
                }else if( value.col_class){
                    col.addClass(value.col_class);
                }

                row.append(col);


                if(_object.GGROWCOLORTOTAL == 1){
                    row.addClass("ggTotalRow");
                    rowFixed.addClass("ggTotalRow");
                }
                if(_object.GGROWCOLORSUBTOTAL == 1){
                    row.addClass("ggTotalSubRow");
                    rowFixed.addClass("ggTotalSubRow");
                }



                if(_object.height ){
                    row.height(_object.height);
                }else{
                    row.height(base.options.defaultRowHeight);
                }

            });

            base.elements.ggleftcol.append(rowFixed);
            base.elements.ggrightcol.append(row);

        }

        base.$el.on('click', '.custom-fa-class' ,function(event){
            console.log("selected group ",base.selected);
            var filtered = [];
            var baseArray = base.data.dataArr;
            var safeCopyArray = _.clone(options.data.dataArr);

            function collapseExpand(baseArray){
                   /* collapse */
                   var tt = [];
                   if(base.selected.rowData.isCollapsed){
                    var filteredArray = [];
                        var removeChildren = function(dataChildren){                          
                            if(!dataChildren[0].hasOwnProperty('level') || dataChildren[0].children.length == 0){
                                baseArray =  _.differenceBy(baseArray,dataChildren,'object_id');
                            }
                            else{
                                _.each(dataChildren,function(ic){
                                    if(ic.children && ic.children.length>0){
                                        ic.isCollapsed = !ic.isCollapsed;
                                        var chil = ic.children; 
                                        baseArray =  _.filter(baseArray,function(rr){return rr.object_id != ic.object_id});

                                        removeChildren(chil);                                       
                                    }
                                })
                            }                            
                            
                        }
                        removeChildren(base.selected.rowData.children);
                        base.selected.rowData.isCollapsed = !base.selected.rowData.isCollapsed;
                        base.data.dataArr = baseArray;
                   }else
                   {
                        _.each(baseArray,function(item){ /*  expanding */                        
                                if(base.selected.rowData && base.selected.rowData.children && base.selected.rowData.children.length
                                    && base.selected.rowData.label == item['label'] && base.selected.rowData.level == item.level
                                    && base.selected.rowData.object_id == item['object_id']){
                                    if((item.isCollapsed == undefined || item.isCollapsed == false )
                                        ){
                                            filtered.push(item);
                                            item.isCollapsed = true;
                                            _.each(base.selected.rowData.children,function(ii){
                                                ii.isCollapsed = ii.isCollapsed ? !ii.isCollapsed: ii.isCollapsed;
                                                filtered.push(ii);
                                            });
                                        
                                    }else{
                                        item.isCollapsed = !item.isCollapsed;
                                        filtered.push(item);
                                    }
                            }else{
                                filtered.push(item);
                            }
                        });
                        base.data.dataArr = filtered;

                   }
                   
            }
            collapseExpand(baseArray);
            base.data.safeCopyArr = base.data.dataArr;
            options.data.dataArr = base.data.safeCopyArr;
           // base.data.isCollapsed = true;
            buildGrid();
        })

          /* pivot expand / collpase  7/30/2020*/
          base.pivotExpandService = {
            expandCollapse: function(){
                var safeCopyArr = _.clone(options.data.dataArr);
                
                let expandCollapsedArray = [];
               if( base.data && base.data.pivotGroup && base.data.pivotGroup.groupRows && base.data.pivotGroup.groupRows.length>0 && !base.data.isCollapsed){
                    _.each(safeCopyArr,function(item){
                                item.isCollapsed = true;
                                expandCollapsedArray.push(item);
                                var expandChildren = function(children){
                                    _.each(children,function(ii){

                                        if(ii.children && ii.children.length>0){
                                            ii.isCollapsed = true;
                                            expandCollapsedArray.push(ii);

                                            expandChildren(ii.children);
                                        }else{
                                            expandCollapsedArray.push(ii);

                                        }
                                    })

                                }
                                if(item.children && item.children.length>0){
                                    expandChildren(item.children);
                                }
                            });
                  //  base.data.dataArr = a;
                  base.data.dataArr = expandCollapsedArray;
                    base.data.isCollapsed = !base.data.isCollapsed
               }
                else if(base.data && base.data.pivotGroup && base.data.pivotGroup.groupRows && base.data.pivotGroup.groupRows.length>0){
                   /*  var a = _.each(safeCopyArr,function(item){
                                if(item.isCollapsed){
                                    item.isCollapsed = !item.isCollapsed;
                                }
                            });
                    var filtered = _.filter(a,{level:0});
                    base.data.dataArr = filtered;
                   base.data.isCollapsed = !base.data.isCollapsed */
                   _.each(safeCopyArr,function(item){
                        var removeChildren = function(dataChildren){                          
                            if(!dataChildren[0].hasOwnProperty('level') || dataChildren[0].children.length == 0){
                                safeCopyArr =  _.differenceBy(safeCopyArr,dataChildren,'object_id');
                            }
                            else{
                                _.each(dataChildren,function(ic){
                                    if(ic.children && ic.children.length>0){
                                        ic.isCollapsed = !ic.isCollapsed;
                                        var chil = ic.children; 
                                        safeCopyArr =  _.filter(safeCopyArr,function(rr){return rr.object_id != ic.object_id});
                                        removeChildren(chil);                                       
                                    }
                                })
                            }                            
                            
                        }
                        if(item.children && item.children.length>0){
                            item.isCollapsed = false;
                            removeChildren(item.children);
                        }else{
                            item.isCollapsed = false;
                        }

                     })
                     base.data.isCollapsed = !base.data.isCollapsed;
                   base.data.safeCopyArr = safeCopyArr;
                   base.data.dataArr = safeCopyArr;
                }
               buildGrid();
            }
        }


	    base.$el.on('change', '#pivotCheck' ,function(event){
            base.selVal = this.checked;
            this.checked ? base.pivotChecked = "enabled" : base.pivotChecked = "disabled";
            buildGrid();
        })
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////// Drop Down Actions ////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////

        //$(document.body).on('click', '.gg-menu-action' ,function(){

        //_object[value.map]



        function dropdownAction(action,element,input,curDataCol,map){

            switch (action) {


                case 'copyAddRow':
                    var row_id =  base.selected.row_id;
                    var index = _.findIndex(base.data.safeCopyArr, { 'object_id':  base.selected.row_id });
                    base.edit.copyAddRow(index);
                    break;
                case 'addRowBelow':
                    var row_id =  base.selected.row_id;
                    var index = _.findIndex(base.data.safeCopyArr, { 'object_id':  base.selected.row_id });
                    base.edit.addRow(index,'below');
                    break;
                case 'addRowAbove':
                    var row_id =  base.selected.row_id;
                    var index = _.findIndex(base.data.safeCopyArr, { 'object_id':  base.selected.row_id });
                    base.edit.addRow(index,'above');
                    break;
                case 'deleteRow':
                    var row_id =  base.selected.row_id;
                    var index = _.findIndex(base.data.safeCopyArr, { 'object_id':  base.selected.row_id });
                    base.edit.deleteRow(index,'above');
                    break;
                case 'editCell':
                    base.edit.editCell('',false);
                    break;
                case 'addCol':
                    var toMove = _.findIndex(base.data.headerArraySafe, { 'object_id': curDataCol.object_id });
                    base.headerService.addCol("AA","string",toMove+1);
                    break;
                case 'removeCol':
                    var toRemove = _.findIndex(base.data.headerArraySafe, { 'object_id': curDataCol.object_id });
                    base.headerService.removeCol(toRemove);
                    break;
                case 'formatCol':
                    var template = '<lable>Column Name</lable><input class="input-sm form-control gg-modal-input" type="text" name="columnName" value="'+curDataCol.label+'">'
                    template += base.headerService.buildFormatSelection();
                    base.ModalService.openModalService("Format Column ",curDataCol.map,'formatCol',template);
                    base.ModalService.positionModal();
                    break;
                case 'fill':
                    base.headerService.fill(input,curDataCol.object_id);
                    break;
                case 'hideCol':
                    break;
                case 'highlightCol':
                    highlight(curDataCol,base.tools.color);
                    break;
                case 'highlight':
                    var color = element.attr('color');
                    highlight(element,color)
                    break;
                case 'sort-a-z':
                    sortBy(curDataCol.map,curDataCol.label,false);
                    break;
                case 'sort-z-a':
                    sortBy(curDataCol.map,curDataCol.label,true);
                    break;
                case 'un-sort':
                    unSort();
                    break;
                case 'find-like':
                    colSearchText(curDataCol.map,input,':','string' );
                    break;
                case 'find-not-like':
                    colSearchText(curDataCol.map,input,'!:','string' );
                    break;
                case 'find-equals-number':
                    colSearchText(curDataCol.map,input,'=','numeric' );
                    break;
                case 'find-not-equals-number':
                    colSearchText(curDataCol.map,input,'!=','numeric' );
                    break;
                case 'find-not-equal':
                    colSearchText(curDataCol.map,input,'!=','string' );
                    break;
                case 'find-greater':
                    colSearchText(curDataCol.map,input,'>=','numeric' );
                    break;
                case 'find-less':
                    colSearchText(curDataCol.map,input,'<=','numeric' );
                    break;
                case 'un-filter':
                    unFilter(map);
                    break;
                case 'blank':
                    colSearchText(curDataCol.map,'','blank','string' );
                    break;
                case 'not-blank':
                    colSearchText(curDataCol.map,'','!blank','string' );
                    break;
                case 'un-select-all':
                    base.removeBatchSelection = true;
                    base.batch.unselectAll();
                    break;
                case 'select-all':
                    base.batch.selectAll();
                    break;
                case 'select-row':
                    base.batch.selectRow();
                    break;
                case 'batch-action':
                    base.api.batchAction(element.attr("value"));
                    break;
                case 'add-comment':
                    base.messageService.renderAddMessageTemplate();
                    break;
                case 'add-attachment':
                    base.messageService.addAttachment();
                    break;
                case 'batchSelectAll':
                    base.batch.selectAll();
                    break;
                case 'batchUnSelect':
                    base.batch.unselectAll();
                    break;
                case 'audit-cells':
                    base.messageService.auditCellsModal();
                    break;
            }

            base.focus.gridBody.focus();

        };









        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////   GLOBAL SEARCH  ///////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var throttledTextInput = _.debounce(function(_filterText){
            base.tableState.search.globalValue = _filterText;
            options.data.tableState.vScroll = {};
            pipe();
        }, 400);


        function globalSearch(_value){
            throttledTextInput(_value)
        };

        base.$el.find('.gg-clear-search').on('click', function(){
            base.elements.globalSearch.val("");
            throttledTextInput("");
        });

       /* options.data.tableState.vScroll : resetting this option to EMPTY if we made any search/sort/filter 6/10/2021*/ 


        function clearAll(){
            base.elements.globalSearch.val("");
            base.tableState.sort = {};
            base.tableState.search = {};
            base.tableState.colSearch = [];
            base.tableState.attachments = false;
            base.tableState.comments = false;
            base.tableState.auditCells = false;
            base.messageService.toggleCommentFilterIcon();
            base.messageService.toggleAttachmentFilterIcon();
            options.data.tableState.vScroll = {};
            if(base.data && base.data.dataArr.length>=0){
                pipe();
            }

        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////   SORT FILTER //////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function sort(e){
            var col_id = $(e.currentTarget).closest(".headerCol").attr('colobj');
            var curDataCol = _.find(base.data.headerArray, {'object_id':col_id});

            if( base.tableState.sort.predicate &&  base.tableState.sort.predicate ===  curDataCol.map){
                if( base.tableState.sort.reverse == true ){
                    unSort();
                }else if( base.tableState.sort.reverse == false) {
                    sortBy(curDataCol.map,curDataCol.label,true,curDataCol.data_type);
                }
            }else{
                sortBy(curDataCol.map,curDataCol.label,false,curDataCol.data_type);
            }

            e.stopPropagation();

        };


        function unSort(){
            base.tableState.sort = {};
            options.data.tableState.vScroll = {};
            pipe();
        }

        function unFilter(_map){
            /* if we clear the gridaction make template selection false  3/4/2020*/
            _.each(base.actionTemplates, function(item){
                if(item.map == _map){
                    if(item.selectedAction){
                        item.selectedAction = false;
                        item.map = '';
                    }
                    base.actionsService.clearSelectedTemp();
                }

            })
            options.data.actionTemplates = base.actionTemplates;

            var index = _.findIndex(base.tableState.colSearch, { predicate:_map });
            if (index > -1) {
                base.tableState.colSearch.splice(index, 1);
            }
            options.data.tableState.vScroll = {};
            pipe();
        }


        function colSearchText(_key,_value,_operator,_type){

            //MAKE SURE ONLY ON VALUE PER KEY
            var index = _.findIndex(base.tableState.colSearch, { predicate:_key });
            if (index > -1) {
                base.tableState.colSearch.splice(index, 1);
            }
            var searchObj = {};
            searchObj.predicate = _key;
            searchObj.value = _value;
            searchObj.type = _type
            searchObj.operator = _operator
            base.tableState.colSearch.push(searchObj);
            options.data.tableState.colSearch = base.tableState.colSearch; /* 3/4/2020 */
            options.data.tableState.vScroll = {};
            pipe();
        }


        function colSearchMultiFilter (_key,_value,_operator,_type,_reverse){
            var index = _.findIndex(base.tableState.colSearch, { predicate:_key });

            if (index > -1) {
                base.tableState.colSearch.splice(index, 1);
            }

            // Change 'undefined' to undefined
            // Heath
            // object:uniqueFilters method:removeSelected - this function will also Change 'undefined' to undefined
            // This is used to find any undefined values.
            // _value will pass 'undefined' so we need to change this to undefined to find any undefined values in base.data.safeCopyArr

            var indexArray = _value.indexOf("undefined");
            if (indexArray !== -1) {
                _value[indexArray] = undefined;
            }
            // Change 'null' to null
            // Divya
            // object:uniqueFilters method:removeSelected - this function will also Change 'null' to null
            // This is used to find any null values.
            // _value will pass 'null' so we need to change this to null to find any null values in base.data.safeCopyArr

            var indexNullArr = _value.indexOf("null");
            if(indexNullArr !== -1){
                _value[indexNullArr] = null;
            }

            var searchObj = {};
            searchObj.predicate = _key;
            searchObj.value = _value;
            searchObj.type = _type
            searchObj.operator = _operator
            searchObj.reverse = _reverse
            base.tableState.colSearch.push(searchObj);
            options.data.tableState.colSearch = base.tableState.colSearch; /* 3/4/2020 */
            options.data.tableState.vScroll = {};
            pipe();

        }

        //SORT BY KEY
        function sortBy(_key,_label,_reverse,_dataType){
            base.tableState.sort.predicate = _key;
            base.tableState.sort.lable = _label;
            base.tableState.sort.reverse = _reverse === true;
            base.tableState.sort.dataType = _dataType;
            options.data.tableState = base.tableState /* 3/4/2020 */
            options.data.tableState.vScroll = {};
            pipe();
        }

        function pipe(){

            var filtered =  base.data.safeCopyArr;



            console.log(" base.tableState  " , base.tableState);


            if( base.tableState.colSearch && base.tableState.colSearch.length ){
                _.each(base.tableState.colSearch, function(model){


                    if( model.operator  === "blank" || model.operator  === "!blank"  ){

                        if(model.operator  === "blank" ){
                            var array = [];
                            array.push(undefined);
                            filtered = _.findByValues(filtered, model.predicate ,array);
                        }else{
                            filtered =   _.filter(filtered, function(o) {
                                if( typeof  o[model.predicate] !== "undefined" &&  o[model.predicate] !== null &&  o[model.predicate] !== "" ){
                                    return o;
                                }
                            });
                        }


                    }else if( ( model.type  === 'numeric' || model.type  === 'number')  && model.predicate.length ){
                        filtered =   _.findNumByProperty(filtered,model.predicate,model.value,model.operator)
                    }else if(model.type === 'string' && model.predicate.length){

                        if( model.operator === ':' ){
                            filtered =  _.findByKeyPartialValue(filtered,model.value,model.predicate);
                        }else if( model.operator === '!:' ){
                            filtered =  _.findNotByKeyPartialValue(filtered,model.value,model.predicate);
                        }else if( model.operator === '=' ){
                            var obj = [];
                            obj[model.predicate] = model.value;
                            filtered =  _.filter(filtered,{ '+model[predicate]+': model.value });
                        }else if( model.operator === '!=' ){

                        }else{
                            filtered =  _.findByKeyPartialValue(filtered,model.value,model.predicate);
                        }

                    }else if( model.type === 'array' &&  model.value.length  ){

                        if(model.reverse){
                            filtered = _.findByValuesNot(filtered, model.predicate , model.value);
                        }else{
                            filtered = _.findByValues(filtered, model.predicate , model.value);
                        }
                    }
                });

                /* if block is added to get the scroll position while switcing the tabs, options.data.tableState.vScroll*/
                if( !_.isEmpty(options.data.tableState.vScroll)){
                    base.vDragg.draggerPositionY = options.data.tableState.vScroll.draggerPositionY;
                    base.vDragg.scrollPositionY = options.data.tableState.vScroll.scrollPositionY;
                }else{
                    base.vDragg.draggerPositionY = 0;
                    base.vDragg.scrollPositionY = 0;
    
                }
                
            }

            if(  base.tableState.search && base.tableState.search.globalValue){
                filtered =  _.findByPartialValue(filtered,base.tableState.search.globalValue);
                if( !_.isEmpty(options.data.tableState.vScroll)){
                    base.vDragg.draggerPositionY = options.data.tableState.vScroll.draggerPositionY;
                    base.vDragg.scrollPositionY = options.data.tableState.vScroll.scrollPositionY;
                }else{
                    base.vDragg.draggerPositionY = 0;
                    base.vDragg.scrollPositionY = 0;
    
                }
            }

            if( base.tableState.sort && base.tableState.sort.predicate ){

                if( base.tableState.sort.dataType === 'date') {
                    if (base.tableState.sort.reverse === true) {
                        filtered =_.sortBy(filtered, function(value) {
                            var dateString = ( value[base.tableState.sort.predicate] === undefined ? null : value[base.tableState.sort.predicate]);
                            return new Date(dateString);
                        }).reverse();
                    } else {
                        filtered = filtered =_.sortBy(filtered, function(value) {
                            var dateString = ( value[base.tableState.sort.predicate] === undefined ? null : value[base.tableState.sort.predicate]);
                            return new Date(dateString)
                        });
                    }
                }else{
                    if (base.tableState.sort.reverse === true) {
                        filtered = _.sortBy(filtered, base.tableState.sort.predicate).reverse();
                    } else {
                        filtered = _.sortBy(filtered, base.tableState.sort.predicate);
                    }
                }
            }




            if( base.tableState.comments){
                var row_key_arr = [];
                _.forEach( base.data.messageObject, function(value, key) {
                    row_key_arr.push(value.row_key)
                })

                if(row_key_arr.length && filtered.length){
                    if( !_.isEmpty(options.data.tableState.vScroll)){
                        base.vDragg.draggerPositionY = options.data.tableState.vScroll.draggerPositionY;
                        base.vDragg.scrollPositionY = options.data.tableState.vScroll.scrollPositionY;
                    }else{
                        base.vDragg.draggerPositionY = 0;
                        base.vDragg.scrollPositionY = 0;
        
                    }
                    filtered = _.findByValues(filtered, 'object_id' , row_key_arr);
                }else{
                    addAlert("alert-warn"," There are no comments to filter on",4000 );
                }
            }

             /* added by Divya fiter the attachments 9/22/2019*/
            if( base.tableState.attachments){
                var row_key_arr1 = [];
                _.forEach( base.data.attachmentObject, function(value, key) {
                    row_key_arr1.push(value.row_key)
                })

                if(row_key_arr1.length && filtered.length){
                    if( !_.isEmpty(options.data.tableState.vScroll)){
                        base.vDragg.draggerPositionY = options.data.tableState.vScroll.draggerPositionY;
                        base.vDragg.scrollPositionY = options.data.tableState.vScroll.scrollPositionY;
                    }else{
                        base.vDragg.draggerPositionY = 0;
                        base.vDragg.scrollPositionY = 0;
        
                    }
                     filtered = _.findByValues(filtered, 'object_id' , row_key_arr1);
                }else{
                    addAlert("alert-warn"," There are no attachments to filter on",4000 );
                }
            }
	    if(base.tableState.auditCells){
                var row_key_arr1 = [];
                _.forEach( base.data.auditCellsObject, function(value, key) {
                    row_key_arr1.push(value.row_key)
                })

                if(row_key_arr1.length && filtered.length){
                     base.vDragg.draggerPositionY = 0;
                     base.vDragg.scrollPositionY = 0;
                     filtered = _.findByValues(filtered, 'object_id' , row_key_arr1);
                }else{
                    addAlert("alert-warn"," There are no overrides to filter on",4000 );
                } 
            }

            base.data.dataArr = filtered;
            var displayString = "Total Records:<b> " +base.data.safeCopyArr.length+ "</b> | Filtered: <b>"+base.data.dataArr.length+"</b>";
            if(options.data.pivotGroup && options.data.pivotGroup.groupRows && options.data.pivotGroup.groupRows.length>0 ||
                options.data.pivotGroup && options.data.pivotGroup.columnToRows && options.data.pivotGroup.columnToRows.length>0){
                    displayString = "Total Records:<b> " +options.data.totalRecords+ "</b> | Group or Pivot Rows: <b>"+base.data.safeCopyArr.length+"</b> | Filtered: <b>"+base.data.dataArr.length+"</b>"
            }
            base.elements.recordDetails.html(displayString);
            setFooterDetails(base.data.safeCopyArr.length,base.data.dataArr.length)
            buildFilterFunctions();
            buildGrid()
        }

///////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////  START FOOTER UI FILTER RENDERING  ////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////


        function buildFilterFunctions(){
            base.elements.footerContainer.html("");
            var clearAll = '<div class="gg-clear-all"><i class="fa fa-times"></i></div>';
            var item = '<div class="filter-item"> A-Z <div class="gg-clear-item"><i class="fa fa-times"></i></div></div>';
            var showClearAll = false;

            // TableState Global Search
            if( base.tableState.search && base.tableState.search.globalValue){
                var item = '<div class="filter-item"> Global Search: '+sanitize(base.tableState.search.globalValue)+' <div class="gg-clear-item" action="globalSearch"><i class="fa fa-times"></i></div></div>';
                base.elements.footerContainer.append(item);
                showClearAll = true;
            }


            // Comment Filter
            if( base.tableState.comments){
                var item = '<div class="filter-item"> Comment Rows: True  <div class="gg-clear-item" action="comments"><i class="fa fa-times"></i></div></div>';
                base.elements.footerContainer.append(item);
                showClearAll = true;
            }

             /* attachment Filter --added by Divya 9/22/2019 */
             if( base.tableState.attachments){
                var item = '<div class="filter-item"> Attachment Rows: True  <div class="gg-clear-item" action="attachments"><i class="fa fa-times"></i></div></div>';
                base.elements.footerContainer.append(item);
                showClearAll = true;
            }
            /* audit Filter --added by Divya 5/31/2021 */
            if( base.tableState.auditCells){
                var item = '<div class="filter-item"> Override Rows: True  <div class="gg-clear-item" action="celloverrides"><i class="fa fa-times"></i></div></div>';
                base.elements.footerContainer.append(item);
                showClearAll = true;
            }

            // TableState Column Search
            if( base.tableState.colSearch.length ){
                _.each(base.tableState.colSearch, function(model){
                    var columnName = _.map(_.filter(base.data.headerArray, { 'map': model.predicate }), 'label');
                    var displayValue = model.value.toString();
                    if(displayValue.length > 50) {
                        displayValue = displayValue.substring(0,45)+"...";
                    }
                    var item = '<div class="filter-item"> '+sanitize(columnName)+ ' ' +model.operator+ ' ' +sanitize(displayValue)+' <div class="gg-clear-item" action="search" map="'+model.predicate+'"><i class="fa fa-times"></i></div></div>';
                    base.elements.footerContainer.append(item);
                    showClearAll = true;
                });
            }


            // TableState Column Search
            if( base.tableState.sort && base.tableState.sort.predicate){

                var sortString = "A <i class='fa fa-long-arrow-right'></i> Z";
                if( base.tableState.sort.reverse ){
                    sortString = "Z <i class='fa fa-long-arrow-right'></i> A"
                }

                var item = '<div class="filter-item"> '+base.tableState.sort.lable+ ' : '+sortString+ '<div class="gg-clear-item" action="sort"><i class="fa fa-times"></i></div></div>';
                base.elements.footerContainer.append(item);
                showClearAll = true;
            }

            if(showClearAll) {
                base.elements.footerContainer.prepend(clearAll);
                // base.elements.footerContainer.append(item)
            }
        }


        function clearFilter(_action,_map){
            if(_action == 'search'){
                unFilter(_map);
            }else if(_action == 'globalSearch'){
                base.tableState.search.globalValue = null;
                base.elements.globalSearch.val("");
            }else if(_action == 'sort'){
                base.tableState.sort = {};
            }else if( _action == 'comments'){
                base.tableState.comments = false;
                base.messageService.toggleCommentFilterIcon();
                /* added by Divya fiter the attachments 9/22/2019*/
            }else if(_action == 'attachments'){
                base.tableState.attachments = false;
                base.messageService.toggleAttachmentFilterIcon();
            }else if(_action == 'celloverrides'){
                base.tableState.auditCells = false;
                base.messageService.toggleOverrideCellstFilterIcon();
            }
            options.data.tableState.vScroll = {};
            pipe();
        }

        
        function setFooterDelete(_count){
            var string = _count === 1 ? '<b>' + _count + ' Row Removed' : '<b>' + _count + ' Rows Removed';
            base.elements.footerDelete.html(string)
            base.elements.footerDelete.addClass('gg-delete-count')
        }

        function setFooterDetails(_length,_filterLength){
            var string;
            if(_length > _filterLength) {
                string = "Total Records: <b>" + _length + "</b> Filterd: <b>" + _filterLength + "</b>";
                if(options.data.pivotGroup && options.data.pivotGroup.groupRows && options.data.pivotGroup.groupRows.length>0 ||
                    options.data.pivotGroup && options.data.pivotGroup.columnToRows && options.data.pivotGroup.columnToRows.length>0){
                        string = "Total Records:<b> " +options.data.totalRecords+ "</b> | Group or Pivot Rows: <b>"+_length+"</b>"
                        + "</b> | Filterd: <b>"+_filterLength+"</b>";
                }
            }else{
                string = "Total Records: <b>" + _length;
                if(options.data.pivotGroup && options.data.pivotGroup.groupRows && options.data.pivotGroup.groupRows.length>0 ||
                    options.data.pivotGroup && options.data.pivotGroup.columnToRows && options.data.pivotGroup.columnToRows.length>0){
                        string = "Total Records:<b> " +options.data.totalRecords+ "</b> | Group or Pivot Rows: <b>"+_length+"</b>";
                }
               
            }

           
            base.elements.footerDetails.html(string)
        }




        base.scroll = {
            trackHScroll: function(event){
                var offset =  base.elements.htrack.offset().left;
                var clickX = event.pageX - offset;
                var rightX = base.hDragg.draggerPositionX + base.hDragg.draggerWidth;
                var leftX = base.hDragg.draggerPositionX;


                if( clickX > rightX){
                    pageRight();
                }else if(clickX < leftX){
                    pageLeft();
                }


            },

            trackVScroll: function(event){
                var offset =  base.elements.vtrack.offset().top;
                var clickY = event.pageY - offset;
                var topY = base.vDragg.draggerPositionY;
                var bottomY = base.vDragg.draggerPositionY + base.vDragg.draggerHeight;


                if( clickY < topY){
                    pageUp();
                }else if(clickY > bottomY){
                    pageDown();
                }
            }

        }




///////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////  START H-SCROLL FUNCTIONS   ////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////

        function buildHScrollBar(){
            //SET UP TRACK
            var left = getGridWidth(base.data.fixedHeaderArrayDisplay) +  base.elements.fixColHandler.width();
            base.elements.htrack.css('left',left+'px');

            if (options.data.settings.hasPivot == 1 && base.pivotChecked == "enabled") {
                var trackWidth = (base.$el.width() - left) - ( base.elements.hbtns.width() + base.elements.vtrack.width()) -270;
            } else if (options.data.settings.hasPivot == 1) {
                var trackWidth = (base.$el.width() - left) - ( base.elements.hbtns.width() + base.elements.vtrack.width()) -25;
            } else {
                var trackWidth = (base.$el.width() - left) - ( base.elements.hbtns.width() + base.elements.vtrack.width() );
            }
            base.elements.htrack.width(trackWidth);

            //SET UP WINDOW
            if(options.data.settings.hasPivot == 1 && base.pivotChecked == "enabled") {
                var scrollWindowWidth =  base.$el.width() - getGridWidth(base.data.fixedHeaderArrayDisplay) - base.elements.vtrack.width() - 270;
            } else if (options.data.settings.hasPivot == 1) {
                var scrollWindowWidth =  base.$el.width() - getGridWidth(base.data.fixedHeaderArrayDisplay) - base.elements.vtrack.width() - 25;
            } else {
                var scrollWindowWidth =  base.$el.width() - getGridWidth(base.data.fixedHeaderArrayDisplay) - base.elements.vtrack.width();
            }
            var containerWidth = base.elements.ggrightcol.width();
            var scrollWidth = containerWidth - scrollWindowWidth;
            var trackRatio = trackWidth / containerWidth;
            var draggerWidth = trackWidth * trackRatio;

            //IF GRID IS SMALLER THEN SCROLL AREA THEN DON'T SHOW GRID
            if( scrollWindowWidth > containerWidth  ){
                resetHScroll()
                draggerWidth = 0;
            }else{
                if( draggerWidth < base.options.vDraggerMinHeight ){
                    draggerWidth = base.options.vDraggerMinHeight;
                }
            }

            base.elements.hdragger.width(draggerWidth);
            trackWidth -= draggerWidth;
            trackRatio = trackWidth / scrollWidth;
            base.hDragg.scrollRatio = trackRatio;
            var scrollRatio = scrollWidth / trackWidth;
            base.hDragg.trackRatio = trackRatio;
            base.hDragg.draggerWidth = draggerWidth;
            base.hDragg.trackWidth = trackWidth - 3;
            base.hDragg.scrollRatio = scrollRatio;
            base.hDragg.scrollWidth = scrollWidth;
            base.hDragg.scrollWindowWidth = scrollWindowWidth;
            base.hDragg.offset = null;
            base.hDragg.maxStartIndex = findLastStartIndex()
            base.vDragg.maxStartIndex = findLastStartVIndex();

            drawHDragger();

        }

        // MOVE THIS FUNCTION

        function resetHScroll(){
            base.hDragg.draggerPositionX = 0;
            base.hDragg.scrollPositionX = 0;
            drawHDragger();
            buildHeaderDom();
            buildBodyDom();
        }


        function onHorzScrollOff(){
            if (!base || !base.hDragg) return;
            base.hDragg.offset = null
        }


        function onHorzScroll(event){
            if (!base || !base.hDragg) return;

            ////////////////////// HANDLES THE OFFSET OF MOUSE CLICK POINT AND LEFT OFFSET OF THE GRID ////////////////////////
            if( base.hDragg.offset == null ){
                base.hDragg.offset = event.pageX - (base.elements.hdragger.offset().left - base.layout.offset.left);
            }


            var draggerWidth = (event.pageX - base.elements.headerLeft.width() - base.hDragg.offset ) ;

            base.hDragg.draggerPositionX = draggerWidth;

            if( draggerWidth >=  0 && draggerWidth <= base.hDragg.trackWidth ){
                base.hDragg.draggerPositionX = draggerWidth;
            }

            if( draggerWidth <=  0){
                base.hDragg.draggerPositionX = 0;
            }

            base.hDragg.scrollPositionX = Math.round( base.hDragg.draggerPositionX * base.hDragg.scrollRatio );

            drawHDragger();
            buildHeaderDom();
            buildBodyDom();
        }



        function setColWidthArr(){
            base.horizontalWidthArray = [0];
            var addition = 0;
            for(var i = 0; i < base.data.headerArrayDisplay.length ; i++){
                if( base.data.headerArrayDisplay[i].width != undefined ){
                    base.horizontalWidthArray.push(parseInt(base.data.headerArrayDisplay[i].width) + addition)
                    addition += parseInt(base.data.headerArrayDisplay[i].width);
                }else{
                    base.horizontalWidthArray.push(parseInt(base.options.defaultColWidth) + addition)
                    addition += parseInt(base.options.defaultColWidth);
                }
            }
        }


        function drawHDragger(){
            setHArrayIndex();

            var position = base.hDragg.draggerPositionX;
            //used to move Hdragger to left when pivot is enabled/opened to avoid overlapping of htrack width and dragger position and making sure Hdragger in htrack width visibility. 
            if((base.elements.htrack.width() < base.hDragg.draggerPositionX + base.hDragg.draggerWidth - 15) && (base.pivotChecked == "enabled")) {
                position = base.elements.htrack.width() - ( base.hDragg.draggerWidth + 4);
            } else if(base.hDragg.scrollPositionX > base.hDragg.scrollWidth) {
                position = base.elements.htrack.width() - ( base.hDragg.draggerWidth + 4);
            }            
            base.elements.hdragger.css('left',(position) + 'px');
            setHeader();
        }

        function setHArrayIndex(){

            var startIndexH = 0,
                endIndexH = 0,
                maxStartIndexH =  base.data.headerArray.length;

            while(base.horizontalWidthArray[startIndexH + 1] <= base.hDragg.scrollPositionX){
                startIndexH++;
            }

            endIndexH = startIndexH;
            while(base.horizontalWidthArray[endIndexH] <= base.hDragg.scrollPositionX + base.hDragg.scrollWindowWidth){
                endIndexH++;
            }


            if(startIndexH > base.hDragg.maxStartIndex ){
                startIndexH = base.hDragg.maxStartIndex
            }


            endIndexH += base.options.colBuffer;
            base.hDragg.startIndex = startIndexH;
            base.hDragg.endIndex = endIndexH;

        }


        function scrollRight(){
            if( base.hDragg.endIndex < base.data.fixedHeaderSafeCopyArr.length + 2 ){
                var currentPosition = base.horizontalWidthArray[base.hDragg.startIndex +1];
                base.hDragg.scrollPositionX = currentPosition;
                base.hDragg.draggerPositionX = Math.round(base.hDragg.scrollPositionX * base.hDragg.trackRatio);
                drawHDragger();
                buildHeaderDom();
                buildBodyDom();
            }
        }


        function scrollLeft(){

            if( base.hDragg.startIndex > 0 ){
                var currentPosition = base.horizontalWidthArray[base.hDragg.startIndex -1];

                base.hDragg.scrollPositionX = currentPosition -1;
                base.hDragg.draggerPositionX = Math.round(base.hDragg.scrollPositionX * base.hDragg.trackRatio);

                drawHDragger();
                buildHeaderDom();
                buildBodyDom();

            }else{
                base.hDragg.scrollPositionX = 0;
                base.hDragg.draggerPositionX = 0;
                drawHDragger();
            }

        }


        function pageLeft(){

            if( base.hDragg.startIndex >  0 ){
                var index = (base.hDragg.startIndex - ( base.hDragg.endIndex - base.hDragg.startIndex) < 0 ) ? 0 : (base.hDragg.startIndex - ( base.hDragg.endIndex - base.hDragg.startIndex) - 1);
                //hack to avoid -1 ^
                if(index < 0 ){
                    index = 0;
                }

                var currentPosition = base.horizontalWidthArray[index];
                base.hDragg.scrollPositionX = currentPosition -1;
                base.hDragg.draggerPositionX = Math.round(base.hDragg.scrollPositionX * base.hDragg.trackRatio);

                drawHDragger();
                buildHeaderDom();
                buildBodyDom();

            }else{
                base.hDragg.scrollPositionX = 0;
                base.hDragg.draggerPositionX = 0;
                drawHDragger();
            }
        }

        function pageRight(){
            if( base.hDragg.endIndex < base.data.fixedHeaderSafeCopyArr.length + 2 ){
                var endIndexH = base.hDragg.startIndex;
                while(base.horizontalWidthArray[endIndexH] <= base.hDragg.scrollPositionX + base.hDragg.scrollWindowWidth){
                    endIndexH++;
                }
                if(endIndexH > base.hDragg.maxStartIndex){
                    endIndexH = base.hDragg.maxStartIndex;
                }


                var currentPosition = base.horizontalWidthArray[endIndexH];
                base.hDragg.scrollPositionX = currentPosition;
                base.hDragg.draggerPositionX = Math.round(base.hDragg.scrollPositionX * base.hDragg.trackRatio);
                drawHDragger();
                buildHeaderDom();
                buildBodyDom();
            }
        }





        function findLastStartIndex(){
            var reverseArray = _.reverse(_.clone(base.horizontalWidthArray));
            var colWidths = 0;
            var counter = 0;
            while(colWidths <= base.hDragg.scrollWindowWidth){
                var start =  reverseArray[counter];
                var end =  reverseArray[counter + 1];
                var col = start - end;
                colWidths += col
                counter++
            }
            var startIndex = base.horizontalWidthArray.length - counter
            return startIndex
        }







///////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// START V-SCROLL FUNCTIONS /////////////////////////////////////////


        function findLastStartVIndex(){

            var gridHeight = base.elements.body.height();
            var rowHeight = 0;
            var index = base.data.dataArr.length - 1;

            if(base.data.dataArr.length < 0) {
                return 1;
            }


            while (rowHeight <= gridHeight) {
                if (typeof base.data.dataArr[index] == "undefined" || typeof base.data.dataArr[index].height == "undefined") {
                    rowHeight += base.options.defaultRowHeight;
                } else {
                    rowHeight += base.data.dataArr[index].height;
                }
                index--;
                if (index <= 0) {
                    break;
                }

            }
            index += 3;
            return index;

        }




        function buildVScrollBar(){

            var scrollHeight =  (base.layout.gridHeight) - (base.layout.scrollWindow - ( base.options.defaultRowHeight * 2) );
            var trackHeight = (base.elements.body.height() - base.elements.vbtns.height() ) - 3; //Remove 3 pixels to allow padding between dragger and scroll container
            var trackRatio = trackHeight / base.layout.gridHeight;
            var draggerHeight = trackHeight * trackRatio;


            if( draggerHeight < base.options.vDraggerMinHeight ){
                draggerHeight = base.options.vDraggerMinHeight;
            }

            trackHeight -= draggerHeight;
            trackRatio = trackHeight / scrollHeight;



            if(base.layout.gridHeight < base.layout.scrollWindow ){
                base.elements.vdragger.hide();
            }else if( !base.elements.vdragger.is(":visible")){
                base.elements.vdragger.show();
            }

            var scrollRatio = scrollHeight / trackHeight;
            base.vDragg.trackRatio = trackRatio;
            base.vDragg.draggerHeight = draggerHeight;
            base.vDragg.trackHeight = trackHeight;
            base.vDragg.scrollRatio = scrollRatio;
            base.vDragg.scrollHeight = scrollHeight;
            //SET DRAGGER HEIGHT
            base.elements.vdragger.height(draggerHeight+'px');

            if( base.vDragg.draggerPositionY > 0 && base.vDragg.preiviousTrackHeight != undefined ){
                var difference =  base.vDragg.trackHeight - base.vDragg.preiviousTrackHeight;
                base.vDragg.draggerPositionY += difference
            }

            base.vDragg.preiviousTrackHeight = trackHeight;
            drawVDragger();
        }


        function setRowHeightArr(){
            base.verticalHeightArray = [0];
            var addition = 0;
            for(var i = 0; i < base.data.dataArr.length; i++){

                if( base.data.dataArr[i].height != undefined ){
                    base.verticalHeightArray.push(parseInt(base.data.dataArr[i].height) + addition)
                    addition += parseInt(base.data.dataArr[i].height);
                }else{
                    base.verticalHeightArray.push(parseInt(base.options.defaultRowHeight) + addition)
                    addition += parseInt(base.options.defaultRowHeight);
                }
            }

            return addition;
        }





        function onScroll(event){
            if (!base || !base.elements) return;
            /////////////////////////////////////////
            // TODO: MAKE SCROLL DRAGGER SCROLL FROM CLICKED LOCATION NOT FROM TOP- ( MIGHT NEED to pass offset at mouse down point )
            /////////////////////////////////////////
            // var subtract = event.pageY - base.elements.vdragger.offset().top;
            var draggerHeight = (event.pageY - base.elements.body.offset().top) ;


            if( draggerHeight >=  0 && draggerHeight <= base.vDragg.trackHeight ){
                base.vDragg.draggerPositionY = draggerHeight ;
            }

            if( draggerHeight <=  0){
                base.vDragg.draggerPositionY = 0;
            }

            if( draggerHeight >=  base.vDragg.trackHeight){
                base.vDragg.draggerPositionY = base.vDragg.trackHeight;
            }

            base.vDragg.scrollPositionY = Math.round(base.vDragg.draggerPositionY * base.vDragg.scrollRatio);
            drawVDragger();
            buildBodyDom();

        }


        function drawVDragger(){
            setArrayIndex();
            base.elements.vdragger.css('top',base.vDragg.draggerPositionY + 'px');
        }

        function setArrayIndex(){

            var startIndexV = 0, endIndexV = 0;
            while(base.verticalHeightArray[startIndexV + 1] <= base.vDragg.scrollPositionY ){
                startIndexV++;
            }
            endIndexV = startIndexV;
            while(base.verticalHeightArray[endIndexV] <= base.vDragg.scrollPositionY + base.elements.body.height()){
                endIndexV++;
            }

            if(startIndexV >= base.vDragg.maxStartIndex ){
                startIndexV = base.vDragg.maxStartIndex - 1;
                base.vDragg.draggerPositionY = base.vDragg.trackHeight;
            }



            base.vDragg.startIndex = startIndexV;
            base.vDragg.endIndex =  endIndexV;

            /* to store the scroll position on top of tableState : 6/10/2021*/
           if(options.data.tableState){
               if((base.data.safeCopyArr.length != base.data.dataArr.length) && (options.data.tableState.colSearch.length >0 || !_.isEmpty(options.data.tableState.search))){
                    options.data.tableState.vScroll = base.vDragg;
               }
           }

        }

        // setVScroll
        function setVScroll(index){

            if(isNaN(index)){
                addAlert("alert-danger","<b>Error:</b> Numeric values only ",4000 );
                return false;
            }

            if(index > base.data.dataArr.length ){
                index = base.data.dataArr.length;
            }else if( index == 0 ){
                index = 1;
            }

            var height = base.verticalHeightArray[index - 1];

            base.vDragg.scrollPositionY = height;
            base.vDragg.draggerPositionY = Math.round(height / base.vDragg.scrollRatio);
            drawVDragger();
            buildBodyDom();

        }


        // setVScroll
        function setHScroll(index){

            if(isNaN(index)){
                addAlert("alert-danger","<b>Error:</b> Numeric values only ",4000 );
                return false;
            }

            if(index > base.data.headerArray.length ){
                index = base.data.headerArray.length;
            }else if( index == 0 ){
                index = 1;
            }

            var width = base.horizontalWidthArray[index - 1];

            base.hDragg.scrollPositionX = width;
            base.hDragg.draggerPositionX = Math.round(width / base.hDragg.scrollRatio);

            drawHDragger();
            buildHeaderDom();

        }



        function scrollDown(){
            base.vDragg.scrollPositionY += base.options.defaultRowHeight * base.options.vClickThroughNum;
            base.vDragg.draggerPositionY = Math.round(base.vDragg.scrollPositionY * base.vDragg.trackRatio);
            drawVDragger();
            buildBodyDom()
        }

        function scrollUp(){
            if( base.vDragg.scrollPositionY > 1 ){
                Math.abs(base.vDragg.scrollPositionY -= base.options.defaultRowHeight * base.options.vClickThroughNum);
                base.vDragg.draggerPositionY = Math.round(base.vDragg.scrollPositionY * base.vDragg.trackRatio);
                drawVDragger();
                buildBodyDom();
            }
        }


        function pageUp(){
            if( base.vDragg.startIndex >  1 ){
                var pageThroughNum = Math.floor(base.elements.body.height() / base.options.defaultRowHeight);
                base.vDragg.scrollPositionY -= base.options.defaultRowHeight * pageThroughNum;

                if( base.vDragg.scrollPositionY < 0 ){
                    base.vDragg.scrollPositionY = 0;
                }

                base.vDragg.draggerPositionY = (Math.round(base.vDragg.scrollPositionY * base.vDragg.trackRatio) >= 0) ?  Math.round(base.vDragg.scrollPositionY * base.vDragg.trackRatio) : 1;
                var vIndex = ( (base.vDragg.startIndex - pageThroughNum) >= 0 ) ? base.vDragg.startIndex - pageThroughNum : 0;
                var row_object_id = base.data.dataArr[vIndex].object_id;
                setSelected(base.selected.col_id,row_object_id,'cell');

                drawVDragger();
                buildBodyDom();
            }

        }

        function pageDown(){


            var pageThroughNum =  Math.floor(base.elements.body.height() / base.options.defaultRowHeight);


            if( base.vDragg.endIndex <=  base.data.dataArr.length ){
                base.vDragg.scrollPositionY += base.options.defaultRowHeight * pageThroughNum;
                base.vDragg.draggerPositionY = Math.round(base.vDragg.scrollPositionY * base.vDragg.trackRatio);

                var row_object_id = base.data.dataArr[base.vDragg.startIndex + pageThroughNum].object_id ;
                setSelected(base.selected.col_id,row_object_id,'cell');

                drawVDragger();
                buildBodyDom();

            }


        }




//////////////////////////////////////// END V-SCROLL FUNCTIONS /////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////// RESIZE COL FUNCTIONS ///////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////

        var colResizeObj = {}, colSizeHandler;

        function setColResizeObj(){
            colResizeObj = {
                startPosition:0,
                currentPosition:0,
                currentHeight:0,
                object_id:null,
                dragOn:false,
                minWidth:base.options.minColWidth
            }
        }



        function dragColHandler(event){

           // var $element = $(event.data.element);
           var eventElem = (event.data);
           var $element = $(eventElem.element);

            if(!colResizeObj.dragOn){
                colResizeObj.startPosition = event.pageX;
                colResizeObj.object_id = $element.parent().attr("colobj")
            }

            colResizeObj.dragOn = true;
            colResizeObj.currentPosition = event.pageX;


            base.elements.resizeColLine.show();
            base.elements.resizeColLine.css('top', base.elements.header.position().top + 'px' );
            base.elements.resizeColLine.css('left',event.pageX+'px');
            base.elements.resizeColLine.css('height', ( base.elements.body.height()+base.elements.header.height())+'px');

        }


        function dragColHandlerEnd(event){
            base.elements.resizeColLine.hide();
            var col_id = colResizeObj.object_id;
            var curDataCol = _.find(base.data.headerArray, {'object_id':col_id});

            if( curDataCol != undefined ){
                var newWidth =  curDataCol.width + (colResizeObj.currentPosition - colResizeObj.startPosition);
                if( newWidth < colResizeObj.minWidth){
                    curDataCol.width = colResizeObj.minWidth;
                }else{
                    curDataCol.width = newWidth;
                }
                setColResizeObj();
                buildGrid();
            }
        }


////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////// RESIZE ROW FUNCTIONS /////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////

        var rowSizeHandler, rowResizeObj = {}

        function setRowResizeObj(){
            rowResizeObj = {
                startPosition:0,
                currentPosition:0,
                currentHeight:0,
                object_id:null,
                dragOn:false,
                minHeight: base.options.minRowHeight

            }
        }

        function dragRowHandlerEnd(event){


            base.elements.resizeRowLine.hide();
            var row_id = rowResizeObj.object_id;
            var curDataRow;
            if (row_id === '-1') {
                curDataRow = base.headerRow = base.headerRow || {};
            } else {
                curDataRow = _.find(base.data.dataArr, {'object_id':row_id});
            }


            if(typeof curDataRow === 'undefined'){
                return false;
            }


            if( curDataRow.height === undefined ){
                curDataRow.height = base.options.defaultRowHeight;
            }



            if( curDataRow != undefined ){
                var newHeight =  curDataRow.height + (rowResizeObj.currentPosition - rowResizeObj.startPosition);
                // ***** Make Sure we are greater then  rowResizeObj.minHeight
                if( newHeight < rowResizeObj.minHeight){
                    curDataRow.height = rowResizeObj.minHeight;
                }else{
                    curDataRow.height = newHeight;
                }
                setRowResizeObj();
                buildGrid();
            }
        };


        function dragRowHandler(event){
           /// var $element = $(event.data.element);
           var eventElem = (event.data);
           var $element = $(eventElem.element);

            if(!rowResizeObj.dragOn){
                rowResizeObj.startPosition = event.pageY;
                rowResizeObj.object_id = $element.parent().parent().attr("rowobj")
            }
            rowResizeObj.dragOn = true;
            rowResizeObj.currentPosition = event.pageY;
            base.elements.resizeRowLine.show();
            base.elements.resizeRowLine.css('top',event.pageY+'px');
            base.elements.resizeRowLine.css('left',base.$el.offset().left + 'px');
        }






//////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////  REORDER COLUMNS  ////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////

        var colReorderObj = {}

        function setColReorderObj(){
            colReorderObj = {
                startPosition:0,
                currentPosition:0,
                currentHeight:0,
                object_id:null,
                dragOn:false,
                blockOffset:0,
                target_object_id:null,
                minWidth:50
            }
        }

        function dragReorderColHandler(event){
           // var $element = $(event.data.element)
           var eventElem = (event.data);
           var $element = $(eventElem.element);


            if(!colReorderObj.dragOn){
                colReorderObj.startPosition = event.pageX;
                colReorderObj.object_id = $element.attr("colobj");
                base.elements.resizeColBlock.css('left',event.pageX+'px');
                base.elements.resizeColBlock.width($element.width());
                base.elements.resizeColBlock.show();
                colReorderObj.blockOffset = event.pageX - $element.offset().left;
            }

            colReorderObj.dragOn = true;
            colReorderObj.currentPosition = event.pageX;
            colReorderObj.target_object_id = getColByWidth(event.pageX);

            if (colReorderObj.target_object_id != null) {
                showColIndicator(colReorderObj.target_object_id);
            }
            base.elements.resizeColBlock.show();
            base.elements.resizeColBlock.height(base.elements.body.height());
            if(options.data && options.data.fromModal && options.data.fromModal ==  true) { //alignments adjustments for grid on modal..
                base.elements.resizeColBlock.css('top', 128 +'px');
                base.elements.resizeColBlock.css('left',((event.pageX - colReorderObj.blockOffset) - (document.querySelector(base.elements.selection.selector).offsetWidth/2))+'px');
            } else {
                base.elements.resizeColBlock.css('top',base.elements.body.offset().top+'px');
                base.elements.resizeColBlock.css('left',(event.pageX - colReorderObj.blockOffset)+'px');
            }

        }


        function showColIndicator(_object_id){
            if (_object_id == null) {
                return;
            }
            var element = $("[colobj='"+_object_id+"']");
            if (!element.length) {
                return;
            }
            var elementOffset = element.offset();
            if (!elementOffset) {
                return;
            }
            var bodyOffset = base.elements.body.offset();
            if (!bodyOffset) {
                return;
            }

            base.elements.colLine.show();
            base.elements.colLine.height(base.elements.body.height());
            if(options.data && options.data.fromModal !=undefined && options.data.fromModal){  //these styles will apply only when call the grid on Modal 8/19/2021
                base.elements.colLine.css('left', (elementOffset.left + (element.width()/2)) +'px');// need to change as it was fixed to only a perticlular resolution..
                base.elements.colLine.css('top', bodyOffset.top - 64 +'px');


            }else{
                base.elements.colLine.css('top', bodyOffset.top+'px');
                base.elements.colLine.css('left', (elementOffset.left + element.width()) +'px');
            }
        }





        //TODO: how to reorder with new safe array
        function dragReorderColHandlerEnd(event){
            base.elements.resizeColBlock.hide();
            base.elements.colLine.hide();
            var toMove = _.findIndex(base.data.headerArraySafe, { 'object_id': colReorderObj.object_id });
            var toWhere = _.findIndex(base.data.headerArraySafe, { 'object_id': colReorderObj.target_object_id });

            if( toMove > 0 && toWhere > 0){
                if(toWhere == 0 ){
                    toWhere ++;
                }
                arraymove(base.data.headerArraySafe,toMove, toWhere);
                setColReorderObj();
                buildGrid();
            }
        };



        function arraymove(arr, fromIndex, toIndex) {
            var element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
        }







        function getColByWidth(_mouseX){
            if (!base.data.headerArray || !base.data.headerArray.length) {
                return null;
            }

            var leftColOffset = base.elements.ggleftcol.offset();
            if (!leftColOffset) {
                return null;
            }
            var hScrollPosition  =  leftColOffset.left + base.elements.ggleftcol.width();
            if( _mouseX > hScrollPosition &&  base.hDragg.scrollPositionX > 0){
                _mouseX =  base.horizontalWidthArray[base.hDragg.startIndex] + _mouseX;
                // _mouseX += base.hDragg.scrollPositionX;
            }

            var offsetLeft = base.$el.offset().left,
                previousX = offsetLeft,
                currentX = offsetLeft,
                returnobj_id = null

            for (var i = 0; i < base.data.headerArray.length; i++) {
                currentX += base.data.headerArray[i].width;
                if( _mouseX >=  previousX && _mouseX <=  currentX  ){
                    returnobj_id = base.data.headerArray[i].object_id;
                    return returnobj_id;
                }
                previousX = currentX;
            }

            return returnobj_id;
        }




////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// FIXED COLUMNS  ////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////

        var colFixedObj = {};

        function setColFixedObj(){
            colFixedObj = {
                startPosition:0,
                currentPosition:0,
                currentHeight:0,
                object_id:null,
                dragOn:false,
                target_object_id:null
            }
        }

////////////////RIGHT HERE
        function positionColFreezeHandle(){
            if (!base.data.headerArray || !base.data.headerArray.length) {
                return;
            }

            var top = base.elements.header.offset().top + 1;
            var left = base.layout.offset.left;

            var height = base.elements.body.height() + base.elements.header.height() -1;
            var fixedColumns = ( base.options.fixedColumn > base.data.headerArray.length )? base.data.headerArray.length : base.options.fixedColumn;
            var width = getWidthTotal(base.data.headerArray,'width',fixedColumns);

            
            base.elements.fixColHandler.height(height);
            if(options.data && options.data.fromModal !=undefined && options.data.fromModal){ // these styles will apply only when call the grid on Modal 8/19/2021
                base.elements.fixColHandler.css('left', width+'px');
                base.elements.fixColHandler.css('top',top - 64 +'px');
            }else{
                base.elements.fixColHandler.css('left',left + width+'px');
                base.elements.fixColHandler.css('top',top+'px');
            }
            

        }



        function dragFixedColHandler(event){
           // var $element = $(event.data.element);
           var eventElem = (event.data);
           var $element = $(eventElem.element);

            if (!base.data.headerArray || !base.data.headerArray.length) {
                return;
            }

            base.elements.fixColHandler.css('left',(event.pageX)+'px');
            colFixedObj.dragOn = true;
            colFixedObj.currentPosition = event.pageX;
            colFixedObj.target_object_id = getColByWidth(event.pageX);

            if(colFixedObj.target_object_id === null && base.data.headerArray[0]){
                colFixedObj.target_object_id = base.data.headerArray[0].object_id;
            }

            if (colFixedObj.target_object_id != null) {
                showColIndicator(colFixedObj.target_object_id);
            }
        }


        function dragFixedColHandlerEnd(event){
            if( colFixedObj.target_object_id != undefined ){
                base.options.fixedColumn = _.findIndex(base.data.headerArray, { object_id: colFixedObj.target_object_id }) + 1;
                if( base.options.fixedColumn < 1 ){
                    base.options.fixedColumn = 1;
                }
                base.elements.colLine.hide();
                setColFixedObj();
                buildGrid();
            }

        }


        function getWidthTotal(_array,_property,_index){


            var width = 0;
            for (var i = 0; i < _index; i++) {
                width += _array[i][_property];
            }


            return width;
        }


        function selectRowGroup(row_id){
            var col_id =  base.data.headerArray[1].map;
            setSelected(col_id,row_id,'row',true);
        }


        function selectRow(_element,_ctrlClick){
            var row_id = _element.attr('rowobj');
            var col_id =  base.data.headerArray[1].map;
            setSelected(col_id,row_id,'row',_ctrlClick);
        }



        function selectCol(map,_ctrlClick){
            if( base.data.dataArr.length){
                var row_id = base.data.dataArr[0].object_id;
                var map  = _.find(base.data.headerArray, {'map': map}).map;
                setSelected(map,row_id,'header',_ctrlClick);
            }
        }


        // Quote attribute selectors. Column maps on form columns can contain
        // spaces, parentheses, or "+" (for example the 1120L Schedule F
        // unallocated-amount headers). An unquoted [map=...] / [obj_id=...]
        // selector throws, and that abort happens before double-click can
        // open the modal. The pencil click never builds this selector.
        function attrEquals(name, value) {
            var safe = String(value == null ? '' : value)
                .replace(/\\/g, '\\\\')
                .replace(/"/g, '\\"');
            return '[' + name + '="' + safe + '"]';
        }

        function selectCell(element,type,event){
            var $cell = $(element);
            var obj_id = $cell.attr('obj_id');
            var row_id = $cell.attr('rowobj');
            if (row_id == null || row_id === '') {
                row_id = $cell.parent().attr('rowobj');
            }
            var col_id = $cell.attr('colobj');
            setSelected(col_id,row_id,'cell');
            //BATCH

            //base.renderSelected.clearAll();

            if(col_id === "batchSelect" && event.which === 1 ){
                base.batch.select();
            }
        }


        function setDefaultSelect(){


            if( base.data.dataArr.length && ( base.selected.row_id === null ||  base.selected.col_id === null) ){
                var headers = base.data.headerArray;
                if (!headers || !headers.length) {
                    return false;
                }
                // Legacy default targets the second visible column when available.
                // Batch-import reloads can temporarily expose only one visible column.
                var colHeader = headers.length > 1 ? headers[1] : headers[0];
                if (!colHeader || !colHeader.map) {
                    return false;
                }
                var map = colHeader.map;
                var row_id = base.data.dataArr[0].object_id;
                setSelected(map,row_id,'cell');
                base.$el.find('.gg-body').focus();
                return true;
            }else{
                //TODO: MAKE THIS WORK WITH GROUP SELECTIONS : ON CHAN
                setSelected(base.selected.col_id,base.selected.row_id,'cell',false);
            }



            return false;
        }


        base.gridSelect = {
            reset: function() {
                resetSelectedValue()
            }
        }


        function resetSelectedValue(){
            base.largeText.hide();
            $('.div-col',base.$el).removeClass("selected_input");
            $('.div-row',base.$el).removeClass("selected-row");
            $('.headerCol',base.$el).removeClass("selected-col-header");
            $('.div-col',base.$el).removeClass("selected-col");
            $('.div-col-prime',base.$el).removeClass("selected-prime-row");
            $('.div-row',base.$el).removeClass("selection-row");

            base.elements.editValue.hide();
            base.elements.editValue.html("");
            base.selected.color = "green";
            base.selected.select_type=null;
            base.selected.row_id=null;
            base.selected.col_id=null;
            base.selected.obj_id=null;
            base.selected.data_type=null;
            base.selected.edit_type=null;
            base.selected.validation=null;
            base.selected.action=null;
            base.selected.format=null;
            base.selected.value=null;
            base.selected.oldValue=null;
            base.selected.rowData=null;
            base.selected.editable='n';
            base.selected.new_row_editable = '0';
            base.selected.element=null;
            base.selected.edit_type = null;
            base.selected.static_values = null;
        }

        //setSelected



        function setSelected(col_id,row_id,type,ctrlClick){

            //  console.log("=========================================");
            //   console.log("col_id" , col_id);
            //  console.log("row_id" , row_id);
            //   console.log("type" , type);


            if(  base.data.dataArr.length <= 0){
                //addAlert("alert-warn","Cell could not be selected",1000 );
                return;
            }


            //DO WE HAVE A GROUP
            if(!ctrlClick === true){
                base.selectedGroup = [];
            }

            resetSelectedValue();

            var curDataCol = _.find(base.data.headerArray, {'map':col_id});


            //Checks to see if a column that might of been hidden had the selected cell. If so we call setDefaultSelect()
            if(typeof curDataCol === 'undefined'  ){
                base.selected.row_id = null;
                setDefaultSelect();
                return false;
            }


            var curDataRow  = _.find(base.data.safeCopyArr, {'object_id':row_id});


            if(typeof curDataRow === 'undefined'  ) {
                base.selected.row_id = null;
                setDefaultSelect();
                return false;
            }

            var element =  $(attrEquals("obj_id", row_id + "-" + col_id), base.$el);

            base.selected.select_type = type;
            base.selected.col_id = curDataCol.map;
            base.selected.row_id = curDataRow.object_id;
            base.selected.obj_id = base.selected.row_id + "-" +  base.selected.col_id;
            base.selected.format = curDataCol.format;
            base.selected.validation = curDataCol.validation;
            base.selected.data_type = curDataCol.data_type;
            base.selected.action = curDataCol.action;
            base.selected.value = curDataRow[curDataCol.map];
            base.selected.oldValue = curDataRow[curDataCol.map];
            base.selected.rowData = curDataRow;
            base.selected.colData = curDataCol;
            base.selected.editable = curDataCol.editable;
            base.selected.element = element;
            base.selected.new_row_editable = (curDataCol.new_row_editable) ? curDataCol.new_row_editable : '0' ;
            base.selected.edit_type = curDataCol.edit_type;
            base.selected.static_values = curDataCol.static_values;


            if(type === 'cell' ){
                //base.renderSelected.renderType = "cellGroup";
                base.renderSelected.setDefaultCell(base.selected);
                // base.largeText.show();
                if(base.selected.edit_type === "comments"){
                    base.largeText.show();
                }
                /* added by Divya 9/22/2019 */
               else if(base.selected.edit_type === "attachments"){
                    base.largeText.show();
                }
            }

           /*  if(type === 'cell' ){
                //base.renderSelected.renderType = "cellGroup";
                base.renderSelected.setDefaultCell(base.selected);
                // base.largeText.show();
                if(base.selected.edit_type === "attachments"){
                    base.largeText.show();
                }
            } */

            options.data.selected = base.selected;
            // $(element).addClass('selected_input');

            //todo: do not allow mix of select type in selectedGroup: cell,header,row
            if( typeof  _.find(base.selectedGroup , {'obj_id':base.selected.obj_id } ) === 'undefined'     ){
                base.selectedGroup.push(_.clone(base.selected));
            }


            base.renderSelected.renderSelected();


            // IF FOUCS IS IN globalSearch DO NOT SET FOCUS ON GRID
            if (base.elements.globalSearch.is(':focus')){
                return true;
            }

            base.focus.gridBody.focus();
            return true;

        }


        function scrollToSelected(_vIndex,_hIndex){
            if( _vIndex <  base.vDragg.startIndex ||  _vIndex > base.vDragg.endIndex ){
                setVScroll(_vIndex);
            }

            if( _hIndex <  base.hDragg.startIndex ||  _hIndex > base.hDragg.endIndex ){
                // setHScroll(_hIndex);
            }
        }



        function arrowMove(_direction){

            var newVIndex = null,
                newHIndex = null,
                vIndex = _.findIndex(base.data.dataArr, {'object_id': base.selected.row_id}),
                hIndex = _.findIndex(base.data.headerArray, {'map': base.selected.col_id})
            if(_direction === 'up' && vIndex > 0){
                base.renderSelected.clearAll();

                newVIndex = vIndex - 1;
                if( newVIndex < base.vDragg.startIndex){
                    scrollUp();
                }
                scrollToSelected(vIndex,hIndex);
                var row_object_id = base.data.dataArr[newVIndex].object_id;
                setSelected(base.selected.col_id,row_object_id,'cell');


            }else if ( _direction === 'down' && vIndex < base.data.dataArr.length -1 ){
                base.renderSelected.clearAll();
                newVIndex = vIndex + 1;
                if( newVIndex >= base.vDragg.endIndex){
                    scrollDown();
                }
                scrollToSelected(vIndex,hIndex);
                var row_object_id = base.data.dataArr[newVIndex].object_id;
                setSelected(base.selected.col_id,row_object_id,'cell');

            }else if(_direction === 'left' &&  hIndex > 1){
                                base.renderSelected.clearAll();

                newHIndex = hIndex - 1;
               
                if( (newHIndex - base.options.fixedColumn) <= base.hDragg.startIndex - 1){
                    scrollLeft();
                }
                var col_object_id = base.data.headerArray[newHIndex].map;
                setSelected(col_object_id,base.selected.row_id,'cell');

            }else if(_direction === 'right' && hIndex < base.data.headerArray.length){
                newHIndex = hIndex + 1;
                base.renderSelected.clearAll();


                if( newHIndex === base.options.fixedColumn && base.hDragg.startIndex > 0  ){
                    resetHScroll();
                }

                if( (newHIndex - base.options.fixedColumn) >= base.hDragg.endIndex - 2 ){
                    scrollRight();
                }

                if(newHIndex < base.data.headerArray.length) {
                    var col_object_id = base.data.headerArray[newHIndex].map;
                }else{
                    var col_object_id = base.data.headerArray[newHIndex-1].map;
                }

                var element = base.$el.find("[obj_id='" + base.selected.row_id + "-" + col_object_id + "']");
                setSelected(col_object_id,base.selected.row_id,'cell');

            }


        }



////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// batchSelecter ////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////



        base.batch = {
            maxSelectAll:3500,
            select: function() {

                var batchObj = {row_id:base.selected.row_id,data:base.selected.rowData};


                if(base.selected.rowData === null  ){
                    return false
                }



                if(base.selected.rowData.ggNotEditable  ){
                    var msg = ( options.data.settings.batch_rule_message) ? options.data.settings.batch_rule_message : 'Row is not Selectable'
                    addAlert("alert-warn",msg,1000 );
                    return
                }



                if ( base.selected.rowData.batchSelect) {
                    delete base.selected.rowData.batchSelect;
                    _.remove(base.batchSelect, {'row_id': base.selected.row_id});
                } else {
                    batchObj.data.batchSelect = "true";
                    base.batchSelect.push(batchObj);
                }
                hideContextMenu();
                
                buildBodyDom();


            },



            //-here

            unSelectNonEditable: function(){
                if( base.selected.rowData.ggNotEditable &&  _.find(base.batchSelect,{ 'row_id': base.selected.row_id})  ){
                    delete base.selected.rowData.batchSelect;
                    _.remove(base.batchSelect, {'row_id': base.selected.row_id});
                }
                buildBodyDom();
            },



            setBatchSelected: function(){

                /* TODO: PROMT USER FOR NOW WE WILL NOT KEEP ITEMS CHECKED
                 var batchArray =  _.filter( base.data.dataArr, {batchSelect:"true"});
                 _.forEach( batchArray, function(value, key) {
                 ////////console.log("value : ------------------  " , value)
                 var batchObj = {row_id:value.object_id,data:value};
                 base.batchSelect.push(batchObj);
                 })
                 */

                base.batchSelect = [];
                

            },

            removeBatchSelectn: function(isRemoved,batchSelect){
                var bdata = {};
                bdata.batchSelect=batchSelect;
                bdata.removeBatchSelection = isRemoved;
                if( options.data.settings.batch_select == 1){
                    base.api.callBack( 'removeBatchSelect',bdata,'removeBatchSelect');
                }
            },

            setSelectedFromBatch: function(){

                /* TODO: PROMT USER FOR NOW WE WILL NOT KEEP ITEMS CHECKED
                 if(base.batchSelect.length > 0 ){
                 _.forEach( base.batchSelect, function(value, key) {
                 var obj = _.find(base.data.dataArr, { 'object_id': value.row_id });
                 obj.batchSelect = "true"
                 base.batchSelect[key].data = obj;
                 })

                 }
                 */
                base.batchSelect = [];
                this.removeBatchSelectn(base.removeBatchSelection,base.batchSelect);
            },

            selectRow: function(){
                this.select();
            },

      
            unselectAll: function(){
                _.forEach( base.batchSelect, function(value, key) {
                    _.remove(base.batchSelect, {'row_id': value.data.row_id});
                    var obj = _.find(base.data.dataArr, { 'object_id': value.row_id });

                    if(typeof obj != "undefined" && typeof obj.batchSelect != "undefined"){
                        delete obj.batchSelect;
                    }
                });

                base.batchSelect = [];
                this.removeBatchSelectn(base.removeBatchSelection,base.batchSelect);
                buildBodyDom();
            },


            selectAll: function(){
                this.unselectAll();
                if( base.data.dataArr.length > this.maxSelectAll  ){
                    var message = "You cannot select more than "+this.maxSelectAll + " at one time. Please use the filters to reduce your selection. ";
                    addAlert("alert-warn",message,4000 );
                    return false;            }
                _.forEach( base.data.dataArr, function(value, key) {


                    if( value.ggNotEditable  ) {


                    }else{
                        value.batchSelect = "true";
                        var batchObj = {row_id: value.object_id, data: value};
                        base.batchSelect.push(batchObj)

                    }

                });
                    this.removeBatchSelectn(!base.removeBatchSelection,base.batchSelect);
                buildBodyDom();
            }

        }



////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////  base.edit  //////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////


        base.edit = {

            visible: true,
            keyDown: function (e,focus) {


                if( typeof base.selected.colData.edit_rules != "undefined" && !base.buildDom.isRowColEditable(base.selected.rowData,base.selected.colData.edit_rules)  ) {
                    var msg = ( base.selected.colData.edit_rule_message) ? base.selected.colData.edit_rule_message : 'Cell is not Editable'
                    addAlert("alert-warn",msg,1000 );
                    return false;
                }

                if(base.selected.edit_type == 'form' && base.selected.colData.edit_icon == 'download'){
                    console.log("downladfsdf");
                  //  this.downloadAllDoc(base.selected.row_id);
                }else if( base.selected.edit_type == 'form'){
                    this.modalFrom();
                }else if( base.selected.edit_type == 'dropdown'){
                    this.dropDownEdit('',false);
                }else if(base.selected.edit_type === 'checkbox' && base.selected.editable === 'y'){
                    this.textAreaEdit(e,focus);
                    //TODO: See if this needs to be removed
                }else if (base.selected.edit_type === 'checkbox'){

                }
                else if( base.selected.editable === 'y'  ){
                    this.textAreaEdit(e,focus);
                }else if(  base.options.gridType === 'batch-save' &&  _.indexOf(base.data.newRow, base.selected.row_id)  > -1 && base.selected.new_row_editable === '1'  ){
                    this.textAreaEdit(e,focus);
                }else{
                    if( e.which != 16 ){
                        addAlert("alert-warn","This cell is not editable",4000 );
                    }else{
                        return true;
                    }
                }


            },

            editCell: function() {

                if (!base.selected || !base.selected.colData) {
                    return false;
                }

                if( typeof base.selected.colData.edit_rules != "undefined" && !base.buildDom.isRowColEditable(base.selected.rowData,base.selected.colData.edit_rules)  ) {
                    var msg = ( base.selected.colData.edit_rule_message) ? base.selected.colData.edit_rule_message : 'Cell is not Editable'
                    addAlert("alert-warn",msg,1000 );
                    return false;
                }

                if(base.selected.edit_type == 'form' && base.selected.colData.edit_icon == 'download'){
                    console.log("downladfsdf");
                   // this.downloadAllDoc(base.selected.row_id);
                }else if( base.selected.edit_type == 'form'){

                    console.log("dsfkadsfsdfdsafjasd;lfjasdfjasjjalskdfjasdfjadsfj")

                    this.modalFrom();
                }else if( base.selected.edit_type == 'dropdown'){
                    this.dropDownEdit('',false);
                }else if( base.selected.edit_type == 'comments'){
                    base.largeText.edit();
                }else if(base.selected.editable === 'y' ){
                    this.textAreaEdit('',false);
                }else if(  base.options.gridType === 'batch-save' &&  _.indexOf(base.data.newRow, base.selected.row_id)  > -1 && base.selected.new_row_editable === '1'    ){
                    this.textAreaEdit('',false);
                }else if (base.selected.edit_type == 'attachments'){
                    base.largeText.edit();
                }
                else{
                    addAlert("alert-warn","This cell is not editable",2000);
                }
            },


            pasteCell: function(_val){

                if( typeof base.selected.colData.edit_rules != "undefined" && !base.buildDom.isRowColEditable(base.selected.rowData,base.selected.colData.edit_rules)  ) {
                    var msg = ( base.selected.colData.edit_rule_message) ? base.selected.colData.edit_rule_message : 'Cell is not Editable'
                    addAlert("alert-warn",msg,1000 );
                    return false;
                }

                if(base.selected.editable === 'y' &&  base.selected.edit_type === 'text' ){
                    this.setValue(_val);
                }else if(  base.options.gridType === 'batch-save' &&  _.indexOf(base.data.newRow, base.selected.row_id)  > -1  && base.selected.new_row_editable === '1'   ){
                    this.setValue(_val);
                }else if(  base.selected.editable === 'y' &&  base.selected.edit_type === 'dropdown'  ){
                    this.checkDropDown(_val);
                }else{
                    addAlert("alert-warn","This cell is not editable",2000 );
                }
            },



            copy: function(){
                var type = "";
                var copyArray = [];
                var columnArray = [];

                if( base.selectedGroup == 'all'){
                    var csv = this.ConvertToCSV(base.data.dataArr)
                    return csv;
                }

                _.forEach( base.selectedGroup, function(value, key) {
                    if(value.select_type === 'row' ){
                        type = "row";
                        copyArray.push(value.rowData)
                    }else if( value.select_type === 'header' ){
                        type = "header";
                        columnArray.push(value.col_id);
                    }else if( base.renderSelected.renderType === "cellGroup" ){
                        type = "cellGroup";
                        columnArray.push(value.col_id);

                    }else if( value.select_type === 'cell' ){
                        type = "cell";
                    }


                });


                switch (type) {
                    case "cell":

                        return base.edit.copyCell();
                        break;

                    case "cellGroup":

                        var headers = _.uniq(columnArray);
                        var array = this.copyCellGroup(base.selectedGroup,headers);
                        var csv = this.ConvertToCSV(array,headers)
                        return csv;
                        break;
                    case "header":
                        var copyArray = base.edit.reduceByColumns(columnArray);
                        var csv = this.ConvertToCSV(copyArray)
                        return csv;
                        break;s
                    case "row":
                        return base.edit.copyRow(copyArray);
                        break;
                }


            },




            copyCol: function(){

            },


            copyCell: function(){
                return base.selected.value;
            },


            copyCellGroup: function(_array,_headers){
                var array = [];
                _.forEach( _array, function(value, key) {
                    array.push(value.row_id)
                });
                return this.reduceByColumnsRows(array,_headers);
            },


            copyRow: function(_array){
                var csv = this.ConvertToCSV(_array)
                return csv;
            },


            ConvertToXlsTable: function(objArray) {
                var str = '<table><tr><td style="background-color: #0d0d0d">test1</td><td>test2</td><td>test3</td><td>test3</td></tr></table>';
            },

            ConvertToCSV: function(objArray) {
                var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
                var str = '';
                for (var i = 0; i < array.length; i++) {
                    var line = '';
                    for (var index in array[i]) {
                        if (line != '') line += '\t'

                        line += array[i][index];
                    }

                    str += line + '\r\n';
                }
                return str;
            },


            reduceByColumns: function(_headers){
                var returnArray = [];
                _.forEach( base.data.dataArr, function(value, key) {
                    var row = {};
                    var obj = _.pick(value, _headers);
                    returnArray.push(obj);
                });
                return returnArray;
            },


            reduceByColumnsRows: function(_rows,_headers){
                var returnArray = [];
                var filtered = _.findByValues(base.data.dataArr, "object_id", _rows);

                _.forEach( filtered, function(value, key) {
                    var row = {};
                    var obj = _.pick(value, _headers);
                    returnArray.push(obj);
                });


                return returnArray;
            },






            autoComplete: function(){
                //TODO: ADD AUTO COMPLETE
                //AUTO COMPLETE  //// REQUIRES | https://github.com/devbridge/jQuery-Autocomplete

            },

            selectCalendar: function(){

            },

            dropDown: function(){

            },


            checkAreaEdit: function (e,focus) {
                var element = base.selected.element;
                var value = 1;

                if( typeof base.selected.value == "undefined" ){
                    value = 1;
                }else{
                    value = ( base.selected.value == 1 ) ? 0 : 1;
                }


                base.edit.setValue(value);
                buildGrid();
            },





            buildSelectOptions: function(values,selected){
                var  htmlString = "<select>";
                _.forEach( values, function(value, key) {
                    if( value.value === selected ){
                        htmlString += "<option selected value='"+value.value+"'>"+value.label+"</option>";
                    }else{
                        htmlString += "<option  value='"+value.value+"'>"+value.label+"</option>";
                    }
                });
                htmlString += "<select>";
                return htmlString;
            },


            checkDropDown: function (_val) {
                var validated = false;
                var values = JSON.parse(base.selected.static_values)
                _.forEach( values, function(value, key) {
                    if(value.value == _val ){
                        validated = true;
                    }
                });

                if(validated){
                    this.setValue(_val);
                    return true;
                }else{
                    addAlert("alert-warn",_val + " is not a valid input. Double click to see valid inputs",4000 );
                    return false;
                }


            },

            dropDownEdit: function (e,focus) {
                var element = base.selected.element;
                if(    base.selected.static_values === null ){
                    addAlert("alert-warn","no values have been set for this drop down",4000 );
                    return false;
                }

                var inputDropMenu = $(base.edit.buildSelectOptions(JSON.parse(base.selected.static_values),base.selected.value));

                base.elements.editValue.append(inputDropMenu);
                base.selected.changed = true;
                base.elements.editValue.show();
                inputDropMenu.css('width', $(element).width() );
                inputDropMenu.css('height', $(element).height() );

                base.elements.editValue.css('top', $(element).offset().top + 'px');
                base.elements.editValue.css('left', $(element).offset().left + 'px');
                base.elements.editValue.css('width', $(element).width());

                inputDropMenu.focus();
                inputDropMenu.change(function () {
                    base.edit.setValue($( this ).val());
                })

                inputDropMenu.focus();

            },






            textAreaEdit: function (e,focus) {

                inputText.focus();
                var element = base.selected.element;
                var code = e.keyCode || e.which;
                var input = String.fromCharCode(code).toLowerCase();


                if(code === 8 || code === 16){
                    var input = "";
                }


                base.elements.editValue.unbind('keydown');


                if(base.selected.edit_type == 'text' ){
                    base.selected.changed = true;
                    base.elements.editValue.html("");
                    base.elements.editValue.show();
                    inputText.css('width', $(element).width() );
                    inputText.css('height', $(element).height() );

                    if ((code >= 96 && code <= 111)  || (code >= 185 && code <= 193) ){
                        input = this.getKeyBoardKeys(code)
                    }

                    if( !focus){
                        input = base.selected.value || "";
                        inputText.val(input);
                    }else{
                        inputText.val(input);
                    }

                    base.elements.editValue.append(inputText);
                    inputText.focus();

                    if( focus) {
                        base.elements.editValue.bind("keydown", function (e) {
                            var arrowCode = e.keyCode || e.which;
                            if (arrowCode === 37 || arrowCode === 38 || arrowCode === 39 || arrowCode === 40) {
                                base.$el.find('.gg-body').focus();
                                if(options.data.pivotGroup){
                                    base.$el.find('.gg-body.isPivot-gridLayout').focus();
                                }
                                base.elements.editValue.unbind('keydown');
                                if (arrowCode == '38') {
                                    base.arrowMove("up");
                                }
                                else if (arrowCode == '40') {
                                    base.arrowMove("down");
                                }
                                else if (arrowCode == '37') {
                                    base.arrowMove("left");
                                }
                                else if (arrowCode == '39') {
                                    base.arrowMove("right");
                                }
                            }
                        })
                    }
                }


                if(options.data && options.data.fromModal && options.data.fromModal == true) { //alignments adjustments for grid on modal..
                    base.elements.editValue.css('top', $(element).offset().top - 64 + 'px');
                    base.elements.editValue.css('left', (document.querySelector(base.elements.selection.selector).offsetLeft + 8) + 'px');
                    base.elements.editValue.css('width', $(element).width());
                } else {
                    base.elements.editValue.css('top', $(element).offset().top + 'px');
                    base.elements.editValue.css('left', $(element).offset().left + 'px');
                    base.elements.editValue.css('width', $(element).width());
                }



            },


            modalFrom: function(){
                var callName = base.selected.colData.call_back;
                var data = {
                    colData:base.selected.colData,
                    rowData:base.selected.rowData
                }
                base.api.callBack(callName,data,'form' );
                return true;
            },



            setValue: function(_value){
                //HACK to fix JOYS emptyspace hack from piviot UTil
                if(isWhiteSpace(_value)){
                    _value = "";
                }



                _value = sanitize(_value);

                if(this.validate(_value)) {

                    if(base.selected.validation === 'date'){
                        _value = dateFormat(_value);
                    }

                    var oldRowData = _.cloneDeep(base.selected.rowData);
                    base.selected.rowData[base.selected.col_id] = _value;


                    var $obj =  base.$el.find('.div-col[obj_id='+base.selected.obj_id+']');


                    //TOD0: CHECK NOT SURE THIS IS NEEDED - Heath 2/5/2019
                    base.elements.editValue.html("");
                    base.elements.editValue.show();


                    var data = {
                        colData : base.selected.colData,
                        rowData : base.selected.rowData,
                        oldRowData: oldRowData,
                        /* 5/30/2019 */
                        col_id : base.selected.col_id,
                        row_id : base.selected.row_id,
                        selected_type : base.selected.select_type
                    }


                    //SAVE TO DB
                    if( base.selected.colData.call_back && base.selected.colData.call_back.length ){
                        base.api.callBack(base.selected.colData.call_back,data,'input');
                    }


                    if( base.options.gridType === 'batch-save' ){
                        base.api.callBack('batch-save',data,'batch-save');
                    }


                }else{
                    //TODO: make this generic
                    var message = " <b>Error:</b> wrong data type"; //Default
                    if(base.validationMessages[base.selected.validation] ){
                        message = base.validationMessages[base.selected.validation];
                    }

                    addAlert("alert-danger",message,4000 );
                    base.elements.editValue.html("");
                    base.elements.editValue.show();
                }



                //DATA HAS BEEN UPDATED SO RERUN IS SELECTABLE
                base.buildDom.batchSelectable(base.selected.rowData);
                base.batch.unSelectNonEditable();



                buildGrid();
                base.$el.find('.gg-body').focus();
            },


            validate: function(value){

                if(base.selected.validation != null && base.selected.validation != "" && !isWhiteSpace(value) && value != "" ) {  ///// -----VALIDATION


                    if (base.selected.validation == 'numeric') {

                        if (IsNumeric(value)) {
                            return true;
                        } else {
                            return false;
                        }
                    }else if(base.selected.validation == 'date'){

                        if (IsDate(value)) {
                            return true;
                        } else {
                            return false;
                        }

                    }else if (base.selected.validation == 'uppercase'){
                        if(value === value.toUpperCase()){
                            return true;
                        }else{
                            return false;
                        }
                    }else if (base.selected.validation == 'lowercase'){
                        if(value === value.toLowerCase()){
                            return true;
                        }else{
                            return false;
                        }
                    }

                    return false;
                }else{
                    return true;
                }
            },


            copyAddRow  : function(index){

                var object_id =  this.createUniqueObjectId(4);
                var copiedRow = _.cloneDeep(base.selected.rowData);
                copiedRow.object_id = object_id;

                //TODO: FIX SO THAT WE ONLY HAVE ONE CASE OF OBJECT_ID not lower and upper
                copiedRow.OBJECT_ID = object_id;


                copiedRow.gridBatchStatus = 'new';
                ++index;

                if(base.options.gridType === 'batch-save'){
                    options.data.dataArr.splice(index, 0, copiedRow);
                    var tempObj = {index:index,data:copiedRow,type:'add'}
                    base.api.callBack('row-added',tempObj,'row-added');
                }else{
                    options.data.dataArr.splice(index, 0, copiedRow);

                }

                base.data.dataArr =  options.data.dataArr;
                base.data.safeCopyArr =  base.data.dataArr;
                base.data.newRow.push(object_id);
                pipe();
            },



            addRow : function(index,position){
                var p = ((position == 'above') ? index : index +1);
                if(p < 0 ){
                    p = 0;
                }

                var object_id =  this.createUniqueObjectId(4);

                if(base.options.gridType === 'batch-save'){
                    var newRow = {object_id:object_id,gridBatchStatus:'new'};
                    options.data.dataArr.splice(p, 0, newRow);
                    var tempObj = {index:index,data:newRow,type:'add'}
                    base.api.callBack('row-added',tempObj,'row-added');
                }else{
                    options.data.dataArr.splice(p, 0, {object_id:object_id});
                }


                base.data.dataArr =  options.data.dataArr;
                base.data.safeCopyArr =  base.data.dataArr;
                base.data.newRow.push(object_id);
                pipe();

            },





            deleteRow : function(index){
                if( base.data.safeCopyArr.length > 1){
                    base.deleteCount ++ ;
                    options.data.dataArr.splice(index, 1);
                    base.data.dataArr =  options.data.dataArr;
                    base.data.safeCopyArr =  base.data.dataArr;
                    var indexNewRow = base.data.newRow.indexOf(base.selected.row_id);
                    if( indexNewRow > -1){

                        base.data.newRow.splice(indexNewRow, 1);


                        if(base.options.gridType === 'batch-save'){
                            var tempObj = {index:index,data:base.selected.curDataRow ,type:'remove'}
                            base.api.callBack('row-added',tempObj,'row-added');
                        }
                    }
                    setFooterDelete(base.deleteCount)
                    pipe();
                }else{
                    addAlert("alert-warn"," You can not delete the last row in a template  ",'3000' );
                }
            },


            createUniqueObjectId : function(_length){
                return base.data.safeCopyArr.length + "_" + randomString(_length);
            },


            createUniqueColId : function(_length){
                return base.data.headerArraySafe.length + "_" + randomString(_length);
            },



            getKeyBoardKeys: function(id){
                var key = 0;
                switch (id) {
                    case 96:
                        key = 0;
                        break;
                    case 97:
                        key = 1;
                        break;
                    case 98:
                        key = 2;
                        break;
                    case 99:
                        key = 3;
                        break;
                    case 100:
                        key = 4;
                        break;
                    case 101:
                        key = 5;
                        break;
                    case 102:
                        key = 6;
                        break;
                    case 103:
                        key = 7;
                        break;
                    case 104:
                        key = 8;
                        break;
                    case 105:
                        key = 9;
                        break;
                    case 106:
                        key = "*";
                        break;
                    case 107:
                        key = "+";
                        break;
                    case 109:
                        key = "-";
                        break;
                    case 110:
                        key = ".";
                        break;
                    case 111:
                        key = "/";
                        break;
                    case 186:
                        key = ";";
                        break;
                    case 187:
                        key = "=";
                        break;
                    case 188:
                        key = ",";
                        break;
                    case 189:
                        key = "-";
                        break;
                    case 190:
                        key = ".";
                        break;
                    case 191:
                        key = "/";
                        break;
                }


                return key;

            }





        }





////////////////////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////// SANITIZE FUNCTIONS  /////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
        // SECURITY: proper HTML output-encoding (OWASP) instead of the previous
        // blocklist regex that tried to strip tags. Blocklist stripping is
        // bypassable and allowed HTML tag injection of grid data/labels/filter
        // chips (finding ASAP-FIND-25-06-0191066). Encoding the five HTML-significant
        // characters renders any markup as literal text in every sanitize() sink.
        // Non-string inputs (e.g. numbers) are returned unchanged to preserve the
        // original contract and keep downstream formatter() behavior intact.
        function sanitize(input) {
            if( input && typeof input === 'string' ){
                return input.replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            }
            return input;
        };

        // Header labels are normally sanitized to prevent HTML injection of
        // backend-provided column names. A few columns are internal, trusted
        // constants whose label is intentionally an icon (e.g. the batchSelect
        // column uses "<i class='fa fa-check'></i>"). Sanitizing those would
        // render the markup as literal text (showing "<i" in the header), so we
        // render them as raw HTML while still sanitizing every other label.
        function headerLabelHtml(value) {
            if (value && (value.map === 'batchSelect' || value.format === 'batchSelect')) {
                return value.label;
            }
            return sanitize(value && value.label);
        };
////////////////////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////// VALIDATION FUNCTIONS  /////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////


        function isBlank(str) {
            return (!str || /^\s*$/.test(str));
        }


        function isEmpty(str) {
            return (!str || 0 === str.length);
        }

        function isWhiteSpace(str){
            if( IsNumeric(str) ){
                return false;
            }
            if(isBlank(str)){
                return true;
            };


            if(str.charCodeAt(0) === 8){
                return true;
            }

            var string = str.trim();
            return ( string.length === 0);
        }



        function IsNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }


        function IsDate(date) {
            var format =  base.dateFormats[0].value;
            return  moment( Date.parse(date)).isValid(); //;
        }


        function randomString(length) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
            if (! length) {
                length = Math.floor(Math.random() * chars.length);
            }
            var str = '';
            for (var i = 0; i < length; i++) {
                str += chars[Math.floor(Math.random() * chars.length)];
            }
            return str;
        }

////////////////////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////// TOOLS FUNCTIONS  /////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////

//TODO REFACTOR FOR ALL CLASSES

        function highlight(_element,color){
            var highLightString = "high-light-"+color;
            base.selected.highLightColor = color;
            _.forEach( base.selectedGroup, function(value, key) {
                highLightElement(value,highLightString,color);
            });
            buildBodyDom();
        }

        function highLightElement(_object,_highLightString,_color){
            if( _object.select_type === 'cell' ){
                var partial_match = "high-light-";
                if( _color == 'none' ) {
                    updateCellClass(_object,_highLightString,'remove','high-light-');
                }else{
                    updateCellClass(_object,_highLightString,'add','high-light-');
                }
            }else if( _object.select_type === 'header' ){
                var curDataCol = _.find(base.data.headerArray, {'map': _object.col_id});
                var removeObj = removePartialString(curDataCol.col_class,'high-light-');
                curDataCol.col_class = removeObj.cssClass;
                if( _color != 'none' ) {
                    curDataCol.col_class += ' ' + _highLightString;
                }

            }else if( _object.select_type === 'row'  ) {
                var curDataRow = _.find(base.data.dataArr, {'object_id': _object.row_id});
                if(! curDataRow.row_class){
                    curDataRow.row_class = "";
                }
                var removeObj = removePartialString(curDataRow.row_class,'high-light-');
                curDataRow.row_class = removeObj.cssClass;
                if( _color != 'none' ) {
                    curDataRow.row_class += ' ' + _highLightString;
                }

            }
        }





        /////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////    UPDATE CELL CLASS      /////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function removePartialString(_data,_partial){

            if(_data == null ){
                return false;
            }


            var x = _data;
            var n = x .indexOf(_partial);
            var returnObj = {};
            var removedClass = "";

            if( n > 0) {
                var p = x.substring(n, x.length);
                removedClass = p;
                _data =  _data.replace(p, '');
            }

            returnObj.cssClass = _data;
            returnObj.removedClass = removedClass;

            return returnObj;
        }





        function updateCellClass(_object,new_class,_type,_partial_match){

            if(typeof base.cellData[_object.obj_id] == "undefined"){
                base.cellData[_object.obj_id] = [];
                var col_class = _.result(_.find(base.data.headerArray, {'map':_object.col_id}),'col_class');
                base.cellData[_object.obj_id].cssClass = col_class;
            }

            if(_type == 'add' ){
                var removeObj =  removePartialString( base.cellData[_object.obj_id].cssClass ,_partial_match);
                base.cellData[_object.obj_id].cssClass = removeObj.cssClass;
                base.cellData[_object.obj_id].cssClass += ' ' + new_class;
                $(base.selected.element).removeClass(removeObj.removedClass);
                $(base.selected.element).addClass(new_class);

            }else{
                var removeObj =  removePartialString( base.cellData[_object.obj_id].cssClass ,_partial_match);
                base.cellData[_object.obj_id].cssClass = removeObj.cssClass;
                $(_object.element).removeClass(removeObj.removedClass);
            }
        }




        ////// END ///////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// TOOLS ACTION  ///////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////


        function toolsAction(_element){
            var action = _element.attr('action');

            // console.log("------------- toolsAction -------------- " , action)
            switch (action) {
                case 'highlight':
                    var color = _element.attr('color')
                    highlight(_element,color);
                    paintColor(color);
                    break;
                case 'full-screen':
                    base.$el.toggleClass('gg-full-screen');
                    // added(by Omi) the below line to adjust modal position on full-screen..
                    (base.$el.hasClass('gg-full-screen')) ? base.$el.find('.gg-col-order-cont').addClass('adjust-modal-full-screen') : base.$el.find('.gg-col-order-cont').removeClass('adjust-modal-full-screen');
                    buildGrid();
                    break;
                case 'new-window':
                    var url= new URL(window.location.href);
                    window.open(url, 'newwindow', 'width='+window.innerWidth+', height='+window.innerHeight);
                   // window.open(window.location.href,'newwindow', 'width='+window.innerWidth+', height='+window.innerHeight);
                    break;
                case 'export' :
                    exportExcel(base.base_url + '/exportToExcel', false);
                    break;
                case 'filtered-export' :
                	exportExcel(base.base_url + '/exportToExcel', true);
                	break;
                case 'paste-xls' :
                    base.pasteXls.paste();
                    break;
                case 'show-hide' :
                    base.headerService.colToolsOpen();
                    break;
                case 'expand-cols' :
                    base.headerService.expandCols();
                    break;
                case 'total-selected' :
                    base.mathFormulas.selectedSum();
                    break;
                case 'batch-action' :
                    base.api.batchAction(_element.attr("value"));
                    break;
                case 'apply-template':
                    base.headerService.colToolsApply(_element.attr("index"));
                    break;
                case 'comment-tools':
                    base.messageService.goToComment();
                    break;
                case 'manage-actions':
                    base.gridActions.launchGridActionModal();
                    break;
                case 'manage-pivot-actions':
                    base.pivotActions.launchPivotActionModal();
                    break;
                case 'format':
                    break;
                case 'actionTemplate':
                    base.actionsService.applyActionTemplate(_element.attr("action_template_key"));
                    break;
                case 'clearActionTemplate':
                    base.actionsService.clearActionTemplate();
                    break;
                case 'expand-collapse-pivot':
                    base.pivotExpandService.expandCollapse();
                break;
            }
            base.focus.gridBody.focus();
        }



        base.mathFormulas = {

            clearTotal: function(){
                base.elements.totalText.html("");
            },

            selectedSum: function () {
                this.clearTotal();
                var value = "";
                var totalObj = {};

                if( base.selected.select_type === "cell" ){
                    totalObj = base.mathFormulas.totalCells();
                }else{
                    totalObj = base.mathFormulas.totalCol();
                }

                var string = "";

                if( totalObj.average != null && !isNaN(totalObj.average)){
                    var average = "";
                    /*
                     if(base.selected.format && base.selected.format.length){
                     average = formatter(totalObj.average,base.selected.format)
                     }else{
                     average = totalObj.average.toFixed(2);
                     }
                     */
                    average = totalObj.average.toFixed(2);
                    string += "Average: " + average + "&nbsp;&nbsp";
                }


                if( totalObj.count ){
                    string += "Count: " + totalObj.count + "&nbsp;&nbsp";
                }


                if( totalObj.sum != null ){
                    var sum = 0;

                    if( Number(totalObj.sum) === totalObj.sum && totalObj.sum % 1 === 0 || totalObj.sum === 0.00){
                        sum = totalObj.sum;
                    }else{
                        sum = totalObj.sum.toFixed(2);
                    }


                    var formatSum = numberWithCommas(sum);


                    string += "Sum: " + formatSum + "&nbsp;&nbsp";
                }


                base.elements.totalText.html(string);


            },

            totalCol :function(){
                var total = "";
                var object = {};
                object.sum = null;
                object.count = null;
                object.average = null;

                console.log("totalCol called")

                if( base.selected.select_type === 'header' ){
                    var total = 0;
                    var count = 0;

                    _.forEach(base.data.dataArr, function (value, key) {
                        _.forEach(base.selectedGroup, function (valueCol, keyCol) {
                            if (typeof value[valueCol.col_id] != "undefined") {
                                if(!isNaN(value[valueCol.col_id]) && valueCol.colData.round_off == '1'){
                                    total += Math.round(parseFloat(value[valueCol.col_id]));
                                }
                                else if(!isNaN(value[valueCol.col_id])){
                                    total += parseFloat(value[valueCol.col_id]);
                                }
                                ++count;
                            }
                        });
                    });

                    object.sum = total;
                    object.count = count;

                    if( object.sum != null ){
                        object.average = object.sum/count;
                    }


                }

                return object;
            },


            totalCells :function(){
                var object = {};
                object.sum = null;
                object.count = null;
                object.average = null;
                if( base.selected.select_type === 'cell' ){

                    _.forEach(base.selectedGroup, function (value, key) {
                        if( typeof value.value != "undefined" ){
                            if(!isNaN(value.value)) {
                                object.sum += parseFloat(value.value);
                            }
                            ++object.count
                        }
                    });

                    object.average = object.sum/object.count;
                }
                return object;
            }



        }

//////////////////////////////////////// AJAX ENGINE  ////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////


        function loadTemplate(_url,_pramaters,_element){
            $(_element).load( _url, function() {
                //////////////////////////console.log("loadTemplate()")
            });
        }



        //////////////////////////////////////////////////////////////////////////////////////////////////
        //// EXPORT EXCEL FUNCTION : Written By JOY
        //////////////////////////////////////////////////////////////////////////////////////////////////

        /*function exportExcel(_url){
            var action_id = ggDom.element('#action_id')[0].innerHTML;
            var grid_id = ggDom.element('#grid_id')[0].innerHTML;
            var sso_id = ggDom.element('#sso_id')[0].innerHTML;
            var all_filter_data = (ggDom.element('#all_filter_data')[0].innerHTML).replace(/&amp;/g, '&');
            var display_filter_data = (ggDom.element('#display_filter_data')[0].innerHTML).replace(/&amp;/g, '&');
            _url = _url + '?' + 'action_id=' + action_id + '&' + 'grid_id=' + grid_id + '&' + 'sso_id=' + sso_id + all_filter_data + display_filter_data;
            window.open(_url,'blank');
        }*/
        function exportExcel(_url, isFilteredGrid) {
        	addAlert("alert-warn","Please wait until the file downloads", 6000);
            var action_id = ggDom.element('#action_id')[0].innerHTML;
            var grid_id = ggDom.element('#grid_id')[0].innerHTML;
            var sso_id = ggDom.element('#sso_id')[0].innerHTML;
            var all_filter_data = (ggDom.element('#all_filter_data')[0].innerHTML).replace(/&amp;/g, '&');
            var display_filter_data = (ggDom.element('#display_filter_data')[0].innerHTML).replace(/&amp;/g, '&');
            var display_all_me_code = (ggDom.element('#display_all_me_code')[0].innerHTML).replace(/&amp;/g, '&');
            var filterArrayAll = all_filter_data.split('&');
            var filterArrayDisplay = display_filter_data.split('&');

             /*dvalaboju001 2/1/2020*/
             var screen_name = ggDom.element('#screen_name')[0].innerHTML;
            var client_name = ggDom.element("#client_name")[0].innerHTML;
            var screenObj = ggDom.element('#screenObj')[0].innerHTML;
            console.log("screen_name",screen_name);
            console.log("client_name",client_name);
            console.log("screenObj",screenObj);

            //Added by Vijay to included the filtered column details
            if(base.tableState.colSearch.length){//Check null, undefined and predicate
           	 	for(var i = 0; i < base.tableState.colSearch.length; i++){
           	 		filterArrayDisplay[filterArrayDisplay.length] = "colFilter_"+base.tableState.colSearch[i].predicate+"="+base.tableState.colSearch[i].value.toString();
                }
            }
            if(display_all_me_code){
            	filterArrayDisplay[filterArrayDisplay.length] = "display_mE_code="+display_all_me_code;
            }
            //---------------------------------------------------------
            var jsonData = {};
            for(var i = 0; i < filterArrayAll.length; i++){
                jsonData[filterArrayAll[i].split('=')[0]] = filterArrayAll[i].split('=')[1];
            }
            for(var i = 0; i < filterArrayDisplay.length; i++){
                jsonData[filterArrayDisplay[i].split('=')[0]] = filterArrayDisplay[i].split('=')[1];
            }
            var _params = {};
            var jsonObj = JSON.stringify(jsonData);
            _url = _url + '?' + 'action_id=' + action_id + '&' + 'grid_id=' + grid_id + '&' + 'sso_id=' + sso_id /*+ all_filter_data + display_filter_data*/;
            _params = _.extend({
                jsonObj: jsonObj
            }, _params);

            //Added by Vijay to included the filtered column details
            if(isFilteredGrid){
            	_params = _.extend({
            		filteredGridData: JSON.stringify(base.data.dataArr)
            	}, _params);
            	_url = _url + '&' + 'filtered_export=' + isFilteredGrid
            }
            //-----------------------------------------------------
            var tableData = JSON.parse(_params.gridData);
            screenObj = JSON.parse(screenObj);
            screenObj['export_date'] = moment().format('MM/DD/YYYY LT');
            var strFilename = screenObj['report_name'].replace(/[^a-zA-Z0-9]/g,'-') + "-" +moment().format('YYYY-MM-DD-hh-mm')+".xlsx";

            /**
             * This is using webworker and exceljs.min.js and file saver. START
             */
            const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            if (window.Worker) {
                var myWorker = new Worker('./lib/webworker/exportToExcel.js');
                if(isFilteredGrid){
                    screenObj.filters = Object.assign({},screenObj['filters'],...colFilters);
                }
                myWorker.postMessage({tableData,screenObj,headerDisplArr});
                myWorker.onmessage = function(e) {
                    console.log('messgae recived');
                    if(e.data.error){
                        addAlert("alert-error"," Data can not be exported, please contact System administrator",4000 );
                    }
                    const blob = new Blob([e.data],{type: EXCEL_TYPE});
                    try {
                        saveAs(blob, strFilename);
                        myWorker.terminate();
                    }catch(error){
                        addAlert("alert-error"," Data can not be exported, please contact System administrator",4000 );
                    }

                }
            } else {
                console.log('Your browser doesn\'t support web workers.');

                /**
                 * This old api implementation.
                 */

            var promise= $.ajax({
                method: 'post',
                url: base.base_url+_url,
                data: _params
            })
            .done(function( data ) {
                if( data.callSuccess != 1 ){
                    addAlert("alert-error"," Data can not be exported, please contact System administrator",4000 );
                }else{
                    let downloadURL= base.base_url+'/download'+'?'+'file_name='+data.file_name+"&client_key="+sessionStorage.getItem('client_key');
                    window.open(downloadURL,'blank');
                }
               });
            }
        }



////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////// CONTEXTMENU FUNCTIONS  /////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////

        function displayContextMenu(_event){
            var element = base.selected.element;
            buildContextMenu(element);
            positionContextMenu(element,_event)
        }

        function buildContextMenu(){
            var element = base.selected.element;
            var rowobj =  element.attr('rowobj');
            var colmap = element.attr('colobj');
            var currentDataCol = _.find(base.data.headerArray, {'map':colmap} )
            var colobj = currentDataCol.object_id;
            var curDataRow = _.find(base.data.safeCopyArr, {'object_id':rowobj});
            var cellValue =  curDataRow[colmap];
            var cellDisplay = cellValue;
            var auditCells = _.filter(options.data.headerArray,{'audit_cells':"1"}); /* 5/29/2019 */


            var menuBase = $("<ul></ul>");
            base.elements.contextMenu.html("");
            //menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='note' ><a><i class='fa fa-tag'></i> Attach Message</a> <div></div></li>");


            //  menuBase.append("<li role='presentation' class='divider'></li>");

            //////// START: FILTERS ////////////////////////////////

            if( base.batchSelectMode ){

                var badge = (base.batchSelect && base.batchSelect.length > 0) ? '<span class="label label-success label-as-badge">'+base.batchSelect.length+'</span>' : '';
                if(curDataRow.batchSelect){
                    menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='select-row'  ><a><i class='fa fa-square-o'></i> Unselect Row</a> <div></div></li>");
                }else{
                    menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='select-row'  ><a><i class='fa fa-check'></i> Select Row</a> <div></div></li>");
                }

                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='select-all'  ><a><i class='fa fa-check-square-o'></i> Select <b>All</b></a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='un-select-all'  ><a><i class='fa fa-square-o'></i> Unselect <b>All</b> "+badge+" </a>      <div></div></li>");
                menuBase.append("<li role='presentation' class='divider'></li>");


                if( base.batchActions && base.batchActions.length && base.selected.rowData.gridBatchStatus !== 'new') {
                    _.forEach(base.batchActions, function (value, key) {
                        var icon = (value.icon && value.icon != "" ) ? value.icon : "fa fa-dot-circle-o ";
                        var listElement = '<li class="gg-context-action batch-actions" colobj="' + colobj + '"  action="batch-action" value="' + key + '"><a><i class="' + icon + '"></i> ' + value.name + '</a> <div></div></li>'
                        menuBase.append(listElement);
                    })
                    menuBase.append("<li role='presentation' class='divider'></li>");
                }else if( base.selected.rowData.gridBatchStatus && base.selected.rowData.gridBatchStatus === 'new' ){
                    menuBase.append("<li class='gg-context-action   ' colobj='"+colobj+"' style='background-color:#f5857c' action='deleteRow' value='' ><a><i class='fa fa-times'></i> Remove New Row</a> <div></div></li>");
                }



            }






            if( typeof cellValue === "undefined" || cellValue === null || cellValue === ""  || cellValue === " ") {

                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='blank' value='" + cellValue + "' ><a>is blank</a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='not-blank' value='" + cellValue + "' ><a>is not blank </a> <div></div></li>");


            }else if( currentDataCol.data_type === 'number' ){

                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='find-equals-number' value='"+cellValue+"' ><a>Equals <b>"+cellValue+"</b></a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='find-not-equals-number' value='"+cellValue+"' ><a>Does Not Equal <b>"+cellValue+"</b></a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='find-greater' value='"+cellValue+"'> <a>Greater Than <b>"+cellValue+"</b></a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='find-less' value='"+cellValue+"' ><a>Less Than <b>"+cellValue+"</b></a> <div></div></li>");

            }else{

                if(cellDisplay.length > 29){
                    cellDisplay = cellDisplay.substring(0,29) + "...";
                }

                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='find-like' value='"+cellValue+"' ><a>Contains <b>"+cellDisplay+"</b></a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='find-not-like' value='"+cellValue+"' ><a>Does Not Contain <b>"+cellDisplay+"</b></a> <div></div></li>");

            }

            var model =  _.filter(base.tableState.colSearch, { predicate: colmap });



            menuBase.append("<li role='presentation' class='divider'></li>");

            if( model != undefined && !_.isEmpty(model) ) {
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='un-filter' value='"+cellValue+"' ><a><i class='fa fa-times'></i> Clear Filter</a> <div></div></li>");
            }


            if( ( currentDataCol.removable || base.options.gridType === 'import')  && cellValue !== undefined ){
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='fill' value='"+cellValue+"' ><a> Fill With: <b>"+cellValue+"</b></a> <div></div></li>");
            }



            if(options.data.settings && options.data.settings.comments){
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='add-comment' ><a><i class='fa fa-commenting'></i> Insert Comment</a> <div></div></li>");
            }

           /*  if(options.data.settings && options.data.settings.attachments){
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='add-attachment' ><a><i class='fa fa-paperclip'></i> Insert Attachment</a> <div></div></li>");
            }
 */
            /* audit cell options 5/29/2019*/

            if(_.find(auditCells,{'grid_header_key':currentDataCol.grid_header_key}) != undefined){
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='audit-cells' ><a><i class='fa fa-history'></i> Audit Cells</a> <div></div></li>");
            }

            /*  */
            if(  currentDataCol.removable  ){
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='removeCol' ><a><i class='fa fa-minus'></i> Remove Column</a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='formatCol' ><a><i class='fa fa-list-alt '></i> Format Column</a> <div></div></li>");

            }


            if( base.options.gridType === 'import' ){
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='addRowAbove' value='' ><a><i class='fa fa-plus'></i> Add Row Above</a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='addRowBelow' value='' ><a><i class='fa fa-plus'></i> Add Row Below</a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='deleteRow' value='' ><a><i class='fa fa-minus'></i> Remove Row</a> <div></div></li>");
            }



            if(  base.options.gridType === 'batch-save'  ){
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' style='background-color:#8dd2e7' action='copyAddRow' value='' ><a> <i class='fa fa-files-o'></i>  Copy Row</a> <div></div></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='addRowBelow' value='' ><a><i class='fa fa-plus'></i>  Add Blank Row</a> <div></div></li>");
                if( curDataRow.gridBatchStatus &&  curDataRow.gridBatchStatus === 'new') {
                    menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='deleteRow' value='' ><a> <i class='fa fa-times'></i> Remove Row</a> <div></div></li>");
                }

            }



            if( base.options.gridType != 'import'  ) {
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='" + colobj + "' action='addCol' ><a><i class='fa fa-plus'></i> Add Column</a> <div></div></li>");
            }



            //////// END: FILTERS ////////////////////////////////


            if( currentDataCol.map !== 'batchSelect'){
                menuBase.append("<li role='presentation' class='divider'></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='highlight' color='"+base.tools.color+"' ><a> <i style='color:"+base.tools.color+"' class='fa fa-paint-brush'></i> Highlight <div class='color-block "+base.tools.color+"'></div></a></li>");
                menuBase.append("<li class='gg-context-action' colobj='"+colobj+"' action='highlight' color='no-fill' ><a>Clear Highlight &nbsp;<div class='color-block no-fill'></div></a></li>");
            }

            base.elements.contextMenu.append(menuBase);
            base.elements.contextMenu.show();




        }


        function positionContextMenu(_element,_event){

            var positionY  = _event.pageY,
                positionX  = _event.pageX,
                bottomHeight = positionY + base.elements.contextMenu.height(),
                rightWidth = positionX + base.elements.contextMenu.width();
            //Set positionY
            if(bottomHeight > windowHeight){
                var offsetY = (bottomHeight - windowHeight) + 2;
                positionY = positionY - offsetY;
            }

            //Set positionX
            if( rightWidth >  windowWidth){
                var offsetX = (rightWidth - windowWidth) + 10;
                positionX = positionX - offsetX;
            }

            base.elements.contextMenu.css('top',positionY+'px');
            base.elements.contextMenu.css('left',positionX+'px');

        }




        function hideContextMenu(){
            if (!base || !base.elements) return;

            if( base.elements.contextMenu.is(":visible")) {
                base.elements.contextMenu.hide();
                base.focus.gridBody.focus();
            }



        }





////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// ALERT FUNCTIONS  ////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////



        base.alertArrayIndex = 0;

        function addAlert(_type,_message,_timeout){
            var alert_id = ++base.alertArrayIndex;
            var alertObject = {alert_id:alert_id, type:_type, message:_message, timeOut:_timeout, visible:false};
            renderAlert(alertObject);
            if(_timeout !== undefined ){
                setTimeout(function() { removeAlert(alert_id,'timeOut'); }, _timeout);
            }

        }

        function removeAlert(_alert_id,_action){
            var alert =  $(".gg-alert[alert-id='" + _alert_id + "']");
            if(_action == 'timeOut'){
                alert.fadeOut("normal", function() {
                    alert.remove();
                });
            }else{
                alert.remove();
            }

        };


        function renderAlert(_object){
            var $alert = $('<div class="gg-alert alert alert-dismissible fade in" role="alert"><button type="button" class="close gg-alert-close">×</button><div class="gg-alert-message"></div></div>');
            $alert.addClass(_object.type);
            $alert.attr('alert-id',_object.alert_id);
            $alert.find('.gg-alert-message').html(_object.message);
            base.elements.alertContainer.append($alert);

        }


        /* */


////| END: AJAX ENGINE  | //////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// TEMPLATES  ////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
        var colSizeHandlerTemplate = $("<div class='resize-col-line'><div class='resize-col-icon'></div></div>"),


            refreshIconTemplate = $("<div class='gg-refresh-icon'><img src='assets/img/loader-yellow-slow.svg' width='60' height='60'> <p>Refreshing Data</p></div>"),


            colFixedHandlerTemplate = '<div class="fixed-col-handler"></div>',


            hiddenTextAreaTemplate = $('<div class="gg-hidden-ta-cnt"><textarea class="gg-hidden-textarea"></textarea></div>'),



            largeTextDisplay = $('<div class="gg-lg-text-cnt"><div class="gg-lg-text"></div><div class="gg-lg-text-btns"><div class="btn btn-info btn-xs gg-lg-text-edit" >Edit</div></div></div>'),





            modalFilterTemplate = $('<div class="gg-modal-filter">'+
                '<div class="gg-modal-header">'+
                '<div class="gg-title">Show Results Where</div><i action="close"  class="fa fa-times modal-action"></i>'+
                '</div>'+
                '<div class="gg-modal-ggBody form-group">'+
                '<div id="gg-modal-select">'+
                '</div>'+
                '<div class="gg-divider"></div>'+
                '<input type="text" class="gg-modal-input input-sm form-control" name="value" placeholder="enter search">'+
                '</div>'+

                '<div class="gg-modal-footer">'+
                '<div action="submit" class="gg-modal-action btn btn-xs btn-info">Ok</div>'+
                '<div action="close" style="margin-left:5px" class="gg-modal-action btn btn-xs btn-danger">Cancel</div>'+
                '</div>'+
                '</div>'),


            modalTemplate = $('<div class="gg-modal-container">'+
                '<div class="gg-modal-header">'+
                '<div class="gg-title"></div><div class="gg-close"><i action="close"  class="fa fa-times gg-modal-action"></i></div>'+
                '</div>'+
                '<div class="gg-modal-ggBody">'+
                '</div>'+
                '<div class="gg-modal-footer">'+
                '<div action="" class="gg-modal-action btn btn-xs btn-info">Ok</div>'+
                '<div action="close" style="margin-left:5px" class="gg-modal-action btn btn-xs btn-danger">Cancel</div>'+
                '</div>'+
                '</div>'),




            colFormatTemplate = '<select name="select" class="input-sm form-control gg-modal-select">'+
                '<option value="string">String</option>'+
                '<option value="number">Number</option>'+
                '<option value="date">Date</option>'+
                '</select>',




            modalFilterNumber = '<select name="select" class="input-sm form-control gg-modal-select">'+
                '<option value="=">Equals </option>'+
                '<option value="!=">Does <u>Not</u> Equal</option>'+
                '<option value=":">Contains</option>'+
                '<option value="!:">Does <u>Not</u> Contains</option>'+
                '<option value=">=">Greater Than</option>'+
                '<option value="<=">Less Than</option>'+
                '<option value="blank">Is Blank</option>'+
                '<option value="!blank">Is <u>Not</u> Blank</option>'+
                '</select>',

            modalFilterString = '<select name="select" class="input-sm form-control gg-modal-select">'+
                '<option value="=">Equals </option>'+
                '<option value="!=">Does <u>Not</u> Equal</option>'+
                '<option value=":">Contains</option>'+
                '<option value="!:">Does <u>Not</u> Contains</option>'+
                '<option value="blank">Is Blank</option>'+
                '<option value="!blank">Is <u>Not</u> Blank</option>'+
                '</select>',

            modalFilterDate = '<select name="select" class="input-sm form-control gg-modal-select">'+
                '<option value="=">NEED TO ADD </option>'+
                '</select>',


            rowSizeHandlerTemplate = $("<div class='resize-row-line'><div class='resize-row-icon'></div></div>"),

            //--unused--//alertTemplate = $('<div class="gg-alert alert  alert-dismissible fade in" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button><div class="gg-alert-message"></div></div>'),

            colReorderHandlerTemplate = $("<div class='reorder-col-block'></div>"),

            colIndicatorTemplate = $("<div class='col-line'></div>"),

            editTemplate = $("<div class='edit-grid-value'></div>"),

            inputText = $('<input type="text" name="currentValue" class="gg-input-text">'),



            checkInput =  $('<input type="checkbox" name="currentCheck" class="gg-input-check">'),



            contextMenuTemplate = $('<div class="gg-context-menu dropdown" style="background-color:rgba(255, 255, 255, 0.9)" ></div>'),

             errorItemTemplate =//$('<div style="display:none" class="gg-error-container error-popup">'+
                                 $('<div style="display:none" class="gg-error-container">'+
                                 '<div class="gg-list-container"></div>'+
                                 '<div class="gg-message-detail-backdrop"></div>'+
                                 '<div class="gg-detail-container"></div>'+
                                 '</div>'),


            messageItemTemplate = $('<div style="display:none " class="gg-message-container">' +
                '<div class="gg-list-container"></div>' +
                '<div class="gg-message-detail-backdrop"></div>'+
                '<div class="gg-detail-container"></div>' +
                '</div>'),
            loadingTemplate = $(' <div class="gtw-web-components gg-loader">' +
            // '<div class="gg-loader-text"> ' +
            //  '<img src="assets/img/ge-logo-loader-dark-bg.svg" width="70" height="70">' +
            //  '<p>fetching data</p> ' +


            // '<div class="gt-loader-logo"> ' +
            // ' <img class="loader" src="assets/img/loader-yellow-slow.svg" width="140" height="140">' +
            // '<img class="logo" src="assets/img/logo-60.png" >' +
            // ' <div class="text">fetching data</div>' +
            // '</div>' +



            // '</div> ' +
            '<div class="gg-loader-text viewport-center"><div class="d-inline-block a-p-20 text-center rounded"><span class="a-loading loading-large a-dark"></span></div></div>' +
            '</div>'),


            selectFiltersTemplate = $(' <div class="gg-loader"> <div class="gg-loader-text"> ' +
                '<img src="assets/img/arrow-filter-sm.png" >' +
                '</div> ' +
                '</div>'),

            dropDstDownTemplate = '<div class="stopEvent gg-dropMenu dropdown" style="position:relative;"> '+
            '<a class="btn btn-super-sm btn-default dropdown-toggle" data-toggle="dropdown"><span class="caret"></span></a> '+
            '<ul class="dropdown-menu gg-menu-container">'+
            '<li  id="dropDstDownFilters" action="string">'+
            '</li> </ul>',


            selectFiltersTemplate = $(' <div class="gg-loader"> <div class="gg-loader-text"> ' +
                '<img src="assets/img/arrow-filter-sm.png" >' +
                '</div> ' +
                '</div>'),

            dropDownTemplate = '<div class="stopEvent gg-dropMenu dropdown" style="position:relative;"> '+
                '<a class="btn btn-super-sm btn-default dropdown-toggle" data-toggle="dropdown"><span class="caret"></span></a> '+
                '<ul class="dropdown-menu gg-menu-container">'+
                '<li class="gg-menu-action" action="select-all"><a> <i class="fa fa-check-square-o"></i> Select All </a></li> '+
                '<li class="gg-menu-action" action="un-select-all"><a> <i class="fa fa-square-o"></i>  Un-select All </li> '+
                '<li role="presentation" class="divider"></li> '+
                '<li class="gg-menu-action" action="sort-a-z"><a>Sort A <i class="fa fa-long-arrow-right"></i> Z</a></li> '+
                '<li class="gg-menu-action" action="sort-z-a"><a>Sort Z <i class="fa fa-long-arrow-right"></i> A</a></li> '+
                '<li class="gg-menu-action gg-remove-sort" action="un-sort"><a>Remove Sort</a></li> '+
                '<li role="presentation" class="divider"></li> '+
                '<li class="gg-menu-action" action="addCol"><a>Add Column</a></li>'+
                '<li class="gg-menu-action" action="removeCol"><a>Remove Column</a></li>'+
                '<li class="gg-menu-action" action="formatCol"><a>Format Column</a></li>'+


                '<li role="presentation" class="divider"></li> '+
                '<li class="gg-menu-action gg-menu-highlight" action="highlightCol"><a>Highlight Column</a></li> '+
                '<li role="presentation" class="divider"></li> '+
                '<li class="gg-menu-action gg-remove-filter" action="un-filter"><a>Remove Filter</a></li> '+
                '<li class="gg-menu-action" id="dropDownFilters" action="string">'+
                '</li> '+
                '<li role="presentation" class="divider"></li> '+
                '<li> ' +
                '<div class="gg-multi-select-container"> ' +
                '<div class="gg-multi-select-search"><i class="fa fa-search"></i> <textarea type="text" placeholder="type or paste from excel" class="gg-multi-select-input" id="multiSelectFilter" name="multiSelectFilter" ></textarea></div> ' +
                '<div class="gg-multi-select" style="resize: both;"> ' +
                '</div> ' +
                '<div class="gg-multi-select-btns"> ' +
                '<div class="btn btn-info btn-xs gg-multi-select-apply">Ok</div> ' +
                '<div class="btn btn-warning btn-xs gg-multi-select-cancel">Cancel</div> ' +
                '</div> ' +
                '</div> ' +
                '</li> '+
                '</ul> '+
                '</div> ',

            mainTemplate = '';



//// ++ END ++////////////////////////////////// TEMPLATES  ////////////////////////////////////////////////////





        function positionMenu(_element,_position){

            var positionX  = _position.offset().left + _position.width(),
                positionY  = _position.offset().top

            _element.css('top',positionY+'px');
            _element.css('left',positionX+'px');

        }



        function positionDropDownAction(_element){

            //_element.css('display','px');


            var menuLeft = _element.width() + _element.offset().left,
                menuBottom = _element.height() + _element.offset().top ,
                bodyBottom = base.elements.body.offset().top + base.elements.body.height() - 50;


            if( menuLeft > base.$el.width()  ){
                _element.css('left',-_element.width()+'px')
            }


            if( menuBottom > bodyBottom  ){
                _element.css('height',bodyBottom+'px');
                _element.scrollTop(1).scrollTop(0);
            }

        }



////////////////////////////////////////////////////////.parent////////////////////////////////////////////
//////////////////////////////////////// PUBLIC FUNCTIONS /////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////




        base.positionMenu = function(_element){
            setTimeout(function(){
                positionDropDownAction(_element);
            }, 1);

        }


        base.arrowMove = function(_direction){
            arrowMove(_direction);
        }

        base.pageUp = function(){
            pageUp();
        }


        base.pageDown = function(){
            pageDown();
        }


        base.gotoLineNumber = function(_val){
            setVScroll(_val);
        }


        base.resetHScroll = function(){
            resetHScroll();
        }


        //base.elements.messageItemContainer


        base.closeContextMenu = function(_element){
            hideContextMenu(_element)
        }


        base.contextmenu = function(_event){
            displayContextMenu(_event)
        }

        base.removeAlert = function(_element){
            removeAlert(_element.parent().attr('alert-id'),'click');
        }


        base.toolsAction = function(_element){
            toolsAction(_element);
        }

        base.selectRow = function(_element,_ctrlClick){
            selectRow(_element,_ctrlClick);
        }





        base.clearFilter = function(_action,_map){
            clearFilter(_action,_map);
        }


        base.clearAll = function(){
            //////////////////////////////console.log(_value);
            clearAll();
        }

        base.globalSearch = function(_value){
            //////////////////////////////console.log(_value);
            globalSearch(_value);
        }

        base.columnSearch = function(_col_id,_value){
            var curDataCol = _.find(base.data.headerArray, {'object_id':_col_id});
            colSearchText(curDataCol.map,_value,":",'string');
            ////////////////console.log("_col_id " , _col_id);
        }


        base.selectCell = function(element,event){
            selectCell(element,'cell',event);
        }

        base.selectCol = function(element,_ctrlClick){
            selectCol(element,_ctrlClick);
        }

        base.dropdownAction = function(action,element,input,col_id){
            var curDataCol = _.find(base.data.headerArray, {'object_id':col_id});
            ////////////////console.log("curDataCol: " , curDataCol);
            var map = curDataCol.map;
            ////////////////console.log("map: " , map);

            dropdownAction(action,element,input,curDataCol,map);


        };

        base.sort = function(e){
            sort(e);
        };

        base.dragFixedColHandlerEnd = function(e){
            dragFixedColHandlerEnd(e);
        };

        base.dragFixedColHandler = function(e){
            dragFixedColHandler(e);
        };

        base.dragReorderColHandlerEnd = function(e){
            dragReorderColHandlerEnd(e);
        };

        base.dragReorderColHandler = function(e){
            dragReorderColHandler(e);
        };

        base.dragRowHandlerEnd = function(e){
            dragRowHandlerEnd(e);
        };

        base.dragRowHandler = function(e){
            dragRowHandler(e);
        };

        base.dragColHandlerEnd = function(e){
            dragColHandlerEnd(e);
        };

        base.dragColHandler = function(e){
            dragColHandler(e);
        };

        base.resize = function(e) {


            if(base != null){

                if(base != null && base.loader.visible ){
                    base.gridFiltersDivHeight = 0;// need to make this to 0,otherwise white space gets added to grid bottom on window resize/showLoader
                    base.loader.setSize();
                }else{
                    buildGrid();
                }

            }


        };

        base.onHorzScrollOff = function(e){
            onHorzScrollOff(e);
        }


        base.hScrollDrag = function(e){
            onHorzScroll(e);
        }


        base.vScrollDrag = function(e){
            onScroll(e);
        }


        base.scrollDown = function(){
            if(base.data.dataArr && base.data.dataArr.length > 0){
                scrollDown();
            }


        };

        base.scrollUp = function(){
            if(base.data.dataArr && base.data.dataArr.length > 0){
                scrollUp();
            }
        };

        base.scrollLeft = function(){

            scrollLeft();

        }

        base.scrollRight = function(){
            scrollRight();
        }

        base.debug = function(e) {
            debug(e);
        };

        base.init()
    };



////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// Default Options /// /////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

    $.gizmoGrid.defaultOptions = {
        fixedColumn: 1,
        defaultRowHeight: 30,
        defaultColWidth: 100,
        minColWidth:50,
        minRowHeight:30,
        vDraggerMinHeight:30,
        vClickThroughNum:1,
        rowBuffer:1,
        colBuffer:1,
        maxUniqueColFilters:2700,
        gridType:'standard',
        maxXlsRows:1000,
        profileImageUrl:"https://colab.gecdn.com/profile_images/86/",
        profileImageExtension:".jpg",
        callBack: function () {}
    }

////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////// PUBLIC EVENTS /// /////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

    $.fn.gizmoGrid = function(options){
        return this.each(function(){
            var gg = new $.gizmoGrid(this, options);
            var interval = null;
            var cellSelectTimeoutId = null;

            function cancelPendingCellSelect() {
                if (cellSelectTimeoutId != null) {
                    clearTimeout(cellSelectTimeoutId);
                    cellSelectTimeoutId = null;
                }
            }

            var element = $(this);
            //EXPOSE THE PUBLIC API
            element.data('gizmoGridApi', gg.api);

            gg.$el.on('click', '.gg-lg-text-edit' ,function(event){
                gg.largeText.edit();
            });

            gg.$el.on('click', '.gg-lg-text-save' ,function(event){
                gg.largeText.save();
            });

            gg.$el.on('click', '.gg-lg-text-cancel' ,function(event){
                gg.largeText.cancel();
            });



            ////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ////////////////////////////////////       headerService      //////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////

            gg.headerService.overlayElement.on('click',function(event){
                gg.headerService.colToolsClose();
            });


            gg.$el.on('click', '.gg-col-reset' ,function(event){
                gg.headerService.colToolTemplateReset(0);
            });


            gg.$el.on('click', '.gg-col-show-all' ,function(event){
                gg.headerService.checkAll();
            });

            gg.$el.on('click', '.gg-col-hide-all' ,function(event){
                gg.headerService.uncheckAll();
            });

            gg.$el.on('change', '.gg-col-select' ,function(event){
                // gg.headerService.colToolsSave();
                var val = $(this).val();
                gg.headerService.colToolsApply(val);
            });


            //Handels all btn actions in gg.headerService.colTools
            gg.$el.on('click', '.gg-col-action' ,function(event){
                var attr = $(this).attr( "action" )
                gg.headerService.colToolTemplateControls(attr);
            });

            gg.$el.on('keyup' , '#gg-col-temp-input',function(e){
                var code = e.keyCode || e.which;
                if(code == 13){
                    gg.headerService.colToolTemplateControls('save');
                }
            });

            gg.$el.on('keyup' , '#gg-col-update-input',function(e){
                var code = e.keyCode || e.which;
                if(code == 13){
                    gg.headerService.colToolTemplateControls('update');
                }
            });






            gg.$el.on('click', '.gg-col-close' ,function(event){
                gg.headerService.colToolsClose();
            });


            gg.$el.on('click', '.gg-comment-display' ,function(event){
                event.originalEvent.preventDefault();
                var element = $(this)
                gg.messageService.setMessageLevel(element.attr( "action" ));
            });

            gg.$el.on('click', '.gg-comment-filter' ,function(event){
                event.originalEvent.preventDefault();
                var element = $(this)
                gg.messageService.toggleCommentRows();
            });

            gg.$el.on('click', '.gg-attachment-filter' ,function(event){
                event.originalEvent.preventDefault();
                var element = $(this)
                gg.messageService.toggleAttachmentRows();
            });


            gg.$el.on('click', '.gg-override-filter' ,function(event){
                event.originalEvent.preventDefault();
                var element = $(this)
                gg.messageService.toggleOverrideCellstRows();
            });

            /************************dvalaboju001 11/14/2019****************** */
            // Export-action clicks are now handled by Angular GridDirective.
            // The legacy handler read a 'filtered' attribute that no longer
            // exists in the Angular scaffold HTML and relied on hidden DOM
            // elements (#action_id, #grid_id, etc.) also absent in Angular.


            gg.$el.on('mousedown', '.gg-col-tools-header' ,function(event){
                var element = $(this)
                event.originalEvent.preventDefault();
                var evtobj= window.event? event : e;
                var cloneElement = element.clone();
                element.addClass('gg-col-header-alpha');
                if(evtobj.ctrlKey){
                    gg.headerService.addDragElement(cloneElement);
                    return false
                }else{
                    gg.headerService.addDragElement(cloneElement);
                    dragToolCol(event);
                }

                $(window).bind('mousemove',  dragToolCol);
                $(window).bind('mouseup', unBindDragToolCol);

            });


            gg.$el.on('mousedown', '.gg-check-show-hide' ,function(event){
                event.stopPropagation();
                event.preventDefault();
                ////console.log(this);
                var map = $(this).parent().attr('map');
                var display = $(this).parent().attr('display');
                gg.headerService.hideShowCol(map,display)
            });




            function dragToolCol(event){
                ////console.log('event' , event);
                var left = event.pageX;
                var top = event.pageY;

                $(".gg-col-tools-header" ).removeClass( "gg-target-element" );
                gg.headerService.dragColTool(left,top);


                var target = $(event.target);
                if ( target.is( "i" ) ) {
                    target.addClass('gg-target-element')
                } else if  (target.is( "div.gg-col-tools-header" )) {
                    target.addClass('gg-target-element')
                }

            }

            function unBindDragToolCol(event){
                $(window).unbind('mousemove', dragToolCol);
                $(window).unbind('mouseup', unBindDragToolCol);

                ////console.log('event.target' , event.target);

                var target = $(event.target);
                var map = "";
                var display = "";

                if ( target.is( "i" ) ) {
                    target = target.parent();
                    map = target.attr('map');
                    display = target.attr('display');
                } else if  (target.is( "div.gg-col-tools-header" )) {
                    map = target.attr('map');
                    display = target.attr('display');
                } else{
                    target == null;
                }


                ////console.log(target);
                ////console.log("map " , map);
                ////console.log("display " , display);

                gg.headerService.dropColTool(map,display);

            }





            ////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////


            /////////////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////// .div-col SELECT /////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////////////

            gg.$el.on('mousedown', '.div-col' ,function(event){
                var element = event.currentTarget;

                event.originalEvent.preventDefault();

                cancelPendingCellSelect();
                cellSelectTimeoutId = setTimeout(function(){
                    cellSelectTimeoutId = null;
                    gg.renderSelected.clearAll();
                    gg.selectCell(element,event);

                    $(window).bind('mousemove', cellSelectHandler);
                    $(window).bind('mouseup', unBindCellSelect);


                    if(gg.preventDefaultContext) {
                        if (event.which === 3) {
                            gg.contextmenu(event);
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                    gg.$el.find('.gg-body').focus();
                }, 10);
            });


            function cellSelectHandler(event){
                var target = $( event.target );
                var fromCellRow = gg.selected.row_id;
                var fromCellCol = gg.selected.col_id;
                if ( target.is( ".div-col-data" ) ) {
                    target = $( event.target ).parent()
                    var toCellRow = target.attr('rowobj');
                    var toCellCol = target.attr('colobj');
                    gg.renderSelected.selectCellGroup(fromCellRow,fromCellCol,toCellRow,toCellCol);
                }else if( target.is( ".div-col" )  ){
                    var toCellRow = target.attr('rowobj');
                    var toCellCol = target.attr('colobj');
                    gg.renderSelected.selectCellGroup(fromCellRow,fromCellCol,toCellRow,toCellCol);
                }

                return true;
            }



            function unBindCellSelect(event){
                //////console.log("UNBIND")
                $(window).unbind('mousemove', cellSelectHandler);
                $(window).unbind('mouseup', unBindCellSelect);
                gg.renderSelected.setCellGroup();
            }





            /////////////////////////////////////////////////////////////////////////////////////////////////////////
            /////////////// .div-col-prime SELECT /////////////////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////////////

            gg.$el.on('mousedown', '.div-col-prime' ,function(event){
                event.originalEvent.preventDefault();
                $(window).bind('mousemove', rowSelectHandler);
                $(window).bind('mouseup', unBindRowSelectDrag);
                gg.selectRow($(this),false);
                gg.renderSelected.selectRowGroup(gg.selected.row_id,gg.selected.row_id);
            });


            /*
             gg.$el.on('click', '.div-col-prime' ,function(event){

             if (event.ctrlKey) {
             gg.selectRow($(this), true);
             } else if(event.shiftKey){
             }else{
             gg.selectRow($(this),false);
             }

             });

             */




            function rowSelectHandler(event){
                var target = $( event.target );
                var fromRow = gg.selected.row_id;
                if ( target.is( ".div-col-data" ) ) {
                    target = $( event.target ).parent()
                    var toRow = target.attr('rowobj');
                    gg.renderSelected.selectRowGroup(fromRow,toRow);
                }else if( target.is( ".div-col-prime" )  ){
                    var toRow = target.attr('rowobj');
                    gg.renderSelected.selectRowGroup(fromRow,toRow);
                }


                //gg.scrollDown(event);

                //TODO: CREATE TICKER ------------------------------
                var top = gg.elements.body.offset().top;
                var bottom = gg.elements.body.height() + gg.elements.body.offset().top;

                if( event.pageY > bottom ){
                    gg.scrollDown(event);
                }

                if( event.pageY < top ){
                    gg.scrollUp(event);
                }


                return true;

            }

            function unBindRowSelectDrag(event){
                // event.data.element.removeClass('gg-btn-mouse-down');
                //////console.log("UNBIND")
                $(window).unbind('mousemove', rowSelectHandler);
                $(window).unbind('mouseup', unBindRowSelectDrag);

                gg.renderSelected.setSelectedGroup();
            }


            /////////////// END DRAG MODAL ///////////////////////////////////////////////////////////////////////////





            gg.$el.on('click', '.gg-check-click' ,function(event){
                gg.edit.checkAreaEdit();
            });



            ///////////////////////////////// START  V-TRACK /////////////////////////////////////
            gg.elements.vtrack.mousedown(function(e) {
                clearInterval(interval);
                if( $(e.target).attr('class') === 'vScroll-track'){
                    var thisEvent = e;
                    gg.scroll.trackVScroll(thisEvent);
                    interval = setInterval(function(e){
                        gg.scroll.trackVScroll(thisEvent);
                    },100)
                    var element =  $(this);
                    $(window).bind('mouseup',{element:element}, unBindVtrackVScroll);
                }else{
                    ////////console.log("called unbind")
                    $(window).unbind('mouseup', unBindVtrackVScroll);
                }
            })

            function unBindVtrackVScroll(event){
                clearInterval(interval);
                $(window).unbind('mouseup', unBindVtrackVScroll);
            }

            ///////////////////////////////// END  V-TRACK /////////////////////////////////////




            ///////////////////////////////// START  H-TRACK /////////////////////////////////////

            gg.elements.htrack.mousedown(function(e) {
                clearInterval(interval);
                if( $(e.target).attr('class') === 'hScroll-track'){
                    var thisEvent = e;
                    gg.scroll.trackHScroll(thisEvent);
                    interval = setInterval(function(e){
                        gg.scroll.trackHScroll(thisEvent);
                    },100)
                    var element =  $(this);
                    $(window).bind('mouseup',{element:element}, unBindHtrackHScroll);
                }else{
                    ////////console.log("called unbind")
                    $(window).unbind('mouseup', unBindHtrackHScroll);
                }
            })

            function unBindHtrackHScroll(event){
                clearInterval(interval);
                $(window).unbind('mouseup', unBindHtrackHScroll);
            }

            ///////////////////////////////// END  H-TRACK /////////////////////////////////////


            // CLOSE ALL OFF CLICKS
            gg.$el.on('click' ,function(event){
                if(event.which !== 3 ) {
                    gg.closeContextMenu();
                }
                gg.$el.find('.gg-drop-down-menu').removeClass('open');
                // Don't auto-close gg-dropMenu when click originates inside one;
                // the toggle / multi-select / action handlers manage their own state.
                // Without this guard, this handler fires before the toggle handler
                // (both bound on gg.$el) and clears .gg-dd-open, so the toggle
                // handler always reads wasOpen=false and never calls buildMenu()
                // on the opening click.
                if (!$(event.target).closest('.gg-dropMenu').length) {
                    gg.$el.find('.gg-dropMenu').removeClass('gg-dd-open');
                }
            });


            gg.$el.on('click', '.open-input' ,function(event){
                var map = $(this).closest('.headerCol').attr('map');
                var action = $(this).attr('action');
                gg.FilterModalService.openFilterModalService(map,action);
            });


            //TODO: REMOVE
            /*gg.$el.on('click', '.modal-action' ,function(event){
                var action = $(this).attr('action');
                var map = $(this).closest('.gg-modal-filter').attr('map');
                switch (action) {
                    case 'close':
                        gg.FilterModalService.closeFilterModalService(map,action);
                        break;
                    case 'submit':
                        gg.FilterModalService.filter(map,action);
                        break;
                }
                //closeFilterModalService
            });*/


            gg.$el.on('click', '.gg-modal-action' ,function(event){
                var action = $(this).attr('action');
                var map = $(this).closest('.gg-modal-filter').attr('map');
                switch (action) {
                    case 'close':
                        gg.ModalService.closeModalService(map,action);
                        break;
                    case 'submit':
                        gg.FilterModalService.filter(map,action);
                        break;
                    case 'formatCol':
                        var select = gg.elements.modalContainer.find('.gg-modal-select').val();
                        var name = gg.elements.modalContainer.find('.gg-modal-input').val();
                        var thisMap = $(this).attr('map');
                        var currentDataCol = _.find(gg.data.headerArray, {'map':thisMap} )
                        gg.headerService.formatCol(currentDataCol,select,name)
                        gg.ModalService.closeModalService(map,action);
                        break;
                }
                //closeFilterModalService
            });





            ////////////////////////////////////////////////////////////////////////////////////////
            /// : START Multi-Filter  //////////////////////////////////////////////////////////////

            gg.$el.on('click', '.gg-dropMenu .dropdown-toggle' ,function(event){
                event.preventDefault();
                event.stopPropagation();

                var parent = $(this).parent(),
                    element = parent.find('.gg-menu-container');
                var map = parent.parent().attr('map');
                var wasOpen = parent.hasClass('gg-dd-open');

                // Close every other open column dropdown, but leave THIS one
                // alone so the wasOpen branch below reflects the real prior
                // state (rather than what the close-all handler just cleared).
                gg.$el.find('.gg-dropMenu').not(parent).removeClass('gg-dd-open');

                if (wasOpen) {
                    parent.removeClass('gg-dd-open');
                    gg.focus.gridBody.focus();
                    return;
                }

                parent.addClass('gg-dd-open');
                parent.find('.gg-multi-select-input').val(''); // RESET SEARCH FILTER
                gg.positionMenu(element);
                gg.uniqueFilters.buildMenu(map, gg.data.dataArr, '', '', true);
            });


            gg.$el.on('keyup' , '.gg-multi-select-input',function(e){
                var code = e.keyCode || e.which;
                if(code == 13){
                    var map = $(this).closest('.headerCol').attr('map');
                    gg.uniqueFilters.applyFilter(map);
                    gg.focus.gridBody.focus();
                }
            });


            gg.$el.on('click', '.gg-multi-select-cancel' ,function(event){
                $(this).closest('.gg-dropMenu').removeClass('gg-dd-open');
                gg.focus.gridBody.focus();
            });



            gg.$el.on('click', '.gg-multi-select-apply' ,function(e){
                var map = $(this).closest('.headerCol').attr('map');
                gg.uniqueFilters.applyFilter(map);
                gg.focus.gridBody.focus();
            });


            gg.$el.on('keyup change', '.gg-multi-select-input' ,function(event){
                var searchString = $(this).val();
                var map = $(this).closest('.headerCol').attr('map');
                gg.uniqueFilters.buildMenu(map,gg.data.dataArr,searchString,true,false);
                event.stopPropagation();

            });

            gg.$el.on('click', '.gg-multi-checkbox_all' ,function(e){
                var map = $(this).closest('.headerCol').attr('map');
                var searchString = $(this).parent().parent().parent().find('.gg-multi-select-input').val();
                if( $(this).is(':checked')){
                    gg.uniqueFilters.buildMenu(map,gg.data.dataArr,searchString,true,false);
                }else{
                    gg.uniqueFilters.buildMenu(map,gg.data.dataArr,searchString,false,false);
                }
            });

            gg.$el.on('click', '.gg-multi-checkbox' ,function(event){
                var map = $(this).closest('.headerCol').attr('map');
                if( $(this).is(':checked') === false ){
                    $(".gg-multi-checkbox_all").prop('checked', false);
                    gg.uniqueFilters.removeSelected(map,$(this).val());
                }else{
                    gg.uniqueFilters.addSelected(map,$(this).val());
                }
            });

            gg.$el.on('click', '.gg-multi-select' ,function(event){
                event.stopPropagation();
            });

	        // gg.$el.on('click', '.gg-dropMenu .dropdown-menu' ,function(event){
            //     event.stopPropagation();
            // });
            /// : END Multi-Filter  //////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////////////////////////////////

            gg.$el.on('click', '.gg-column-click' ,function(event){
                var element = $(event.currentTarget);
                var parent = element.parent();
                var col_id = element.closest('.gg-dropMenu').attr('colObj');
                var inputVal = parent.find('.gg-column-search');
                gg.columnSearch(col_id, inputVal.val());
            })


            gg.$el.on('keydown', '.go-to-input' ,function(event){
                event.stopPropagation();
                if(event.which == 13) {
                    event.stopPropagation()
                    var val = $(this).val();
                    gg.gotoLineNumber(val);
                    $(this).val("");
                }
            });


            gg.$el.on('keydown', '.gg-input-text' ,function(event){
                if(event.which == 13) {
                    $('.gg-input-text', gg.$el).blur();
                }
            });


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////// COPY PASTE HANDLERS  /////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////



            gg.$el.on('keydown',function(e){
                var evtobj= window.event? event : e
                var className = document.activeElement.getAttribute("class");
                var code = e.keyCode || e.which;



                //console.log("evtobj " , evtobj);
                //console.log("className " , className);
                //console.log("code " , code);
                //console.log("evtobj.metaKey " , evtobj.metaKey);


                if( (evtobj.ctrlKey  || evtobj.metaKey)    && ( className == 'gg-body' || className == 'gg-hidden-textarea' 
                    || className=='gg-body isPivot-gridLayout' || className=='gg-body isPivotExpand-gridLayout')) {





                    //console.log("DID WE MAKE IT IN HERE ");

                    gg.elements.hiddenTA.val("");
                    gg.elements.hiddenTA.focus();


                    if(  code === 67 ){
                        gg.elements.hiddenTA.val(gg.edit.copy());
                        gg.elements.hiddenTA.select();
                        var successful = document.execCommand('copy');
                        // gg.elements.hiddenTA.val("");

                    }

                    gg.elements.hiddenTA.bind("keyup", function (e) {
                        if( code === 86){
                            var data = gg.elements.hiddenTA.val().trim();
                            gg.elements.hiddenTA.val("");


                            //Check to see if this is on cell or many
                            var rows = data.split("\n").length;
                            var cells = data.split("\t").length;
                            if(rows > 1 || cells > 1 ){
                                gg.pasteXls.processXls(data);
                            }else{
                                gg.edit.pasteCell(data);
                            }



                        }

                        gg.focus.gridBody.focus();
                        gg.elements.hiddenTA.unbind('keyup');
                    });
                }
            });




            gg.$el.on('click', '.endCap' ,function(e){
                //////console.log("test");

                gg.renderSelected.selectedAll();

            });



            // working
            gg.$el.on('mousedown', '.gg-input-text' ,function(event){

                if( event.which === 3 ){
                    //////////console.log("mouse down mouse down ")
                    gg.edit.setValue($(this).val());

                    gg.elements.editValue.hide();
                    gg.elements.editValue.html("");
                    gg.contextmenu(event);

                    var element = event.currentTarget;



                    //base.elements.editValue.css("top","0px");

                    //event.stopPropagation();
                }
            })



            gg.$el.on('keydown' , '.gg-body, .gg-body.isPivotExpand-gridLayout, .gg-body.isPivot-gridLayout' ,function(e){
                var className = document.activeElement.getAttribute("class");
                var code = e.keyCode || e.which;
                var evtobj= window.event? event : e
                e.preventDefault();

                var keyDownDebounce = _.debounce(function(e) {

                    e.stopPropagation();
                    e.preventDefault();



                    console.log("code ---is this being called className  " , className);
                    //console.log("evtobj " , evtobj);
                    if(className == 'gg-body' || className == 'gg-body isPivotExpand-gridLayout' 
                        || className == 'gg-body isPivot-gridLayout'){
                        if( _.inRange(parseInt(code),112,124) ){
                            ////////console.log("f-keys");
                        }else if( _.inRange(parseInt(code),146,185) ) {
                            ////////console.log("uknown-keys");
                        }else {
    
    
                            switch (code) {
                                case 18:
                                    ////////console.log("18");
                                    break;
                                case 17:
                                    ////////console.log("17");
                                    break;
                                case 91:
                                    ////////console.log("17");
                                    break;
    
                                case 38:
                                    gg.arrowMove("up");
                                    break;
    
                                case 40:
                                    gg.arrowMove("down");
                                    break;
    
                                case 37:
                                    gg.arrowMove("left");
                                    break;
    
                                case 39:
                                    gg.arrowMove("right");
                                    break;
    
                                case 33:
                                    gg.pageUp();
                                    break;
    
                                case 34:
                                    gg.pageDown();
                                    break;
    
                                case 17:
                                    gg.edit.keyDown(e, true);
                                    break;
    
                                case 13:
                                    gg.edit.keyDown(e, false);
                                    break;
    
    
                                case 91:
                                    gg.edit.keyDown(e, false);
                                    break;
    
                                default:
                                    gg.edit.keyDown(e, true);
                            }
                            e.preventDefault();
    
                        }
                    }
                   

                }, 5);
                keyDownDebounce(e);
            });

            gg.$el.on('click', '.gg-grid-action' ,function(event){
                var element = $(this)
                //action_key = element.closest('.gg-dropMenu').attr('colObj'),
                //input = element.parent().find('.gg-dropMenu-input').val(),
                //action = element.attr('action');
                //gg.dropdownAction(action,element,input,col_id)

                //action_key = element.closest('.gg-dropMenu').attr('action_key'),
                var action_key = element.attr('action_key');
                event.stopPropagation();
                event.preventDefault();
                console.log(action_key);
                console.log(element);
            });
            gg.$el.on('keydown', '.gg-dropMenu-input' ,function(event){
                if(event.which == 13) {
                    var element = $(this),
                        action = element.parent().find('.gg-menu-action').attr('action'),
                        col_id = element.closest('.gg-dropMenu').attr('colObj'),
                        input = element.parent().find('.gg-dropMenu-input').val();
                    gg.dropdownAction(action,element,input,col_id)
                }
            });


            gg.$el.on('click', '.gg-menu-action' ,function(e){
                var element = $(this),
                    col_id = element.closest('.gg-dropMenu').attr('colObj'),
                    input = element.parent().find('.gg-dropMenu-input').val(),
                    action = element.attr('action');
                gg.dropdownAction(action,element,input,col_id)
                element.closest('.gg-dropMenu').removeClass('gg-dd-open');

            });

            gg.$el.on('click', '.gg-context-action' ,function(e){

                var element = $(this),
                    col_id = element.attr('colobj'),
                    input = element.attr('value'),
                    action = element.attr('action');
                gg.dropdownAction(action,element,input,col_id);
            });


            gg.$el.on('mouseover', '.gg-hot-spot' ,function(event){
                var element = $(event.currentTarget);
                gg.messageService.hoverShow(element.attr('obj_id'),element.offset().left,element.offset().top,element.width(),element.height());
            });

            gg.$el.on('mouseout', '.gg-hot-spot' ,function(e){
                //gg.dropdownAction(e);
                var openElement = $('.gg-message-container', gg.$el);
                if(!openElement.is(':hover')){
                    gg.messageService.hoverHide();
                }

            });

            $('.gg-message-container' ,gg.$el).mouseleave(function(e) {
                gg.messageService.hoverHide();
            });
            gg.$el.on('click', '.gg-attachment-action' ,function(event){
                var parent_key = $(this).attr('parent_key'),
                parent_type = $(this).attr('parent_type'),
                action = $(this).attr('action'),
                file_name=$(this).attr('file_name');
                console.log("++++++---+++++",parent_key,parent_type,action,gg,base);
                if(action=="download"){
                    gg.messageService.downLoadAttachment(file_name,parent_key);
                   /*  var secondaryWindow = window.open(base.base_url +'/downloadCommentAttachement?fileName=' +file_name+"&commentKey="+parent_key);
                    if (secondaryWindow == null) {
                        return;
                    }
                    // Check if there was a problem downloading the attachment.
                    secondaryWindow.onload = function () {
                        if (secondaryWindow.document.body.innerHTML.length > 0) {
                                $scope.$broadcast('gtw.admin.client.downloadLogo.failed');
                                secondaryWindow.close();
                        }
                    }; */
                }else if( action  === 'edit'){
                   gg.messageService.editAttachments(parent_key,parent_type);

                }else if(action === 'preview'){
                    gg.messageService.previewAttachments(parent_key,file_name);

                }else if(action === 'deleteAttachment')
                    gg.messageService.deleteAttachmentByname(file_name,parent_key,parent_type);
            });
            gg.$el.on('click', '.gg-message-action' ,function(event){
                var comment_key = $(this).attr('comment_key'),
                    action = $(this).attr('action'),
                    task_status = $(this).attr('task_status'),
                    task_action_item = $(this).attr('task_action_item');

                //console.log("comment_key: " , comment_key);
                //console.log("action: " , action);


                if( action  === 'edit'){
                    gg.messageService.editMessage(comment_key);
                }else if(action  === 'resolve' ){
                    gg.messageService.resolve(comment_key,task_status,task_action_item);
                }else if(action  === 'showForm' ){
                    gg.$el.find('.reply-form-update[comment_key='+comment_key+']').show();
                    gg.$el.find('.gg-reply-comments[comment_key='+comment_key+']').hide();
                }else if(action  === 'cancelEdit' ){
                    gg.$el.find('.reply-form-update[comment_key='+comment_key+']').hide();
                    var val = gg.$el.find('.gg-reply-comments[comment_key='+comment_key+']').text();
                    gg.$el.find('.gg-reply-update-text-area[comment_key='+comment_key+']').val(val);
                    gg.$el.find('.gg-reply-comments[comment_key='+comment_key+']').show();
                }else if(action  === 'deleteReply' ){
                    gg.messageService.deleteReply(comment_key);
                }else if(action  === 'editReply') {
                    var text = gg.$el.find('.gg-reply-update-text-area[comment_key='+comment_key+']').val();
                    gg.messageService.editReply(comment_key,text);
                }else if(action  === 'copyLink') {
                    //gg.messageService.editReply(comment_key);
                    //console.log("copy the link")
                }

            });


            gg.$el.on('click', '.gg-header' ,function(event){
                gg.messageService.destroyMessages()
            });


            gg.$el.on('blur', '.gg-input-text' ,function(event){

                gg.elements.editValue.hide();
                gg.elements.editValue.html("");
                gg.edit.setValue( $(this).val() );
                event.stopPropagation();

            });



            gg.$el.on('click', '.div-col' ,function(event){
                var element = event.currentTarget;
                if( $(element).hasClass('gg-hot-spot')){
                    var element = $(event.currentTarget);
                    gg.messageService.renderMessages(element.attr('obj_id'),element.offset().left,element.offset().top,element.width(),element.height());
                    gg.messageService.toggleOpen();
                }else{
                    gg.messageService.destroyMessages();
                }



                /*
                if(  gg.selected.colData.edit_type === "dropdown"){
                    var element = event.currentTarget;
                    gg.edit.editCell(element,false);
                }
                */


            });




            gg.$el.on('click', '.gg-reply-btn' ,function(event){
                $(".gg-message-scroll").scrollTop($(".gg-message-scroll")[0].scrollHeight);
                gg.$el.find('.gg-reply-text-area').focus();

            });


            gg.$el.on('click', '.gg-add-reply' ,function(event){
                gg.messageService.addReply(  gg.$el.find('.gg-reply-text-area').val());
            });



            gg.$el.on('click', '.gg-reply-form .attach' ,function(event){
                gg.messageService.editMessage(gg.messageService.position.comment_key);
            });


            gg.$el.on('click', '.gg-cancel-reply' ,function(event){
                gg.$el.find('.gg-reply-text-area').val('');
            });


            gg.$el.on('contextmenu' ,function(event){

                if(gg.preventDefaultContext){
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                }



            });

            gg.$el.on('click', '.gg-alert-close' ,function(event){
                gg.removeAlert($(this));
            });


            gg.$el.on('click', '.tools-action' ,function(event){
                gg.toolsAction($(this));
            });



            gg.$el.on('click', '.gg-clear-item' ,function(event){
                //gg.actionsService.clearSelectedTemp(); /*  commented 3/4/2020 if we need to clear the individual item, we dont want to clear the grid actions */
                gg.clearFilter($(this).attr('action'),$(this).attr('map'));
            });


            gg.$el.on('click', '.gg-clear-all' ,function(event){
                gg.actionsService.clearSelectedTemp();
                gg.clearAll();
            });


            gg.$el.on('keyup', '.gg-global-search' ,function(event){
                event.stopPropagation();
                gg.globalSearch( $(this).val() );
            })






            gg.$el.on('keyup', '.gg-column-search' ,function(event){
                if(event.which == 13) {
                    var element = $(event.currentTarget);
                    var col_id = element.closest('.gg-dropMenu').attr('colObj');
                    gg.columnSearch(col_id, $(this).val());
                }
            })


            gg.$el.on('click', '.close-form' ,function(event){
                ////////////////////////////////console.log("test------", $(this).val());
                gg.closeForm();
            })


            gg.$el.on('click', '.grid-action-btn' ,function(event){
                ////////////////////////////////console.log("test------", $(this).val());
                var rowobj = $(this).parent().attr('rowobj');
                var colobj =  $(this).parent().attr('colobj');
                var curDataRow = _.find(gg.data.safeCopyArr, {'object_id':rowobj});
                var curDataCol = _.find(gg.data.headerArray, {'map':colobj});
                var data = {
                    colData:curDataCol,
                    rowData:curDataRow
                }
                gg.api.callBack( curDataCol.call_back,data,'form');
            })

            gg.$el.on('click', '.grid-download-btn' ,function(event){
                var rowobj = $(this).parent().attr('rowobj');
                var colobj =  $(this).parent().attr('colobj');
                var curDataRow = _.find(gg.data.safeCopyArr, {'object_id':rowobj});
                var curDataCol = _.find(gg.data.headerArray, {'map':colobj});
               /// downloadAllDoc(curDataRow.DOC_PARENT_KEY)
               var id = curDataRow.DOC_PARENT_KEY != null ? curDataRow.DOC_PARENT_KEY : curDataRow.OBJECT_ID;
               gg.messageService.downloadAllDoc(id);
            })

            gg.$el.on('click', '.grid-download-file-btn' ,function(event){
                var rowobj = $(this).parent().attr('rowobj');
                var colobj =  $(this).parent().attr('colobj');
                var curDataRow = _.find(gg.data.safeCopyArr, {'object_id':rowobj});
                var curDataCol = _.find(gg.data.headerArray, {'map':colobj});
               gg.messageService.downloadDoc(curDataRow.FILE_NAME);
            })


            gg.$el.on('click', '.grid-drill-down-btn' ,function(event){
                var data = {
                    colData: gg.selected.colData,
                    rowData: gg.selected.rowData,
                    value:   gg.selected.value
                }

                gg.api.callBack( 'drillDown',data,'drillDown');
            })


            gg.$el.on('click', '.grid-link-btn' ,function(event){
                var data = {
                    colData: gg.selected.colData,
                    rowData: gg.selected.rowData,
                    value:   gg.selected.value
                }
                gg.api.callBack( 'link',data,'link');
            })


            gg.$el.on('click', '.grid-drilldown-btn' ,function(event){
                var data = {
                    colData: gg.selected.colData,
                    rowData: gg.selected.rowData,
                    value:   gg.selected.value
                }

                gg.api.callBack( 'drillDown',data,'drillDown');
            })


            gg.$el.on('keydown', '.gg-input-text' ,function(event){
                event.stopPropagation();
            });

            gg.$el.on('keydown', '.gg-dropMenu-input' ,function(event){
                event.stopPropagation();
            });


            gg.$el.on('keydown', '.div-col' ,function(event){
               console.log("keydown test test tets");
               event.stopPropagation();

            });


            gg.$el.on('dblclick', '.div-col' ,function(e){
                cancelPendingCellSelect();
                var element = this;
                var openedForm = false;
                try {
                    openedForm = openFormModalFromCell(element);
                } catch (err) {}
                try {
                    gg.selectCell(element,e);
                } catch (err) {}
                if (!openedForm) {
                    gg.edit.editCell(element,false);
                }
            });

            // Same path as the pencil (.grid-action-btn) click. Double-click
            // used to depend on selectCell/editCell, which aborts when the
            // column map is not a safe CSS identifier, so only the pencil
            // opened the modal.
            function openFormModalFromCell(element) {
                var $cell = $(element);
                var colobj = $cell.attr('colobj');
                var rowobj = $cell.attr('rowobj');
                if (rowobj == null || rowobj === '') {
                    rowobj = $cell.parent().attr('rowobj');
                }
                var curDataCol = _.find(gg.data.headerArray, {'map': colobj});
                if (!curDataCol && gg.data.headerArraySafe) {
                    curDataCol = _.find(gg.data.headerArraySafe, {'map': colobj});
                }
                if (!curDataCol || curDataCol.edit_type != 'form' || !curDataCol.call_back) {
                    return false;
                }
                if (curDataCol.edit_icon == 'download') {
                    return false;
                }
                var curDataRow = _.find(gg.data.safeCopyArr, {'object_id': rowobj});
                if (!curDataRow) {
                    return false;
                }
                if (typeof curDataCol.edit_rules != "undefined" &&
                    !gg.buildDom.isRowColEditable(curDataRow, curDataCol.edit_rules)) {
                    return false;
                }
                gg.api.callBack(curDataCol.call_back, {
                    colData: curDataCol,
                    rowData: curDataRow
                }, 'form');
                return true;
            }


            gg.$el.on('click', '.sortHeader' ,function(e){
                gg.sort(e);
                gg.focus.gridBody.focus();
            });


            $('.btn-scroll-right' ,gg.$el).mousedown(function(e) {
                clearInterval(interval);
                $(this).addClass('gg-btn-mouse-down');
                gg.scrollRight(e);
                interval = setInterval(function(e){
                    gg.scrollRight(e);
                },100)
                var element =  $(this);
                $(window).bind('mouseup',{element:element}, unBindVButtonScroll);
            })


            $('.btn-scroll-left' ,gg.$el).mousedown(function(e) {
                clearInterval(interval);
                $(this).addClass('gg-btn-mouse-down');
                gg.scrollLeft(e);
                interval = setInterval(function(e){
                    gg.scrollLeft(e);
                },100)
                var element =  $(this);
                $(window).bind('mouseup',{element:element}, unBindVButtonScroll);
            })


            $('.btn-scroll-down' ,gg.$el).mousedown(function(e) {
                clearInterval(interval);
                $(this).addClass('gg-btn-mouse-down');
                gg.scrollDown(e);
                interval = setInterval(function(e){
                    gg.scrollDown(e);
                },100)
                var element =  $(this);
                $(window).bind('mouseup',{element:element}, unBindVButtonScroll);
            })

            $('.btn-scroll-up' ,gg.$el).mousedown(function(e) {
                clearInterval(interval);
                $(this).addClass('gg-btn-mouse-down');
                gg.scrollUp(e);
                interval = setInterval(function(e){
                    gg.scrollUp(e);
                },100)
                var element =  $(this);
                $(window).bind('mouseup',{element:element}, unBindVButtonScroll);
            })


            function unBindVButtonScroll(event){
                clearInterval(interval);
                event.data.element.removeClass('gg-btn-mouse-down');
                $(window).unbind('mouseup', unBindVButtonScroll);
            }

            /////////////// TOREMOVE TOREMOVE ------------ ///////////////////////////////////////////////////////////
            /////////////// START DRAG MODAL /////////////////////////////////////////////////////////////////////////

            $('.gg-modal-filter .gg-modal-header' ,gg.$el).mousedown(function(e) {
                var element =  $(this);
                $(window).bind('mousemove',{element:element}, dragFilterModalHandler);
                $(window).bind('mouseup',{element:element}, unBindFilterModalDrag);
            })

            function dragFilterModalHandler(event){
                var $element =  $('.gg-modal-filter .gg-modal-header' ,gg.$el)
                gg.FilterModalService.dragModal( event.pageY - 15, event.pageX - $element.width() / 2)
            }

            function unBindFilterModalDrag(event){
                // event.data.element.removeClass('gg-btn-mouse-down');
                $(window).unbind('mousemove', dragFilterModalHandler);
                $(window).unbind('mouseup', unBindFilterModalDrag);
            }

            /////////////// END DRAG MODAL ///////////////////////////////////////////////////////////////////////////


            /////////////// START DRAG MODAL /////////////////////////////////////////////////////////////////////////

            $('.gg-modal-container .gg-modal-header' ,gg.$el).mousedown(function(e) {
                var element =  $(this);
                $(window).bind('mousemove',{element:element}, dragModalHandler);
                $(window).bind('mouseup',{element:element}, unBindModalDrag);
            })

            function dragModalHandler(event){
                var $element =  $('.gg-modal-container .gg-modal-header' ,gg.$el)
                gg.ModalService.dragModal( event.pageY - 15, event.pageX - $element.width() / 2)
            }

            function unBindModalDrag(event){
                // event.data.element.removeClass('gg-btn-mouse-down');
                $(window).unbind('mousemove', dragModalHandler);
                $(window).unbind('mouseup', unBindModalDrag);
            }

            /////////////// END DRAG MODAL ///////////////////////////////////////////////////////////////////////////



            /////////////// START V-SCROLL //////////////////////////////////////////////////////

            gg.$el.on('mousedown', '.vScroll-dragger' ,function(event){
                $('body').css( 'cursor', 'pointer' );
                var element = event.target;
                $(window).bind('mouseup',{element:element}, unBindVDragger);
                $(window).bind('mousemove',{element:element}, gg.vScrollDrag);
                event.originalEvent.preventDefault();
            });


            gg.$el.bind('mousewheel DOMMouseScroll', function(event){

                if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                    gg.scrollUp(event);
                }
                else {
                    gg.scrollDown(event);
                }

            });

            function unBindVDragger(){
                $('body').css( 'cursor', 'default' );
                $(window).unbind('mousemove', gg.vScrollDrag);
                $(window).unbind('mouseup', unBindVDragger);
            }


            /////////////// END V-SCROLL //////////////////////////////////////////////////////

            /////////////// START V-SCROLL //////////////////////////////////////////////////////

            gg.$el.on('mousedown', '.hScroll-dragger' ,function(event){

                event.stopPropagation();
                event.preventDefault();
                $('body').css( 'cursor', 'pointer' );
                var element = event.target;
                $(window).bind('mouseup',{element:element}, unBindHDragger);
                $(window).bind('mousemove',{element:element}, gg.hScrollDrag);
                event.originalEvent.preventDefault();
                return false

            });

            function unBindHDragger(){
                $('body').css( 'cursor', 'default' );
                $(window).unbind('mousemove', gg.hScrollDrag);
                $(window).unbind('mouseup', unBindHDragger);
                gg.onHorzScrollOff();
            }


            ////////////////// END H-SCROLL //////////////////////////////////////////////////////////





            $(window).resize(function(e) {
                gg.resize(e);
            });




            // ++ START ++ //////////////////////////////// COL RESIZE /////////////////////////////
            gg.$el.on('mousedown', '.col-resize-handle' ,function(event){
                event.stopPropagation();
                var element = event.target;
                $(window).bind('mouseup',{element:element}, unBindDragColHandler);
                $(window).bind('mousemove',{element:element}, gg.dragColHandler);
                event.preventDefault();
            });

            function unBindDragColHandler(){
                $(window).unbind('mousemove', gg.dragColHandler);
                $(window).unbind('mouseup', unBindDragColHandler);
                gg.dragColHandlerEnd();
                event.stopPropagation();
            }

            // ++ END ++ ///////////////////////////////// COL RESIZE /////////////////////////////

            // ++ START ++ //////////////////////////////// ROW RESIZE /////////////////////////////
            gg.$el.on('mousedown', '.row-resize-handle' ,function(event){
                event.stopPropagation();
                var element = event.target;
                $(window).bind('mouseup',{element:element}, unBindDragRowHandler);
                $(window).bind('mousemove',{element:element}, gg.dragRowHandler);
                event.preventDefault();
            });

            function unBindDragRowHandler(){
                $(window).unbind('mousemove', gg.dragRowHandler);
                $(window).unbind('mouseup', unBindDragRowHandler);
                gg.dragRowHandlerEnd();
                event.stopPropagation();
            }

            // ++ END ++ ///////////////////////////////// ROW RESIZE /////////////////////////////

            // ++ START ++ //////////////////////////////// COL REORDER /////////////////////////////

            gg.$el.on('mousedown', '.dragOrder' ,function(event){
                if (event.which !== 3) { //MAKE SURE NOT RIGHT CLICK
                    ////////console.log("this " , this);
                    event.stopPropagation();

                    console.log("Grid info ----------------------------" , gg);
                    var element = $(this);

                    //DO NOT LET USER CHANGE ORDER ON IMPORT
                    if( gg.options.gridType && gg.options.gridType !== 'import'){
                        $(window).bind('mouseup',{element:element}, unBindColReorderHandler);
                        $(window).bind('mousemove',{element:element}, gg.dragReorderColHandler);
                    }



                    var map = element.attr("map");

                    //////console.log(" map : " ,map);

                    if (event.ctrlKey) {
                        gg.renderSelected.setColGroup(map,true);
                    } else if(event.shiftKey){
                        //WILL BE SHIFT SELECT
                    }else{
                        // gg.selectCol($(element),false);
                        gg.renderSelected.setColGroup(map,false);
                    }

                    event.preventDefault();



                }
            });


            function unBindColReorderHandler(){
                $(window).unbind('mousemove', gg.dragReorderColHandler);
                $(window).unbind('mouseup', unBindColReorderHandler);
                gg.dragReorderColHandlerEnd();
                event.stopPropagation();
            }

            // ++ END ++ ///////////////////////////////// COL REORDER /////////////////////////////

            // ++ START ++ //////////////////////////////// COL FIXED  /////////////////////////////


            gg.$el.on('mousedown', '.fixed-col-handler' ,function(event){

                gg.resetHScroll();

                if (event.which !== 3) { //MAKE SURE NOT RIGHT CLICK
                    event.stopPropagation();
                    var element = event.target;
                    $(window).bind('mouseup',{element:element}, unBindColFixedHandler);
                    $(window).bind('mousemove',{element:element}, gg.dragFixedColHandler);
                    event.preventDefault();
                }

            });

            function unBindColFixedHandler(){
                $(window).unbind('mousemove', gg.dragFixedColHandler);
                $(window).unbind('mouseup', unBindColFixedHandler);
                gg.dragFixedColHandlerEnd();
                event.stopPropagation();
            }

            // ++ END ++ //////////////////////////////// COL FIXED  /////////////////////////////
            gg.$el.on('mousedown', '.stopEvent' ,function(event){
                event.stopPropagation();
            });


            ///// JQUERY MESSAGE FUNCTIONS ///////////////////////////////////////////////////////////////////////

            gg.$el.on('click', '.gg-tab' ,function(event){
                $('.gg-tab' ,gg.$el).removeClass('active');
                $('.gg-tab-body' ,gg.$el).css('display','none');
                $(this).addClass('active');
                var tabShow = $(this)[0].getAttribute('show');//$(this).attr('show');
                $(".gg-tab-body[gg-tab='"+tabShow+"']" ,gg.$el).css('display','block');
            })




            gg.$el.on('click', '.gg-message' ,function(event){
                var comment_key = $(this).attr('comment_key');
                var element = $(this).find('.gg-message-arrow').find('i');
                element.removeClass('fa-chevron-right');
                element.addClass('fa-spinner fa-pulse ');
                gg.messageService.loadMessage(comment_key);
            });


            gg.$el.on('click', '.gg-attachement' ,function(event){
                var parent_key = $(this).attr('parent_key');
                var parent_type = $(this).attr('parent_type');
                var element = $(this).find('.gg-message-arrow').find('i');
                element.removeClass('fa-chevron-right');
                element.addClass('fa-spinner fa-pulse ');
                gg.messageService.loadAttachment(parent_key,parent_type);
            });

            gg.$el.on('click', '.gg-message-top' ,function(event){
                gg.messageService.back();
            });




            $(document).on("resizeGrid", function (e) {
                setTimeout(function(){
                    gg.resize(e);
                }, 500);
            });



            gg.$el.bind( "ggUpdateData", function( e , data ) {
                gg.api.updateData(data);
            });

            gg.$el.bind( "ggLoadData", function( e , data ) {
                gg.api.loadData(data);
            });



            //TODO: MAKE IT SO ALL OTHER gg-drop-down-menu WHEN CLICKED

            gg.$el.on('click', '.gg-toggle-menu' ,function(event){

                var position = $(this).attr( "position" );
                var $dropMenu = $(this).find('.gg-drop-down-menu');

                if( $dropMenu.hasClass('open') ){
                    $dropMenu.removeClass('open')
                }else{
                    $dropMenu.addClass('open');
                }

                if( position == 'left' ){
                    var width = $dropMenu.width();
                    $dropMenu.css('left','-'+width+'px');
                }

                event.stopPropagation();
            });



        });
    };



//////////////////////////////////// ADD TO LODASH //////////////////////////////////////////////////////

//Add to LODASH Library
// findArrayByPartialValue
// Searched an ARRAY (String or Number) for partial values
_.mixin({
    'findArrayByPartialValue': function(collection, searchValue) {
        return _.filter(collection, function(object) {
                var n = ((typeof object === "undefined" || object === null) ? "" : object.toString());
                if (_.includes(n.toLowerCase(), searchValue.toLowerCase())) {
                    return true
                }
                return false;
        });
    }
});


// findByPartialValue
// Searched an Collection (String or Number) for partial values
    _.mixin({
        'findByPartialValue': function(collection, value) {
            return _.filter(collection, function(object) {
                for(var key in object){
                    if( object[key] != '' && object[key] != null) {
                        var n = object[key].toString();
                        if (_.includes(n.toLowerCase(), value.toLowerCase())) {
                            return true
                        }
                    }
                };
                return false;
            });
        }
    });



    _.mixin({
        'findByKeyPartialValue': function(collection, value, predicate) {
            return _.filter(collection, function(object) {
                var n = object[predicate];
                if( n != undefined  ){
                    n = n.toString();
                    if( _.includes(n.toLowerCase(), value.toLowerCase()) ){
                        return true
                    }
                    return false;
                }
                return false;
            })
        }
    });


    _.mixin({
        'findNotByKeyPartialValue': function(collection, value, predicate) {

            return _.filter(collection, function(object) {
                var n = object[predicate];
                if( n != undefined  ){
                    n = n.toString();
                    if( !_.includes(n.toLowerCase(), value.toLowerCase()) ){
                        return true
                    }
                    return false;
                }
                return false;
            })
        }
    });






//Add to LODASH Library
    _.mixin({
        'findNumByProperty': function(collection,property,value,operator) {
            return _.filter(collection, function(object) {

                // var num = parseInt(object[property]);
                var num = parseFloat(object[property]);

                if( operator == '>=' && num >= value ){
                    return true;
                }
                if( operator == '<=' && num <= value ){
                    return true;
                }
                if( operator == '=' && num == value ){
                    return true;
                }
                if( operator == '!=' && num != value ){
                    return true;
                }

                return false;
            });
        }
    });



    /*
     * Provides a convenience extension to _.isEmpty which allows for
     * determining an object as being empty based on either the default
     * implementation or by evaluating each property to undefined, in
     * which case the object is considered empty.
     */
    _.mixin( function() {
        // reference the original implementation
        var _isEmpty = _.isEmpty;
        return {
            // If defined is true, and value is an object, object is considered
            // to be empty if all properties are undefined, otherwise the default
            // implementation is invoked.
            isEmpty: function(value, defined) {
                if (defined && _.isObject(value)) {
                    return !(_.some || _.any)( value, function(value, key) {
                        return value !== undefined;
                    });
                }
                return _isEmpty(value);
            }
        }
    }());




    _.mixin({
        'uniqueColVal': function(_arr,_map,_data_type) {
            var data = _.map(_arr, _map);
            var uniq =   _.uniq(data);
            return uniq;
        }
    })


    _.mixin({
        'findByValues': function(collection, property, values) {
            return _.filter(collection, function(item) {
                return _.includes(values, item[property]);
            });
        }
    });

    _.mixin({
        'findByValuesNot': function(collection, property, values) {
            return _.filter(collection, function(item) {
                 return !_.includes(values, item[property]);
            });
        }
    });

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////START:  handlebarsjs helpers /////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



    Handlebars.registerHelper('ifCond', function(condition,equles, val1, val2) {
        if(condition === equles ){
            return val1;
        }else{
            return val2;
        }
    });




    Handlebars.registerHelper('splitName', function(name) {
        var t = name.split(" ");
        return t.length > 1 ?t[0].slice(0, 1)  + t[1].slice(0, 1):t[0].slice(0, 1);
    });


    Handlebars.registerHelper('showEdit', function( sso_id ,userAccessLevel ,curUser ,notifyList ) {

        function checkList(_curUser){
            var found = _.find(notifyList, { 'sso_id': _curUser })
            // console.log("notifyList"  , notifyList);
            // console.log("_curUser"  , _curUser);
            // console.log("found"  , found);
            if( found !== undefined ){
                return true;
            }else{
                return false;
            }
        }

        if(sso_id === curUser) {
            return true;
        }else if(userAccessLevel === 5){
            return true;
        }else if(checkList(curUser)){
            return true;
        }

        return false;
    });


    Handlebars.registerHelper('trimString', function(passedString, startstring, endstring) {
        // SECURITY: comment text is user-supplied. Returning a plain string lets
        // Handlebars HTML-escape it (the {{ }} default). Previously this returned
        // new Handlebars.SafeString(...), which disabled escaping and allowed a
        // stored XSS in the cell-comment hover tooltip.
        // (Pentest finding ASAP-FIND-25-06-0191065 - A03:2021 Injection / persistent XSS.)
        var safeSource = (passedString == null) ? '' : String(passedString);
        var theString = safeSource.substring( startstring, endstring );
        if(safeSource.length > endstring){
            theString += " ...";
        }
        return theString;
    });



    Handlebars.registerHelper('timeAgo', function(_date) {
        var date = new Date(_date);
        return moment( date).fromNow();
    });



////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////END:  handlebarsjs helpers /////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


});

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////START:  handlebarsjs templates //////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
var detailAttaHBTemplate = '<div class="gg-message-detail">'+
'        <div class="gg-message-top">' +
            '<li class="flex-item1"><i class="fa fa-chevron-left"></i></li>'+
            '<li class="flex-item2">{{ parent_type }}</li>'+
            '<li class="flex-item3"><img class="circular--square" src="assets/img/default-user-icon.png"></li>'+
            '<li class="flex-item4">{{timeAgo date}}</li> '+
            '<li class="flex-item1"></li> '+
'       </div>'+
'</div>';


var detailMessageHBTemplate = '<div class="gg-message-detail {{type}}">' +
'    <div class="gg-message-top">' +
'        <i class="fa fa-chevron-left" style="cursor: pointer"></i>' +
'        <span style="padding-left: 10px;font-family:ge-inspira;">{{ display_name }}</span>' +
'        <div style="display:inline-block; float:right;">'+
'           <span>{{timeAgo date}}</span>' +
'           <i class="fa fa-times" style="margin-left: 10px; cursor: pointer;"></i>'+
'        </div>'+
'    </div>' +
'    <div class="gg-message-header">' +
'        <div class="flex-wrapper">' +
'            <div class="flex-1">' +
        '   {{#if avatar_path}} '+
        '   <img alt="User1" height="50" width="50" cx="30" cy="30" r="19" x="45%" y="45%" style="float:left;margin-top: 7px;margin-right: 12px;" title="{{display_name}}"'+
            'src="{{avatar_path}}">'+
        '   {{else}}' +
'                <svg height="65" width="60" style="float: left">' +
'                    <circle cx="30" cy="30" r="25" stroke-width="3" fill="#cd5763"></circle>' +
'                    <text fill="white" font-size="24" font-family="Arial" x="50%" y="50%" alignment-baseline="middle" text-anchor="middle">{{{splitName display_name}}}</text>' +
'                </svg>{{/if}}' +
'            </div>' +
'            <div class="flex-2">' +
'                <ul>' +
'                    <li>Type:  Action Item</li>' +
'                    <li>' +
'                        View Type:  ' +
'                        <span class="circle-tag" style="{{ifCond is_public 1 "background-color: #33cc33" "background-color: #ff0000"}}"></span> {{ifCond is_public 1 "Public" "Private"}}' +
'                    </li>' +
'                    <li>Cell Data:  ({{value}})</li>' +
'                    <li>Target Date:  {{timeAgo date}}</li>' +
'                </ul>' +
'            </div>' +
'            <div class="flex-3">' +
'                <ul class="ul-list-style">' +
'                    <li class="li-list-style">' +
'                        <button type="button" class="btn btn-xs btn-default gg-message-action" style="height: 26px" task_status="{{task_status}}" task_action_item = "{{task_action_item}}" comment_key="{{comment_key}}" action="resolve">Resolve</button>' +
'                    </li>' +
'                    <li class="li-list-style">'+
'                       <div class="gg-drop-down">' +
'                           <div class="edit-btn gg-toggle-menu" position="left" style="font-size: 15px;"><i class="fa fa-ellipsis-v"></i>' +
'                               <ul class="gg-drop-down-menu">' +
'                                   <li class="gg-message-action" action="edit" comment_key="{{comment_key}}">Edit</li>' +
'                               </ul>' +
'                           </div>' +
'                       </div>' +
'                     </li>' +
'                </ul>' +
'            </div>' +
'        </div>' +
'        {{#if (showEdit sso_id userAccessLevel curUser notifyList) }}' +
'            <div class="right" style="padding-top:4px;"></div>' +
'        {{/if}}' +
'    </div>' +
'    <div class="clearfix"></div>' +
'' +
'    <div class="tab-bar">' +
'        <ul class="row" style="margin:0px">' +
'            <li show="comments" class="gg-tab col-md-4 active">Comments</li>' +
'            <li show="notify" class="gg-tab col-md-4">User Assign</li>' +
'            <li show="attachments" class="gg-tab col-md-4">Documents</li>' +
'        </ul>' +
'    </div>' +
'    <div class="gg-message-tabs" style="background: transparent; height: 300px;">' +
'        <div class="gg-tab-body" style="display:block" gg-tab="comments">' +
'           <div class="body" style="display:block">'+
'               {{message}}' +
'           </div>'+
'            <div class="gg-message-reply gg-messages-scroll">' +
'                {{#each replyList}}' +
'                    <div class="gg-reply clearfix" comment_key="{{comment_key}}" parent_key="{{parent_key}}">' +
                '   {{#if avatar_path}} '+
                '   <img alt="User1" height="40" width="40" cx="20" cy="20" r="19" x="45%" y="45%" style="float:left;margin-top: 7px;margin-right: 12px;" title="{{display_name}}"'+
                    'src="{{avatar_path}}">'+
                '   {{else}}' +
'                        <svg height="60" width="55" style="float: left">' +
'                            <circle cx="25" cy="25" r="20" stroke-width="3" fill="#1ca5cf"></circle>' +
'                            <text fill="white" font-size="20" font-family="Arial" x="45%" y="45%" alignment-baseline="middle" text-anchor="middle">{{{splitName display_name}}}</text>' +
'                        </svg>{{/if}}' +
'                        <div class="details-col">' +
'                            <h2>{{display_name}}<span style="font-size:12px; float: right;">{{timeAgo date}}</span></h2>' +
'                        </div>' +
'                        <div class="edit-col">' +
'                            <div class="gg-drop-down">' +
'                                <div class="edit-btn gg-toggle-menu" position="left"><i class="fa fa-ellipsis-v"></i>' +
'                                    <ul class="gg-drop-down-menu">' +
'                                        <li class="gg-message-action" action="showForm" comment_key="{{comment_key}}">Edit</li>' +
'                                        <li class="gg-message-action" action="deleteReply" comment_key="{{comment_key}}">Delete' +
'                                        </li>' +
'                                    </ul>' +
'                                </div>' +
'                            </div>' +
'                        </div>' +
'                        <div class="reply-form-update" comment_key="{{comment_key}}" parent_key="{{parent_key}}">' +
'                            <textarea class="gg-reply-update-text-area" comment_key="{{comment_key}}" name="update_comment">{{message}}</textarea>' +
'                            <div class="gg-reply-update-actions">' +
'                                <div class="btn btn-xs btn-info gg-message-action" action="editReply" comment_key="{{comment_key}}">Save</div>' +
'                                <div class="btn btn-xs btn-warning gg-message-action" action="cancelEdit" comment_key="{{comment_key}}">Cancel</div>' +
'                            </div>' +
'                        </div>' +
'                        <div class="gg-reply-comments" comment_key="{{comment_key}}">' +
'                            <span>{{message}}</span>' +
'                        </div>' +
'                    </div>' +
'                {{/each}}' +
'            </div>' +
'            <div class="gg-reply-form">' +
'                <textarea class="gg-reply-text-area" placeholder="add comment" name="new_comment"></textarea>' +
'                <i class="fa fa-paperclip attach" aria-hidden="true"></i>'+
'                <div class="btn btn-xs btn-info pull-right gg-add-reply">' +
'                    <i class="fa fa-arrow-circle-up" style="font-size: 20px"></i>' +
'                </div>' +
'            </div>' +
'        </div>' +
'        <div class="gg-tab-body" gg-tab="attachments">' +
'           <div class="gg-attachment gg-messages-scroll">'+
'            <b>Attachments:</b><br />' +
'            {{#each attachmentList}}' +
'                <li><i class="fa fa-file"></i> {{file_name}}</li>' +
'            {{/each}}' +
'           </div>'+
'        </div>' +
'        <div class="gg-tab-body" gg-tab="notify" style="padding: 5px;">' +
'           <div class="user-assigned">'+
'               <label>Assigned:</label><br>'+
'               <span><i class="fa fa-user user-icon"></i>{{ display_name }}</span>'+
'           </div>'+
'           <div class="user-notify">'+
'               <b>Notify:</b><br />' +
'               {{#each notifyList}}' +
'                   <li><i class="fa fa-user user-icon"></i> {{sso_id}} - {{display_name}} </li>' +
'               {{/each}}' +
'           </div>'+
'        </div>' +
'    </div>' +
'</div>';

var listMessageHBTemplate =
    '  <div class="gg-messages-scroll">'+
    '  {{#each comments}}'+
    '  <div class="gg-message clearfix" comment_key="{{comment_key}}">'+
    '  <div class="gg-message-status {{type}}"></div>'+
    '   {{#if avatar_path}} '+
    '   <img alt="User1" height="40" width="40" cx="20" cy="20" r="19" x="45%" y="45%" style="float:left;margin-top: 7px;margin-right: 12px;" title="{{display_name}}"'+
        'src="{{avatar_path}}">'+
    '   {{else}}' +
    '  <svg height="60" width="55" style="float: left"><circle cx="25" cy="25" r="20" stroke-width="3" fill="#cd5763"></circle>'+
        '<text fill="white" font-size="20" font-family="Arial" x="45%" y="45%" alignment-baseline="middle" text-anchor="middle"> {{{splitName display_name}}}</text></svg>{{/if}}'+
    '  <div class="gg-message-details">'+
    '  <div class="name">{{display_name}}<div class="date"><b>{{timeAgo date}}</b></div></div>'+
    '  <div class="subject"><span>{{trimString message 0 80}}</span></div>'+
    '  </div>'+
    '  <div class="gg-message-arrow" >' +
        '<i class="fa fa-chevron-right"></i>' +
      '</div>'+
    '  </div>'+
    '  {{/each}}'+
    '  </div>';

 var listAttachmentHBTemplate =

    '  <div class="gg-messages-scroll">'+
   '  {{#each attachments}}'+
    '  <div class="gg-message" parent_key="{{parent_key}}"parent_type="{{parent_type}}">'+
    '  <div class="gg-message-details">'+
    '  <div class="name">{{file_name}}</div>'+
         '<br><br>'+
        ' <i class="fa fa-cloud-download gg-attachment-action" style="margin-right:5px" action="download" parent_key="{{parent_key}}" file_name="{{file_name}}" parent_type={{parent_type}}></i>'+
         '<i  class="fa fa-eye gg-attachment-action" action="preview" parent_key="{{parent_key}}" file_name="{{file_name}}"></i>'+
    '  </div>'+
    '  <div class="gg-attachment-ellipse" >' +
        '      <div class="gg-drop-down">' +
        '       <div class="edit-btn gg-toggle-menu" position="left"><i class="fa fa-ellipsis-v"></i>' +
            '       <ul class="gg-drop-down-menu">' +
          //'             <li class="gg-attachment-action" action="download" parent_key="{{parent_key}}" file_name="{{file_name}}">Download</li>' +
            '           <li class="gg-attachment-action" action="edit" parent_key="{{parent_key}}" parent_type="{{parent_type}}">Edit</li>' +
            '           <li class="gg-attachment-action" action="deleteAttachment" parent_key="{{parent_key}}" parent_type="{{parent_type}}" file_name="{{file_name}}">Delete</li>' +
            '       </ul> '+
            '    </div>'+
        '       </div>'+
         '</div>'+
    '  </div>'+
    '  {{/each}}'+
    '  </div>';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////END:  handlebarsjs templates /////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
